
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref85b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref85b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1K4o4", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $144d7d87acaa8950$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $144d7d87acaa8950$export$f3b8ed2e4a5d10b8; });
function $144d7d87acaa8950$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("e2996", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a37858c721279338$export$7c398597f8905a1; });
function $a37858c721279338$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $a37858c721279338$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $a37858c721279338$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $a37858c721279338$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("5kWiG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3e2c0b3c34a727d3$export$2996f80ef42b8419; });
function $3e2c0b3c34a727d3$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hHaEF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ce1eb7a7847cf6d4$export$d60067ff2358eee8; });
function $ce1eb7a7847cf6d4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ce1eb7a7847cf6d4$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $ce1eb7a7847cf6d4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ce1eb7a7847cf6d4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("8EGc6", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $64d2ca0b63cc36d2$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $64d2ca0b63cc36d2$export$1e71eb4bef00f6b0; });
function $64d2ca0b63cc36d2$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("dACZV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9e4ce34f355067d5$export$7e4530ad35d3bb8; });

var $aLByk = parcelRequire("aLByk");
function $9e4ce34f355067d5$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $aLByk._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("aLByk", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $7d6b6c53d019132a$export$c2c98ac76e997b63; });
function $7d6b6c53d019132a$export$c2c98ac76e997b63(o, p) {
    $7d6b6c53d019132a$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7d6b6c53d019132a$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("jhb1H", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e0882876d2049d71$export$8dd05c13f5255580; });

var $8wb0B = parcelRequire("8wb0B");

var $drer0 = parcelRequire("drer0");

var $9WH53 = parcelRequire("9WH53");
function $e0882876d2049d71$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $drer0._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $8wb0B._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $8wb0B._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9WH53._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("8wb0B", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $6339da03daa44400$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $6339da03daa44400$export$f09211a7d3c496a1; });
function $6339da03daa44400$export$f09211a7d3c496a1(o) {
    $6339da03daa44400$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6339da03daa44400$export$f09211a7d3c496a1(o);
}

});

parcelRegister("drer0", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $9c88fe61dc568c9c$export$685354647fba1516; });
function $9c88fe61dc568c9c$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("9WH53", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $73daf2b96360aece$export$ef97c660ca164e52; });

var $1K4o4 = parcelRequire("1K4o4");

var $2lB2g = parcelRequire("2lB2g");
function $73daf2b96360aece$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $2lB2g._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $1K4o4._assert_this_initialized)(self);
}

});
parcelRegister("2lB2g", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $1b5a45679bee7e01$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $1b5a45679bee7e01$export$5f0017c582d45a2d; });
function $1b5a45679bee7e01$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("gAasq", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $c1281ec2e4f7c38e$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $c1281ec2e4f7c38e$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $2lB2g = parcelRequire("2lB2g");
var $c1281ec2e4f7c38e$var$extendStatics = function extendStatics1(d, b) {
    $c1281ec2e4f7c38e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c1281ec2e4f7c38e$var$extendStatics(d, b);
};
function $c1281ec2e4f7c38e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c1281ec2e4f7c38e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c1281ec2e4f7c38e$export$18ce0697a983be9b = function __assign1() {
    $c1281ec2e4f7c38e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c1281ec2e4f7c38e$export$18ce0697a983be9b.apply(this, arguments);
};
function $c1281ec2e4f7c38e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c1281ec2e4f7c38e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c1281ec2e4f7c38e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c1281ec2e4f7c38e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c1281ec2e4f7c38e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c1281ec2e4f7c38e$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $2lB2g._)(x)) === "symbol" ? x : "".concat(x);
}
function $c1281ec2e4f7c38e$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $2lB2g._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c1281ec2e4f7c38e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c1281ec2e4f7c38e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c1281ec2e4f7c38e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c1281ec2e4f7c38e$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c1281ec2e4f7c38e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c1281ec2e4f7c38e$export$45d3717a4c69092e(o, m, p);
}
function $c1281ec2e4f7c38e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c1281ec2e4f7c38e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c1281ec2e4f7c38e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c1281ec2e4f7c38e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c1281ec2e4f7c38e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c1281ec2e4f7c38e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c1281ec2e4f7c38e$export$10c90e4f7922046c(v) {
    return this instanceof $c1281ec2e4f7c38e$export$10c90e4f7922046c ? (this.v = v, this) : new $c1281ec2e4f7c38e$export$10c90e4f7922046c(v);
}
function $c1281ec2e4f7c38e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c1281ec2e4f7c38e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c1281ec2e4f7c38e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c1281ec2e4f7c38e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c1281ec2e4f7c38e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c1281ec2e4f7c38e$export$19a8beecd37a4c45 === "function" ? $c1281ec2e4f7c38e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c1281ec2e4f7c38e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c1281ec2e4f7c38e$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $c1281ec2e4f7c38e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c1281ec2e4f7c38e$export$45d3717a4c69092e(result, mod, k);
    }
    $c1281ec2e4f7c38e$var$__setModuleDefault(result, mod);
    return result;
}
function $c1281ec2e4f7c38e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $c1281ec2e4f7c38e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c1281ec2e4f7c38e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c1281ec2e4f7c38e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c1281ec2e4f7c38e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c1281ec2e4f7c38e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c1281ec2e4f7c38e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c1281ec2e4f7c38e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $c1281ec2e4f7c38e$export$2e2bcd8739ae039 = {
    __extends: $c1281ec2e4f7c38e$export$a8ba968b8961cb8a,
    __assign: $c1281ec2e4f7c38e$export$18ce0697a983be9b,
    __rest: $c1281ec2e4f7c38e$export$3c9a16f847548506,
    __decorate: $c1281ec2e4f7c38e$export$29e00dfd3077644b,
    __param: $c1281ec2e4f7c38e$export$d5ad3fd78186038f,
    __metadata: $c1281ec2e4f7c38e$export$f1db080c865becb9,
    __awaiter: $c1281ec2e4f7c38e$export$1050f835b63b671e,
    __generator: $c1281ec2e4f7c38e$export$67ebef60e6f28a6,
    __createBinding: $c1281ec2e4f7c38e$export$45d3717a4c69092e,
    __exportStar: $c1281ec2e4f7c38e$export$f33643c0debef087,
    __values: $c1281ec2e4f7c38e$export$19a8beecd37a4c45,
    __read: $c1281ec2e4f7c38e$export$8d051b38c9118094,
    __spread: $c1281ec2e4f7c38e$export$afc72e2116322959,
    __spreadArrays: $c1281ec2e4f7c38e$export$6388937ca91ccae8,
    __spreadArray: $c1281ec2e4f7c38e$export$1216008129fb82ed,
    __await: $c1281ec2e4f7c38e$export$10c90e4f7922046c,
    __asyncGenerator: $c1281ec2e4f7c38e$export$e427f37a30a4de9b,
    __asyncDelegator: $c1281ec2e4f7c38e$export$bbd80228419bb833,
    __asyncValues: $c1281ec2e4f7c38e$export$e3b29a3d6162315f,
    __makeTemplateObject: $c1281ec2e4f7c38e$export$4fb47efe1390b86f,
    __importStar: $c1281ec2e4f7c38e$export$c21735bcef00d192,
    __importDefault: $c1281ec2e4f7c38e$export$da59b14a69baef04,
    __classPrivateFieldGet: $c1281ec2e4f7c38e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c1281ec2e4f7c38e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c1281ec2e4f7c38e$export$81fdc39f203e4e04,
    __addDisposableResource: $c1281ec2e4f7c38e$export$88ac25d8e944e405,
    __disposeResources: $c1281ec2e4f7c38e$export$8f076105dc360e92
};

});

parcelRegister("5TLNx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $44b72a7cd24093dc$export$fdf2a89c76341bbf; });

var $bbJTY = parcelRequire("bbJTY");

var $bGU10 = parcelRequire("bGU10");

var $54C9f = parcelRequire("54C9f");

var $gry2Y = parcelRequire("gry2Y");
function $44b72a7cd24093dc$export$fdf2a89c76341bbf(arr, i) {
    return (0, $bbJTY._array_with_holes)(arr) || (0, $bGU10._iterable_to_array_limit)(arr, i) || (0, $gry2Y._unsupported_iterable_to_array)(arr, i) || (0, $54C9f._non_iterable_rest)();
}

});
parcelRegister("bbJTY", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $825453f46bc6fbb6$export$e6256bf45c68d561; });
function $825453f46bc6fbb6$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("bGU10", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $882f116985cbf940$export$2fd15edff6687200; });
function $882f116985cbf940$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("54C9f", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $3b1aeae9720c913e$export$60dbc22abd7da546; });
function $3b1aeae9720c913e$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("gry2Y", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $bf8993fe2ebd1ef5$export$a5be06335b3a083c; });

var $48FFY = parcelRequire("48FFY");
function $bf8993fe2ebd1ef5$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $48FFY._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $48FFY._array_like_to_array)(o, minLen);
}

});
parcelRegister("48FFY", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $30383cbf32f1bb71$export$79e617b1955a2616; });
function $30383cbf32f1bb71$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("gbAcq", function(module, exports) {

$parcel$export(module.exports, "DayTable", function () { return DayTable; });
$parcel$export(module.exports, "TableDateProfileGenerator", function () { return TableDateProfileGenerator; });
$parcel$export(module.exports, "DayGridView", function () { return DayTableView; });

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $eKxsN = parcelRequire("eKxsN");

var $8wb0B = parcelRequire("8wb0B");

var $dACZV = parcelRequire("dACZV");

var $5TJQB = parcelRequire("5TJQB");

var $jhb1H = parcelRequire("jhb1H");

var $c1gko = parcelRequire("c1gko");

var $kgSvt = parcelRequire("kgSvt");
var css_248z = ':root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:"";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:"";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}';
(0, $c1gko.cw)(css_248z);
function splitSegsByRow(segs, rowCnt) {
    var byRow = [];
    for(var i = 0; i < rowCnt; i += 1)byRow[i] = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var seg = _step.value;
            byRow[seg.row].push(seg);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return byRow;
}
function splitSegsByFirstCol(segs, colCnt) {
    var byCol = [];
    for(var i = 0; i < colCnt; i += 1)byCol[i] = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var seg = _step.value;
            byCol[seg.firstCol].push(seg);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return byCol;
}
function splitInteractionByRow(ui, rowCnt) {
    var byRow = [];
    if (!ui) for(var i = 0; i < rowCnt; i += 1)byRow[i] = null;
    else {
        for(var i1 = 0; i1 < rowCnt; i1 += 1)byRow[i1] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ui.segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var seg = _step.value;
                byRow[seg.row].segs.push(seg);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return byRow;
}
var DEFAULT_TABLE_EVENT_TIME_FORMAT = (0, $c1gko.x)({
    hour: "numeric",
    minute: "2-digit",
    omitZeroMinute: true,
    meridiem: "narrow"
});
function hasListItemDisplay(seg) {
    var display = seg.eventRange.ui.display;
    return display === "list-item" || display === "auto" && !seg.eventRange.def.allDay && seg.firstCol === seg.lastCol && // can't be multi-day
    seg.isStart && // "
    seg.isEnd // "
    ;
}
var TableBlockEvent = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(TableBlockEvent, BaseComponent);
    var _super = (0, $jhb1H._)(TableBlockEvent);
    function TableBlockEvent() {
        (0, $5kWiG._)(this, TableBlockEvent);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(TableBlockEvent, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                return (0, $kgSvt.createElement)((0, $c1gko.cj), Object.assign({}, props, {
                    elClasses: [
                        "fc-daygrid-event",
                        "fc-daygrid-block-event",
                        "fc-h-event"
                    ],
                    defaultTimeFormat: DEFAULT_TABLE_EVENT_TIME_FORMAT,
                    defaultDisplayEventEnd: props.defaultDisplayEventEnd,
                    disableResizing: !props.seg.eventRange.def.allDay
                }));
            }
        }
    ]);
    return TableBlockEvent;
}((0, $c1gko.B));
var TableListItemEvent = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(TableListItemEvent, BaseComponent);
    var _super = (0, $jhb1H._)(TableListItemEvent);
    function TableListItemEvent() {
        (0, $5kWiG._)(this, TableListItemEvent);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(TableListItemEvent, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var seg = props.seg;
                var timeFormat = options.eventTimeFormat || DEFAULT_TABLE_EVENT_TIME_FORMAT;
                var timeText = (0, $c1gko.bQ)(seg, timeFormat, context, true, props.defaultDisplayEventEnd);
                return (0, $kgSvt.createElement)((0, $c1gko.cn), Object.assign({}, props, {
                    elTag: "a",
                    elClasses: [
                        "fc-daygrid-event",
                        "fc-daygrid-dot-event"
                    ],
                    elAttrs: (0, $c1gko.bU)(props.seg, context),
                    defaultGenerator: renderInnerContent,
                    timeText: timeText,
                    isResizing: false,
                    isDateSelecting: false
                }));
            }
        }
    ]);
    return TableListItemEvent;
}((0, $c1gko.B));
function renderInnerContent(renderProps) {
    return (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, (0, $kgSvt.createElement)("div", {
        className: "fc-daygrid-event-dot",
        style: {
            borderColor: renderProps.borderColor || renderProps.backgroundColor
        }
    }), renderProps.timeText && (0, $kgSvt.createElement)("div", {
        className: "fc-event-time"
    }, renderProps.timeText), (0, $kgSvt.createElement)("div", {
        className: "fc-event-title"
    }, renderProps.event.title || (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, "\xa0")));
}
var TableCellMoreLink = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(TableCellMoreLink, BaseComponent);
    var _super = (0, $jhb1H._)(TableCellMoreLink);
    function TableCellMoreLink() {
        (0, $5kWiG._)(this, TableCellMoreLink);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.compileSegs = (0, $c1gko.z)(compileSegs);
        return _this;
    }
    (0, $hHaEF._)(TableCellMoreLink, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var _this_compileSegs = this.compileSegs(props.singlePlacements), allSegs = _this_compileSegs.allSegs, invisibleSegs = _this_compileSegs.invisibleSegs;
                return (0, $kgSvt.createElement)((0, $c1gko.cr), {
                    elClasses: [
                        "fc-daygrid-more-link"
                    ],
                    dateProfile: props.dateProfile,
                    todayRange: props.todayRange,
                    allDayDate: props.allDayDate,
                    moreCnt: props.moreCnt,
                    allSegs: allSegs,
                    hiddenSegs: invisibleSegs,
                    alignmentElRef: props.alignmentElRef,
                    alignGridTop: props.alignGridTop,
                    extraDateSpan: props.extraDateSpan,
                    popoverContent: function() {
                        var isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) || (props.eventResize ? props.eventResize.affectedInstances : null) || {};
                        return (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, allSegs.map(function(seg) {
                            var instanceId = seg.eventRange.instance.instanceId;
                            return (0, $kgSvt.createElement)("div", {
                                className: "fc-daygrid-event-harness",
                                key: instanceId,
                                style: {
                                    visibility: isForcedInvisible[instanceId] ? "hidden" : ""
                                }
                            }, hasListItemDisplay(seg) ? (0, $kgSvt.createElement)(TableListItemEvent, Object.assign({
                                seg: seg,
                                isDragging: false,
                                isSelected: instanceId === props.eventSelection,
                                defaultDisplayEventEnd: false
                            }, (0, $c1gko.bS)(seg, props.todayRange))) : (0, $kgSvt.createElement)(TableBlockEvent, Object.assign({
                                seg: seg,
                                isDragging: false,
                                isResizing: false,
                                isDateSelecting: false,
                                isSelected: instanceId === props.eventSelection,
                                defaultDisplayEventEnd: false
                            }, (0, $c1gko.bS)(seg, props.todayRange))));
                        }));
                    }
                });
            }
        }
    ]);
    return TableCellMoreLink;
}((0, $c1gko.B));
function compileSegs(singlePlacements) {
    var allSegs = [];
    var invisibleSegs = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = singlePlacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var placement = _step.value;
            allSegs.push(placement.seg);
            if (!placement.isVisible) invisibleSegs.push(placement.seg);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        allSegs: allSegs,
        invisibleSegs: invisibleSegs
    };
}
var DEFAULT_WEEK_NUM_FORMAT = (0, $c1gko.x)({
    week: "narrow"
});
var TableCell = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $dACZV._)(TableCell, DateComponent);
    var _super = (0, $jhb1H._)(TableCell);
    function TableCell() {
        (0, $5kWiG._)(this, TableCell);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.rootElRef = (0, $kgSvt.createRef)();
        _this.state = {
            dayNumberId: (0, $c1gko.a5)()
        };
        _this.handleRootEl = function(el) {
            (0, $c1gko.Y)(_this.rootElRef, el);
            (0, $c1gko.Y)(_this.props.elRef, el);
        };
        return _this;
    }
    (0, $hHaEF._)(TableCell, [
        {
            key: "render",
            value: function render() {
                var _this = this, context = _this.context, props = _this.props, state = _this.state, rootElRef = _this.rootElRef;
                var options = context.options, dateEnv = context.dateEnv;
                var date = props.date, dateProfile = props.dateProfile;
                // TODO: memoize this?
                var isMonthStart = props.showDayNumber && shouldDisplayMonthStart(date, dateProfile.currentRange, dateEnv);
                return (0, $kgSvt.createElement)((0, $c1gko.cl), {
                    elTag: "td",
                    elRef: this.handleRootEl,
                    elClasses: [
                        "fc-daygrid-day"
                    ].concat((0, $5TJQB._)(props.extraClassNames || [])),
                    elAttrs: Object.assign(Object.assign(Object.assign({}, props.extraDataAttrs), props.showDayNumber ? {
                        "aria-labelledby": state.dayNumberId
                    } : {}), {
                        role: "gridcell"
                    }),
                    defaultGenerator: renderTopInner,
                    date: date,
                    dateProfile: dateProfile,
                    todayRange: props.todayRange,
                    showDayNumber: props.showDayNumber,
                    isMonthStart: isMonthStart,
                    extraRenderProps: props.extraRenderProps
                }, function(InnerContent, renderProps) {
                    return (0, $kgSvt.createElement)("div", {
                        ref: props.innerElRef,
                        className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner",
                        style: {
                            minHeight: props.minHeight
                        }
                    }, props.showWeekNumber && (0, $kgSvt.createElement)((0, $c1gko.cq), {
                        elTag: "a",
                        elClasses: [
                            "fc-daygrid-week-number"
                        ],
                        elAttrs: (0, $c1gko.b0)(context, date, "week"),
                        date: date,
                        defaultFormat: DEFAULT_WEEK_NUM_FORMAT
                    }), !renderProps.isDisabled && (props.showDayNumber || (0, $c1gko.cm)(options) || props.forceDayTop) ? (0, $kgSvt.createElement)("div", {
                        className: "fc-daygrid-day-top"
                    }, (0, $kgSvt.createElement)(InnerContent, {
                        elTag: "a",
                        elClasses: [
                            "fc-daygrid-day-number",
                            isMonthStart && "fc-daygrid-month-start"
                        ],
                        elAttrs: Object.assign(Object.assign({}, (0, $c1gko.b0)(context, date)), {
                            id: state.dayNumberId
                        })
                    })) : props.showDayNumber ? // for creating correct amount of space (see issue #7162)
                    (0, $kgSvt.createElement)("div", {
                        className: "fc-daygrid-day-top",
                        style: {
                            visibility: "hidden"
                        }
                    }, (0, $kgSvt.createElement)("a", {
                        className: "fc-daygrid-day-number"
                    }, "\xa0")) : undefined, (0, $kgSvt.createElement)("div", {
                        className: "fc-daygrid-day-events",
                        ref: props.fgContentElRef
                    }, props.fgContent, (0, $kgSvt.createElement)("div", {
                        className: "fc-daygrid-day-bottom",
                        style: {
                            marginTop: props.moreMarginTop
                        }
                    }, (0, $kgSvt.createElement)(TableCellMoreLink, {
                        allDayDate: date,
                        singlePlacements: props.singlePlacements,
                        moreCnt: props.moreCnt,
                        alignmentElRef: rootElRef,
                        alignGridTop: !props.showDayNumber,
                        extraDateSpan: props.extraDateSpan,
                        dateProfile: props.dateProfile,
                        eventSelection: props.eventSelection,
                        eventDrag: props.eventDrag,
                        eventResize: props.eventResize,
                        todayRange: props.todayRange
                    }))), (0, $kgSvt.createElement)("div", {
                        className: "fc-daygrid-day-bg"
                    }, props.bgContent));
                });
            }
        }
    ]);
    return TableCell;
}((0, $c1gko.be));
function renderTopInner(props) {
    return props.dayNumberText || (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, "\xa0");
}
function shouldDisplayMonthStart(date, currentRange, dateEnv) {
    var currentStart = currentRange.start, currentEnd = currentRange.end;
    var currentEndIncl = (0, $c1gko.bg)(currentEnd, -1);
    var currentFirstYear = dateEnv.getYear(currentStart);
    var currentFirstMonth = dateEnv.getMonth(currentStart);
    var currentLastYear = dateEnv.getYear(currentEndIncl);
    var currentLastMonth = dateEnv.getMonth(currentEndIncl);
    // spans more than one month?
    return !(currentFirstYear === currentLastYear && currentFirstMonth === currentLastMonth) && Boolean(// first date in current view?
    date.valueOf() === currentStart.valueOf() || // a month-start that's within the current range?
    dateEnv.getDay(date) === 1 && date.valueOf() < currentEnd.valueOf());
}
function generateSegKey(seg) {
    return seg.eventRange.instance.instanceId + ":" + seg.firstCol;
}
function generateSegUid(seg) {
    return generateSegKey(seg) + ":" + seg.lastCol;
}
function computeFgSegPlacement(segs, dayMaxEvents, dayMaxEventRows, strictOrder, segHeights, maxContentHeight, cells) {
    var hierarchy = new DayGridSegHierarchy(function(segEntry) {
        // TODO: more DRY with generateSegUid
        var segUid = segs[segEntry.index].eventRange.instance.instanceId + ":" + segEntry.span.start + ":" + (segEntry.span.end - 1);
        return segHeights[segUid];
    });
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    } else if (typeof dayMaxEvents === "number") hierarchy.maxStackCnt = dayMaxEvents;
    else if (typeof dayMaxEventRows === "number") {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    var segInputs = [];
    var unknownHeightSegs = [];
    for(var i = 0; i < segs.length; i += 1){
        var seg = segs[i];
        var segUid = generateSegUid(seg);
        var eventHeight = segHeights[segUid];
        if (eventHeight != null) segInputs.push({
            index: i,
            span: {
                start: seg.firstCol,
                end: seg.lastCol + 1
            }
        });
        else unknownHeightSegs.push(seg);
    }
    var hiddenEntries = hierarchy.addSegs(segInputs);
    var segRects = hierarchy.toRects();
    var _placeRects = placeRects(segRects, segs, cells), singleColPlacements = _placeRects.singleColPlacements, multiColPlacements = _placeRects.multiColPlacements, leftoverMargins = _placeRects.leftoverMargins;
    var moreCnts = [];
    var moreMarginTops = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // add segs with unknown heights
        for(var _iterator = unknownHeightSegs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var seg1 = _step.value;
            multiColPlacements[seg1.firstCol].push({
                seg: seg1,
                isVisible: false,
                isAbsolute: true,
                absoluteTop: 0,
                marginTop: 0
            });
            for(var col = seg1.firstCol; col <= seg1.lastCol; col += 1)singleColPlacements[col].push({
                seg: resliceSeg(seg1, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // add the hidden entries
    for(var col1 = 0; col1 < cells.length; col1 += 1)moreCnts.push(0);
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = hiddenEntries[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var hiddenEntry = _step1.value;
            var seg2 = segs[hiddenEntry.index];
            var hiddenSpan = hiddenEntry.span;
            multiColPlacements[hiddenSpan.start].push({
                seg: resliceSeg(seg2, hiddenSpan.start, hiddenSpan.end, cells),
                isVisible: false,
                isAbsolute: true,
                absoluteTop: 0,
                marginTop: 0
            });
            for(var col2 = hiddenSpan.start; col2 < hiddenSpan.end; col2 += 1){
                moreCnts[col2] += 1;
                singleColPlacements[col2].push({
                    seg: resliceSeg(seg2, col2, col2 + 1, cells),
                    isVisible: false,
                    isAbsolute: false,
                    absoluteTop: 0,
                    marginTop: 0
                });
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    // deal with leftover margins
    for(var col3 = 0; col3 < cells.length; col3 += 1)moreMarginTops.push(leftoverMargins[col3]);
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        moreCnts: moreCnts,
        moreMarginTops: moreMarginTops
    };
}
// rects ordered by top coord, then left
function placeRects(allRects, segs, cells) {
    var rectsByEachCol = groupRectsByEachCol(allRects, cells.length);
    var singleColPlacements = [];
    var multiColPlacements = [];
    var leftoverMargins = [];
    for(var col = 0; col < cells.length; col += 1){
        var rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        var singlePlacements = [];
        var currentHeight = 0;
        var currentMarginTop = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var rect = _step.value;
                var seg = segs[rect.index];
                singlePlacements.push({
                    seg: resliceSeg(seg, col, col + 1, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: rect.levelCoord - currentHeight
                });
                currentHeight = rect.levelCoord + rect.thickness;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // compute mixed static/absolute segs in multiPlacements
        var multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = rects[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var rect1 = _step1.value;
                var seg1 = segs[rect1.index];
                var isAbsolute = rect1.span.end - rect1.span.start > 1; // multi-column?
                var isFirstCol = rect1.span.start === col;
                currentMarginTop += rect1.levelCoord - currentHeight; // amount of space since bottom of previous seg
                currentHeight = rect1.levelCoord + rect1.thickness; // height will now be bottom of current seg
                if (isAbsolute) {
                    currentMarginTop += rect1.thickness;
                    if (isFirstCol) multiPlacements.push({
                        seg: resliceSeg(seg1, rect1.span.start, rect1.span.end, cells),
                        isVisible: true,
                        isAbsolute: true,
                        absoluteTop: rect1.levelCoord,
                        marginTop: 0
                    });
                } else if (isFirstCol) {
                    multiPlacements.push({
                        seg: resliceSeg(seg1, rect1.span.start, rect1.span.end, cells),
                        isVisible: true,
                        isAbsolute: false,
                        absoluteTop: rect1.levelCoord,
                        marginTop: currentMarginTop
                    });
                    currentMarginTop = 0;
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        leftoverMargins: leftoverMargins
    };
}
function groupRectsByEachCol(rects, colCnt) {
    var rectsByEachCol = [];
    for(var col = 0; col < colCnt; col += 1)rectsByEachCol.push([]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rect = _step.value;
            for(var col1 = rect.span.start; col1 < rect.span.end; col1 += 1)rectsByEachCol[col1].push(rect);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return rectsByEachCol;
}
function resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) return seg;
    var eventRange = seg.eventRange;
    var origRange = eventRange.range;
    var slicedRange = (0, $c1gko.o)(origRange, {
        start: cells[spanStart].date,
        end: (0, $c1gko.t)(cells[spanEnd - 1].date, 1)
    });
    return Object.assign(Object.assign({}, seg), {
        firstCol: spanStart,
        lastCol: spanEnd - 1,
        eventRange: {
            def: eventRange.def,
            ui: Object.assign(Object.assign({}, eventRange.ui), {
                durationEditable: false
            }),
            instance: eventRange.instance,
            range: slicedRange
        },
        isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(),
        isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf()
    });
}
var DayGridSegHierarchy = /*#__PURE__*/ function(SegHierarchy) {
    "use strict";
    (0, $dACZV._)(DayGridSegHierarchy, SegHierarchy);
    var _super = (0, $jhb1H._)(DayGridSegHierarchy);
    function DayGridSegHierarchy() {
        (0, $5kWiG._)(this, DayGridSegHierarchy);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // config
        _this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        _this.forceHidden = {};
        return _this;
    }
    (0, $hHaEF._)(DayGridSegHierarchy, [
        {
            key: "addSegs",
            value: function addSegs(segInputs) {
                var _this = this;
                var hiddenSegs = (0, $eKxsN._)((0, $8wb0B._)(DayGridSegHierarchy.prototype), "addSegs", this).call(this, segInputs);
                var entriesByLevel = this.entriesByLevel;
                var excludeHidden = function(entry) {
                    return !_this.forceHidden[(0, $c1gko.bB)(entry)];
                };
                // remove the forced-hidden segs
                for(var level = 0; level < entriesByLevel.length; level += 1)entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
                return hiddenSegs;
            }
        },
        {
            key: "handleInvalidInsertion",
            value: function handleInvalidInsertion(insertion, entry, hiddenEntries) {
                var _this = this, entriesByLevel = _this.entriesByLevel, forceHidden = _this.forceHidden;
                var touchingEntry = insertion.touchingEntry, touchingLevel = insertion.touchingLevel, touchingLateral = insertion.touchingLateral;
                if (this.hiddenConsumes && touchingEntry) {
                    var touchingEntryId = (0, $c1gko.bB)(touchingEntry);
                    // if not already hidden
                    if (!forceHidden[touchingEntryId]) {
                        if (this.allowReslicing) {
                            var placeholderEntry = Object.assign(Object.assign({}, touchingEntry), {
                                span: (0, $c1gko.bF)(touchingEntry.span, entry.span)
                            });
                            var placeholderEntryId = (0, $c1gko.bB)(placeholderEntry);
                            forceHidden[placeholderEntryId] = true;
                            entriesByLevel[touchingLevel][touchingLateral] = placeholderEntry; // replace touchingEntry with our placeholder
                            this.splitEntry(touchingEntry, entry, hiddenEntries); // split up the touchingEntry, reinsert it
                        } else {
                            forceHidden[touchingEntryId] = true;
                            hiddenEntries.push(touchingEntry);
                        }
                    }
                }
                return (0, $eKxsN._)((0, $8wb0B._)(DayGridSegHierarchy.prototype), "handleInvalidInsertion", this).call(this, insertion, entry, hiddenEntries);
            }
        }
    ]);
    return DayGridSegHierarchy;
}((0, $c1gko.bA));
var TableRow = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $dACZV._)(TableRow, DateComponent);
    var _super = (0, $jhb1H._)(TableRow);
    function TableRow() {
        (0, $5kWiG._)(this, TableRow);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.cellElRefs = new (0, $c1gko.cf)(); // the <td>
        _this.frameElRefs = new (0, $c1gko.cf)(); // the fc-daygrid-day-frame
        _this.fgElRefs = new (0, $c1gko.cf)(); // the fc-daygrid-day-events
        _this.segHarnessRefs = new (0, $c1gko.cf)(); // indexed by "instanceId:firstCol"
        _this.rootElRef = (0, $kgSvt.createRef)();
        _this.state = {
            framePositions: null,
            maxContentHeight: null,
            segHeights: {}
        };
        _this.handleResize = function(isForced) {
            if (isForced) _this.updateSizing(true); // isExternal=true
        };
        return _this;
    }
    (0, $hHaEF._)(TableRow, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this1 = this, props = _this1.props, state = _this1.state, context = _this1.context;
                var options = context.options;
                var colCnt = props.cells.length;
                var businessHoursByCol = splitSegsByFirstCol(props.businessHourSegs, colCnt);
                var bgEventSegsByCol = splitSegsByFirstCol(props.bgEventSegs, colCnt);
                var highlightSegsByCol = splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
                var mirrorSegsByCol = splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
                var _computeFgSegPlacement = computeFgSegPlacement((0, $c1gko.bR)(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.segHeights, state.maxContentHeight, props.cells), singleColPlacements = _computeFgSegPlacement.singleColPlacements, multiColPlacements = _computeFgSegPlacement.multiColPlacements, moreCnts = _computeFgSegPlacement.moreCnts, moreMarginTops = _computeFgSegPlacement.moreMarginTops;
                var isForcedInvisible = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
                return (0, $kgSvt.createElement)("tr", {
                    ref: this.rootElRef,
                    role: "row"
                }, props.renderIntro && props.renderIntro(), props.cells.map(function(cell, col) {
                    var normalFgNodes = _this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
                    var mirrorFgNodes = _this.renderFgSegs(col, buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
                    return (0, $kgSvt.createElement)(TableCell, {
                        key: cell.key,
                        elRef: _this.cellElRefs.createRef(cell.key),
                        innerElRef: _this.frameElRefs.createRef(cell.key),
                        dateProfile: props.dateProfile,
                        date: cell.date,
                        showDayNumber: props.showDayNumbers,
                        showWeekNumber: props.showWeekNumbers && col === 0,
                        forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */ ,
                        todayRange: props.todayRange,
                        eventSelection: props.eventSelection,
                        eventDrag: props.eventDrag,
                        eventResize: props.eventResize,
                        extraRenderProps: cell.extraRenderProps,
                        extraDataAttrs: cell.extraDataAttrs,
                        extraClassNames: cell.extraClassNames,
                        extraDateSpan: cell.extraDateSpan,
                        moreCnt: moreCnts[col],
                        moreMarginTop: moreMarginTops[col],
                        singlePlacements: singleColPlacements[col],
                        fgContentElRef: _this.fgElRefs.createRef(cell.key),
                        fgContent: (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, normalFgNodes), (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, mirrorFgNodes)),
                        bgContent: (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, _this.renderFillSegs(highlightSegsByCol[col], "highlight"), _this.renderFillSegs(businessHoursByCol[col], "non-business"), _this.renderFillSegs(bgEventSegsByCol[col], "bg-event")),
                        minHeight: props.cellMinHeight
                    });
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateSizing(true);
                this.context.addResizeHandler(this.handleResize);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var currentProps = this.props;
                this.updateSizing(!(0, $c1gko.E)(prevProps, currentProps));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.context.removeResizeHandler(this.handleResize);
            }
        },
        {
            key: "getHighlightSegs",
            value: function getHighlightSegs() {
                var props = this.props;
                if (props.eventDrag && props.eventDrag.segs.length) return props.eventDrag.segs;
                if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
                return props.dateSelectionSegs;
            }
        },
        {
            key: "getMirrorSegs",
            value: function getMirrorSegs() {
                var props = this.props;
                if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
                return [];
            }
        },
        {
            key: "renderFgSegs",
            value: function renderFgSegs(col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
                var context = this.context;
                var eventSelection = this.props.eventSelection;
                var framePositions = this.state.framePositions;
                var defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
                var isMirror = isDragging || isResizing || isDateSelecting;
                var nodes = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (framePositions) try {
                    for(var _iterator = segPlacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var placement = _step.value;
                        var seg = placement.seg;
                        var instanceId = seg.eventRange.instance.instanceId;
                        var isVisible = placement.isVisible && !isForcedInvisible[instanceId];
                        var isAbsolute = placement.isAbsolute;
                        var left = "";
                        var right = "";
                        if (isAbsolute) {
                            if (context.isRtl) {
                                right = 0;
                                left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                            } else {
                                left = 0;
                                right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                            }
                        }
                        /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */ nodes.push((0, $kgSvt.createElement)("div", {
                            className: "fc-daygrid-event-harness" + (isAbsolute ? " fc-daygrid-event-harness-abs" : ""),
                            key: generateSegKey(seg),
                            ref: isMirror ? null : this.segHarnessRefs.createRef(generateSegUid(seg)),
                            style: {
                                visibility: isVisible ? "" : "hidden",
                                marginTop: isAbsolute ? "" : placement.marginTop,
                                top: isAbsolute ? placement.absoluteTop : "",
                                left: left,
                                right: right
                            }
                        }, hasListItemDisplay(seg) ? (0, $kgSvt.createElement)(TableListItemEvent, Object.assign({
                            seg: seg,
                            isDragging: isDragging,
                            isSelected: instanceId === eventSelection,
                            defaultDisplayEventEnd: defaultDisplayEventEnd
                        }, (0, $c1gko.bS)(seg, todayRange))) : (0, $kgSvt.createElement)(TableBlockEvent, Object.assign({
                            seg: seg,
                            isDragging: isDragging,
                            isResizing: isResizing,
                            isDateSelecting: isDateSelecting,
                            isSelected: instanceId === eventSelection,
                            defaultDisplayEventEnd: defaultDisplayEventEnd
                        }, (0, $c1gko.bS)(seg, todayRange)))));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return nodes;
            }
        },
        {
            key: "renderFillSegs",
            value: function renderFillSegs(segs, fillType) {
                var isRtl = this.context.isRtl;
                var todayRange = this.props.todayRange;
                var framePositions = this.state.framePositions;
                var nodes = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (framePositions) try {
                    for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var seg = _step.value;
                        var leftRightCss = isRtl ? {
                            right: 0,
                            left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol]
                        } : {
                            left: 0,
                            right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol]
                        };
                        nodes.push((0, $kgSvt.createElement)("div", {
                            key: (0, $c1gko.bT)(seg.eventRange),
                            className: "fc-daygrid-bg-harness",
                            style: leftRightCss
                        }, fillType === "bg-event" ? (0, $kgSvt.createElement)((0, $c1gko.cp), Object.assign({
                            seg: seg
                        }, (0, $c1gko.bS)(seg, todayRange))) : (0, $c1gko.co)(fillType)));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return (0, $kgSvt.createElement).apply(void 0, [
                    (0, $kgSvt.Fragment),
                    {}
                ].concat((0, $5TJQB._)(nodes)));
            }
        },
        {
            key: "updateSizing",
            value: function updateSizing(isExternalSizingChange) {
                var _this = this, props = _this.props, state = _this.state, frameElRefs = _this.frameElRefs;
                if (!props.forPrint && props.clientWidth !== null // positioning ready?
                ) {
                    if (isExternalSizingChange) {
                        var frameEls = props.cells.map(function(cell) {
                            return frameElRefs.currentMap[cell.key];
                        });
                        if (frameEls.length) {
                            var originEl = this.rootElRef.current;
                            var newPositionCache = new (0, $c1gko.ba)(originEl, frameEls, true, false);
                            if (!state.framePositions || !state.framePositions.similarTo(newPositionCache)) this.setState({
                                framePositions: new (0, $c1gko.ba)(originEl, frameEls, true, false)
                            });
                        }
                    }
                    var oldSegHeights = this.state.segHeights;
                    var newSegHeights = this.querySegHeights();
                    var limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
                    this.safeSetState({
                        // HACK to prevent oscillations of events being shown/hidden from max-event-rows
                        // Essentially, once you compute an element's height, never null-out.
                        // TODO: always display all events, as visibility:hidden?
                        segHeights: Object.assign(Object.assign({}, oldSegHeights), newSegHeights),
                        maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null
                    });
                }
            }
        },
        {
            key: "querySegHeights",
            value: function querySegHeights() {
                var segElMap = this.segHarnessRefs.currentMap;
                var segHeights = {};
                // get the max height amongst instance segs
                for(var segUid in segElMap){
                    var height = Math.round(segElMap[segUid].getBoundingClientRect().height);
                    segHeights[segUid] = Math.max(segHeights[segUid] || 0, height);
                }
                return segHeights;
            }
        },
        {
            key: "computeMaxContentHeight",
            value: function computeMaxContentHeight() {
                var firstKey = this.props.cells[0].key;
                var cellEl = this.cellElRefs.currentMap[firstKey];
                var fcContainerEl = this.fgElRefs.currentMap[firstKey];
                return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
            }
        },
        {
            key: "getCellEls",
            value: function getCellEls() {
                var elMap = this.cellElRefs.currentMap;
                return this.props.cells.map(function(cell) {
                    return elMap[cell.key];
                });
            }
        }
    ]);
    return TableRow;
}((0, $c1gko.be));
TableRow.addStateEquality({
    segHeights: (0, $c1gko.E)
});
function buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) return [];
    var topsByInstanceId = buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map(function(seg) {
        return {
            seg: seg,
            isVisible: true,
            isAbsolute: true,
            absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
            marginTop: 0
        };
    });
}
function buildAbsoluteTopHash(colPlacements) {
    var topsByInstanceId = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = colPlacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var placements = _step.value;
            try {
                for(var _iterator1 = placements[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var placement = _step1.value;
                    topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return topsByInstanceId;
}
var TableRows = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $dACZV._)(TableRows, DateComponent);
    var _super = (0, $jhb1H._)(TableRows);
    function TableRows() {
        (0, $5kWiG._)(this, TableRows);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.splitBusinessHourSegs = (0, $c1gko.z)(splitSegsByRow);
        _this.splitBgEventSegs = (0, $c1gko.z)(splitSegsByRow);
        _this.splitFgEventSegs = (0, $c1gko.z)(splitSegsByRow);
        _this.splitDateSelectionSegs = (0, $c1gko.z)(splitSegsByRow);
        _this.splitEventDrag = (0, $c1gko.z)(splitInteractionByRow);
        _this.splitEventResize = (0, $c1gko.z)(splitInteractionByRow);
        _this.rowRefs = new (0, $c1gko.cf)();
        return _this;
    }
    (0, $hHaEF._)(TableRows, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this1 = this, props = _this1.props, context = _this1.context;
                var rowCnt = props.cells.length;
                var businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
                var bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
                var fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
                var dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
                var eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
                var eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
                // for DayGrid view with many rows, force a min-height on cells so doesn't appear squished
                // choose 7 because a month view will have max 6 rows
                var cellMinHeight = rowCnt >= 7 && props.clientWidth ? props.clientWidth / context.options.aspectRatio / 6 : null;
                return (0, $kgSvt.createElement)((0, $c1gko.ch), {
                    unit: "day"
                }, function(nowDate, todayRange) {
                    return (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, props.cells.map(function(cells, row) {
                        return (0, $kgSvt.createElement)(TableRow, {
                            ref: _this.rowRefs.createRef(row),
                            key: cells.length ? cells[0].date.toISOString() : row // in case there are no cells (like when resource view is loading)
                            ,
                            showDayNumbers: rowCnt > 1,
                            showWeekNumbers: props.showWeekNumbers,
                            todayRange: todayRange,
                            dateProfile: props.dateProfile,
                            cells: cells,
                            renderIntro: props.renderRowIntro,
                            businessHourSegs: businessHourSegsByRow[row],
                            eventSelection: props.eventSelection,
                            bgEventSegs: bgEventSegsByRow[row].filter(isSegAllDay),
                            fgEventSegs: fgEventSegsByRow[row],
                            dateSelectionSegs: dateSelectionSegsByRow[row],
                            eventDrag: eventDragByRow[row],
                            eventResize: eventResizeByRow[row],
                            dayMaxEvents: props.dayMaxEvents,
                            dayMaxEventRows: props.dayMaxEventRows,
                            clientWidth: props.clientWidth,
                            clientHeight: props.clientHeight,
                            cellMinHeight: cellMinHeight,
                            forPrint: props.forPrint
                        });
                    }));
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.registerInteractiveComponent();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                // for if started with zero cells
                this.registerInteractiveComponent();
            }
        },
        {
            key: "registerInteractiveComponent",
            value: function registerInteractiveComponent() {
                if (!this.rootEl) {
                    // HACK: need a daygrid wrapper parent to do positioning
                    // NOTE: a daygrid resource view w/o resources can have zero cells
                    var firstCellEl = this.rowRefs.currentMap[0].getCellEls()[0];
                    var rootEl = firstCellEl ? firstCellEl.closest(".fc-daygrid-body") : null;
                    if (rootEl) {
                        this.rootEl = rootEl;
                        this.context.registerInteractiveComponent(this, {
                            el: rootEl,
                            isHitComboAllowed: this.props.isHitComboAllowed
                        });
                    }
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.rootEl) {
                    this.context.unregisterInteractiveComponent(this);
                    this.rootEl = null;
                }
            }
        },
        {
            // Hit System
            // ----------------------------------------------------------------------------------------------------
            key: "prepareHits",
            value: function prepareHits() {
                this.rowPositions = new (0, $c1gko.ba)(this.rootEl, this.rowRefs.collect().map(function(rowObj) {
                    return rowObj.getCellEls()[0];
                }), false, true);
                this.colPositions = new (0, $c1gko.ba)(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), true, false);
            }
        },
        {
            key: "queryHit",
            value: function queryHit(positionLeft, positionTop) {
                var _this = this, colPositions = _this.colPositions, rowPositions = _this.rowPositions;
                var col = colPositions.leftToIndex(positionLeft);
                var row = rowPositions.topToIndex(positionTop);
                if (row != null && col != null) {
                    var cell = this.props.cells[row][col];
                    return {
                        dateProfile: this.props.dateProfile,
                        dateSpan: Object.assign({
                            range: this.getCellRange(row, col),
                            allDay: true
                        }, cell.extraDateSpan),
                        dayEl: this.getCellEl(row, col),
                        rect: {
                            left: colPositions.lefts[col],
                            right: colPositions.rights[col],
                            top: rowPositions.tops[row],
                            bottom: rowPositions.bottoms[row]
                        },
                        layer: 0
                    };
                }
                return null;
            }
        },
        {
            key: "getCellEl",
            value: function getCellEl(row, col) {
                return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
            }
        },
        {
            key: "getCellRange",
            value: function getCellRange(row, col) {
                var start = this.props.cells[row][col].date;
                var end = (0, $c1gko.t)(start, 1);
                return {
                    start: start,
                    end: end
                };
            }
        }
    ]);
    return TableRows;
}((0, $c1gko.be));
function isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}
var Table = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $dACZV._)(Table, DateComponent);
    var _super = (0, $jhb1H._)(Table);
    function Table() {
        (0, $5kWiG._)(this, Table);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.elRef = (0, $kgSvt.createRef)();
        _this.needsScrollReset = false;
        return _this;
    }
    (0, $hHaEF._)(Table, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var dayMaxEventRows = props.dayMaxEventRows, dayMaxEvents = props.dayMaxEvents, expandRows = props.expandRows;
                var limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
                // if rows can't expand to fill fixed height, can't do balanced-height event limit
                // TODO: best place to normalize these options?
                if (limitViaBalanced && !expandRows) {
                    limitViaBalanced = false;
                    dayMaxEventRows = null;
                    dayMaxEvents = null;
                }
                var classNames = [
                    "fc-daygrid-body",
                    limitViaBalanced ? "fc-daygrid-body-balanced" : "fc-daygrid-body-unbalanced",
                    expandRows ? "" : "fc-daygrid-body-natural"
                ];
                return (0, $kgSvt.createElement)("div", {
                    ref: this.elRef,
                    className: classNames.join(" "),
                    style: {
                        // these props are important to give this wrapper correct dimensions for interactions
                        // TODO: if we set it here, can we avoid giving to inner tables?
                        width: props.clientWidth,
                        minWidth: props.tableMinWidth
                    }
                }, (0, $kgSvt.createElement)("table", {
                    role: "presentation",
                    className: "fc-scrollgrid-sync-table",
                    style: {
                        width: props.clientWidth,
                        minWidth: props.tableMinWidth,
                        height: expandRows ? props.clientHeight : ""
                    }
                }, props.colGroupNode, (0, $kgSvt.createElement)("tbody", {
                    role: "presentation"
                }, (0, $kgSvt.createElement)(TableRows, {
                    dateProfile: props.dateProfile,
                    cells: props.cells,
                    renderRowIntro: props.renderRowIntro,
                    showWeekNumbers: props.showWeekNumbers,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    businessHourSegs: props.businessHourSegs,
                    bgEventSegs: props.bgEventSegs,
                    fgEventSegs: props.fgEventSegs,
                    dateSelectionSegs: props.dateSelectionSegs,
                    eventSelection: props.eventSelection,
                    eventDrag: props.eventDrag,
                    eventResize: props.eventResize,
                    dayMaxEvents: dayMaxEvents,
                    dayMaxEventRows: dayMaxEventRows,
                    forPrint: props.forPrint,
                    isHitComboAllowed: props.isHitComboAllowed
                }))));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.requestScrollReset();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.dateProfile !== this.props.dateProfile) this.requestScrollReset();
                else this.flushScrollReset();
            }
        },
        {
            key: "requestScrollReset",
            value: function requestScrollReset() {
                this.needsScrollReset = true;
                this.flushScrollReset();
            }
        },
        {
            key: "flushScrollReset",
            value: function flushScrollReset() {
                if (this.needsScrollReset && this.props.clientWidth // sizes computed?
                ) {
                    var subjectEl = getScrollSubjectEl(this.elRef.current, this.props.dateProfile);
                    if (subjectEl) {
                        var originEl = subjectEl.closest(".fc-daygrid-body");
                        var scrollEl = originEl.closest(".fc-scroller");
                        var scrollTop = subjectEl.getBoundingClientRect().top - originEl.getBoundingClientRect().top;
                        scrollEl.scrollTop = scrollTop ? scrollTop + 1 : 0; // overcome border
                    }
                    this.needsScrollReset = false;
                }
            }
        }
    ]);
    return Table;
}((0, $c1gko.be));
function getScrollSubjectEl(containerEl, dateProfile) {
    var el;
    if (dateProfile.currentRangeUnit.match(/year|month/)) el = containerEl.querySelector('[data-date="'.concat((0, $c1gko.bx)(dateProfile.currentDate), '-01"]'));
    if (!el) el = containerEl.querySelector('[data-date="'.concat((0, $c1gko.bv)(dateProfile.currentDate), '"]'));
    return el;
}
var DayTableSlicer = /*#__PURE__*/ function(Slicer) {
    "use strict";
    (0, $dACZV._)(DayTableSlicer, Slicer);
    var _super = (0, $jhb1H._)(DayTableSlicer);
    function DayTableSlicer() {
        (0, $5kWiG._)(this, DayTableSlicer);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.forceDayIfListItem = true;
        return _this;
    }
    (0, $hHaEF._)(DayTableSlicer, [
        {
            key: "sliceRange",
            value: function sliceRange(dateRange, dayTableModel) {
                return dayTableModel.sliceRange(dateRange);
            }
        }
    ]);
    return DayTableSlicer;
}((0, $c1gko.bW));
var DayTable = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $dACZV._)(DayTable, DateComponent);
    var _super = (0, $jhb1H._)(DayTable);
    function DayTable() {
        (0, $5kWiG._)(this, DayTable);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.slicer = new DayTableSlicer();
        _this.tableRef = (0, $kgSvt.createRef)();
        return _this;
    }
    (0, $hHaEF._)(DayTable, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                return (0, $kgSvt.createElement)(Table, Object.assign({
                    ref: this.tableRef
                }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), {
                    dateProfile: props.dateProfile,
                    cells: props.dayTableModel.cells,
                    colGroupNode: props.colGroupNode,
                    tableMinWidth: props.tableMinWidth,
                    renderRowIntro: props.renderRowIntro,
                    dayMaxEvents: props.dayMaxEvents,
                    dayMaxEventRows: props.dayMaxEventRows,
                    showWeekNumbers: props.showWeekNumbers,
                    expandRows: props.expandRows,
                    headerAlignElRef: props.headerAlignElRef,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    forPrint: props.forPrint
                }));
            }
        }
    ]);
    return DayTable;
}((0, $c1gko.be));
var TableDateProfileGenerator = /*#__PURE__*/ function(DateProfileGenerator) {
    "use strict";
    (0, $dACZV._)(TableDateProfileGenerator, DateProfileGenerator);
    var _super = (0, $jhb1H._)(TableDateProfileGenerator);
    function TableDateProfileGenerator() {
        (0, $5kWiG._)(this, TableDateProfileGenerator);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(TableDateProfileGenerator, [
        {
            // Computes the date range that will be rendered
            key: "buildRenderRange",
            value: function buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
                var renderRange = (0, $eKxsN._)((0, $8wb0B._)(TableDateProfileGenerator.prototype), "buildRenderRange", this).call(this, currentRange, currentRangeUnit, isRangeAllDay);
                var props = this.props;
                return buildDayTableRenderRange({
                    currentRange: renderRange,
                    snapToWeek: /^(year|month)$/.test(currentRangeUnit),
                    fixedWeekCount: props.fixedWeekCount,
                    dateEnv: props.dateEnv
                });
            }
        }
    ]);
    return TableDateProfileGenerator;
}((0, $c1gko.U));
function buildDayTableRenderRange(props) {
    var dateEnv = props.dateEnv, currentRange = props.currentRange;
    var start = currentRange.start, end = currentRange.end;
    var endOfWeek;
    // year and month views should be aligned with weeks. this is already done for week
    if (props.snapToWeek) {
        start = dateEnv.startOfWeek(start);
        // make end-of-week if not already
        endOfWeek = dateEnv.startOfWeek(end);
        if (endOfWeek.valueOf() !== end.valueOf()) end = (0, $c1gko.bh)(endOfWeek, 1);
    }
    // ensure 6 weeks
    if (props.fixedWeekCount) {
        // TODO: instead of these date-math gymnastics (for multimonth view),
        // compute dateprofiles of all months, then use start of first and end of last.
        var lastMonthRenderStart = dateEnv.startOfWeek(dateEnv.startOfMonth((0, $c1gko.t)(currentRange.end, -1)));
        var rowCnt = Math.ceil((0, $c1gko.bi)(lastMonthRenderStart, end));
        end = (0, $c1gko.bh)(end, 6 - rowCnt);
    }
    return {
        start: start,
        end: end
    };
}
/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/ // It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
var TableView = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $dACZV._)(TableView, DateComponent);
    var _super = (0, $jhb1H._)(TableView);
    function TableView() {
        (0, $5kWiG._)(this, TableView);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.headerElRef = (0, $kgSvt.createRef)();
        return _this;
    }
    (0, $hHaEF._)(TableView, [
        {
            key: "renderSimpleLayout",
            value: function renderSimpleLayout(headerRowContent, bodyContent) {
                var _this = this, props = _this.props, context = _this.context;
                var sections = [];
                var stickyHeaderDates = (0, $c1gko.cc)(context.options);
                if (headerRowContent) sections.push({
                    type: "header",
                    key: "header",
                    isSticky: stickyHeaderDates,
                    chunk: {
                        elRef: this.headerElRef,
                        tableClassName: "fc-col-header",
                        rowContent: headerRowContent
                    }
                });
                sections.push({
                    type: "body",
                    key: "body",
                    liquid: true,
                    chunk: {
                        content: bodyContent
                    }
                });
                return (0, $kgSvt.createElement)((0, $c1gko.ct), {
                    elClasses: [
                        "fc-daygrid"
                    ],
                    viewSpec: context.viewSpec
                }, (0, $kgSvt.createElement)((0, $c1gko.b$), {
                    liquid: !props.isHeightAuto && !props.forPrint,
                    collapsibleWidth: props.forPrint,
                    cols: [],
                    sections: sections
                }));
            }
        },
        {
            key: "renderHScrollLayout",
            value: function renderHScrollLayout(headerRowContent, bodyContent, colCnt, dayMinWidth) {
                var ScrollGrid = this.context.pluginHooks.scrollGridImpl;
                if (!ScrollGrid) throw new Error("No ScrollGrid implementation");
                var _this = this, props = _this.props, context = _this.context;
                var stickyHeaderDates = !props.forPrint && (0, $c1gko.cc)(context.options);
                var stickyFooterScrollbar = !props.forPrint && (0, $c1gko.cb)(context.options);
                var sections = [];
                if (headerRowContent) sections.push({
                    type: "header",
                    key: "header",
                    isSticky: stickyHeaderDates,
                    chunks: [
                        {
                            key: "main",
                            elRef: this.headerElRef,
                            tableClassName: "fc-col-header",
                            rowContent: headerRowContent
                        }
                    ]
                });
                sections.push({
                    type: "body",
                    key: "body",
                    liquid: true,
                    chunks: [
                        {
                            key: "main",
                            content: bodyContent
                        }
                    ]
                });
                if (stickyFooterScrollbar) sections.push({
                    type: "footer",
                    key: "footer",
                    isSticky: true,
                    chunks: [
                        {
                            key: "main",
                            content: (0, $c1gko.ca)
                        }
                    ]
                });
                return (0, $kgSvt.createElement)((0, $c1gko.ct), {
                    elClasses: [
                        "fc-daygrid"
                    ],
                    viewSpec: context.viewSpec
                }, (0, $kgSvt.createElement)(ScrollGrid, {
                    liquid: !props.isHeightAuto && !props.forPrint,
                    forPrint: props.forPrint,
                    collapsibleWidth: props.forPrint,
                    colGroups: [
                        {
                            cols: [
                                {
                                    span: colCnt,
                                    minWidth: dayMinWidth
                                }
                            ]
                        }
                    ],
                    sections: sections
                }));
            }
        }
    ]);
    return TableView;
}((0, $c1gko.be));
var DayTableView = /*#__PURE__*/ function(TableView) {
    "use strict";
    (0, $dACZV._)(DayTableView, TableView);
    var _super = (0, $jhb1H._)(DayTableView);
    function DayTableView() {
        (0, $5kWiG._)(this, DayTableView);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.buildDayTableModel = (0, $c1gko.z)(buildDayTableModel);
        _this.headerRef = (0, $kgSvt.createRef)();
        _this.tableRef = (0, $kgSvt.createRef)();
        return _this;
    }
    (0, $hHaEF._)(DayTableView, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_context = this.context, options = _this_context.options, dateProfileGenerator = _this_context.dateProfileGenerator;
                var props = this.props;
                var dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
                var headerContent = options.dayHeaders && (0, $kgSvt.createElement)((0, $c1gko.bK), {
                    ref: this.headerRef,
                    dateProfile: props.dateProfile,
                    dates: dayTableModel.headerDates,
                    datesRepDistinctDays: dayTableModel.rowCnt === 1
                });
                var bodyContent = function(contentArg) {
                    return (0, $kgSvt.createElement)(DayTable, {
                        ref: _this.tableRef,
                        dateProfile: props.dateProfile,
                        dayTableModel: dayTableModel,
                        businessHours: props.businessHours,
                        dateSelection: props.dateSelection,
                        eventStore: props.eventStore,
                        eventUiBases: props.eventUiBases,
                        eventSelection: props.eventSelection,
                        eventDrag: props.eventDrag,
                        eventResize: props.eventResize,
                        nextDayThreshold: options.nextDayThreshold,
                        colGroupNode: contentArg.tableColGroupNode,
                        tableMinWidth: contentArg.tableMinWidth,
                        dayMaxEvents: options.dayMaxEvents,
                        dayMaxEventRows: options.dayMaxEventRows,
                        showWeekNumbers: options.weekNumbers,
                        expandRows: !props.isHeightAuto,
                        headerAlignElRef: _this.headerElRef,
                        clientWidth: contentArg.clientWidth,
                        clientHeight: contentArg.clientHeight,
                        forPrint: props.forPrint
                    });
                };
                return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
            }
        }
    ]);
    return DayTableView;
}(TableView);
function buildDayTableModel(dateProfile, dateProfileGenerator) {
    var daySeries = new (0, $c1gko.bO)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $c1gko.bV)(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}

});
parcelRegister("eKxsN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $abcf51b57bc5d40e$export$afb3516d9d608401; });

var $3BYcR = parcelRequire("3BYcR");
function $abcf51b57bc5d40e$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $abcf51b57bc5d40e$export$afb3516d9d608401 = Reflect.get;
    else $abcf51b57bc5d40e$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $3BYcR._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $abcf51b57bc5d40e$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRegister("3BYcR", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $2a13878ccaa1d553$export$e4187255aefbc259; });

var $8wb0B = parcelRequire("8wb0B");
function $2a13878ccaa1d553$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $8wb0B._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("5TJQB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $44b5a721551804df$export$1b5e630bc3aea29f; });

var $8nP8A = parcelRequire("8nP8A");

var $CBeoK = parcelRequire("CBeoK");

var $avQI4 = parcelRequire("avQI4");

var $gry2Y = parcelRequire("gry2Y");
function $44b5a721551804df$export$1b5e630bc3aea29f(arr) {
    return (0, $8nP8A._array_without_holes)(arr) || (0, $CBeoK._iterable_to_array)(arr) || (0, $gry2Y._unsupported_iterable_to_array)(arr) || (0, $avQI4._non_iterable_spread)();
}

});
parcelRegister("8nP8A", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $61a8238b40443412$export$7e0947b5ad3404e2; });

var $48FFY = parcelRequire("48FFY");
function $61a8238b40443412$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $48FFY._array_like_to_array)(arr);
}

});

parcelRegister("CBeoK", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $07406e122ea90463$export$1eb58a6e75231000; });
function $07406e122ea90463$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("avQI4", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $7a75afb41c23cdca$export$e6f3c4780d19eb2b; });
function $7a75afb41c23cdca$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("c1gko", function(module, exports) {

$parcel$export(module.exports, "cw", function () { return $8c023e653ef8da49$export$c373adc892eb6355; });
$parcel$export(module.exports, "ad", function () { return $8c023e653ef8da49$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "D", function () { return $8c023e653ef8da49$export$96f57966bedc81b4; });
$parcel$export(module.exports, "aO", function () { return $8c023e653ef8da49$export$c03999cb2f36933f; });
$parcel$export(module.exports, "$", function () { return $8c023e653ef8da49$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "aQ", function () { return $8c023e653ef8da49$export$f96d196f7728bb5; });
$parcel$export(module.exports, "aP", function () { return $8c023e653ef8da49$export$2ed0fc6709e59212; });
$parcel$export(module.exports, "ae", function () { return $8c023e653ef8da49$export$f787f51d84a910ad; });
$parcel$export(module.exports, "aR", function () { return $8c023e653ef8da49$export$738ab4df8bf92ae9; });
$parcel$export(module.exports, "a5", function () { return $8c023e653ef8da49$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "a1", function () { return $8c023e653ef8da49$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "a2", function () { return $8c023e653ef8da49$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "b2", function () { return $8c023e653ef8da49$export$2ec5befb9e6c97d4; });
$parcel$export(module.exports, "g", function () { return $8c023e653ef8da49$export$39b482c5e57630a8; });
$parcel$export(module.exports, "ax", function () { return $8c023e653ef8da49$export$9fa96a7d116ea3ce; });
$parcel$export(module.exports, "aw", function () { return $8c023e653ef8da49$export$92108d983e8ee699; });
$parcel$export(module.exports, "ar", function () { return $8c023e653ef8da49$export$d24c54395ce0c509; });
$parcel$export(module.exports, "as", function () { return $8c023e653ef8da49$export$6554612db691658e; });
$parcel$export(module.exports, "at", function () { return $8c023e653ef8da49$export$493d36ec626b6698; });
$parcel$export(module.exports, "au", function () { return $8c023e653ef8da49$export$1fbe638ecf81657e; });
$parcel$export(module.exports, "k", function () { return $8c023e653ef8da49$export$342063e11d6c3cad; });
$parcel$export(module.exports, "av", function () { return $8c023e653ef8da49$export$d66dc83d8cfc8dd; });
$parcel$export(module.exports, "d", function () { return $8c023e653ef8da49$export$4368d992c4eafac0; });
$parcel$export(module.exports, "bp", function () { return $8c023e653ef8da49$export$b169257caa88022a; });
$parcel$export(module.exports, "s", function () { return $8c023e653ef8da49$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "bo", function () { return $8c023e653ef8da49$export$847533e5bf524f5f; });
$parcel$export(module.exports, "bs", function () { return $8c023e653ef8da49$export$4e222d082f82ee97; });
$parcel$export(module.exports, "bt", function () { return $8c023e653ef8da49$export$56350196709588fc; });
$parcel$export(module.exports, "c", function () { return $8c023e653ef8da49$export$db3b6bfb95261072; });
$parcel$export(module.exports, "i", function () { return $8c023e653ef8da49$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "bh", function () { return $8c023e653ef8da49$export$31e67cf12fc9668; });
$parcel$export(module.exports, "t", function () { return $8c023e653ef8da49$export$625550452a3fa3ec; });
$parcel$export(module.exports, "bg", function () { return $8c023e653ef8da49$export$136fd86de524d3c2; });
$parcel$export(module.exports, "bi", function () { return $8c023e653ef8da49$export$62d08d6fa708df47; });
$parcel$export(module.exports, "bl", function () { return $8c023e653ef8da49$export$a36fb7d24305ed9d; });
$parcel$export(module.exports, "q", function () { return $8c023e653ef8da49$export$9e5f44173e64f162; });
$parcel$export(module.exports, "y", function () { return $8c023e653ef8da49$export$4a5767248b18ef41; });
$parcel$export(module.exports, "bw", function () { return $8c023e653ef8da49$export$45d219bdcd8ac53c; });
$parcel$export(module.exports, "bv", function () { return $8c023e653ef8da49$export$5dbe06c6d8c68cfb; });
$parcel$export(module.exports, "bx", function () { return $8c023e653ef8da49$export$26a0a7676ca7aa04; });
$parcel$export(module.exports, "bu", function () { return $8c023e653ef8da49$export$f438b12253c2b499; });
$parcel$export(module.exports, "z", function () { return $8c023e653ef8da49$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $8c023e653ef8da49$export$ebd11618f299a286; });
$parcel$export(module.exports, "E", function () { return $8c023e653ef8da49$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "x", function () { return $8c023e653ef8da49$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "N", function () { return $8c023e653ef8da49$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "n", function () { return $8c023e653ef8da49$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "e", function () { return $8c023e653ef8da49$export$f1e1789686576879; });
$parcel$export(module.exports, "O", function () { return $8c023e653ef8da49$export$c4ce752e73470fba; });
$parcel$export(module.exports, "P", function () { return $8c023e653ef8da49$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "Q", function () { return $8c023e653ef8da49$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "R", function () { return $8c023e653ef8da49$export$db202ddc8be9136; });
$parcel$export(module.exports, "M", function () { return $8c023e653ef8da49$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "m", function () { return $8c023e653ef8da49$export$953cecd6e717a553; });
$parcel$export(module.exports, "h", function () { return $8c023e653ef8da49$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "a", function () { return $8c023e653ef8da49$export$407448d2b89b1813; });
$parcel$export(module.exports, "f", function () { return $8c023e653ef8da49$export$2d1720544b23b823; });
$parcel$export(module.exports, "v", function () { return $8c023e653ef8da49$export$90a7f3efeed30595; });
$parcel$export(module.exports, "S", function () { return $8c023e653ef8da49$export$25ce5a424b770e84; });
$parcel$export(module.exports, "T", function () { return $8c023e653ef8da49$export$971d5caa766a69d7; });
$parcel$export(module.exports, "aa", function () { return $8c023e653ef8da49$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "V", function () { return $8c023e653ef8da49$export$e7c866399fa523f5; });
$parcel$export(module.exports, "a4", function () { return $8c023e653ef8da49$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "a3", function () { return $8c023e653ef8da49$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "B", function () { return $8c023e653ef8da49$export$ef35774e6d314e91; });
$parcel$export(module.exports, "Y", function () { return $8c023e653ef8da49$export$8743009a87fcb00f; });
$parcel$export(module.exports, "ac", function () { return $8c023e653ef8da49$export$2219238a014317b0; });
$parcel$export(module.exports, "C", function () { return $8c023e653ef8da49$export$e7094788287c5e9b; });
$parcel$export(module.exports, "ct", function () { return $8c023e653ef8da49$export$e9316ff9106cdb75; });
$parcel$export(module.exports, "b", function () { return $8c023e653ef8da49$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "o", function () { return $8c023e653ef8da49$export$ae1af26003f05816; });
$parcel$export(module.exports, "b9", function () { return $8c023e653ef8da49$export$4ae495d48253603d; });
$parcel$export(module.exports, "H", function () { return $8c023e653ef8da49$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "az", function () { return $8c023e653ef8da49$export$3d12bd131bb975d1; });
$parcel$export(module.exports, "aA", function () { return $8c023e653ef8da49$export$91c6e00c14e7e6fd; });
$parcel$export(module.exports, "J", function () { return $8c023e653ef8da49$export$b4171a6734a65d42; });
$parcel$export(module.exports, "G", function () { return $8c023e653ef8da49$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "a8", function () { return $8c023e653ef8da49$export$c3950d9923825c02; });
$parcel$export(module.exports, "U", function () { return $8c023e653ef8da49$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "aj", function () { return $8c023e653ef8da49$export$3b513254972cfc9c; });
$parcel$export(module.exports, "al", function () { return $8c023e653ef8da49$export$ab83b03e4111b1d0; });
$parcel$export(module.exports, "ak", function () { return $8c023e653ef8da49$export$21579262ef46735b; });
$parcel$export(module.exports, "W", function () { return $8c023e653ef8da49$export$71cec2538cb2c617; });
$parcel$export(module.exports, "I", function () { return $8c023e653ef8da49$export$9bb611d729802a56; });
$parcel$export(module.exports, "aW", function () { return $8c023e653ef8da49$export$9d0e2d13d04f7070; });
$parcel$export(module.exports, "aV", function () { return $8c023e653ef8da49$export$1ee57be6f6687d2c; });
$parcel$export(module.exports, "p", function () { return $8c023e653ef8da49$export$ffb5f4729a158638; });
$parcel$export(module.exports, "j", function () { return $8c023e653ef8da49$export$35e795649ee09318; });
$parcel$export(module.exports, "K", function () { return $8c023e653ef8da49$export$3466f893ebf79586; });
$parcel$export(module.exports, "L", function () { return $8c023e653ef8da49$export$61196ced6d74a310; });
$parcel$export(module.exports, "F", function () { return $8c023e653ef8da49$export$d66501df72047452; });
$parcel$export(module.exports, "X", function () { return $8c023e653ef8da49$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "cu", function () { return $8c023e653ef8da49$export$9ddbdd0bfc5623a; });
$parcel$export(module.exports, "cv", function () { return $8c023e653ef8da49$export$1776704b6532a19a; });
$parcel$export(module.exports, "bX", function () { return $8c023e653ef8da49$export$6d1e945284085e64; });
$parcel$export(module.exports, "a0", function () { return $8c023e653ef8da49$export$34aec0b863436764; });
$parcel$export(module.exports, "w", function () { return $8c023e653ef8da49$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "af", function () { return $8c023e653ef8da49$export$c9170ad7d4cd7e57; });
$parcel$export(module.exports, "bP", function () { return $8c023e653ef8da49$export$a91cd623adc48128; });
$parcel$export(module.exports, "_", function () { return $8c023e653ef8da49$export$71511d61b312f219; });
$parcel$export(module.exports, "bR", function () { return $8c023e653ef8da49$export$4d522598b426bb73; });
$parcel$export(module.exports, "bQ", function () { return $8c023e653ef8da49$export$993a080e5cb62d74; });
$parcel$export(module.exports, "bS", function () { return $8c023e653ef8da49$export$6dabbe08653f866f; });
$parcel$export(module.exports, "bT", function () { return $8c023e653ef8da49$export$1314441b8d04e1d5; });
$parcel$export(module.exports, "bU", function () { return $8c023e653ef8da49$export$e0c3a065614c6254; });
$parcel$export(module.exports, "bf", function () { return $8c023e653ef8da49$export$151db275011178c4; });
$parcel$export(module.exports, "l", function () { return $8c023e653ef8da49$export$882b5998b3b9117c; });
$parcel$export(module.exports, "u", function () { return $8c023e653ef8da49$export$3b14a55fb2447963; });
$parcel$export(module.exports, "r", function () { return $8c023e653ef8da49$export$43caf9889c228507; });
$parcel$export(module.exports, "ab", function () { return $8c023e653ef8da49$export$555508cbc6add439; });
$parcel$export(module.exports, "Z", function () { return $8c023e653ef8da49$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "a6", function () { return $8c023e653ef8da49$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "bG", function () { return $8c023e653ef8da49$export$aff10ba49ece4b91; });
$parcel$export(module.exports, "a7", function () { return $8c023e653ef8da49$export$a93c5207d687da10; });
$parcel$export(module.exports, "a9", function () { return $8c023e653ef8da49$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "aF", function () { return $8c023e653ef8da49$export$cf2f7c5792f80b46; });
$parcel$export(module.exports, "aE", function () { return $8c023e653ef8da49$export$158acd800e1ef08b; });
$parcel$export(module.exports, "aG", function () { return $8c023e653ef8da49$export$53a70dd1ebbae346; });
$parcel$export(module.exports, "aH", function () { return $8c023e653ef8da49$export$a33b77bbdbb8366c; });
$parcel$export(module.exports, "aI", function () { return $8c023e653ef8da49$export$b9a6b53f9be3734; });
$parcel$export(module.exports, "aY", function () { return $8c023e653ef8da49$export$e171bab687b50e0; });
$parcel$export(module.exports, "a_", function () { return $8c023e653ef8da49$export$a17c37559e1db147; });
$parcel$export(module.exports, "aZ", function () { return $8c023e653ef8da49$export$527e9aa3390079e9; });
$parcel$export(module.exports, "b0", function () { return $8c023e653ef8da49$export$8c78c7c36408ea29; });
$parcel$export(module.exports, "b3", function () { return $8c023e653ef8da49$export$53c86fa97d611818; });
$parcel$export(module.exports, "b6", function () { return $8c023e653ef8da49$export$c18d01048907ea92; });
$parcel$export(module.exports, "b5", function () { return $8c023e653ef8da49$export$7a0bdf7d4a91ea88; });
$parcel$export(module.exports, "ba", function () { return $8c023e653ef8da49$export$7060da4b5db56fb9; });
$parcel$export(module.exports, "bb", function () { return $8c023e653ef8da49$export$c5d1328b37d47994; });
$parcel$export(module.exports, "bc", function () { return $8c023e653ef8da49$export$d22783b3c2400a3a; });
$parcel$export(module.exports, "bd", function () { return $8c023e653ef8da49$export$7f557e5eb95176c2; });
$parcel$export(module.exports, "be", function () { return $8c023e653ef8da49$export$51b138e5a065c2bb; });
$parcel$export(module.exports, "bA", function () { return $8c023e653ef8da49$export$2e63b696b2c9441b; });
$parcel$export(module.exports, "bF", function () { return $8c023e653ef8da49$export$b2bcef12bcefba04; });
$parcel$export(module.exports, "bB", function () { return $8c023e653ef8da49$export$eb84e45a33f6ba7c; });
$parcel$export(module.exports, "bD", function () { return $8c023e653ef8da49$export$b0165a7e514844; });
$parcel$export(module.exports, "bC", function () { return $8c023e653ef8da49$export$d76842aa27385215; });
$parcel$export(module.exports, "bE", function () { return $8c023e653ef8da49$export$381353cf1dd55255; });
$parcel$export(module.exports, "bH", function () { return $8c023e653ef8da49$export$60bb826a6acf3081; });
$parcel$export(module.exports, "bI", function () { return $8c023e653ef8da49$export$27d1aff6bea49709; });
$parcel$export(module.exports, "bJ", function () { return $8c023e653ef8da49$export$1abb261478089fe6; });
$parcel$export(module.exports, "ch", function () { return $8c023e653ef8da49$export$6e4b1d19c6e2e012; });
$parcel$export(module.exports, "bK", function () { return $8c023e653ef8da49$export$ebc5e65867841cbe; });
$parcel$export(module.exports, "bO", function () { return $8c023e653ef8da49$export$2538633961795d6b; });
$parcel$export(module.exports, "bV", function () { return $8c023e653ef8da49$export$dabba94403d45c8e; });
$parcel$export(module.exports, "bW", function () { return $8c023e653ef8da49$export$6b179bb11f7fd3a0; });
$parcel$export(module.exports, "bZ", function () { return $8c023e653ef8da49$export$c667925124dac624; });
$parcel$export(module.exports, "b_", function () { return $8c023e653ef8da49$export$c69d65aa55814164; });
$parcel$export(module.exports, "cd", function () { return $8c023e653ef8da49$export$807f1ba34db587c7; });
$parcel$export(module.exports, "cf", function () { return $8c023e653ef8da49$export$49e6ee724f7f1ace; });
$parcel$export(module.exports, "ca", function () { return $8c023e653ef8da49$export$89e9012e902952b6; });
$parcel$export(module.exports, "cc", function () { return $8c023e653ef8da49$export$a1edd97dd51cd48d; });
$parcel$export(module.exports, "cb", function () { return $8c023e653ef8da49$export$54c4fabc2291e9c0; });
$parcel$export(module.exports, "b$", function () { return $8c023e653ef8da49$export$add49c223b9ce4ea; });
$parcel$export(module.exports, "cn", function () { return $8c023e653ef8da49$export$1343a74baacb0543; });
$parcel$export(module.exports, "cj", function () { return $8c023e653ef8da49$export$d92db8a7dc823bb0; });
$parcel$export(module.exports, "ck", function () { return $8c023e653ef8da49$export$c1df809846363ebe; });
$parcel$export(module.exports, "cl", function () { return $8c023e653ef8da49$export$b975d55abac2bbe3; });
$parcel$export(module.exports, "cm", function () { return $8c023e653ef8da49$export$b02498c06ddfef28; });
$parcel$export(module.exports, "cp", function () { return $8c023e653ef8da49$export$cd571ca6d1702b73; });
$parcel$export(module.exports, "co", function () { return $8c023e653ef8da49$export$87b6ab1c2cb8b955; });
$parcel$export(module.exports, "cq", function () { return $8c023e653ef8da49$export$a3c9165b94390bcd; });
$parcel$export(module.exports, "cr", function () { return $8c023e653ef8da49$export$cbfbec548517f2b6; });
$parcel$export(module.exports, "cs", function () { return $8c023e653ef8da49$export$bde1ed0f60b38f2f; });

var $1K4o4 = parcelRequire("1K4o4");

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $8EGc6 = parcelRequire("8EGc6");

var $dACZV = parcelRequire("dACZV");

var $5TLNx = parcelRequire("5TLNx");

var $5TJQB = parcelRequire("5TJQB");

var $9CX8V = parcelRequire("9CX8V");

var $jhb1H = parcelRequire("jhb1H");

var $kgSvt = parcelRequire("kgSvt");

var $8p1MK = parcelRequire("8p1MK");
var $8c023e653ef8da49$var$styleTexts = [];
var $8c023e653ef8da49$var$styleEls = new Map();
function $8c023e653ef8da49$export$c373adc892eb6355(styleText) {
    $8c023e653ef8da49$var$styleTexts.push(styleText);
    $8c023e653ef8da49$var$styleEls.forEach(function(styleEl) {
        $8c023e653ef8da49$var$appendStylesTo(styleEl, styleText);
    });
}
function $8c023e653ef8da49$export$4c3d22f3d993c33f(el) {
    if (el.isConnected) $8c023e653ef8da49$var$registerStylesRoot(el.getRootNode());
}
function $8c023e653ef8da49$var$registerStylesRoot(rootNode) {
    var styleEl = $8c023e653ef8da49$var$styleEls.get(rootNode);
    if (!styleEl || !styleEl.isConnected) {
        styleEl = rootNode.querySelector("style[data-fullcalendar]");
        if (!styleEl) {
            styleEl = document.createElement("style");
            styleEl.setAttribute("data-fullcalendar", "");
            var nonce = $8c023e653ef8da49$var$getNonceValue();
            if (nonce) styleEl.nonce = nonce;
            var parentEl = rootNode === document ? document.head : rootNode;
            var insertBefore = rootNode === document ? parentEl.querySelector("script,link[rel=stylesheet],link[as=style],style") : parentEl.firstChild;
            parentEl.insertBefore(styleEl, insertBefore);
        }
        $8c023e653ef8da49$var$styleEls.set(rootNode, styleEl);
        $8c023e653ef8da49$var$hydrateStylesRoot(styleEl);
    }
}
function $8c023e653ef8da49$var$hydrateStylesRoot(styleEl) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $8c023e653ef8da49$var$styleTexts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var styleText = _step.value;
            $8c023e653ef8da49$var$appendStylesTo(styleEl, styleText);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $8c023e653ef8da49$var$appendStylesTo(styleEl, styleText) {
    var sheet = styleEl.sheet;
    var ruleCnt = sheet.cssRules.length;
    styleText.split("}").forEach(function(styleStr, i) {
        styleStr = styleStr.trim();
        if (styleStr) sheet.insertRule(styleStr + "}", ruleCnt + i);
    });
}
// nonce
// -------------------------------------------------------------------------------------------------
var $8c023e653ef8da49$var$queriedNonceValue;
function $8c023e653ef8da49$var$getNonceValue() {
    if ($8c023e653ef8da49$var$queriedNonceValue === undefined) $8c023e653ef8da49$var$queriedNonceValue = $8c023e653ef8da49$var$queryNonceValue();
    return $8c023e653ef8da49$var$queriedNonceValue;
}
/*
TODO: discourage meta tag and instead put nonce attribute on placeholder <style> tag
*/ function $8c023e653ef8da49$var$queryNonceValue() {
    var metaWithNonce = document.querySelector('meta[name="csp-nonce"]');
    if (metaWithNonce && metaWithNonce.hasAttribute("content")) return metaWithNonce.getAttribute("content");
    var elWithNonce = document.querySelector("script[nonce]");
    if (elWithNonce) return elWithNonce.nonce || "";
    return "";
}
// main
// -------------------------------------------------------------------------------------------------
if (typeof document !== "undefined") $8c023e653ef8da49$var$registerStylesRoot(document);
var $8c023e653ef8da49$var$css_248z = ':root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url("data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMg8SBfAAAAC8AAAAYGNtYXAXVtKNAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5ZgYydxIAAAF4AAAFNGhlYWQUJ7cIAAAGrAAAADZoaGVhB20DzAAABuQAAAAkaG10eCIABhQAAAcIAAAALGxvY2ED4AU6AAAHNAAAABhtYXhwAA8AjAAAB0wAAAAgbmFtZXsr690AAAdsAAABhnBvc3QAAwAAAAAI9AAAACAAAwPAAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADpBgPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6Qb//f//AAAAAAAg6QD//f//AAH/4xcEAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAWIAjQKeAskAEwAAJSc3NjQnJiIHAQYUFwEWMjc2NCcCnuLiDQ0MJAz/AA0NAQAMJAwNDcni4gwjDQwM/wANIwz/AA0NDCMNAAAAAQFiAI0CngLJABMAACUBNjQnASYiBwYUHwEHBhQXFjI3AZ4BAA0N/wAMJAwNDeLiDQ0MJAyNAQAMIw0BAAwMDSMM4uINIwwNDQAAAAIA4gC3Ax4CngATACcAACUnNzY0JyYiDwEGFB8BFjI3NjQnISc3NjQnJiIPAQYUHwEWMjc2NCcB87e3DQ0MIw3VDQ3VDSMMDQ0BK7e3DQ0MJAzVDQ3VDCQMDQ3zuLcMJAwNDdUNIwzWDAwNIwy4twwkDA0N1Q0jDNYMDA0jDAAAAgDiALcDHgKeABMAJwAAJTc2NC8BJiIHBhQfAQcGFBcWMjchNzY0LwEmIgcGFB8BBwYUFxYyNwJJ1Q0N1Q0jDA0Nt7cNDQwjDf7V1Q0N1QwkDA0Nt7cNDQwkDLfWDCMN1Q0NDCQMt7gMIw0MDNYMIw3VDQ0MJAy3uAwjDQwMAAADAFUAAAOrA1UAMwBoAHcAABMiBgcOAQcOAQcOARURFBYXHgEXHgEXHgEzITI2Nz4BNz4BNz4BNRE0JicuAScuAScuASMFITIWFx4BFx4BFx4BFREUBgcOAQcOAQcOASMhIiYnLgEnLgEnLgE1ETQ2Nz4BNz4BNz4BMxMhMjY1NCYjISIGFRQWM9UNGAwLFQkJDgUFBQUFBQ4JCRULDBgNAlYNGAwLFQkJDgUFBQUFBQ4JCRULDBgN/aoCVgQIBAQHAwMFAQIBAQIBBQMDBwQECAT9qgQIBAQHAwMFAQIBAQIBBQMDBwQECASAAVYRGRkR/qoRGRkRA1UFBAUOCQkVDAsZDf2rDRkLDBUJCA4FBQUFBQUOCQgVDAsZDQJVDRkLDBUJCQ4FBAVVAgECBQMCBwQECAX9qwQJAwQHAwMFAQICAgIBBQMDBwQDCQQCVQUIBAQHAgMFAgEC/oAZEhEZGRESGQAAAAADAFUAAAOrA1UAMwBoAIkAABMiBgcOAQcOAQcOARURFBYXHgEXHgEXHgEzITI2Nz4BNz4BNz4BNRE0JicuAScuAScuASMFITIWFx4BFx4BFx4BFREUBgcOAQcOAQcOASMhIiYnLgEnLgEnLgE1ETQ2Nz4BNz4BNz4BMxMzFRQWMzI2PQEzMjY1NCYrATU0JiMiBh0BIyIGFRQWM9UNGAwLFQkJDgUFBQUFBQ4JCRULDBgNAlYNGAwLFQkJDgUFBQUFBQ4JCRULDBgN/aoCVgQIBAQHAwMFAQIBAQIBBQMDBwQECAT9qgQIBAQHAwMFAQIBAQIBBQMDBwQECASAgBkSEhmAERkZEYAZEhIZgBEZGREDVQUEBQ4JCRUMCxkN/asNGQsMFQkIDgUFBQUFBQ4JCBUMCxkNAlUNGQsMFQkJDgUEBVUCAQIFAwIHBAQIBf2rBAkDBAcDAwUBAgICAgEFAwMHBAMJBAJVBQgEBAcCAwUCAQL+gIASGRkSgBkSERmAEhkZEoAZERIZAAABAOIAjQMeAskAIAAAExcHBhQXFjI/ARcWMjc2NC8BNzY0JyYiDwEnJiIHBhQX4uLiDQ0MJAzi4gwkDA0N4uINDQwkDOLiDCQMDQ0CjeLiDSMMDQ3h4Q0NDCMN4uIMIw0MDOLiDAwNIwwAAAABAAAAAQAAa5n0y18PPPUACwQAAAAAANivOVsAAAAA2K85WwAAAAADqwNVAAAACAACAAAAAAAAAAEAAAPA/8AAAAQAAAAAAAOrAAEAAAAAAAAAAAAAAAAAAAALBAAAAAAAAAAAAAAAAgAAAAQAAWIEAAFiBAAA4gQAAOIEAABVBAAAVQQAAOIAAAAAAAoAFAAeAEQAagCqAOoBngJkApoAAQAAAAsAigADAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAA4ArgABAAAAAAABAAcAAAABAAAAAAACAAcAYAABAAAAAAADAAcANgABAAAAAAAEAAcAdQABAAAAAAAFAAsAFQABAAAAAAAGAAcASwABAAAAAAAKABoAigADAAEECQABAA4ABwADAAEECQACAA4AZwADAAEECQADAA4APQADAAEECQAEAA4AfAADAAEECQAFABYAIAADAAEECQAGAA4AUgADAAEECQAKADQApGZjaWNvbnMAZgBjAGkAYwBvAG4Ac1ZlcnNpb24gMS4wAFYAZQByAHMAaQBvAG4AIAAxAC4AMGZjaWNvbnMAZgBjAGkAYwBvAG4Ac2ZjaWNvbnMAZgBjAGkAYwBvAG4Ac1JlZ3VsYXIAUgBlAGcAdQBsAGEAcmZjaWNvbnMAZgBjAGkAYwBvAG4Ac0ZvbnQgZ2VuZXJhdGVkIGJ5IEljb01vb24uAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgAAAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=") format("truetype")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:"\\e900"}.fc-icon-chevron-right:before{content:"\\e901"}.fc-icon-chevrons-left:before{content:"\\e902"}.fc-icon-chevrons-right:before{content:"\\e903"}.fc-icon-minus-square:before{content:"\\e904"}.fc-icon-plus-square:before{content:"\\e905"}.fc-icon-x:before{content:"\\e906"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:"";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:"";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:"";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}';
$8c023e653ef8da49$export$c373adc892eb6355($8c023e653ef8da49$var$css_248z);
var $8c023e653ef8da49$export$96f57966bedc81b4 = /*#__PURE__*/ function() {
    "use strict";
    function DelayedRunner(drainedOption) {
        (0, $5kWiG._)(this, DelayedRunner);
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
    (0, $hHaEF._)(DelayedRunner, [
        {
            key: "request",
            value: function request(delay) {
                this.isDirty = true;
                if (!this.isPaused()) {
                    this.clearTimeout();
                    if (delay == null) this.tryDrain();
                    else this.timeoutId = setTimeout(this.tryDrain.bind(this), delay);
                }
            }
        },
        {
            key: "pause",
            value: function pause() {
                var scope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                var pauseDepths = this.pauseDepths;
                pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
                this.clearTimeout();
            }
        },
        {
            key: "resume",
            value: function resume() {
                var scope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", force = arguments.length > 1 ? arguments[1] : void 0;
                var pauseDepths = this.pauseDepths;
                if (scope in pauseDepths) {
                    if (force) delete pauseDepths[scope];
                    else {
                        pauseDepths[scope] -= 1;
                        var depth = pauseDepths[scope];
                        if (depth <= 0) delete pauseDepths[scope];
                    }
                    this.tryDrain();
                }
            }
        },
        {
            key: "isPaused",
            value: function isPaused() {
                return Object.keys(this.pauseDepths).length;
            }
        },
        {
            key: "tryDrain",
            value: function tryDrain() {
                if (!this.isRunning && !this.isPaused()) {
                    this.isRunning = true;
                    while(this.isDirty){
                        this.isDirty = false;
                        this.drained(); // might set isDirty to true again
                    }
                    this.isRunning = false;
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.clearTimeout();
                this.isDirty = false;
                this.pauseDepths = {};
            }
        },
        {
            key: "clearTimeout",
            value: function clearTimeout1() {
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                    this.timeoutId = 0;
                }
            }
        },
        {
            key: "drained",
            value: function drained() {
                if (this.drainedOption) this.drainedOption();
            }
        }
    ]);
    return DelayedRunner;
}();
function $8c023e653ef8da49$export$c03999cb2f36933f(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function $8c023e653ef8da49$export$3d8c2f653ac9d0b9(el, selector) {
    if (el.closest) return el.closest(selector);
    if (!document.documentElement.contains(el)) return null;
    do {
        if ($8c023e653ef8da49$export$f96d196f7728bb5(el, selector)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $8c023e653ef8da49$export$f96d196f7728bb5(el, selector) {
    var method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function $8c023e653ef8da49$export$9f4f30ee63539e24(container, selector) {
    var containers = container instanceof HTMLElement ? [
        container
    ] : container;
    var allMatches = [];
    for(var i = 0; i < containers.length; i += 1){
        var matches = containers[i].querySelectorAll(selector);
        for(var j = 0; j < matches.length; j += 1)allMatches.push(matches[j]);
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function $8c023e653ef8da49$export$faec65b429be379(parent, selector) {
    var parents = parent instanceof HTMLElement ? [
        parent
    ] : parent;
    var allMatches = [];
    for(var i = 0; i < parents.length; i += 1){
        var childNodes = parents[i].children; // only ever elements
        for(var j = 0; j < childNodes.length; j += 1){
            var childNode = childNodes[j];
            if (!selector || $8c023e653ef8da49$export$f96d196f7728bb5(childNode, selector)) allMatches.push(childNode);
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
var $8c023e653ef8da49$var$PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function $8c023e653ef8da49$export$2ed0fc6709e59212(el, props) {
    for(var propName in props)$8c023e653ef8da49$export$f787f51d84a910ad(el, propName, props[propName]);
}
function $8c023e653ef8da49$export$f787f51d84a910ad(el, name, val) {
    if (val == null) el.style[name] = "";
    else if (typeof val === "number" && $8c023e653ef8da49$var$PIXEL_PROP_RE.test(name)) el.style[name] = "".concat(val, "px");
    else el.style[name] = val;
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function $8c023e653ef8da49$export$738ab4df8bf92ae9(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Unique ID for DOM attribute
var $8c023e653ef8da49$var$guid$1 = 0;
function $8c023e653ef8da49$export$a8550f7dbe79f93a() {
    $8c023e653ef8da49$var$guid$1 += 1;
    return "fc-dom-" + $8c023e653ef8da49$var$guid$1;
}
// Stops a mouse/touch event from doing it's native browser action
function $8c023e653ef8da49$export$d29e374196577086(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function $8c023e653ef8da49$var$buildDelegationHandler(selector, handler) {
    return function(ev) {
        var matchedChild = $8c023e653ef8da49$export$3d8c2f653ac9d0b9(ev.target, selector);
        if (matchedChild) handler.call(matchedChild, ev, matchedChild);
    };
}
function $8c023e653ef8da49$export$3c2fa207a37baaea(container, eventType, selector, handler) {
    var attachedHandler = $8c023e653ef8da49$var$buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return function() {
        container.removeEventListener(eventType, attachedHandler);
    };
}
function $8c023e653ef8da49$export$ce26c07117d59d6a(container, selector, onMouseEnter, onMouseLeave) {
    var currentMatchedChild;
    return $8c023e653ef8da49$export$3c2fa207a37baaea(container, "mouseover", selector, function(mouseOverEv, matchedChild) {
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            var realOnMouseLeave = function(mouseLeaveEv) {
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener("mouseleave", realOnMouseLeave);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener("mouseleave", realOnMouseLeave);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
var $8c023e653ef8da49$var$transitionEventNames = [
    "webkitTransitionEnd",
    "otransitionend",
    "oTransitionEnd",
    "msTransitionEnd",
    "transitionend"
];
// triggered only when the next single subsequent transition finishes
function $8c023e653ef8da49$export$2ec5befb9e6c97d4(el, callback) {
    var realCallback = function(ev) {
        callback(ev);
        $8c023e653ef8da49$var$transitionEventNames.forEach(function(eventName) {
            el.removeEventListener(eventName, realCallback);
        });
    };
    $8c023e653ef8da49$var$transitionEventNames.forEach(function(eventName) {
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
// ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------
function $8c023e653ef8da49$var$createAriaClickAttrs(handler) {
    return Object.assign({
        onClick: handler
    }, $8c023e653ef8da49$var$createAriaKeyboardAttrs(handler));
}
function $8c023e653ef8da49$var$createAriaKeyboardAttrs(handler) {
    return {
        tabIndex: 0,
        onKeyDown: function(ev) {
            if (ev.key === "Enter" || ev.key === " ") {
                handler(ev);
                ev.preventDefault(); // if space, don't scroll down page
            }
        }
    };
}
var $8c023e653ef8da49$var$guidNumber = 0;
function $8c023e653ef8da49$export$39b482c5e57630a8() {
    $8c023e653ef8da49$var$guidNumber += 1;
    return String($8c023e653ef8da49$var$guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/ // Make the mouse cursor express that an event is not allowed in the current area
function $8c023e653ef8da49$export$9fa96a7d116ea3ce() {
    document.body.classList.add("fc-not-allowed");
}
// Returns the mouse cursor to its original look
function $8c023e653ef8da49$export$92108d983e8ee699() {
    document.body.classList.remove("fc-not-allowed");
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/ function $8c023e653ef8da49$export$d24c54395ce0c509(el) {
    el.style.userSelect = "none";
    el.style.webkitUserSelect = "none";
    el.addEventListener("selectstart", $8c023e653ef8da49$export$d29e374196577086);
}
function $8c023e653ef8da49$export$6554612db691658e(el) {
    el.style.userSelect = "";
    el.style.webkitUserSelect = "";
    el.removeEventListener("selectstart", $8c023e653ef8da49$export$d29e374196577086);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/ function $8c023e653ef8da49$export$493d36ec626b6698(el) {
    el.addEventListener("contextmenu", $8c023e653ef8da49$export$d29e374196577086);
}
function $8c023e653ef8da49$export$1fbe638ecf81657e(el) {
    el.removeEventListener("contextmenu", $8c023e653ef8da49$export$d29e374196577086);
}
function $8c023e653ef8da49$export$7a38258bbe170828(input) {
    var specs = [];
    var tokens = [];
    var i;
    var token;
    if (typeof input === "string") tokens = input.split(/\s*,\s*/);
    else if (typeof input === "function") tokens = [
        input
    ];
    else if (Array.isArray(input)) tokens = input;
    for(i = 0; i < tokens.length; i += 1){
        token = tokens[i];
        if (typeof token === "string") specs.push(token.charAt(0) === "-" ? {
            field: token.substring(1),
            order: -1
        } : {
            field: token,
            order: 1
        });
        else if (typeof token === "function") specs.push({
            func: token
        });
    }
    return specs;
}
function $8c023e653ef8da49$export$2f6ca3d3b1f80bf5(obj0, obj1, fieldSpecs) {
    var i;
    var cmp;
    for(i = 0; i < fieldSpecs.length; i += 1){
        cmp = $8c023e653ef8da49$var$compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) return cmp;
    }
    return 0;
}
function $8c023e653ef8da49$var$compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) return fieldSpec.func(obj0, obj1);
    return $8c023e653ef8da49$export$8a5498727ef6be21(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
}
function $8c023e653ef8da49$export$8a5498727ef6be21(a, b) {
    if (!a && !b) return 0;
    if (b == null) return -1;
    if (a == null) return 1;
    if (typeof a === "string" || typeof b === "string") return String(a).localeCompare(String(b));
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $8c023e653ef8da49$export$1a82df3d29112e01(val, len) {
    var s = String(val);
    return "000".substr(0, len - s.length) + s;
}
function $8c023e653ef8da49$export$342063e11d6c3cad(formatter, args, fallbackText) {
    if (typeof formatter === "function") return formatter.apply(void 0, (0, $5TJQB._)(args));
    if (typeof formatter === "string") return args.reduce(function(str, arg, index) {
        return str.replace("$" + index, arg || "");
    }, formatter);
    return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $8c023e653ef8da49$export$d66dc83d8cfc8dd(a, b) {
    return a - b;
}
function $8c023e653ef8da49$export$306ddfe3a8403e2(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/ function $8c023e653ef8da49$var$computeSmallestCellWidth(cellEl) {
    var allWidthEl = cellEl.querySelector(".fc-scrollgrid-shrink-frame");
    var contentWidthEl = cellEl.querySelector(".fc-scrollgrid-shrink-cushion");
    if (!allWidthEl) throw new Error("needs fc-scrollgrid-shrink-frame className"); // TODO: use const
    if (!contentWidthEl) throw new Error("needs fc-scrollgrid-shrink-cushion className");
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
    contentWidthEl.getBoundingClientRect().width;
}
var $8c023e653ef8da49$var$INTERNAL_UNITS = [
    "years",
    "months",
    "days",
    "milliseconds"
];
var $8c023e653ef8da49$var$PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function $8c023e653ef8da49$export$4368d992c4eafac0(input, unit) {
    if (typeof input === "string") return $8c023e653ef8da49$var$parseString(input);
    if (typeof input === "object" && input) return $8c023e653ef8da49$var$parseObject(input);
    if (typeof input === "number") return $8c023e653ef8da49$var$parseObject((0, $8EGc6._)({}, unit || "milliseconds", input));
    return null;
}
function $8c023e653ef8da49$var$parseString(s) {
    var m = $8c023e653ef8da49$var$PARSE_RE.exec(s);
    if (m) {
        var sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 3600000 + // hours
            (m[4] ? parseInt(m[4], 10) : 0) * 60000 + // minutes
            (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
            (m[6] ? parseInt(m[6], 10) : 0 // ms
            ))
        };
    }
    return null;
}
function $8c023e653ef8da49$var$parseObject(obj) {
    var duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 3600000 + // hours
        (obj.minutes || obj.minute || 0) * 60000 + // minutes
        (obj.seconds || obj.second || 0) * 1000 + // seconds
        (obj.milliseconds || obj.millisecond || obj.ms || 0)
    };
    var weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function $8c023e653ef8da49$var$durationsEqual(d0, d1) {
    return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
}
function $8c023e653ef8da49$export$acf3ba20e47771d(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) return dur.days;
    return 0;
}
// Simple Math
function $8c023e653ef8da49$export$b169257caa88022a(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds
    };
}
function $8c023e653ef8da49$export$2408f22a0fab9ae5(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds
    };
}
function $8c023e653ef8da49$export$847533e5bf524f5f(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function $8c023e653ef8da49$var$asRoughYears(dur) {
    return $8c023e653ef8da49$var$asRoughDays(dur) / 365;
}
function $8c023e653ef8da49$var$asRoughMonths(dur) {
    return $8c023e653ef8da49$var$asRoughDays(dur) / 30;
}
function $8c023e653ef8da49$var$asRoughDays(dur) {
    return $8c023e653ef8da49$export$4e222d082f82ee97(dur) / 864e5;
}
function $8c023e653ef8da49$export$4b170465d7badfa1(dur) {
    return $8c023e653ef8da49$export$4e222d082f82ee97(dur) / 60000;
}
function $8c023e653ef8da49$export$479ac0420f53ed26(dur) {
    return $8c023e653ef8da49$export$4e222d082f82ee97(dur) / 1000;
}
function $8c023e653ef8da49$export$4e222d082f82ee97(dur) {
    return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
}
// Advanced Math
function $8c023e653ef8da49$export$56350196709588fc(numerator, denominator) {
    var res = null;
    for(var i = 0; i < $8c023e653ef8da49$var$INTERNAL_UNITS.length; i += 1){
        var unit = $8c023e653ef8da49$var$INTERNAL_UNITS[i];
        if (denominator[unit]) {
            var localRes = numerator[unit] / denominator[unit];
            if (!$8c023e653ef8da49$export$306ddfe3a8403e2(localRes) || res !== null && res !== localRes) return null;
            res = localRes;
        } else if (numerator[unit]) // needs to divide by something but can't!
        return null;
    }
    return res;
}
function $8c023e653ef8da49$export$db3b6bfb95261072(dur) {
    var ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) return {
            unit: "millisecond",
            value: ms
        };
        if (ms % 60000 !== 0) return {
            unit: "second",
            value: ms / 1000
        };
        if (ms % 3600000 !== 0) return {
            unit: "minute",
            value: ms / 60000
        };
        if (ms) return {
            unit: "hour",
            value: ms / 3600000
        };
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) return {
            unit: "week",
            value: dur.days / 7
        };
        return {
            unit: "day",
            value: dur.days
        };
    }
    if (dur.months) return {
        unit: "month",
        value: dur.months
    };
    if (dur.years) return {
        unit: "year",
        value: dur.years
    };
    return {
        unit: "millisecond",
        value: 0
    };
}
// TODO: new util arrayify?
function $8c023e653ef8da49$export$9d398bebfec1c039(array, exactVal) {
    var removeCnt = 0;
    var i = 0;
    while(i < array.length)if (array[i] === exactVal) {
        array.splice(i, 1);
        removeCnt += 1;
    } else i += 1;
    return removeCnt;
}
function $8c023e653ef8da49$export$23f2a1d2818174ef(a0, a1, equalityFunc) {
    if (a0 === a1) return true;
    var len = a0.length;
    var i;
    if (len !== a1.length) return false;
    for(i = 0; i < len; i += 1){
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) return false;
    }
    return true;
}
var $8c023e653ef8da49$var$DAY_IDS = [
    "sun",
    "mon",
    "tue",
    "wed",
    "thu",
    "fri",
    "sat"
];
// Adding
function $8c023e653ef8da49$export$31e67cf12fc9668(m, n) {
    var a = $8c023e653ef8da49$var$dateToUtcArray(m);
    a[2] += n * 7;
    return $8c023e653ef8da49$var$arrayToUtcDate(a);
}
function $8c023e653ef8da49$export$625550452a3fa3ec(m, n) {
    var a = $8c023e653ef8da49$var$dateToUtcArray(m);
    a[2] += n;
    return $8c023e653ef8da49$var$arrayToUtcDate(a);
}
function $8c023e653ef8da49$export$136fd86de524d3c2(m, n) {
    var a = $8c023e653ef8da49$var$dateToUtcArray(m);
    a[6] += n;
    return $8c023e653ef8da49$var$arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function $8c023e653ef8da49$export$62d08d6fa708df47(m0, m1) {
    return $8c023e653ef8da49$export$a36fb7d24305ed9d(m0, m1) / 7;
}
function $8c023e653ef8da49$export$a36fb7d24305ed9d(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 86400000;
}
function $8c023e653ef8da49$var$diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 3600000;
}
function $8c023e653ef8da49$var$diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 60000;
}
function $8c023e653ef8da49$var$diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function $8c023e653ef8da49$export$5521614468b862fb(m0, m1) {
    var m0day = $8c023e653ef8da49$export$9e5f44173e64f162(m0);
    var m1day = $8c023e653ef8da49$export$9e5f44173e64f162(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round($8c023e653ef8da49$export$a36fb7d24305ed9d(m0day, m1day)),
        milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
    };
}
// Diffing Whole Units
function $8c023e653ef8da49$export$b4d5ecaefe2b27f3(m0, m1) {
    var d = $8c023e653ef8da49$export$4a5767248b18ef41(m0, m1);
    if (d !== null && d % 7 === 0) return d / 7;
    return null;
}
function $8c023e653ef8da49$export$4a5767248b18ef41(m0, m1) {
    if ($8c023e653ef8da49$var$timeAsMs(m0) === $8c023e653ef8da49$var$timeAsMs(m1)) return Math.round($8c023e653ef8da49$export$a36fb7d24305ed9d(m0, m1));
    return null;
}
// Start-Of
function $8c023e653ef8da49$export$9e5f44173e64f162(m) {
    return $8c023e653ef8da49$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate()
    ]);
}
function $8c023e653ef8da49$var$startOfHour(m) {
    return $8c023e653ef8da49$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours()
    ]);
}
function $8c023e653ef8da49$var$startOfMinute(m) {
    return $8c023e653ef8da49$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes()
    ]);
}
function $8c023e653ef8da49$var$startOfSecond(m) {
    return $8c023e653ef8da49$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds()
    ]);
}
// Week Computation
function $8c023e653ef8da49$var$weekOfYear(marker, dow, doy) {
    var y = marker.getUTCFullYear();
    var w = $8c023e653ef8da49$var$weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) return $8c023e653ef8da49$var$weekOfGivenYear(marker, y - 1, dow, doy);
    var nextW = $8c023e653ef8da49$var$weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) return Math.min(w, nextW);
    return w;
}
function $8c023e653ef8da49$var$weekOfGivenYear(marker, year, dow, doy) {
    var firstWeekStart = $8c023e653ef8da49$var$arrayToUtcDate([
        year,
        0,
        1 + $8c023e653ef8da49$var$firstWeekOffset(year, dow, doy)
    ]);
    var dayStart = $8c023e653ef8da49$export$9e5f44173e64f162(marker);
    var days = Math.round($8c023e653ef8da49$export$a36fb7d24305ed9d(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function $8c023e653ef8da49$var$firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    var fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    var fwdlw = (7 + $8c023e653ef8da49$var$arrayToUtcDate([
        year,
        0,
        fwd
    ]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function $8c023e653ef8da49$var$dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ];
}
function $8c023e653ef8da49$var$arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], a[3] || 0, a[4] || 0, a[5] || 0);
}
function $8c023e653ef8da49$var$dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ];
}
function $8c023e653ef8da49$var$arrayToUtcDate(a) {
    var _Date;
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) a = a.concat([
        0
    ]);
    return new Date((_Date = Date).UTC.apply(_Date, (0, $5TJQB._)(a)));
}
// Other Utils
function $8c023e653ef8da49$export$55ff3cc1821e8445(m) {
    return !isNaN(m.valueOf());
}
function $8c023e653ef8da49$var$timeAsMs(m) {
    return m.getUTCHours() * 3600000 + m.getUTCMinutes() * 60000 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
}
// timeZoneOffset is in minutes
function $8c023e653ef8da49$export$45d219bdcd8ac53c(marker, timeZoneOffset) {
    var stripZeroTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var s = marker.toISOString();
    s = s.replace(".000", "");
    if (stripZeroTime) s = s.replace("T00:00:00Z", "");
    if (s.length > 10) {
        if (timeZoneOffset == null) s = s.replace("Z", "");
        else if (timeZoneOffset !== 0) s = s.replace("Z", $8c023e653ef8da49$var$formatTimeZoneOffset(timeZoneOffset, true));
    // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function $8c023e653ef8da49$export$5dbe06c6d8c68cfb(marker) {
    return marker.toISOString().replace(/T.*$/, "");
}
function $8c023e653ef8da49$export$26a0a7676ca7aa04(marker) {
    return marker.toISOString().match(/^\d{4}-\d{2}/)[0];
}
// TODO: use Date::toISOString and use everything after the T?
function $8c023e653ef8da49$export$f438b12253c2b499(marker) {
    return $8c023e653ef8da49$export$1a82df3d29112e01(marker.getUTCHours(), 2) + ":" + $8c023e653ef8da49$export$1a82df3d29112e01(marker.getUTCMinutes(), 2) + ":" + $8c023e653ef8da49$export$1a82df3d29112e01(marker.getUTCSeconds(), 2);
}
function $8c023e653ef8da49$var$formatTimeZoneOffset(minutes) {
    var doIso = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var sign = minutes < 0 ? "-" : "+";
    var abs = Math.abs(minutes);
    var hours = Math.floor(abs / 60);
    var mins = Math.round(abs % 60);
    if (doIso) return "".concat(sign + $8c023e653ef8da49$export$1a82df3d29112e01(hours, 2), ":").concat($8c023e653ef8da49$export$1a82df3d29112e01(mins, 2));
    return "GMT".concat(sign).concat(hours).concat(mins ? ":".concat($8c023e653ef8da49$export$1a82df3d29112e01(mins, 2)) : "");
}
function $8c023e653ef8da49$export$df995fae86a55f06(workerFunc, resEquality, teardownFunc) {
    var currentArgs;
    var currentRes;
    return function() {
        for(var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++){
            newArgs[_key] = arguments[_key];
        }
        if (!currentArgs) currentRes = workerFunc.apply(this, newArgs);
        else if (!$8c023e653ef8da49$export$23f2a1d2818174ef(currentArgs, newArgs)) {
            if (teardownFunc) teardownFunc(currentRes);
            var res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function $8c023e653ef8da49$export$ebd11618f299a286(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArg;
    var currentRes;
    return function(newArg) {
        if (!currentArg) currentRes = workerFunc.call(_this, newArg);
        else if (!$8c023e653ef8da49$export$a9c23c6ac3fc3eca(currentArg, newArg)) {
            if (teardownFunc) teardownFunc(currentRes);
            var res = workerFunc.call(_this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArg = newArg;
        return currentRes;
    };
}
function $8c023e653ef8da49$export$890c4ad488842ce7(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArgSets = [];
    var currentResults = [];
    return function(newArgSets) {
        var currentLen = currentArgSets.length;
        var newLen = newArgSets.length;
        var i = 0;
        for(; i < currentLen; i += 1){
            if (!newArgSets[i]) {
                if (teardownFunc) teardownFunc(currentResults[i]);
            } else if (!$8c023e653ef8da49$export$23f2a1d2818174ef(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) teardownFunc(currentResults[i]);
                var res = workerFunc.apply(_this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) currentResults[i] = res;
            }
        }
        for(; i < newLen; i += 1)currentResults[i] = workerFunc.apply(_this, newArgSets[i]);
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function $8c023e653ef8da49$export$24baa2b76016ce0e(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArgHash = {};
    var currentResHash = {};
    return function(newArgHash) {
        var newResHash = {};
        for(var key in newArgHash){
            if (!currentResHash[key]) newResHash[key] = workerFunc.apply(_this, newArgHash[key]);
            else if (!$8c023e653ef8da49$export$23f2a1d2818174ef(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) teardownFunc(currentResHash[key]);
                var res = workerFunc.apply(_this, newArgHash[key]);
                newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
            } else newResHash[key] = currentResHash[key];
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}
var $8c023e653ef8da49$var$EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 0,
    omitZeroMinute: 0,
    meridiem: 0,
    omitCommas: 0
};
var $8c023e653ef8da49$var$STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1
};
var $8c023e653ef8da49$var$MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
var $8c023e653ef8da49$var$COMMA_RE = /,/g; // we need re for globalness
var $8c023e653ef8da49$var$MULTI_SPACE_RE = /\s+/g;
var $8c023e653ef8da49$var$LTR_RE = /\u200e/g; // control character
var $8c023e653ef8da49$var$UTC_RE = /UTC|GMT/;
var $8c023e653ef8da49$var$NativeFormatter = /*#__PURE__*/ function() {
    "use strict";
    function NativeFormatter(formatSettings) {
        (0, $5kWiG._)(this, NativeFormatter);
        var standardDateProps = {};
        var extendedSettings = {};
        var severity = 0;
        for(var name in formatSettings)if (name in $8c023e653ef8da49$var$EXTENDED_SETTINGS_AND_SEVERITIES) {
            extendedSettings[name] = formatSettings[name];
            severity = Math.max($8c023e653ef8da49$var$EXTENDED_SETTINGS_AND_SEVERITIES[name], severity);
        } else {
            standardDateProps[name] = formatSettings[name];
            if (name in $8c023e653ef8da49$var$STANDARD_DATE_PROP_SEVERITIES) severity = Math.max($8c023e653ef8da49$var$STANDARD_DATE_PROP_SEVERITIES[name], severity);
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.severity = severity;
        this.buildFormattingFunc = $8c023e653ef8da49$export$df995fae86a55f06($8c023e653ef8da49$var$buildFormattingFunc);
    }
    (0, $hHaEF._)(NativeFormatter, [
        {
            key: "format",
            value: function format(date, context) {
                return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
            }
        },
        {
            key: "formatRange",
            value: function formatRange(start, end, context, betterDefaultSeparator) {
                var _this = this, standardDateProps = _this.standardDateProps, extendedSettings = _this.extendedSettings;
                var diffSeverity = $8c023e653ef8da49$var$computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
                if (!diffSeverity) return this.format(start, context);
                var biggestUnitForPartial = diffSeverity;
                if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
                (standardDateProps.year === "numeric" || standardDateProps.year === "2-digit") && (standardDateProps.month === "numeric" || standardDateProps.month === "2-digit") && (standardDateProps.day === "numeric" || standardDateProps.day === "2-digit")) biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
                var full0 = this.format(start, context);
                var full1 = this.format(end, context);
                if (full0 === full1) return full0;
                var partialDateProps = $8c023e653ef8da49$var$computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
                var partialFormattingFunc = $8c023e653ef8da49$var$buildFormattingFunc(partialDateProps, extendedSettings, context);
                var partial0 = partialFormattingFunc(start);
                var partial1 = partialFormattingFunc(end);
                var insertion = $8c023e653ef8da49$var$findCommonInsertion(full0, partial0, full1, partial1);
                var separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || "";
                if (insertion) return insertion.before + partial0 + separator + partial1 + insertion.after;
                return full0 + separator + full1;
            }
        },
        {
            key: "getLargestUnit",
            value: function getLargestUnit() {
                switch(this.severity){
                    case 7:
                    case 6:
                    case 5:
                        return "year";
                    case 4:
                        return "month";
                    case 3:
                        return "week";
                    case 2:
                        return "day";
                    default:
                        return "time"; // really?
                }
            }
        }
    ]);
    return NativeFormatter;
}();
function $8c023e653ef8da49$var$buildFormattingFunc(standardDateProps, extendedSettings, context) {
    var standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === "short") return function(date) {
        return $8c023e653ef8da49$var$formatTimeZoneOffset(date.timeZoneOffset);
    };
    if (standardDatePropCnt === 0 && extendedSettings.week) return function(date) {
        return $8c023e653ef8da49$var$formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
    };
    return $8c023e653ef8da49$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function $8c023e653ef8da49$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = Object.assign({}, standardDateProps); // copy
    extendedSettings = Object.assign({}, extendedSettings); // copy
    $8c023e653ef8da49$var$sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = "UTC"; // we leverage the only guaranteed timeZone for our UTC markers
    var normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    var zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        var zeroProps = Object.assign({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return function(date) {
        var marker = date.marker;
        var format;
        if (zeroFormat && !marker.getUTCMinutes()) format = zeroFormat;
        else format = normalFormat;
        var s = format.format(marker);
        return $8c023e653ef8da49$var$postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function $8c023e653ef8da49$var$sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) standardDateProps.hour = "2-digit";
        if (!standardDateProps.minute) standardDateProps.minute = "2-digit";
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === "long") standardDateProps.timeZoneName = "short";
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) delete extendedSettings.omitZeroMinute;
}
function $8c023e653ef8da49$var$postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace($8c023e653ef8da49$var$LTR_RE, ""); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === "short") s = $8c023e653ef8da49$var$injectTzoStr(s, context.timeZone === "UTC" || date.timeZoneOffset == null ? "UTC" : $8c023e653ef8da49$var$formatTimeZoneOffset(date.timeZoneOffset));
    if (extendedSettings.omitCommas) s = s.replace($8c023e653ef8da49$var$COMMA_RE, "").trim();
    if (extendedSettings.omitZeroMinute) s = s.replace(":00", ""); // zeroFormat doesn't always achieve this
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) s = s.replace($8c023e653ef8da49$var$MERIDIEM_RE, "").trim();
    else if (extendedSettings.meridiem === "narrow") s = s.replace($8c023e653ef8da49$var$MERIDIEM_RE, function(m0, m1) {
        return m1.toLocaleLowerCase();
    });
    else if (extendedSettings.meridiem === "short") s = s.replace($8c023e653ef8da49$var$MERIDIEM_RE, function(m0, m1) {
        return "".concat(m1.toLocaleLowerCase(), "m");
    });
    else if (extendedSettings.meridiem === "lowercase") s = s.replace($8c023e653ef8da49$var$MERIDIEM_RE, function(m0) {
        return m0.toLocaleLowerCase();
    });
    s = s.replace($8c023e653ef8da49$var$MULTI_SPACE_RE, " ");
    s = s.trim();
    return s;
}
function $8c023e653ef8da49$var$injectTzoStr(s, tzoStr) {
    var replaced = false;
    s = s.replace($8c023e653ef8da49$var$UTC_RE, function() {
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) s += " ".concat(tzoStr);
    return s;
}
function $8c023e653ef8da49$var$formatWeekNumber(num, weekText, weekTextLong, locale, display) {
    var parts = [];
    if (display === "long") parts.push(weekTextLong);
    else if (display === "short" || display === "narrow") parts.push(weekText);
    if (display === "long" || display === "short") parts.push(" ");
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === "rtl") parts.reverse();
    return parts.join("");
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function $8c023e653ef8da49$var$computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) return 5;
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) return 4;
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) return 2;
    if ($8c023e653ef8da49$var$timeAsMs(d0) !== $8c023e653ef8da49$var$timeAsMs(d1)) return 1;
    return 0;
}
function $8c023e653ef8da49$var$computePartialFormattingOptions(options, biggestUnit) {
    var partialOptions = {};
    for(var name in options)if (!(name in $8c023e653ef8da49$var$STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
    $8c023e653ef8da49$var$STANDARD_DATE_PROP_SEVERITIES[name] <= biggestUnit) partialOptions[name] = options[name];
    return partialOptions;
}
function $8c023e653ef8da49$var$findCommonInsertion(full0, partial0, full1, partial1) {
    var i0 = 0;
    while(i0 < full0.length){
        var found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) break;
        var before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        var after0 = full0.substr(i0);
        var i1 = 0;
        while(i1 < full1.length){
            var found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) break;
            var before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            var after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) return {
                before: before0,
                after: after0
            };
        }
    }
    return null;
}
function $8c023e653ef8da49$var$expandZonedMarker(dateInfo, calendarSystem) {
    var a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6]
    };
}
function $8c023e653ef8da49$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    var startInfo = $8c023e653ef8da49$var$expandZonedMarker(start, context.calendarSystem);
    var endInfo = end ? $8c023e653ef8da49$var$expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator
    };
}
/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/ /*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/ var $8c023e653ef8da49$var$CmdFormatter = /*#__PURE__*/ function() {
    "use strict";
    function CmdFormatter(cmdStr) {
        (0, $5kWiG._)(this, CmdFormatter);
        this.cmdStr = cmdStr;
    }
    (0, $hHaEF._)(CmdFormatter, [
        {
            key: "format",
            value: function format(date, context, betterDefaultSeparator) {
                return context.cmdFormatter(this.cmdStr, $8c023e653ef8da49$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
            }
        },
        {
            key: "formatRange",
            value: function formatRange(start, end, context, betterDefaultSeparator) {
                return context.cmdFormatter(this.cmdStr, $8c023e653ef8da49$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
            }
        }
    ]);
    return CmdFormatter;
}();
var $8c023e653ef8da49$var$FuncFormatter = /*#__PURE__*/ function() {
    "use strict";
    function FuncFormatter(func) {
        (0, $5kWiG._)(this, FuncFormatter);
        this.func = func;
    }
    (0, $hHaEF._)(FuncFormatter, [
        {
            key: "format",
            value: function format(date, context, betterDefaultSeparator) {
                return this.func($8c023e653ef8da49$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
            }
        },
        {
            key: "formatRange",
            value: function formatRange(start, end, context, betterDefaultSeparator) {
                return this.func($8c023e653ef8da49$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
            }
        }
    ]);
    return FuncFormatter;
}();
function $8c023e653ef8da49$export$d141bba7fdc215a3(input) {
    if (typeof input === "object" && input) return new $8c023e653ef8da49$var$NativeFormatter(input);
    if (typeof input === "string") return new $8c023e653ef8da49$var$CmdFormatter(input);
    if (typeof input === "function") return new $8c023e653ef8da49$var$FuncFormatter(input);
    return null;
}
// base options
// ------------
var $8c023e653ef8da49$export$a07804094c3ecf2d = {
    navLinkDayClick: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    navLinkWeekClick: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    duration: $8c023e653ef8da49$export$4368d992c4eafac0,
    bootstrapFontAwesome: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    buttonIcons: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    customButtons: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    defaultAllDayEventDuration: $8c023e653ef8da49$export$4368d992c4eafac0,
    defaultTimedEventDuration: $8c023e653ef8da49$export$4368d992c4eafac0,
    nextDayThreshold: $8c023e653ef8da49$export$4368d992c4eafac0,
    scrollTime: $8c023e653ef8da49$export$4368d992c4eafac0,
    scrollTimeReset: Boolean,
    slotMinTime: $8c023e653ef8da49$export$4368d992c4eafac0,
    slotMaxTime: $8c023e653ef8da49$export$4368d992c4eafac0,
    dayPopoverFormat: $8c023e653ef8da49$export$d141bba7fdc215a3,
    slotDuration: $8c023e653ef8da49$export$4368d992c4eafac0,
    snapDuration: $8c023e653ef8da49$export$4368d992c4eafac0,
    headerToolbar: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    footerToolbar: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: $8c023e653ef8da49$export$d141bba7fdc215a3,
    dayHeaderClassNames: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    dayHeaderContent: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    dayHeaderDidMount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    dayHeaderWillUnmount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    dayCellClassNames: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    dayCellContent: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    dayCellDidMount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    dayCellWillUnmount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    weekNumbers: Boolean,
    weekNumberClassNames: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    weekNumberContent: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    weekNumberDidMount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    weekNumberWillUnmount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    editable: Boolean,
    viewClassNames: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    viewDidMount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    viewWillUnmount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    nowIndicator: Boolean,
    nowIndicatorClassNames: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    nowIndicatorContent: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    nowIndicatorDidMount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    nowIndicatorWillUnmount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    locale: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventOrder: $8c023e653ef8da49$export$7a38258bbe170828,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    contentHeight: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    direction: String,
    weekNumberFormat: $8c023e653ef8da49$export$d141bba7fdc215a3,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    weekTextLong: String,
    progressiveEventRendering: Boolean,
    businessHours: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    initialDate: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    now: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    stickyHeaderDates: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    stickyFooterScrollbar: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    viewHeight: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    defaultAllDay: Boolean,
    eventSourceFailure: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventSourceSuccess: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventConstraint: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventAllow: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventContent: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventDidMount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventWillUnmount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    selectConstraint: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    selectOverlap: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    selectAllow: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    slotLaneClassNames: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    slotLaneContent: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    slotLaneDidMount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    slotLaneWillUnmount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    slotLabelClassNames: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    slotLabelContent: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    slotLabelDidMount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    slotLabelWillUnmount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    dayMaxEvents: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    dayMaxEventRows: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    dayMinWidth: Number,
    slotLabelInterval: $8c023e653ef8da49$export$4368d992c4eafac0,
    allDayText: String,
    allDayClassNames: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    allDayContent: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    allDayDidMount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    allDayWillUnmount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: $8c023e653ef8da49$export$d141bba7fdc215a3,
    rerenderDelay: Number,
    moreLinkText: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    moreLinkHint: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: $8c023e653ef8da49$export$4368d992c4eafac0,
    hiddenDays: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    fixedWeekCount: Boolean,
    validRange: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    visibleRange: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    titleFormat: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventInteractive: Boolean,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    viewHint: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    navLinkHint: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    closeHint: String,
    timeHint: String,
    eventHint: String,
    moreLinkClick: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    moreLinkClassNames: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    moreLinkContent: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    moreLinkDidMount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    moreLinkWillUnmount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    monthStartFormat: $8c023e653ef8da49$export$d141bba7fdc215a3,
    // for connectors
    // (can't be part of plugin system b/c must be provided at runtime)
    handleCustomRendering: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    customRenderingMetaMap: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
var $8c023e653ef8da49$export$f1e1789686576879 = {
    eventDisplay: "auto",
    defaultRangeSeparator: " - ",
    titleRangeSeparator: " \u2013 ",
    defaultTimedEventDuration: "01:00:00",
    defaultAllDayEventDuration: {
        day: 1
    },
    forceEventDuration: false,
    nextDayThreshold: "00:00:00",
    dayHeaders: true,
    initialView: "",
    aspectRatio: 1.35,
    headerToolbar: {
        start: "title",
        center: "",
        end: "today prev,next"
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: "local",
    editable: false,
    nowIndicator: false,
    scrollTime: "06:00:00",
    scrollTimeReset: true,
    slotMinTime: "00:00:00",
    slotMaxTime: "24:00:00",
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: "start",
    endParam: "end",
    timeZoneParam: "timeZone",
    timeZone: "local",
    locales: [],
    locale: "",
    themeSystem: "standard",
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: "*",
    eventOrder: "start,-duration,allDay,title",
    dayPopoverFormat: {
        month: "long",
        day: "numeric",
        year: "numeric"
    },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30,
    monthStartFormat: {
        month: "long",
        day: "numeric"
    }
};
// calendar listeners
// ------------------
var $8c023e653ef8da49$export$c4ce752e73470fba = {
    datesSet: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventsSet: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventAdd: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventChange: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventRemove: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    windowResize: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventClick: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventMouseEnter: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventMouseLeave: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    select: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    unselect: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    loading: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    // internal
    _unmount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    _beforeprint: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    _afterprint: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    _noEventDrop: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    _noEventResize: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    _resize: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    _scrollRequest: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5
};
// calendar-specific options
// -------------------------
var $8c023e653ef8da49$export$56c0d5a1e737357d = {
    buttonText: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    buttonHints: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    views: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    plugins: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    initialEvents: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    events: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventSources: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5
};
var $8c023e653ef8da49$export$3722cfe417b6ed86 = (0, $8EGc6._)({
    headerToolbar: $8c023e653ef8da49$var$isMaybeObjectsEqual,
    footerToolbar: $8c023e653ef8da49$var$isMaybeObjectsEqual,
    buttonText: $8c023e653ef8da49$var$isMaybeObjectsEqual,
    buttonHints: $8c023e653ef8da49$var$isMaybeObjectsEqual,
    buttonIcons: $8c023e653ef8da49$var$isMaybeObjectsEqual,
    dateIncrement: $8c023e653ef8da49$var$isMaybeObjectsEqual,
    plugins: $8c023e653ef8da49$var$isMaybeArraysEqual,
    events: $8c023e653ef8da49$var$isMaybeArraysEqual,
    eventSources: $8c023e653ef8da49$var$isMaybeArraysEqual
}, "resources", $8c023e653ef8da49$var$isMaybeArraysEqual);
function $8c023e653ef8da49$var$isMaybeObjectsEqual(a, b) {
    if (typeof a === "object" && typeof b === "object" && a && b) return $8c023e653ef8da49$export$a9c23c6ac3fc3eca(a, b);
    return a === b;
}
function $8c023e653ef8da49$var$isMaybeArraysEqual(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return $8c023e653ef8da49$export$23f2a1d2818174ef(a, b);
    return a === b;
}
// view-specific options
// ---------------------
var $8c023e653ef8da49$export$db202ddc8be9136 = {
    type: String,
    component: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    usesMinMaxTime: Boolean,
    classNames: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    content: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    didMount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    willUnmount: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function $8c023e653ef8da49$export$3a1a48c8f6ef640e(optionSets) {
    return $8c023e653ef8da49$export$953cecd6e717a553(optionSets, $8c023e653ef8da49$export$3722cfe417b6ed86);
}
function $8c023e653ef8da49$export$f38c853ae54ed474(input, refiners) {
    var refined = {};
    var extra = {};
    for(var propName in refiners)if (propName in input) refined[propName] = refiners[propName](input[propName]);
    for(var propName1 in input)if (!(propName1 in refiners)) extra[propName1] = input[propName1];
    return {
        refined: refined,
        extra: extra
    };
}
function $8c023e653ef8da49$export$7ccc53e8f1e7dfc5(raw) {
    return raw;
}
var $8c023e653ef8da49$var$hasOwnProperty = Object.prototype.hasOwnProperty;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function $8c023e653ef8da49$export$953cecd6e717a553(propObjs, complexPropsMap) {
    var dest = {};
    if (complexPropsMap) {
        for(var name in complexPropsMap)if (complexPropsMap[name] === $8c023e653ef8da49$var$isMaybeObjectsEqual) {
            var complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for(var i = propObjs.length - 1; i >= 0; i -= 1){
                var val = propObjs[i][name];
                if (typeof val === "object" && val) complexObjs.unshift(val);
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) dest[name] = $8c023e653ef8da49$export$953cecd6e717a553(complexObjs);
        }
    }
    // copy values into the destination, going from last to first
    for(var i1 = propObjs.length - 1; i1 >= 0; i1 -= 1){
        var props = propObjs[i1];
        for(var name1 in props)if (!(name1 in dest)) dest[name1] = props[name1];
    }
    return dest;
}
function $8c023e653ef8da49$export$dda1d9f60106f0e9(hash, func) {
    var filtered = {};
    for(var key in hash)if (func(hash[key], key)) filtered[key] = hash[key];
    return filtered;
}
function $8c023e653ef8da49$export$407448d2b89b1813(hash, func) {
    var newHash = {};
    for(var key in hash)newHash[key] = func(hash[key], key);
    return newHash;
}
function $8c023e653ef8da49$export$2d1720544b23b823(a) {
    var hash = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            hash[item] = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return hash;
}
// TODO: reassess browser support
// https://caniuse.com/?search=object.values
function $8c023e653ef8da49$export$90a7f3efeed30595(obj) {
    var a = [];
    for(var key in obj)a.push(obj[key]);
    return a;
}
function $8c023e653ef8da49$export$a9c23c6ac3fc3eca(obj0, obj1) {
    if (obj0 === obj1) return true;
    for(var key in obj0)if ($8c023e653ef8da49$var$hasOwnProperty.call(obj0, key)) {
        if (!(key in obj1)) return false;
    }
    for(var key1 in obj1)if ($8c023e653ef8da49$var$hasOwnProperty.call(obj1, key1)) {
        if (obj0[key1] !== obj1[key1]) return false;
    }
    return true;
}
var $8c023e653ef8da49$var$HANDLER_RE = /^on[A-Z]/;
function $8c023e653ef8da49$var$isNonHandlerPropsEqual(obj0, obj1) {
    var keys = $8c023e653ef8da49$var$getUnequalProps(obj0, obj1);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!$8c023e653ef8da49$var$HANDLER_RE.test(key)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $8c023e653ef8da49$var$getUnequalProps(obj0, obj1) {
    var keys = [];
    for(var key in obj0){
        if ($8c023e653ef8da49$var$hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) keys.push(key);
        }
    }
    for(var key1 in obj1){
        if ($8c023e653ef8da49$var$hasOwnProperty.call(obj1, key1)) {
            if (obj0[key1] !== obj1[key1]) keys.push(key1);
        }
    }
    return keys;
}
function $8c023e653ef8da49$export$23ebac1979863676(oldProps, newProps) {
    var equalityFuncs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (oldProps === newProps) return true;
    for(var key in newProps){
        if (key in oldProps && $8c023e653ef8da49$var$isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else return false;
    }
    // check for props that were omitted in the new
    for(var key1 in oldProps){
        if (!(key1 in newProps)) return false;
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/ function $8c023e653ef8da49$var$isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) return true;
    if (comparator) return comparator(val0, val1);
    return false;
}
function $8c023e653ef8da49$export$91477dc880baac21(hash) {
    var startIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, endIndex = arguments.length > 2 ? arguments[2] : void 0, step = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    var res = [];
    if (endIndex == null) endIndex = Object.keys(hash).length;
    for(var i = startIndex; i < endIndex; i += step){
        var val = hash[i];
        if (val !== undefined) res.push(val);
    }
    return res;
}
var $8c023e653ef8da49$var$calendarSystemClassMap = {};
function $8c023e653ef8da49$var$registerCalendarSystem(name, theClass) {
    $8c023e653ef8da49$var$calendarSystemClassMap[name] = theClass;
}
function $8c023e653ef8da49$var$createCalendarSystem(name) {
    return new $8c023e653ef8da49$var$calendarSystemClassMap[name]();
}
var $8c023e653ef8da49$var$GregorianCalendarSystem = /*#__PURE__*/ function() {
    "use strict";
    function GregorianCalendarSystem() {
        (0, $5kWiG._)(this, GregorianCalendarSystem);
    }
    (0, $hHaEF._)(GregorianCalendarSystem, [
        {
            key: "getMarkerYear",
            value: function getMarkerYear(d) {
                return d.getUTCFullYear();
            }
        },
        {
            key: "getMarkerMonth",
            value: function getMarkerMonth(d) {
                return d.getUTCMonth();
            }
        },
        {
            key: "getMarkerDay",
            value: function getMarkerDay(d) {
                return d.getUTCDate();
            }
        },
        {
            key: "arrayToMarker",
            value: function arrayToMarker(arr) {
                return $8c023e653ef8da49$var$arrayToUtcDate(arr);
            }
        },
        {
            key: "markerToArray",
            value: function markerToArray(marker) {
                return $8c023e653ef8da49$var$dateToUtcArray(marker);
            }
        }
    ]);
    return GregorianCalendarSystem;
}();
$8c023e653ef8da49$var$registerCalendarSystem("gregory", $8c023e653ef8da49$var$GregorianCalendarSystem);
var $8c023e653ef8da49$var$ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function $8c023e653ef8da49$export$674f8f4247a5112e(str) {
    var m = $8c023e653ef8da49$var$ISO_RE.exec(str);
    if (m) {
        var marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number("0.".concat(m[12])) * 1000 : 0));
        if ($8c023e653ef8da49$export$55ff3cc1821e8445(marker)) {
            var timeZoneOffset = null;
            if (m[13]) timeZoneOffset = (m[15] === "-" ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
            return {
                marker: marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset: timeZoneOffset
            };
        }
    }
    return null;
}
var $8c023e653ef8da49$export$25ce5a424b770e84 = /*#__PURE__*/ function() {
    "use strict";
    function DateEnv(settings) {
        (0, $5kWiG._)(this, DateEnv);
        var timeZone = this.timeZone = settings.timeZone;
        var isNamedTimeZone = timeZone !== "local" && timeZone !== "UTC";
        if (settings.namedTimeZoneImpl && isNamedTimeZone) this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = $8c023e653ef8da49$var$createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === "ISO") {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === "number") this.weekDow = settings.firstDay;
        if (typeof settings.weekNumberCalculation === "function") this.weekNumberFunc = settings.weekNumberCalculation;
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
    (0, $hHaEF._)(DateEnv, [
        {
            // Creating / Parsing
            key: "createMarker",
            value: function createMarker(input) {
                var meta = this.createMarkerMeta(input);
                if (meta === null) return null;
                return meta.marker;
            }
        },
        {
            key: "createNowMarker",
            value: function createNowMarker() {
                if (this.canComputeOffset) return this.timestampToMarker(new Date().valueOf());
                // if we can't compute the current date val for a timezone,
                // better to give the current local date vals than UTC
                return $8c023e653ef8da49$var$arrayToUtcDate($8c023e653ef8da49$var$dateToLocalArray(new Date()));
            }
        },
        {
            key: "createMarkerMeta",
            value: function createMarkerMeta(input) {
                if (typeof input === "string") return this.parse(input);
                var marker = null;
                if (typeof input === "number") marker = this.timestampToMarker(input);
                else if (input instanceof Date) {
                    input = input.valueOf();
                    if (!isNaN(input)) marker = this.timestampToMarker(input);
                } else if (Array.isArray(input)) marker = $8c023e653ef8da49$var$arrayToUtcDate(input);
                if (marker === null || !$8c023e653ef8da49$export$55ff3cc1821e8445(marker)) return null;
                return {
                    marker: marker,
                    isTimeUnspecified: false,
                    forcedTzo: null
                };
            }
        },
        {
            key: "parse",
            value: function parse1(s) {
                var parts = $8c023e653ef8da49$export$674f8f4247a5112e(s);
                if (parts === null) return null;
                var marker = parts.marker;
                var forcedTzo = null;
                if (parts.timeZoneOffset !== null) {
                    if (this.canComputeOffset) marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60000);
                    else forcedTzo = parts.timeZoneOffset;
                }
                return {
                    marker: marker,
                    isTimeUnspecified: parts.isTimeUnspecified,
                    forcedTzo: forcedTzo
                };
            }
        },
        {
            // Accessors
            key: "getYear",
            value: function getYear(marker) {
                return this.calendarSystem.getMarkerYear(marker);
            }
        },
        {
            key: "getMonth",
            value: function getMonth(marker) {
                return this.calendarSystem.getMarkerMonth(marker);
            }
        },
        {
            key: "getDay",
            value: function getDay(marker) {
                return this.calendarSystem.getMarkerDay(marker);
            }
        },
        {
            // Adding / Subtracting
            key: "add",
            value: function add(marker, dur) {
                var a = this.calendarSystem.markerToArray(marker);
                a[0] += dur.years;
                a[1] += dur.months;
                a[2] += dur.days;
                a[6] += dur.milliseconds;
                return this.calendarSystem.arrayToMarker(a);
            }
        },
        {
            key: "subtract",
            value: function subtract(marker, dur) {
                var a = this.calendarSystem.markerToArray(marker);
                a[0] -= dur.years;
                a[1] -= dur.months;
                a[2] -= dur.days;
                a[6] -= dur.milliseconds;
                return this.calendarSystem.arrayToMarker(a);
            }
        },
        {
            key: "addYears",
            value: function addYears(marker, n) {
                var a = this.calendarSystem.markerToArray(marker);
                a[0] += n;
                return this.calendarSystem.arrayToMarker(a);
            }
        },
        {
            key: "addMonths",
            value: function addMonths(marker, n) {
                var a = this.calendarSystem.markerToArray(marker);
                a[1] += n;
                return this.calendarSystem.arrayToMarker(a);
            }
        },
        {
            // Diffing Whole Units
            key: "diffWholeYears",
            value: function diffWholeYears(m0, m1) {
                var calendarSystem = this.calendarSystem;
                if ($8c023e653ef8da49$var$timeAsMs(m0) === $8c023e653ef8da49$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
                return null;
            }
        },
        {
            key: "diffWholeMonths",
            value: function diffWholeMonths(m0, m1) {
                var calendarSystem = this.calendarSystem;
                if ($8c023e653ef8da49$var$timeAsMs(m0) === $8c023e653ef8da49$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
                return null;
            }
        },
        {
            // Range / Duration
            key: "greatestWholeUnit",
            value: function greatestWholeUnit(m0, m1) {
                var n = this.diffWholeYears(m0, m1);
                if (n !== null) return {
                    unit: "year",
                    value: n
                };
                n = this.diffWholeMonths(m0, m1);
                if (n !== null) return {
                    unit: "month",
                    value: n
                };
                n = $8c023e653ef8da49$export$b4d5ecaefe2b27f3(m0, m1);
                if (n !== null) return {
                    unit: "week",
                    value: n
                };
                n = $8c023e653ef8da49$export$4a5767248b18ef41(m0, m1);
                if (n !== null) return {
                    unit: "day",
                    value: n
                };
                n = $8c023e653ef8da49$var$diffHours(m0, m1);
                if ($8c023e653ef8da49$export$306ddfe3a8403e2(n)) return {
                    unit: "hour",
                    value: n
                };
                n = $8c023e653ef8da49$var$diffMinutes(m0, m1);
                if ($8c023e653ef8da49$export$306ddfe3a8403e2(n)) return {
                    unit: "minute",
                    value: n
                };
                n = $8c023e653ef8da49$var$diffSeconds(m0, m1);
                if ($8c023e653ef8da49$export$306ddfe3a8403e2(n)) return {
                    unit: "second",
                    value: n
                };
                return {
                    unit: "millisecond",
                    value: m1.valueOf() - m0.valueOf()
                };
            }
        },
        {
            key: "countDurationsBetween",
            value: function countDurationsBetween(m0, m1, d) {
                // TODO: can use greatestWholeUnit
                var diff;
                if (d.years) {
                    diff = this.diffWholeYears(m0, m1);
                    if (diff !== null) return diff / $8c023e653ef8da49$var$asRoughYears(d);
                }
                if (d.months) {
                    diff = this.diffWholeMonths(m0, m1);
                    if (diff !== null) return diff / $8c023e653ef8da49$var$asRoughMonths(d);
                }
                if (d.days) {
                    diff = $8c023e653ef8da49$export$4a5767248b18ef41(m0, m1);
                    if (diff !== null) return diff / $8c023e653ef8da49$var$asRoughDays(d);
                }
                return (m1.valueOf() - m0.valueOf()) / $8c023e653ef8da49$export$4e222d082f82ee97(d);
            }
        },
        {
            // Start-Of
            // these DON'T return zoned-dates. only UTC start-of dates
            key: "startOf",
            value: function startOf(m, unit) {
                if (unit === "year") return this.startOfYear(m);
                if (unit === "month") return this.startOfMonth(m);
                if (unit === "week") return this.startOfWeek(m);
                if (unit === "day") return $8c023e653ef8da49$export$9e5f44173e64f162(m);
                if (unit === "hour") return $8c023e653ef8da49$var$startOfHour(m);
                if (unit === "minute") return $8c023e653ef8da49$var$startOfMinute(m);
                if (unit === "second") return $8c023e653ef8da49$var$startOfSecond(m);
                return null;
            }
        },
        {
            key: "startOfYear",
            value: function startOfYear(m) {
                return this.calendarSystem.arrayToMarker([
                    this.calendarSystem.getMarkerYear(m)
                ]);
            }
        },
        {
            key: "startOfMonth",
            value: function startOfMonth(m) {
                return this.calendarSystem.arrayToMarker([
                    this.calendarSystem.getMarkerYear(m),
                    this.calendarSystem.getMarkerMonth(m)
                ]);
            }
        },
        {
            key: "startOfWeek",
            value: function startOfWeek(m) {
                return this.calendarSystem.arrayToMarker([
                    this.calendarSystem.getMarkerYear(m),
                    this.calendarSystem.getMarkerMonth(m),
                    m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7
                ]);
            }
        },
        {
            // Week Number
            key: "computeWeekNumber",
            value: function computeWeekNumber(marker) {
                if (this.weekNumberFunc) return this.weekNumberFunc(this.toDate(marker));
                return $8c023e653ef8da49$var$weekOfYear(marker, this.weekDow, this.weekDoy);
            }
        },
        {
            // TODO: choke on timeZoneName: long
            key: "format",
            value: function format(marker, formatter) {
                var dateOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return formatter.format({
                    marker: marker,
                    timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
                }, this);
            }
        },
        {
            key: "formatRange",
            value: function formatRange(start, end, formatter) {
                var dateOptions = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                if (dateOptions.isEndExclusive) end = $8c023e653ef8da49$export$136fd86de524d3c2(end, -1);
                return formatter.formatRange({
                    marker: start,
                    timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
                }, {
                    marker: end,
                    timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
                }, this, dateOptions.defaultSeparator);
            }
        },
        {
            /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */ key: "formatIso",
            value: function formatIso(marker) {
                var extraOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var timeZoneOffset = null;
                if (!extraOptions.omitTimeZoneOffset) {
                    if (extraOptions.forcedTzo != null) timeZoneOffset = extraOptions.forcedTzo;
                    else timeZoneOffset = this.offsetForMarker(marker);
                }
                return $8c023e653ef8da49$export$45d219bdcd8ac53c(marker, timeZoneOffset, extraOptions.omitTime);
            }
        },
        {
            // TimeZone
            key: "timestampToMarker",
            value: function timestampToMarker(ms) {
                if (this.timeZone === "local") return $8c023e653ef8da49$var$arrayToUtcDate($8c023e653ef8da49$var$dateToLocalArray(new Date(ms)));
                if (this.timeZone === "UTC" || !this.namedTimeZoneImpl) return new Date(ms);
                return $8c023e653ef8da49$var$arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
            }
        },
        {
            key: "offsetForMarker",
            value: function offsetForMarker(m) {
                if (this.timeZone === "local") return -$8c023e653ef8da49$var$arrayToLocalDate($8c023e653ef8da49$var$dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
                if (this.timeZone === "UTC") return 0;
                if (this.namedTimeZoneImpl) return this.namedTimeZoneImpl.offsetForArray($8c023e653ef8da49$var$dateToUtcArray(m));
                return null;
            }
        },
        {
            // Conversion
            key: "toDate",
            value: function toDate(m, forcedTzo) {
                if (this.timeZone === "local") return $8c023e653ef8da49$var$arrayToLocalDate($8c023e653ef8da49$var$dateToUtcArray(m));
                if (this.timeZone === "UTC") return new Date(m.valueOf()); // make sure it's a copy
                if (!this.namedTimeZoneImpl) return new Date(m.valueOf() - (forcedTzo || 0));
                return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray($8c023e653ef8da49$var$dateToUtcArray(m)) * 60000);
            }
        }
    ]);
    return DateEnv;
}();
var $8c023e653ef8da49$export$971d5caa766a69d7 = /*#__PURE__*/ function() {
    "use strict";
    function Theme(calendarOptions) {
        (0, $5kWiG._)(this, Theme);
        if (this.iconOverrideOption) this.setIconOverride(calendarOptions[this.iconOverrideOption]);
    }
    (0, $hHaEF._)(Theme, [
        {
            key: "setIconOverride",
            value: function setIconOverride(iconOverrideHash) {
                var iconClassesCopy;
                var buttonName;
                if (typeof iconOverrideHash === "object" && iconOverrideHash) {
                    iconClassesCopy = Object.assign({}, this.iconClasses);
                    for(buttonName in iconOverrideHash)iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
                    this.iconClasses = iconClassesCopy;
                } else if (iconOverrideHash === false) this.iconClasses = {};
            }
        },
        {
            key: "applyIconOverridePrefix",
            value: function applyIconOverridePrefix(className) {
                var prefix = this.iconOverridePrefix;
                if (prefix && className.indexOf(prefix) !== 0) className = prefix + className;
                return className;
            }
        },
        {
            key: "getClass",
            value: function getClass(key) {
                return this.classes[key] || "";
            }
        },
        {
            key: "getIconClass",
            value: function getIconClass(buttonName, isRtl) {
                var className;
                if (isRtl && this.rtlIconClasses) className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
                else className = this.iconClasses[buttonName];
                if (className) return "".concat(this.baseIconClass, " ").concat(className);
                return "";
            }
        },
        {
            key: "getCustomButtonIconClass",
            value: function getCustomButtonIconClass(customButtonProps) {
                var className;
                if (this.iconOverrideCustomButtonOption) {
                    className = customButtonProps[this.iconOverrideCustomButtonOption];
                    if (className) return "".concat(this.baseIconClass, " ").concat(this.applyIconOverridePrefix(className));
                }
                return "";
            }
        }
    ]);
    return Theme;
}();
$8c023e653ef8da49$export$971d5caa766a69d7.prototype.classes = {};
$8c023e653ef8da49$export$971d5caa766a69d7.prototype.iconClasses = {};
$8c023e653ef8da49$export$971d5caa766a69d7.prototype.baseIconClass = "";
$8c023e653ef8da49$export$971d5caa766a69d7.prototype.iconOverridePrefix = "";
/*
NOTE: this can be a public API, especially createElement for hooks.
See examples/typescript-scheduler/src/index.ts
*/ function $8c023e653ef8da49$export$7910e0436ed8d1de(runBeforeFlush) {
    runBeforeFlush();
    var oldDebounceRendering = $kgSvt.options.debounceRendering; // orig
    var callbackQ = [];
    function execCallbackSync(callback) {
        callbackQ.push(callback);
    }
    $kgSvt.options.debounceRendering = execCallbackSync;
    $kgSvt.render($kgSvt.createElement($8c023e653ef8da49$var$FakeComponent, {}), document.createElement("div"));
    while(callbackQ.length)callbackQ.shift()();
    $kgSvt.options.debounceRendering = oldDebounceRendering;
}
var $8c023e653ef8da49$var$FakeComponent = /*#__PURE__*/ function(_preact_Component) {
    "use strict";
    (0, $dACZV._)(FakeComponent, _preact_Component);
    var _super = (0, $jhb1H._)(FakeComponent);
    function FakeComponent() {
        (0, $5kWiG._)(this, FakeComponent);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(FakeComponent, [
        {
            key: "render",
            value: function render() {
                return $kgSvt.createElement("div", {});
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({});
            }
        }
    ]);
    return FakeComponent;
}($kgSvt.Component);
// TODO: use preact/compat instead?
function $8c023e653ef8da49$export$995eb9fca571757(defaultValue) {
    var ContextType = $kgSvt.createContext(defaultValue);
    var origProvider = ContextType.Provider;
    ContextType.Provider = function() {
        var _this = this;
        var isNew = !this.getChildContext;
        var children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params
        if (isNew) {
            var subs = [];
            this.shouldComponentUpdate = function(_props) {
                if (_this.props.value !== _props.value) subs.forEach(function(c) {
                    c.context = _props.value;
                    c.forceUpdate();
                });
            };
            this.sub = function(c) {
                subs.push(c);
                var old = c.componentWillUnmount;
                c.componentWillUnmount = function() {
                    subs.splice(subs.indexOf(c), 1);
                    old && old.call(c);
                };
            };
        }
        return children;
    };
    return ContextType;
}
var $8c023e653ef8da49$export$c5d7c1ac98841e53 = /*#__PURE__*/ function() {
    "use strict";
    function ScrollResponder(execFunc, emitter, scrollTime, scrollTimeReset) {
        var _this = this;
        (0, $5kWiG._)(this, ScrollResponder);
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = function(request) {
            _this.queuedRequest = Object.assign({}, _this.queuedRequest || {}, request);
            _this.drain();
        };
        emitter.on("_scrollRequest", this.handleScrollRequest);
        this.fireInitialScroll();
    }
    (0, $hHaEF._)(ScrollResponder, [
        {
            key: "detach",
            value: function detach() {
                this.emitter.off("_scrollRequest", this.handleScrollRequest);
            }
        },
        {
            key: "update",
            value: function update(isDatesNew) {
                if (isDatesNew && this.scrollTimeReset) this.fireInitialScroll(); // will drain
                else this.drain();
            }
        },
        {
            key: "fireInitialScroll",
            value: function fireInitialScroll() {
                this.handleScrollRequest({
                    time: this.scrollTime
                });
            }
        },
        {
            key: "drain",
            value: function drain() {
                if (this.queuedRequest && this.execFunc(this.queuedRequest)) this.queuedRequest = null;
            }
        }
    ]);
    return ScrollResponder;
}();
var $8c023e653ef8da49$export$e7c866399fa523f5 = $8c023e653ef8da49$export$995eb9fca571757({}); // for Components
function $8c023e653ef8da49$export$efca4cbe5dd06740(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv: dateEnv,
        options: viewOptions,
        pluginHooks: pluginHooks,
        emitter: emitter,
        dispatch: dispatch,
        getCurrentData: getCurrentData,
        calendarApi: calendarApi,
        viewSpec: viewSpec,
        viewApi: viewApi,
        dateProfileGenerator: dateProfileGenerator,
        theme: theme,
        isRtl: viewOptions.direction === "rtl",
        addResizeHandler: function(handler) {
            emitter.on("_resize", handler);
        },
        removeResizeHandler: function(handler) {
            emitter.off("_resize", handler);
        },
        createScrollResponder: function(execFunc) {
            return new $8c023e653ef8da49$export$c5d7c1ac98841e53(execFunc, emitter, $8c023e653ef8da49$export$4368d992c4eafac0(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent: registerInteractiveComponent,
        unregisterInteractiveComponent: unregisterInteractiveComponent
    };
}
/* eslint max-classes-per-file: off */ var $8c023e653ef8da49$export$6559d589eb85fbb6 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $dACZV._)(PureComponent, Component);
    var _super = (0, $jhb1H._)(PureComponent);
    function PureComponent() {
        (0, $5kWiG._)(this, PureComponent);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(PureComponent, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                if (this.debug) // eslint-disable-next-line no-console
                console.log($8c023e653ef8da49$var$getUnequalProps(nextProps, this.props), $8c023e653ef8da49$var$getUnequalProps(nextState, this.state));
                return !$8c023e653ef8da49$export$23ebac1979863676(this.props, nextProps, this.propEquality) || !$8c023e653ef8da49$export$23ebac1979863676(this.state, nextState, this.stateEquality);
            }
        },
        {
            // HACK for freakin' React StrictMode
            key: "safeSetState",
            value: function safeSetState(newState) {
                if (!$8c023e653ef8da49$export$23ebac1979863676(this.state, Object.assign(Object.assign({}, this.state), newState), this.stateEquality)) this.setState(newState);
            }
        }
    ]);
    return PureComponent;
}((0, $kgSvt.Component));
$8c023e653ef8da49$export$6559d589eb85fbb6.addPropsEquality = $8c023e653ef8da49$var$addPropsEquality;
$8c023e653ef8da49$export$6559d589eb85fbb6.addStateEquality = $8c023e653ef8da49$var$addStateEquality;
$8c023e653ef8da49$export$6559d589eb85fbb6.contextType = $8c023e653ef8da49$export$e7c866399fa523f5;
$8c023e653ef8da49$export$6559d589eb85fbb6.prototype.propEquality = {};
$8c023e653ef8da49$export$6559d589eb85fbb6.prototype.stateEquality = {};
var $8c023e653ef8da49$export$ef35774e6d314e91 = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0, $dACZV._)(BaseComponent, PureComponent);
    var _super = (0, $jhb1H._)(BaseComponent);
    function BaseComponent() {
        (0, $5kWiG._)(this, BaseComponent);
        return _super.apply(this, arguments);
    }
    return BaseComponent;
}($8c023e653ef8da49$export$6559d589eb85fbb6);
$8c023e653ef8da49$export$ef35774e6d314e91.contextType = $8c023e653ef8da49$export$e7c866399fa523f5;
function $8c023e653ef8da49$var$addPropsEquality(propEquality) {
    var hash = Object.create(this.prototype.propEquality);
    Object.assign(hash, propEquality);
    this.prototype.propEquality = hash;
}
function $8c023e653ef8da49$var$addStateEquality(stateEquality) {
    var hash = Object.create(this.prototype.stateEquality);
    Object.assign(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function $8c023e653ef8da49$export$8743009a87fcb00f(ref, current) {
    if (typeof ref === "function") ref(current);
    else if (ref) // see https://github.com/facebook/react/issues/13029
    ref.current = current;
}
var $8c023e653ef8da49$var$ContentInjector = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(ContentInjector, BaseComponent);
    var _super = (0, $jhb1H._)(ContentInjector);
    function ContentInjector() {
        (0, $5kWiG._)(this, ContentInjector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = $8c023e653ef8da49$export$39b482c5e57630a8();
        _this.queuedDomNodes = [];
        _this.currentDomNodes = [];
        _this.handleEl = function(el) {
            if (!$8c023e653ef8da49$var$hasCustomRenderingHandler(_this.props.generatorName, _this.context.options)) _this.updateElRef(el);
        };
        _this.updateElRef = function(el) {
            if (_this.props.elRef) $8c023e653ef8da49$export$8743009a87fcb00f(_this.props.elRef, el);
        };
        return _this;
    }
    (0, $hHaEF._)(ContentInjector, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var customGenerator = props.customGenerator, defaultGenerator = props.defaultGenerator, renderProps = props.renderProps;
                var attrs = $8c023e653ef8da49$export$a274e22fb40f762e(props, [], this.handleEl);
                var useDefault = false;
                var innerContent;
                var queuedDomNodes = [];
                var currentGeneratorMeta;
                if (customGenerator != null) {
                    var customGeneratorRes = typeof customGenerator === "function" ? customGenerator(renderProps, (0, $kgSvt.createElement)) : customGenerator;
                    if (customGeneratorRes === true) useDefault = true;
                    else {
                        var isObject = customGeneratorRes && typeof customGeneratorRes === "object"; // non-null
                        if (isObject && "html" in customGeneratorRes) attrs.dangerouslySetInnerHTML = {
                            __html: customGeneratorRes.html
                        };
                        else if (isObject && "domNodes" in customGeneratorRes) queuedDomNodes = Array.prototype.slice.call(customGeneratorRes.domNodes);
                        else if (isObject ? (0, $kgSvt.isValidElement)(customGeneratorRes) // vdom node
                         : typeof customGeneratorRes !== "function" // primitive value (like string or number)
                        ) // use in vdom
                        innerContent = customGeneratorRes;
                        else // an exotic object for handleCustomRendering
                        currentGeneratorMeta = customGeneratorRes;
                    }
                } else useDefault = !$8c023e653ef8da49$var$hasCustomRenderingHandler(props.generatorName, options);
                if (useDefault && defaultGenerator) innerContent = defaultGenerator(renderProps);
                this.queuedDomNodes = queuedDomNodes;
                this.currentGeneratorMeta = currentGeneratorMeta;
                return (0, $kgSvt.createElement)(props.elTag, attrs, innerContent);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.applyQueueudDomNodes();
                this.triggerCustomRendering(true);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.applyQueueudDomNodes();
                this.triggerCustomRendering(true);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.triggerCustomRendering(false); // TODO: different API for removal?
            }
        },
        {
            key: "triggerCustomRendering",
            value: function triggerCustomRendering(isActive) {
                var _a;
                var _this = this, props = _this.props, context = _this.context;
                var _context_options = context.options, handleCustomRendering = _context_options.handleCustomRendering, customRenderingMetaMap = _context_options.customRenderingMetaMap;
                if (handleCustomRendering) {
                    var generatorMeta = (_a = this.currentGeneratorMeta) !== null && _a !== void 0 ? _a : customRenderingMetaMap === null || customRenderingMetaMap === void 0 ? void 0 : customRenderingMetaMap[props.generatorName];
                    if (generatorMeta) handleCustomRendering(Object.assign(Object.assign({
                        id: this.id,
                        isActive: isActive,
                        containerEl: this.base,
                        reportNewContainerEl: this.updateElRef,
                        generatorMeta: generatorMeta
                    }, props), {
                        elClasses: (props.elClasses || []).filter($8c023e653ef8da49$var$isTruthy)
                    }));
                }
            }
        },
        {
            key: "applyQueueudDomNodes",
            value: function applyQueueudDomNodes() {
                var _this = this, queuedDomNodes = _this.queuedDomNodes, currentDomNodes = _this.currentDomNodes;
                var el = this.base;
                if (!$8c023e653ef8da49$export$23f2a1d2818174ef(queuedDomNodes, currentDomNodes)) {
                    currentDomNodes.forEach($8c023e653ef8da49$export$c03999cb2f36933f);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = queuedDomNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var newNode = _step.value;
                            el.appendChild(newNode);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.currentDomNodes = queuedDomNodes;
                }
            }
        }
    ]);
    return ContentInjector;
}($8c023e653ef8da49$export$ef35774e6d314e91);
$8c023e653ef8da49$var$ContentInjector.addPropsEquality({
    elClasses: $8c023e653ef8da49$export$23f2a1d2818174ef,
    elStyle: $8c023e653ef8da49$export$a9c23c6ac3fc3eca,
    elAttrs: $8c023e653ef8da49$var$isNonHandlerPropsEqual,
    renderProps: $8c023e653ef8da49$export$a9c23c6ac3fc3eca
});
// Util
/*
Does UI-framework provide custom way of rendering?
*/ function $8c023e653ef8da49$var$hasCustomRenderingHandler(generatorName, options) {
    var _a;
    return Boolean(options.handleCustomRendering && generatorName && ((_a = options.customRenderingMetaMap) === null || _a === void 0 ? void 0 : _a[generatorName]));
}
function $8c023e653ef8da49$export$a274e22fb40f762e(props, extraClassNames, elRef) {
    var attrs = Object.assign(Object.assign({}, props.elAttrs), {
        ref: elRef
    });
    if (props.elClasses || extraClassNames) attrs.className = (props.elClasses || []).concat(extraClassNames || []).concat(attrs.className || []).filter(Boolean).join(" ");
    if (props.elStyle) attrs.style = props.elStyle;
    return attrs;
}
function $8c023e653ef8da49$var$isTruthy(val) {
    return Boolean(val);
}
var $8c023e653ef8da49$export$2219238a014317b0 = $8c023e653ef8da49$export$995eb9fca571757(0);
var $8c023e653ef8da49$export$e7094788287c5e9b = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $dACZV._)(ContentContainer, Component);
    var _super = (0, $jhb1H._)(ContentContainer);
    function ContentContainer() {
        (0, $5kWiG._)(this, ContentContainer);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.InnerContent = $8c023e653ef8da49$var$InnerContentInjector.bind(undefined, (0, $1K4o4._)(_this));
        _this.handleEl = function(el) {
            _this.el = el;
            if (_this.props.elRef) $8c023e653ef8da49$export$8743009a87fcb00f(_this.props.elRef, el);
        };
        return _this;
    }
    (0, $hHaEF._)(ContentContainer, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var generatedClassNames = $8c023e653ef8da49$var$generateClassNames(props.classNameGenerator, props.renderProps);
                if (props.children) {
                    var elAttrs = $8c023e653ef8da49$export$a274e22fb40f762e(props, generatedClassNames, this.handleEl);
                    var children = props.children(this.InnerContent, props.renderProps, elAttrs);
                    if (props.elTag) return (0, $kgSvt.createElement)(props.elTag, elAttrs, children);
                    else return children;
                } else return (0, $kgSvt.createElement)($8c023e653ef8da49$var$ContentInjector, Object.assign(Object.assign({}, props), {
                    elRef: this.handleEl,
                    elTag: props.elTag || "div",
                    elClasses: (props.elClasses || []).concat(generatedClassNames),
                    renderId: this.context
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _a, _b;
                (_b = (_a = this.props).didMount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
                    el: this.el
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _a, _b;
                (_b = (_a = this.props).willUnmount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
                    el: this.el
                }));
            }
        }
    ]);
    return ContentContainer;
}((0, $kgSvt.Component));
$8c023e653ef8da49$export$e7094788287c5e9b.contextType = $8c023e653ef8da49$export$2219238a014317b0;
function $8c023e653ef8da49$var$InnerContentInjector(containerComponent, props) {
    var parentProps = containerComponent.props;
    return (0, $kgSvt.createElement)($8c023e653ef8da49$var$ContentInjector, Object.assign({
        renderProps: parentProps.renderProps,
        generatorName: parentProps.generatorName,
        customGenerator: parentProps.customGenerator,
        defaultGenerator: parentProps.defaultGenerator,
        renderId: containerComponent.context
    }, props));
}
// Utils
function $8c023e653ef8da49$var$generateClassNames(classNameGenerator, renderProps) {
    var classNames = typeof classNameGenerator === "function" ? classNameGenerator(renderProps) : classNameGenerator || [];
    return typeof classNames === "string" ? [
        classNames
    ] : classNames;
}
var $8c023e653ef8da49$export$e9316ff9106cdb75 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(ViewContainer, BaseComponent);
    var _super = (0, $jhb1H._)(ViewContainer);
    function ViewContainer() {
        (0, $5kWiG._)(this, ViewContainer);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(ViewContainer, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var renderProps = {
                    view: context.viewApi
                };
                return (0, $kgSvt.createElement)($8c023e653ef8da49$export$e7094788287c5e9b, Object.assign({}, props, {
                    elTag: props.elTag || "div",
                    elClasses: (0, $5TJQB._)($8c023e653ef8da49$export$8b22cf2602fb60ce(props.viewSpec)).concat((0, $5TJQB._)(props.elClasses || [])),
                    renderProps: renderProps,
                    classNameGenerator: options.viewClassNames,
                    generatorName: undefined,
                    didMount: options.viewDidMount,
                    willUnmount: options.viewWillUnmount
                }), function() {
                    return props.children;
                });
            }
        }
    ]);
    return ViewContainer;
}($8c023e653ef8da49$export$ef35774e6d314e91);
function $8c023e653ef8da49$export$8b22cf2602fb60ce(viewSpec) {
    return [
        "fc-".concat(viewSpec.type, "-view"),
        "fc-view"
    ];
}
function $8c023e653ef8da49$var$parseRange(input, dateEnv) {
    var start = null;
    var end = null;
    if (input.start) start = dateEnv.createMarker(input.start);
    if (input.end) end = dateEnv.createMarker(input.end);
    if (!start && !end) return null;
    if (start && end && end < start) return null;
    return {
        start: start,
        end: end
    };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function $8c023e653ef8da49$var$invertRanges(ranges, constraintRange) {
    var invertedRanges = [];
    var start = constraintRange.start; // the end of the previous range. the start of the new range
    var i;
    var dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort($8c023e653ef8da49$var$compareRanges);
    for(i = 0; i < ranges.length; i += 1){
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) invertedRanges.push({
            start: start,
            end: dateRange.start
        });
        if (dateRange.end > start) start = dateRange.end;
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) invertedRanges.push({
        start: start,
        end: constraintRange.end
    });
    return invertedRanges;
}
function $8c023e653ef8da49$var$compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function $8c023e653ef8da49$export$ae1af26003f05816(range0, range1) {
    var start = range0.start, end = range0.end;
    var newRange = null;
    if (range1.start !== null) {
        if (start === null) start = range1.start;
        else start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
    }
    if (range1.end != null) {
        if (end === null) end = range1.end;
        else end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
    }
    if (start === null || end === null || start < end) newRange = {
        start: start,
        end: end
    };
    return newRange;
}
function $8c023e653ef8da49$export$f074adc9fbd50943(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function $8c023e653ef8da49$export$ad4aebacdcaf47f8(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
}
function $8c023e653ef8da49$export$4ae495d48253603d(outerRange, innerRange) {
    return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
}
function $8c023e653ef8da49$export$7f8ddf7c7c20b3cd(range, date) {
    return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function $8c023e653ef8da49$var$constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) return range.start;
    if (range.end != null && date >= range.end) return new Date(range.end.valueOf() - 1);
    return date;
}
/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/ // given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function $8c023e653ef8da49$var$computeAlignedDayRange(timedRange) {
    var dayCnt = Math.floor($8c023e653ef8da49$export$a36fb7d24305ed9d(timedRange.start, timedRange.end)) || 1;
    var start = $8c023e653ef8da49$export$9e5f44173e64f162(timedRange.start);
    var end = $8c023e653ef8da49$export$625550452a3fa3ec(start, dayCnt);
    return {
        start: start,
        end: end
    };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function $8c023e653ef8da49$export$28f7fcd39efa255(timedRange) {
    var nextDayThreshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8c023e653ef8da49$export$4368d992c4eafac0(0);
    var startDay = null;
    var endDay = null;
    if (timedRange.end) {
        endDay = $8c023e653ef8da49$export$9e5f44173e64f162(timedRange.end);
        var endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= $8c023e653ef8da49$export$4e222d082f82ee97(nextDayThreshold)) endDay = $8c023e653ef8da49$export$625550452a3fa3ec(endDay, 1);
    }
    if (timedRange.start) {
        startDay = $8c023e653ef8da49$export$9e5f44173e64f162(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) endDay = $8c023e653ef8da49$export$625550452a3fa3ec(startDay, 1);
    }
    return {
        start: startDay,
        end: endDay
    };
}
// spans from one day into another?
function $8c023e653ef8da49$export$3d12bd131bb975d1(range) {
    var visibleRange = $8c023e653ef8da49$export$28f7fcd39efa255(range);
    return $8c023e653ef8da49$export$a36fb7d24305ed9d(visibleRange.start, visibleRange.end) > 1;
}
function $8c023e653ef8da49$export$91c6e00c14e7e6fd(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === "year") return $8c023e653ef8da49$export$4368d992c4eafac0(dateEnv.diffWholeYears(date0, date1), "year");
    if (largeUnit === "month") return $8c023e653ef8da49$export$4368d992c4eafac0(dateEnv.diffWholeMonths(date0, date1), "month");
    return $8c023e653ef8da49$export$5521614468b862fb(date0, date1); // returns a duration
}
function $8c023e653ef8da49$export$b4171a6734a65d42(currentDate, action) {
    switch(action.type){
        case "CHANGE_DATE":
            return action.dateMarker;
        default:
            return currentDate;
    }
}
function $8c023e653ef8da49$export$2329c99376c9d0a4(options, dateEnv) {
    var initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) return dateEnv.createMarker(initialDateInput);
    return $8c023e653ef8da49$export$c3950d9923825c02(options.now, dateEnv); // getNow already returns unzoned
}
function $8c023e653ef8da49$export$c3950d9923825c02(nowInput, dateEnv) {
    if (typeof nowInput === "function") nowInput = nowInput();
    if (nowInput == null) return dateEnv.createNowMarker();
    return dateEnv.createMarker(nowInput);
}
var $8c023e653ef8da49$export$3a6d5c9ae78a2c08 = /*#__PURE__*/ function() {
    "use strict";
    function DateProfileGenerator(props) {
        (0, $5kWiG._)(this, DateProfileGenerator);
        this.props = props;
        this.nowDate = $8c023e653ef8da49$export$c3950d9923825c02(props.nowInput, props.dateEnv);
        this.initHiddenDays();
    }
    (0, $hHaEF._)(DateProfileGenerator, [
        {
            /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/ // Builds a structure with info about what the dates/ranges will be for the "prev" view.
            key: "buildPrev",
            value: function buildPrev(currentDateProfile, currentDate, forceToValid) {
                var dateEnv = this.props.dateEnv;
                var prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
                return this.build(prevDate, -1, forceToValid);
            }
        },
        {
            // Builds a structure with info about what the dates/ranges will be for the "next" view.
            key: "buildNext",
            value: function buildNext(currentDateProfile, currentDate, forceToValid) {
                var dateEnv = this.props.dateEnv;
                var nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
                return this.build(nextDate, 1, forceToValid);
            }
        },
        {
            // Builds a structure holding dates/ranges for rendering around the given date.
            // Optional direction param indicates whether the date is being incremented/decremented
            // from its previous value. decremented = -1, incremented = 1 (default).
            key: "build",
            value: function build(currentDate, direction) {
                var forceToValid = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var props = this.props;
                var validRange;
                var currentInfo;
                var isRangeAllDay;
                var renderRange;
                var activeRange;
                var isValid;
                validRange = this.buildValidRange();
                validRange = this.trimHiddenDays(validRange);
                if (forceToValid) currentDate = $8c023e653ef8da49$var$constrainMarkerToRange(currentDate, validRange);
                currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
                isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
                renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
                renderRange = this.trimHiddenDays(renderRange);
                activeRange = renderRange;
                if (!props.showNonCurrentDates) activeRange = $8c023e653ef8da49$export$ae1af26003f05816(activeRange, currentInfo.range);
                activeRange = this.adjustActiveRange(activeRange);
                activeRange = $8c023e653ef8da49$export$ae1af26003f05816(activeRange, validRange); // might return null
                // it's invalid if the originally requested date is not contained,
                // or if the range is completely outside of the valid range.
                isValid = $8c023e653ef8da49$export$ad4aebacdcaf47f8(currentInfo.range, validRange);
                // HACK: constrain to render-range so `currentDate` is more useful to view rendering
                if (!$8c023e653ef8da49$export$7f8ddf7c7c20b3cd(renderRange, currentDate)) currentDate = renderRange.start;
                return {
                    currentDate: currentDate,
                    // constraint for where prev/next operations can go and where events can be dragged/resized to.
                    // an object with optional start and end properties.
                    validRange: validRange,
                    // range the view is formally responsible for.
                    // for example, a month view might have 1st-31st, excluding padded dates
                    currentRange: currentInfo.range,
                    // name of largest unit being displayed, like "month" or "week"
                    currentRangeUnit: currentInfo.unit,
                    isRangeAllDay: isRangeAllDay,
                    // dates that display events and accept drag-n-drop
                    // will be `null` if no dates accept events
                    activeRange: activeRange,
                    // date range with a rendered skeleton
                    // includes not-active days that need some sort of DOM
                    renderRange: renderRange,
                    // Duration object that denotes the first visible time of any given day
                    slotMinTime: props.slotMinTime,
                    // Duration object that denotes the exclusive visible end time of any given day
                    slotMaxTime: props.slotMaxTime,
                    isValid: isValid,
                    // how far the current date will move for a prev/next operation
                    dateIncrement: this.buildDateIncrement(currentInfo.duration)
                };
            }
        },
        {
            // Builds an object with optional start/end properties.
            // Indicates the minimum/maximum dates to display.
            // not responsible for trimming hidden days.
            key: "buildValidRange",
            value: function buildValidRange() {
                var input = this.props.validRangeInput;
                var simpleInput = typeof input === "function" ? input.call(this.props.calendarApi, this.nowDate) : input;
                return this.refineRange(simpleInput) || {
                    start: null,
                    end: null
                }; // completely open-ended
            }
        },
        {
            // Builds a structure with info about the "current" range, the range that is
            // highlighted as being the current month for example.
            // See build() for a description of `direction`.
            // Guaranteed to have `range` and `unit` properties. `duration` is optional.
            key: "buildCurrentRangeInfo",
            value: function buildCurrentRangeInfo(date, direction) {
                var props = this.props;
                var duration = null;
                var unit = null;
                var range = null;
                var dayCount;
                if (props.duration) {
                    duration = props.duration;
                    unit = props.durationUnit;
                    range = this.buildRangeFromDuration(date, direction, duration, unit);
                } else if (dayCount = this.props.dayCount) {
                    unit = "day";
                    range = this.buildRangeFromDayCount(date, direction, dayCount);
                } else if (range = this.buildCustomVisibleRange(date)) unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
                else {
                    duration = this.getFallbackDuration();
                    unit = $8c023e653ef8da49$export$db3b6bfb95261072(duration).unit;
                    range = this.buildRangeFromDuration(date, direction, duration, unit);
                }
                return {
                    duration: duration,
                    unit: unit,
                    range: range
                };
            }
        },
        {
            key: "getFallbackDuration",
            value: function getFallbackDuration() {
                return $8c023e653ef8da49$export$4368d992c4eafac0({
                    day: 1
                });
            }
        },
        {
            // Returns a new activeRange to have time values (un-ambiguate)
            // slotMinTime or slotMaxTime causes the range to expand.
            key: "adjustActiveRange",
            value: function adjustActiveRange(range) {
                var _this_props = this.props, dateEnv = _this_props.dateEnv, usesMinMaxTime = _this_props.usesMinMaxTime, slotMinTime = _this_props.slotMinTime, slotMaxTime = _this_props.slotMaxTime;
                var start = range.start, end = range.end;
                if (usesMinMaxTime) {
                    // expand active range if slotMinTime is negative (why not when positive?)
                    if ($8c023e653ef8da49$var$asRoughDays(slotMinTime) < 0) {
                        start = $8c023e653ef8da49$export$9e5f44173e64f162(start); // necessary?
                        start = dateEnv.add(start, slotMinTime);
                    }
                    // expand active range if slotMaxTime is beyond one day (why not when negative?)
                    if ($8c023e653ef8da49$var$asRoughDays(slotMaxTime) > 1) {
                        end = $8c023e653ef8da49$export$9e5f44173e64f162(end); // necessary?
                        end = $8c023e653ef8da49$export$625550452a3fa3ec(end, -1);
                        end = dateEnv.add(end, slotMaxTime);
                    }
                }
                return {
                    start: start,
                    end: end
                };
            }
        },
        {
            // Builds the "current" range when it is specified as an explicit duration.
            // `unit` is the already-computed greatestDurationDenominator unit of duration.
            key: "buildRangeFromDuration",
            value: function buildRangeFromDuration(date, direction, duration, unit) {
                var _this_props = this.props, dateEnv = _this_props.dateEnv, dateAlignment = _this_props.dateAlignment;
                var start;
                var end;
                var res;
                // compute what the alignment should be
                if (!dateAlignment) {
                    var dateIncrement = this.props.dateIncrement;
                    if (dateIncrement) {
                        // use the smaller of the two units
                        if ($8c023e653ef8da49$export$4e222d082f82ee97(dateIncrement) < $8c023e653ef8da49$export$4e222d082f82ee97(duration)) dateAlignment = $8c023e653ef8da49$export$db3b6bfb95261072(dateIncrement).unit;
                        else dateAlignment = unit;
                    } else dateAlignment = unit;
                }
                // if the view displays a single day or smaller
                if ($8c023e653ef8da49$var$asRoughDays(duration) <= 1) {
                    if (this.isHiddenDay(start)) {
                        start = this.skipHiddenDays(start, direction);
                        start = $8c023e653ef8da49$export$9e5f44173e64f162(start);
                    }
                }
                function computeRes() {
                    start = dateEnv.startOf(date, dateAlignment);
                    end = dateEnv.add(start, duration);
                    res = {
                        start: start,
                        end: end
                    };
                }
                computeRes();
                // if range is completely enveloped by hidden days, go past the hidden days
                if (!this.trimHiddenDays(res)) {
                    date = this.skipHiddenDays(date, direction);
                    computeRes();
                }
                return res;
            }
        },
        {
            // Builds the "current" range when a dayCount is specified.
            key: "buildRangeFromDayCount",
            value: function buildRangeFromDayCount(date, direction, dayCount) {
                var _this_props = this.props, dateEnv = _this_props.dateEnv, dateAlignment = _this_props.dateAlignment;
                var runningCount = 0;
                var start = date;
                var end;
                if (dateAlignment) start = dateEnv.startOf(start, dateAlignment);
                start = $8c023e653ef8da49$export$9e5f44173e64f162(start);
                start = this.skipHiddenDays(start, direction);
                end = start;
                do {
                    end = $8c023e653ef8da49$export$625550452a3fa3ec(end, 1);
                    if (!this.isHiddenDay(end)) runningCount += 1;
                }while (runningCount < dayCount);
                return {
                    start: start,
                    end: end
                };
            }
        },
        {
            // Builds a normalized range object for the "visible" range,
            // which is a way to define the currentRange and activeRange at the same time.
            key: "buildCustomVisibleRange",
            value: function buildCustomVisibleRange(date) {
                var props = this.props;
                var input = props.visibleRangeInput;
                var simpleInput = typeof input === "function" ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
                var range = this.refineRange(simpleInput);
                if (range && (range.start == null || range.end == null)) return null;
                return range;
            }
        },
        {
            // Computes the range that will represent the element/cells for *rendering*,
            // but which may have voided days/times.
            // not responsible for trimming hidden days.
            key: "buildRenderRange",
            value: function buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
                return currentRange;
            }
        },
        {
            // Compute the duration value that should be added/substracted to the current date
            // when a prev/next operation happens.
            key: "buildDateIncrement",
            value: function buildDateIncrement(fallback) {
                var dateIncrement = this.props.dateIncrement;
                var customAlignment;
                if (dateIncrement) return dateIncrement;
                if (customAlignment = this.props.dateAlignment) return $8c023e653ef8da49$export$4368d992c4eafac0(1, customAlignment);
                if (fallback) return fallback;
                return $8c023e653ef8da49$export$4368d992c4eafac0({
                    days: 1
                });
            }
        },
        {
            key: "refineRange",
            value: function refineRange(rangeInput) {
                if (rangeInput) {
                    var range = $8c023e653ef8da49$var$parseRange(rangeInput, this.props.dateEnv);
                    if (range) range = $8c023e653ef8da49$export$28f7fcd39efa255(range);
                    return range;
                }
                return null;
            }
        },
        {
            /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/ // Initializes internal variables related to calculating hidden days-of-week
            key: "initHiddenDays",
            value: function initHiddenDays() {
                var hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
                var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
                var dayCnt = 0;
                var i;
                if (this.props.weekends === false) hiddenDays.push(0, 6); // 0=sunday, 6=saturday
                for(i = 0; i < 7; i += 1)if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) dayCnt += 1;
                if (!dayCnt) throw new Error("invalid hiddenDays"); // all days were hidden? bad.
                this.isHiddenDayHash = isHiddenDayHash;
            }
        },
        {
            // Remove days from the beginning and end of the range that are computed as hidden.
            // If the whole range is trimmed off, returns null
            key: "trimHiddenDays",
            value: function trimHiddenDays(range) {
                var start = range.start, end = range.end;
                if (start) start = this.skipHiddenDays(start);
                if (end) end = this.skipHiddenDays(end, -1, true);
                if (start == null || end == null || start < end) return {
                    start: start,
                    end: end
                };
                return null;
            }
        },
        {
            // Is the current day hidden?
            // `day` is a day-of-week index (0-6), or a Date (used for UTC)
            key: "isHiddenDay",
            value: function isHiddenDay(day) {
                if (day instanceof Date) day = day.getUTCDay();
                return this.isHiddenDayHash[day];
            }
        },
        {
            // Incrementing the current day until it is no longer a hidden day, returning a copy.
            // DOES NOT CONSIDER validRange!
            // If the initial value of `date` is not a hidden day, don't do anything.
            // Pass `isExclusive` as `true` if you are dealing with an end date.
            // `inc` defaults to `1` (increment one day forward each time)
            key: "skipHiddenDays",
            value: function skipHiddenDays(date) {
                var inc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, isExclusive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                while(this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7])date = $8c023e653ef8da49$export$625550452a3fa3ec(date, inc);
                return date;
            }
        }
    ]);
    return DateProfileGenerator;
}();
function $8c023e653ef8da49$export$3b513254972cfc9c(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: $8c023e653ef8da49$export$39b482c5e57630a8(),
        defId: defId,
        range: range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
    };
}
function $8c023e653ef8da49$var$parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for(var i = 0; i < recurringTypes.length; i += 1){
        var parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            var allDay = refined.allDay;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) allDay = false;
                }
            }
            return {
                allDay: allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i
            };
        }
    }
    return null;
}
function $8c023e653ef8da49$var$expandRecurring(eventStore, framingRange, context) {
    var dateEnv = context.dateEnv, pluginHooks = context.pluginHooks, options = context.options;
    var defs = eventStore.defs, instances = eventStore.instances;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = $8c023e653ef8da49$export$dda1d9f60106f0e9(instances, function(instance) {
        return !defs[instance.defId].recurringDef;
    });
    for(var defId in defs){
        var def = defs[defId];
        if (def.recurringDef) {
            var duration = def.recurringDef.duration;
            if (!duration) duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
            var starts = $8c023e653ef8da49$var$expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = starts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var start = _step.value;
                    var instance = $8c023e653ef8da49$export$3b513254972cfc9c(defId, {
                        start: start,
                        end: dateEnv.add(start, duration)
                    });
                    instances[instance.instanceId] = instance;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    return {
        defs: defs,
        instances: instances
    };
}
/*
Event MUST have a recurringDef
*/ function $8c023e653ef8da49$var$expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    var typeDef = recurringTypes[eventDef.recurringDef.typeId];
    var markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) markers = markers.map($8c023e653ef8da49$export$9e5f44173e64f162);
    return markers;
}
var $8c023e653ef8da49$var$EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
    interactive: Boolean
};
var $8c023e653ef8da49$var$EVENT_DATE_REFINERS = {
    start: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    end: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    date: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
var $8c023e653ef8da49$var$EVENT_REFINERS = Object.assign(Object.assign(Object.assign({}, $8c023e653ef8da49$var$EVENT_NON_DATE_REFINERS), $8c023e653ef8da49$var$EVENT_DATE_REFINERS), {
    extendedProps: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5
});
function $8c023e653ef8da49$var$parseEvent(raw, eventSource, context, allowOpenRange) {
    var refiners = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $8c023e653ef8da49$var$buildEventRefiners(context), defIdMap = arguments.length > 5 ? arguments[5] : void 0, instanceIdMap = arguments.length > 6 ? arguments[6] : void 0;
    var _refineEventDef = $8c023e653ef8da49$export$ab83b03e4111b1d0(raw, context, refiners), refined = _refineEventDef.refined, extra = _refineEventDef.extra;
    var defaultAllDay = $8c023e653ef8da49$var$computeIsDefaultAllDay(eventSource, context);
    var recurringRes = $8c023e653ef8da49$var$parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        var def = $8c023e653ef8da49$export$21579262ef46735b(refined, extra, eventSource ? eventSource.sourceId : "", recurringRes.allDay, Boolean(recurringRes.duration), context, defIdMap);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration
        };
        return {
            def: def,
            instance: null
        };
    }
    var singleRes = $8c023e653ef8da49$var$parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        var def1 = $8c023e653ef8da49$export$21579262ef46735b(refined, extra, eventSource ? eventSource.sourceId : "", singleRes.allDay, singleRes.hasEnd, context, defIdMap);
        var instance = $8c023e653ef8da49$export$3b513254972cfc9c(def1.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        if (instanceIdMap && def1.publicId && instanceIdMap[def1.publicId]) instance.instanceId = instanceIdMap[def1.publicId];
        return {
            def: def1,
            instance: instance
        };
    }
    return null;
}
function $8c023e653ef8da49$export$ab83b03e4111b1d0(raw, context) {
    var refiners = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $8c023e653ef8da49$var$buildEventRefiners(context);
    return $8c023e653ef8da49$export$f38c853ae54ed474(raw, refiners);
}
function $8c023e653ef8da49$var$buildEventRefiners(context) {
    return Object.assign(Object.assign(Object.assign({}, $8c023e653ef8da49$var$EVENT_UI_REFINERS), $8c023e653ef8da49$var$EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/ function $8c023e653ef8da49$export$21579262ef46735b(refined, extra, sourceId, allDay, hasEnd, context, defIdMap) {
    var def = {
        title: refined.title || "",
        groupId: refined.groupId || "",
        publicId: refined.id || "",
        url: refined.url || "",
        recurringDef: null,
        defId: (defIdMap && refined.id ? defIdMap[refined.id] : "") || $8c023e653ef8da49$export$39b482c5e57630a8(),
        sourceId: sourceId,
        allDay: allDay,
        hasEnd: hasEnd,
        interactive: refined.interactive,
        ui: $8c023e653ef8da49$export$71cec2538cb2c617(refined, context),
        extendedProps: Object.assign(Object.assign({}, refined.extendedProps || {}), extra)
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.eventDefMemberAdders[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var memberAdder = _step.value;
            Object.assign(def, memberAdder(refined));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // help out EventImpl from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function $8c023e653ef8da49$var$parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    var allDay = refined.allDay;
    var startMeta;
    var startMarker = null;
    var hasEnd = false;
    var endMeta;
    var endMarker = null;
    var startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) startMarker = startMeta.marker;
    else if (!allowOpenRange) return null;
    if (refined.end != null) endMeta = context.dateEnv.createMarkerMeta(refined.end);
    if (allDay == null) {
        if (defaultAllDay != null) allDay = defaultAllDay;
        else // fall back to the date props LAST
        allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
    }
    if (allDay && startMarker) startMarker = $8c023e653ef8da49$export$9e5f44173e64f162(startMarker);
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) endMarker = $8c023e653ef8da49$export$9e5f44173e64f162(endMarker);
        if (startMarker && endMarker <= startMarker) endMarker = null;
    }
    if (endMarker) hasEnd = true;
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
    }
    return {
        allDay: allDay,
        hasEnd: hasEnd,
        range: {
            start: startMarker,
            end: endMarker
        },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null
    };
}
function $8c023e653ef8da49$var$computeIsDefaultAllDay(eventSource, context) {
    var res = null;
    if (eventSource) res = eventSource.defaultAllDay;
    if (res == null) res = context.options.defaultAllDay;
    return res;
}
function $8c023e653ef8da49$var$parseEvents(rawEvents, eventSource, context, allowOpenRange, defIdMap, instanceIdMap) {
    var eventStore = $8c023e653ef8da49$export$9bb611d729802a56();
    var eventRefiners = $8c023e653ef8da49$var$buildEventRefiners(context);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rawEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rawEvent = _step.value;
            var tuple = $8c023e653ef8da49$var$parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners, defIdMap, instanceIdMap);
            if (tuple) $8c023e653ef8da49$export$9d0e2d13d04f7070(tuple, eventStore);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return eventStore;
}
function $8c023e653ef8da49$export$9d0e2d13d04f7070(tuple) {
    var eventStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8c023e653ef8da49$export$9bb611d729802a56();
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function $8c023e653ef8da49$export$1ee57be6f6687d2c(eventStore, instanceId) {
    var instance = eventStore.instances[instanceId];
    if (instance) {
        var def = eventStore.defs[instance.defId];
        // get events/instances with same group
        var newStore = $8c023e653ef8da49$var$filterEventStoreDefs(eventStore, function(lookDef) {
            return $8c023e653ef8da49$var$isEventDefsGrouped(def, lookDef);
        });
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def.defId] = def;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return $8c023e653ef8da49$export$9bb611d729802a56();
}
function $8c023e653ef8da49$var$isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function $8c023e653ef8da49$export$9bb611d729802a56() {
    return {
        defs: {},
        instances: {}
    };
}
function $8c023e653ef8da49$export$317a3d46287192d8(store0, store1) {
    return {
        defs: Object.assign(Object.assign({}, store0.defs), store1.defs),
        instances: Object.assign(Object.assign({}, store0.instances), store1.instances)
    };
}
function $8c023e653ef8da49$var$filterEventStoreDefs(eventStore, filterFunc) {
    var defs = $8c023e653ef8da49$export$dda1d9f60106f0e9(eventStore.defs, filterFunc);
    var instances = $8c023e653ef8da49$export$dda1d9f60106f0e9(eventStore.instances, function(instance) {
        return defs[instance.defId] // still exists?
        ;
    });
    return {
        defs: defs,
        instances: instances
    };
}
function $8c023e653ef8da49$var$excludeSubEventStore(master, sub) {
    var defs = master.defs, instances = master.instances;
    var filteredDefs = {};
    var filteredInstances = {};
    for(var defId in defs)if (!sub.defs[defId]) filteredDefs[defId] = defs[defId];
    for(var instanceId in instances)if (!sub.instances[instanceId] && // not explicitly excluded
    filteredDefs[instances[instanceId].defId] // def wasn't filtered away
    ) filteredInstances[instanceId] = instances[instanceId];
    return {
        defs: filteredDefs,
        instances: filteredInstances
    };
}
function $8c023e653ef8da49$var$normalizeConstraint(input, context) {
    if (Array.isArray(input)) return $8c023e653ef8da49$var$parseEvents(input, null, context, true); // allowOpenRange=true
    if (typeof input === "object" && input) return $8c023e653ef8da49$var$parseEvents([
        input
    ], null, context, true); // allowOpenRange=true
    if (input != null) return String(input);
    return null;
}
function $8c023e653ef8da49$export$d377dcb2b61d6c4e(raw) {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "string") return raw.split(/\s+/);
    return [];
}
// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
var $8c023e653ef8da49$var$EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    overlap: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    allow: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    className: $8c023e653ef8da49$export$d377dcb2b61d6c4e,
    classNames: $8c023e653ef8da49$export$d377dcb2b61d6c4e,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String
};
var $8c023e653ef8da49$var$EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: "",
    borderColor: "",
    textColor: "",
    classNames: []
};
function $8c023e653ef8da49$export$71cec2538cb2c617(refined, context) {
    var constraint = $8c023e653ef8da49$var$normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [
            constraint
        ] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [
            refined.allow
        ] : [],
        backgroundColor: refined.backgroundColor || refined.color || "",
        borderColor: refined.borderColor || refined.color || "",
        textColor: refined.textColor || "",
        classNames: (refined.className || []).concat(refined.classNames || [])
    };
}
// TODO: prevent against problems with <2 args!
function $8c023e653ef8da49$export$1a8f5705751d8277(uis) {
    return uis.reduce($8c023e653ef8da49$var$combineTwoEventUis, $8c023e653ef8da49$var$EMPTY_EVENT_UI);
}
function $8c023e653ef8da49$var$combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === "boolean" ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames)
    };
}
var $8c023e653ef8da49$var$EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    // for any network-related sources
    success: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    failure: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5
};
function $8c023e653ef8da49$export$ffb5f4729a158638(raw, context) {
    var refiners = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $8c023e653ef8da49$export$35e795649ee09318(context);
    var rawObj;
    if (typeof raw === "string") rawObj = {
        url: raw
    };
    else if (typeof raw === "function" || Array.isArray(raw)) rawObj = {
        events: raw
    };
    else if (typeof raw === "object" && raw) rawObj = raw;
    if (rawObj) {
        var _refineProps = $8c023e653ef8da49$export$f38c853ae54ed474(rawObj, refiners), refined = _refineProps.refined, extra = _refineProps.extra;
        var metaRes = $8c023e653ef8da49$var$buildEventSourceMeta(refined, context);
        if (metaRes) return {
            _raw: raw,
            isFetching: false,
            latestFetchId: "",
            fetchRange: null,
            defaultAllDay: refined.defaultAllDay,
            eventDataTransform: refined.eventDataTransform,
            success: refined.success,
            failure: refined.failure,
            publicId: refined.id || "",
            sourceId: $8c023e653ef8da49$export$39b482c5e57630a8(),
            sourceDefId: metaRes.sourceDefId,
            meta: metaRes.meta,
            ui: $8c023e653ef8da49$export$71cec2538cb2c617(refined, context),
            extendedProps: extra
        };
    }
    return null;
}
function $8c023e653ef8da49$export$35e795649ee09318(context) {
    return Object.assign(Object.assign(Object.assign({}, $8c023e653ef8da49$var$EVENT_UI_REFINERS), $8c023e653ef8da49$var$EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function $8c023e653ef8da49$var$buildEventSourceMeta(raw, context) {
    var defs = context.pluginHooks.eventSourceDefs;
    for(var i = defs.length - 1; i >= 0; i -= 1){
        var def = defs[i];
        var meta = def.parseMeta(raw);
        if (meta) return {
            sourceDefId: i,
            meta: meta
        };
    }
    return null;
}
function $8c023e653ef8da49$export$3466f893ebf79586(eventStore, action, eventSources, dateProfile, context) {
    switch(action.type){
        case "RECEIVE_EVENTS":
            return $8c023e653ef8da49$var$receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case "RESET_RAW_EVENTS":
            return $8c023e653ef8da49$var$resetRawEvents(eventStore, eventSources[action.sourceId], action.rawEvents, dateProfile.activeRange, context);
        case "ADD_EVENTS":
            return $8c023e653ef8da49$var$addEvent(eventStore, action.eventStore, dateProfile ? dateProfile.activeRange : null, context);
        case "RESET_EVENTS":
            return action.eventStore;
        case "MERGE_EVENTS":
            return $8c023e653ef8da49$export$317a3d46287192d8(eventStore, action.eventStore);
        case "PREV":
        case "NEXT":
        case "CHANGE_DATE":
        case "CHANGE_VIEW_TYPE":
            if (dateProfile) return $8c023e653ef8da49$var$expandRecurring(eventStore, dateProfile.activeRange, context);
            return eventStore;
        case "REMOVE_EVENTS":
            return $8c023e653ef8da49$var$excludeSubEventStore(eventStore, action.eventStore);
        case "REMOVE_EVENT_SOURCE":
            return $8c023e653ef8da49$var$excludeEventsBySourceId(eventStore, action.sourceId);
        case "REMOVE_ALL_EVENT_SOURCES":
            return $8c023e653ef8da49$var$filterEventStoreDefs(eventStore, function(eventDef) {
                return !eventDef.sourceId // only keep events with no source id
                ;
            });
        case "REMOVE_ALL_EVENTS":
            return $8c023e653ef8da49$export$9bb611d729802a56();
        default:
            return eventStore;
    }
}
function $8c023e653ef8da49$var$receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        var subset = $8c023e653ef8da49$var$parseEvents($8c023e653ef8da49$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) subset = $8c023e653ef8da49$var$expandRecurring(subset, fetchRange, context);
        return $8c023e653ef8da49$export$317a3d46287192d8($8c023e653ef8da49$var$excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function $8c023e653ef8da49$var$resetRawEvents(existingEventStore, eventSource, rawEvents, activeRange, context) {
    var _buildPublicIdMaps = $8c023e653ef8da49$var$buildPublicIdMaps(existingEventStore), defIdMap = _buildPublicIdMaps.defIdMap, instanceIdMap = _buildPublicIdMaps.instanceIdMap;
    var newEventStore = $8c023e653ef8da49$var$parseEvents($8c023e653ef8da49$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context, false, defIdMap, instanceIdMap);
    return $8c023e653ef8da49$var$expandRecurring(newEventStore, activeRange, context);
}
function $8c023e653ef8da49$var$transformRawEvents(rawEvents, eventSource, context) {
    var calEachTransform = context.options.eventDataTransform;
    var sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) rawEvents = $8c023e653ef8da49$var$transformEachRawEvent(rawEvents, sourceEachTransform);
    if (calEachTransform) rawEvents = $8c023e653ef8da49$var$transformEachRawEvent(rawEvents, calEachTransform);
    return rawEvents;
}
function $8c023e653ef8da49$var$transformEachRawEvent(rawEvents, func) {
    var refinedEvents;
    if (!func) refinedEvents = rawEvents;
    else {
        refinedEvents = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rawEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var rawEvent = _step.value;
                var refinedEvent = func(rawEvent);
                if (refinedEvent) refinedEvents.push(refinedEvent);
                else if (refinedEvent == null) refinedEvents.push(rawEvent);
                 // if a different falsy value, do nothing
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return refinedEvents;
}
function $8c023e653ef8da49$var$addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) subset = $8c023e653ef8da49$var$expandRecurring(subset, expandRange, context);
    return $8c023e653ef8da49$export$317a3d46287192d8(eventStore, subset);
}
function $8c023e653ef8da49$export$61196ced6d74a310(eventStore, oldDateEnv, newDateEnv) {
    var defs = eventStore.defs;
    var instances = $8c023e653ef8da49$export$407448d2b89b1813(eventStore.instances, function(instance) {
        var def = defs[instance.defId];
        if (def.allDay) return instance; // isn't dependent on timezone
        return Object.assign(Object.assign({}, instance), {
            range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
            },
            forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
            forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
        });
    });
    return {
        defs: defs,
        instances: instances
    };
}
function $8c023e653ef8da49$var$excludeEventsBySourceId(eventStore, sourceId) {
    return $8c023e653ef8da49$var$filterEventStoreDefs(eventStore, function(eventDef) {
        return eventDef.sourceId !== sourceId;
    });
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function $8c023e653ef8da49$var$excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: $8c023e653ef8da49$export$dda1d9f60106f0e9(eventStore.instances, function(instance) {
            return !removals[instance.instanceId];
        })
    };
}
function $8c023e653ef8da49$var$buildPublicIdMaps(eventStore) {
    var defs = eventStore.defs, instances = eventStore.instances;
    var defIdMap = {};
    var instanceIdMap = {};
    for(var defId in defs){
        var def = defs[defId];
        var publicId = def.publicId;
        if (publicId) defIdMap[publicId] = defId;
    }
    for(var instanceId in instances){
        var instance = instances[instanceId];
        var def1 = defs[instance.defId];
        var publicId1 = def1.publicId;
        if (publicId1) instanceIdMap[publicId1] = instanceId;
    }
    return {
        defIdMap: defIdMap,
        instanceIdMap: instanceIdMap
    };
}
var $8c023e653ef8da49$export$d66501df72047452 = /*#__PURE__*/ function() {
    "use strict";
    function Emitter() {
        (0, $5kWiG._)(this, Emitter);
        this.handlers = {};
        this.thisContext = null;
    }
    (0, $hHaEF._)(Emitter, [
        {
            key: "setThisContext",
            value: function setThisContext(thisContext) {
                this.thisContext = thisContext;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
        },
        {
            key: "on",
            value: function on(type, handler) {
                $8c023e653ef8da49$var$addToHash(this.handlers, type, handler);
            }
        },
        {
            key: "off",
            value: function off(type, handler) {
                $8c023e653ef8da49$var$removeFromHash(this.handlers, type, handler);
            }
        },
        {
            key: "trigger",
            value: function trigger(type) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var attachedHandlers = this.handlers[type] || [];
                var optionHandler = this.options && this.options[type];
                var handlers = [].concat(optionHandler || [], attachedHandlers);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var handler = _step.value;
                        handler.apply(this.thisContext, args);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "hasHandlers",
            value: function hasHandlers(type) {
                return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
            }
        }
    ]);
    return Emitter;
}();
function $8c023e653ef8da49$var$addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = [])).push(handler);
}
function $8c023e653ef8da49$var$removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) hash[type] = hash[type].filter(function(func) {
            return func !== handler;
        });
    } else delete hash[type]; // remove all handler funcs for this type
}
var $8c023e653ef8da49$var$DEF_DEFAULTS = {
    startTime: "09:00",
    endTime: "17:00",
    daysOfWeek: [
        1,
        2,
        3,
        4,
        5
    ],
    display: "inverse-background",
    classNames: "fc-non-business",
    groupId: "_businessHours"
};
/*
TODO: pass around as EventDefHash!!!
*/ function $8c023e653ef8da49$export$78acf4525d8a74c4(input, context) {
    return $8c023e653ef8da49$var$parseEvents($8c023e653ef8da49$var$refineInputs(input), null, context);
}
function $8c023e653ef8da49$var$refineInputs(input) {
    var rawDefs;
    if (input === true) rawDefs = [
        {}
    ]; // will get DEF_DEFAULTS verbatim
    else if (Array.isArray(input)) // if specifying an array, every sub-definition NEEDS a day-of-week
    rawDefs = input.filter(function(rawDef) {
        return rawDef.daysOfWeek;
    });
    else if (typeof input === "object" && input) rawDefs = [
        input
    ];
    else rawDefs = [];
    rawDefs = rawDefs.map(function(rawDef) {
        return Object.assign(Object.assign({}, $8c023e653ef8da49$var$DEF_DEFAULTS), rawDef);
    });
    return rawDefs;
}
function $8c023e653ef8da49$export$9ddbdd0bfc5623a(selection, pev, context) {
    context.emitter.trigger("select", Object.assign(Object.assign({}, $8c023e653ef8da49$var$buildDateSpanApiWithContext(selection, context)), {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    }));
}
function $8c023e653ef8da49$var$triggerDateUnselect(pev, context) {
    context.emitter.trigger("unselect", {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    });
}
function $8c023e653ef8da49$var$buildDateSpanApiWithContext(dateSpan, context) {
    var props = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.dateSpanTransforms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transform = _step.value;
            Object.assign(props, transform(dateSpan, context));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    Object.assign(props, $8c023e653ef8da49$var$buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function $8c023e653ef8da49$export$1776704b6532a19a(allDay, marker, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var end = marker;
    if (allDay) {
        end = $8c023e653ef8da49$export$9e5f44173e64f162(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    } else end = dateEnv.add(end, options.defaultTimedEventDuration);
    return end;
}
// applies the mutation to ALL defs/instances within the event store
function $8c023e653ef8da49$export$6d1e945284085e64(eventStore, eventConfigBase, mutation, context) {
    var eventConfigs = $8c023e653ef8da49$var$compileEventUis(eventStore.defs, eventConfigBase);
    var dest = $8c023e653ef8da49$export$9bb611d729802a56();
    for(var defId in eventStore.defs){
        var def = eventStore.defs[defId];
        dest.defs[defId] = $8c023e653ef8da49$var$applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for(var instanceId in eventStore.instances){
        var instance = eventStore.instances[instanceId];
        var def1 = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = $8c023e653ef8da49$var$applyMutationToEventInstance(instance, def1, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function $8c023e653ef8da49$var$applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    var standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) standardProps.hasEnd = true; // TODO: is this mutation okay?
    var copy = Object.assign(Object.assign(Object.assign({}, eventDef), standardProps), {
        ui: Object.assign(Object.assign({}, eventDef.ui), standardProps.ui)
    });
    if (mutation.extendedProps) copy.extendedProps = Object.assign(Object.assign({}, copy.extendedProps), mutation.extendedProps);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.eventDefMutationAppliers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var applier = _step.value;
            applier(copy, mutation, context);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!copy.hasEnd && context.options.forceEventDuration) copy.hasEnd = true;
    return copy;
}
function $8c023e653ef8da49$var$applyMutationToEventInstance(eventInstance, eventDef, eventConfig, mutation, context) {
    var dateEnv = context.dateEnv;
    var forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    var clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    var copy = Object.assign({}, eventInstance);
    if (forceAllDay) copy.range = $8c023e653ef8da49$var$computeAlignedDayRange(copy.range);
    if (mutation.datesDelta && eventConfig.startEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.datesDelta),
        end: dateEnv.add(copy.range.end, mutation.datesDelta)
    };
    if (mutation.startDelta && eventConfig.durationEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.startDelta),
        end: copy.range.end
    };
    if (mutation.endDelta && eventConfig.durationEditable) copy.range = {
        start: copy.range.start,
        end: dateEnv.add(copy.range.end, mutation.endDelta)
    };
    if (clearEnd) copy.range = {
        start: copy.range.start,
        end: $8c023e653ef8da49$export$1776704b6532a19a(eventDef.allDay, copy.range.start, context)
    };
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) copy.range = {
        start: $8c023e653ef8da49$export$9e5f44173e64f162(copy.range.start),
        end: $8c023e653ef8da49$export$9e5f44173e64f162(copy.range.end)
    };
    // handle invalid durations
    if (copy.range.end < copy.range.start) copy.range.end = $8c023e653ef8da49$export$1776704b6532a19a(eventDef.allDay, copy.range.start, context);
    return copy;
}
var $8c023e653ef8da49$var$EventSourceImpl = /*#__PURE__*/ function() {
    "use strict";
    function EventSourceImpl(context, internalEventSource) {
        (0, $5kWiG._)(this, EventSourceImpl);
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
    (0, $hHaEF._)(EventSourceImpl, [
        {
            key: "remove",
            value: function remove() {
                this.context.dispatch({
                    type: "REMOVE_EVENT_SOURCE",
                    sourceId: this.internalEventSource.sourceId
                });
            }
        },
        {
            key: "refetch",
            value: function refetch() {
                this.context.dispatch({
                    type: "FETCH_EVENT_SOURCES",
                    sourceIds: [
                        this.internalEventSource.sourceId
                    ],
                    isRefetch: true
                });
            }
        },
        {
            key: "id",
            get: function get() {
                return this.internalEventSource.publicId;
            }
        },
        {
            key: "url",
            get: function get() {
                return this.internalEventSource.meta.url;
            }
        },
        {
            key: "format",
            get: function get() {
                return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
            }
        }
    ]);
    return EventSourceImpl;
}();
var $8c023e653ef8da49$export$34aec0b863436764 = /*#__PURE__*/ function() {
    "use strict";
    function EventImpl(context, def, instance) {
        (0, $5kWiG._)(this, EventImpl);
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
    (0, $hHaEF._)(EventImpl, [
        {
            /*
    TODO: make event struct more responsible for this
    */ key: "setProp",
            value: function setProp(name, val) {
                if (name in $8c023e653ef8da49$var$EVENT_DATE_REFINERS) console.warn("Could not set date-related prop 'name'. Use one of the date-related methods instead.");
                else if (name === "id") {
                    val = $8c023e653ef8da49$var$EVENT_NON_DATE_REFINERS[name](val);
                    this.mutate({
                        standardProps: {
                            publicId: val
                        }
                    });
                } else if (name in $8c023e653ef8da49$var$EVENT_NON_DATE_REFINERS) {
                    val = $8c023e653ef8da49$var$EVENT_NON_DATE_REFINERS[name](val);
                    this.mutate({
                        standardProps: (0, $8EGc6._)({}, name, val)
                    });
                } else if (name in $8c023e653ef8da49$var$EVENT_UI_REFINERS) {
                    var ui = $8c023e653ef8da49$var$EVENT_UI_REFINERS[name](val);
                    if (name === "color") ui = {
                        backgroundColor: val,
                        borderColor: val
                    };
                    else if (name === "editable") ui = {
                        startEditable: val,
                        durationEditable: val
                    };
                    else ui = (0, $8EGc6._)({}, name, val);
                    this.mutate({
                        standardProps: {
                            ui: ui
                        }
                    });
                } else console.warn("Could not set prop '".concat(name, "'. Use setExtendedProp instead."));
            }
        },
        {
            key: "setExtendedProp",
            value: function setExtendedProp(name, val) {
                this.mutate({
                    extendedProps: (0, $8EGc6._)({}, name, val)
                });
            }
        },
        {
            key: "setStart",
            value: function setStart(startInput) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var dateEnv = this._context.dateEnv;
                var start = dateEnv.createMarker(startInput);
                if (start && this._instance) {
                    var instanceRange = this._instance.range;
                    var startDelta = $8c023e653ef8da49$export$91c6e00c14e7e6fd(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
                    if (options.maintainDuration) this.mutate({
                        datesDelta: startDelta
                    });
                    else this.mutate({
                        startDelta: startDelta
                    });
                }
            }
        },
        {
            key: "setEnd",
            value: function setEnd(endInput) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var dateEnv = this._context.dateEnv;
                var end;
                if (endInput != null) {
                    end = dateEnv.createMarker(endInput);
                    if (!end) return; // TODO: warning if parsed bad
                }
                if (this._instance) {
                    if (end) {
                        var endDelta = $8c023e653ef8da49$export$91c6e00c14e7e6fd(this._instance.range.end, end, dateEnv, options.granularity);
                        this.mutate({
                            endDelta: endDelta
                        });
                    } else this.mutate({
                        standardProps: {
                            hasEnd: false
                        }
                    });
                }
            }
        },
        {
            key: "setDates",
            value: function setDates(startInput, endInput) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var dateEnv = this._context.dateEnv;
                var standardProps = {
                    allDay: options.allDay
                };
                var start = dateEnv.createMarker(startInput);
                var end;
                if (!start) return; // TODO: warning if parsed bad
                if (endInput != null) {
                    end = dateEnv.createMarker(endInput);
                    if (!end) return;
                }
                if (this._instance) {
                    var instanceRange = this._instance.range;
                    // when computing the diff for an event being converted to all-day,
                    // compute diff off of the all-day values the way event-mutation does.
                    if (options.allDay === true) instanceRange = $8c023e653ef8da49$var$computeAlignedDayRange(instanceRange);
                    var startDelta = $8c023e653ef8da49$export$91c6e00c14e7e6fd(instanceRange.start, start, dateEnv, options.granularity);
                    if (end) {
                        var endDelta = $8c023e653ef8da49$export$91c6e00c14e7e6fd(instanceRange.end, end, dateEnv, options.granularity);
                        if ($8c023e653ef8da49$var$durationsEqual(startDelta, endDelta)) this.mutate({
                            datesDelta: startDelta,
                            standardProps: standardProps
                        });
                        else this.mutate({
                            startDelta: startDelta,
                            endDelta: endDelta,
                            standardProps: standardProps
                        });
                    } else {
                        standardProps.hasEnd = false;
                        this.mutate({
                            datesDelta: startDelta,
                            standardProps: standardProps
                        });
                    }
                }
            }
        },
        {
            key: "moveStart",
            value: function moveStart(deltaInput) {
                var delta = $8c023e653ef8da49$export$4368d992c4eafac0(deltaInput);
                if (delta) this.mutate({
                    startDelta: delta
                });
            }
        },
        {
            key: "moveEnd",
            value: function moveEnd(deltaInput) {
                var delta = $8c023e653ef8da49$export$4368d992c4eafac0(deltaInput);
                if (delta) this.mutate({
                    endDelta: delta
                });
            }
        },
        {
            key: "moveDates",
            value: function moveDates(deltaInput) {
                var delta = $8c023e653ef8da49$export$4368d992c4eafac0(deltaInput);
                if (delta) this.mutate({
                    datesDelta: delta
                });
            }
        },
        {
            key: "setAllDay",
            value: function setAllDay(allDay) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var standardProps = {
                    allDay: allDay
                };
                var maintainDuration = options.maintainDuration;
                if (maintainDuration == null) maintainDuration = this._context.options.allDayMaintainDuration;
                if (this._def.allDay !== allDay) standardProps.hasEnd = maintainDuration;
                this.mutate({
                    standardProps: standardProps
                });
            }
        },
        {
            key: "formatRange",
            value: function formatRange(formatInput) {
                var dateEnv = this._context.dateEnv;
                var instance = this._instance;
                var formatter = $8c023e653ef8da49$export$d141bba7fdc215a3(formatInput);
                if (this._def.hasEnd) return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
                    forcedStartTzo: instance.forcedStartTzo,
                    forcedEndTzo: instance.forcedEndTzo
                });
                return dateEnv.format(instance.range.start, formatter, {
                    forcedTzo: instance.forcedStartTzo
                });
            }
        },
        {
            key: "mutate",
            value: function mutate(mutation) {
                var instance = this._instance;
                if (instance) {
                    var def = this._def;
                    var context = this._context;
                    var eventStore = context.getCurrentData().eventStore;
                    var relevantEvents = $8c023e653ef8da49$export$1ee57be6f6687d2c(eventStore, instance.instanceId);
                    var eventConfigBase = {
                        "": {
                            display: "",
                            startEditable: true,
                            durationEditable: true,
                            constraints: [],
                            overlap: null,
                            allows: [],
                            backgroundColor: "",
                            borderColor: "",
                            textColor: "",
                            classNames: []
                        }
                    };
                    relevantEvents = $8c023e653ef8da49$export$6d1e945284085e64(relevantEvents, eventConfigBase, mutation, context);
                    var oldEvent = new EventImpl(context, def, instance); // snapshot
                    this._def = relevantEvents.defs[def.defId];
                    this._instance = relevantEvents.instances[instance.instanceId];
                    context.dispatch({
                        type: "MERGE_EVENTS",
                        eventStore: relevantEvents
                    });
                    context.emitter.trigger("eventChange", {
                        oldEvent: oldEvent,
                        event: this,
                        relatedEvents: $8c023e653ef8da49$export$efccba1c4a2ef57b(relevantEvents, context, instance),
                        revert: function() {
                            context.dispatch({
                                type: "RESET_EVENTS",
                                eventStore: eventStore
                            });
                        }
                    });
                }
            }
        },
        {
            key: "remove",
            value: function remove() {
                var context = this._context;
                var asStore = $8c023e653ef8da49$var$eventApiToStore(this);
                context.dispatch({
                    type: "REMOVE_EVENTS",
                    eventStore: asStore
                });
                context.emitter.trigger("eventRemove", {
                    event: this,
                    relatedEvents: [],
                    revert: function() {
                        context.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: asStore
                        });
                    }
                });
            }
        },
        {
            key: "source",
            get: function get() {
                var sourceId = this._def.sourceId;
                if (sourceId) return new $8c023e653ef8da49$var$EventSourceImpl(this._context, this._context.getCurrentData().eventSources[sourceId]);
                return null;
            }
        },
        {
            key: "start",
            get: function get() {
                return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
            }
        },
        {
            key: "startStr",
            get: function get() {
                var instance = this._instance;
                if (instance) return this._context.dateEnv.formatIso(instance.range.start, {
                    omitTime: this._def.allDay,
                    forcedTzo: instance.forcedStartTzo
                });
                return "";
            }
        },
        {
            key: "endStr",
            get: function get() {
                var instance = this._instance;
                if (instance && this._def.hasEnd) return this._context.dateEnv.formatIso(instance.range.end, {
                    omitTime: this._def.allDay,
                    forcedTzo: instance.forcedEndTzo
                });
                return "";
            }
        },
        {
            key: "id",
            get: // computable props that all access the def
            // TODO: find a TypeScript-compatible way to do this at scale
            function get() {
                return this._def.publicId;
            }
        },
        {
            key: "groupId",
            get: function get() {
                return this._def.groupId;
            }
        },
        {
            key: "allDay",
            get: function get() {
                return this._def.allDay;
            }
        },
        {
            key: "title",
            get: function get() {
                return this._def.title;
            }
        },
        {
            key: "url",
            get: function get() {
                return this._def.url;
            }
        },
        {
            key: "display",
            get: function get() {
                return this._def.ui.display || "auto";
            } // bad. just normalize the type earlier
        },
        {
            key: "startEditable",
            get: function get() {
                return this._def.ui.startEditable;
            }
        },
        {
            key: "durationEditable",
            get: function get() {
                return this._def.ui.durationEditable;
            }
        },
        {
            key: "constraint",
            get: function get() {
                return this._def.ui.constraints[0] || null;
            }
        },
        {
            key: "overlap",
            get: function get() {
                return this._def.ui.overlap;
            }
        },
        {
            key: "allow",
            get: function get() {
                return this._def.ui.allows[0] || null;
            }
        },
        {
            key: "backgroundColor",
            get: function get() {
                return this._def.ui.backgroundColor;
            }
        },
        {
            key: "borderColor",
            get: function get() {
                return this._def.ui.borderColor;
            }
        },
        {
            key: "textColor",
            get: function get() {
                return this._def.ui.textColor;
            }
        },
        {
            key: "classNames",
            get: // NOTE: user can't modify these because Object.freeze was called in event-def parsing
            function get() {
                return this._def.ui.classNames;
            }
        },
        {
            key: "extendedProps",
            get: function get() {
                return this._def.extendedProps;
            }
        },
        {
            key: "toPlainObject",
            value: function toPlainObject() {
                var settings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var def = this._def;
                var ui = def.ui;
                var _this = this, startStr = _this.startStr, endStr = _this.endStr;
                var res = {
                    allDay: def.allDay
                };
                if (def.title) res.title = def.title;
                if (startStr) res.start = startStr;
                if (endStr) res.end = endStr;
                if (def.publicId) res.id = def.publicId;
                if (def.groupId) res.groupId = def.groupId;
                if (def.url) res.url = def.url;
                if (ui.display && ui.display !== "auto") res.display = ui.display;
                // TODO: what about recurring-event properties???
                // TODO: include startEditable/durationEditable/constraint/overlap/allow
                if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) res.color = ui.backgroundColor;
                else {
                    if (ui.backgroundColor) res.backgroundColor = ui.backgroundColor;
                    if (ui.borderColor) res.borderColor = ui.borderColor;
                }
                if (ui.textColor) res.textColor = ui.textColor;
                if (ui.classNames.length) res.classNames = ui.classNames;
                if (Object.keys(def.extendedProps).length) {
                    if (settings.collapseExtendedProps) Object.assign(res, def.extendedProps);
                    else res.extendedProps = def.extendedProps;
                }
                return res;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.toPlainObject();
            }
        }
    ]);
    return EventImpl;
}();
function $8c023e653ef8da49$var$eventApiToStore(eventApi) {
    var def = eventApi._def;
    var instance = eventApi._instance;
    return {
        defs: (0, $8EGc6._)({}, def.defId, def),
        instances: instance ? (0, $8EGc6._)({}, instance.instanceId, instance) : {}
    };
}
function $8c023e653ef8da49$export$efccba1c4a2ef57b(eventStore, context, excludeInstance) {
    var defs = eventStore.defs, instances = eventStore.instances;
    var eventApis = [];
    var excludeInstanceId = excludeInstance ? excludeInstance.instanceId : "";
    for(var id in instances){
        var instance = instances[id];
        var def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) eventApis.push(new $8c023e653ef8da49$export$34aec0b863436764(context, def, instance));
    }
    return eventApis;
}
/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/ function $8c023e653ef8da49$export$c9170ad7d4cd7e57(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    var inverseBgByGroupId = {};
    var inverseBgByDefId = {};
    var defByGroupId = {};
    var bgRanges = [];
    var fgRanges = [];
    var eventUis = $8c023e653ef8da49$var$compileEventUis(eventStore.defs, eventUiBases);
    for(var defId in eventStore.defs){
        var def = eventStore.defs[defId];
        var ui = eventUis[def.defId];
        if (ui.display === "inverse-background") {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) defByGroupId[def.groupId] = def;
            } else inverseBgByDefId[defId] = [];
        }
    }
    for(var instanceId in eventStore.instances){
        var instance = eventStore.instances[instanceId];
        var def1 = eventStore.defs[instance.defId];
        var ui1 = eventUis[def1.defId];
        var origRange = instance.range;
        var normalRange = !def1.allDay && nextDayThreshold ? $8c023e653ef8da49$export$28f7fcd39efa255(origRange, nextDayThreshold) : origRange;
        var slicedRange = $8c023e653ef8da49$export$ae1af26003f05816(normalRange, framingRange);
        if (slicedRange) {
            if (ui1.display === "inverse-background") {
                if (def1.groupId) inverseBgByGroupId[def1.groupId].push(slicedRange);
                else inverseBgByDefId[instance.defId].push(slicedRange);
            } else if (ui1.display !== "none") (ui1.display === "background" ? bgRanges : fgRanges).push({
                def: def1,
                ui: ui1,
                instance: instance,
                range: slicedRange,
                isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
            });
        }
    }
    for(var groupId in inverseBgByGroupId){
        var ranges = inverseBgByGroupId[groupId];
        var invertedRanges = $8c023e653ef8da49$var$invertRanges(ranges, framingRange);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = invertedRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var invertedRange = _step.value;
                var def2 = defByGroupId[groupId];
                var ui2 = eventUis[def2.defId];
                bgRanges.push({
                    def: def2,
                    ui: ui2,
                    instance: null,
                    range: invertedRange,
                    isStart: false,
                    isEnd: false
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    for(var defId1 in inverseBgByDefId){
        var ranges1 = inverseBgByDefId[defId1];
        var invertedRanges1 = $8c023e653ef8da49$var$invertRanges(ranges1, framingRange);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = invertedRanges1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var invertedRange1 = _step1.value;
                bgRanges.push({
                    def: eventStore.defs[defId1],
                    ui: eventUis[defId1],
                    instance: null,
                    range: invertedRange1,
                    isStart: false,
                    isEnd: false
                });
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return {
        bg: bgRanges,
        fg: fgRanges
    };
}
function $8c023e653ef8da49$export$a91cd623adc48128(def) {
    return def.ui.display === "background" || def.ui.display === "inverse-background";
}
function $8c023e653ef8da49$var$setElSeg(el, seg) {
    el.fcSeg = seg;
}
function $8c023e653ef8da49$export$71511d61b312f219(el) {
    return el.fcSeg || el.parentNode.fcSeg || // for the harness
    null;
}
// event ui computation
function $8c023e653ef8da49$var$compileEventUis(eventDefs, eventUiBases) {
    return $8c023e653ef8da49$export$407448d2b89b1813(eventDefs, function(eventDef) {
        return $8c023e653ef8da49$var$compileEventUi(eventDef, eventUiBases);
    });
}
function $8c023e653ef8da49$var$compileEventUi(eventDef, eventUiBases) {
    var uis = [];
    if (eventUiBases[""]) uis.push(eventUiBases[""]);
    if (eventUiBases[eventDef.defId]) uis.push(eventUiBases[eventDef.defId]);
    uis.push(eventDef.ui);
    return $8c023e653ef8da49$export$1a8f5705751d8277(uis);
}
function $8c023e653ef8da49$export$4d522598b426bb73(segs, eventOrderSpecs) {
    var objs = segs.map($8c023e653ef8da49$var$buildSegCompareObj);
    objs.sort(function(obj0, obj1) {
        return $8c023e653ef8da49$export$2f6ca3d3b1f80bf5(obj0, obj1, eventOrderSpecs);
    });
    return objs.map(function(c) {
        return c._seg;
    });
}
// returns a object with all primitive props that can be compared
function $8c023e653ef8da49$var$buildSegCompareObj(seg) {
    var eventRange = seg.eventRange;
    var eventDef = eventRange.def;
    var range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    var start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    var end = range.end ? range.end.valueOf() : 0; // "
    return Object.assign(Object.assign(Object.assign({}, eventDef.extendedProps), eventDef), {
        id: eventDef.publicId,
        start: start,
        end: end,
        duration: end - start,
        allDay: Number(eventDef.allDay),
        _seg: seg
    });
}
function $8c023e653ef8da49$var$computeSegDraggable(seg, context) {
    var pluginHooks = context.pluginHooks;
    var transformers = pluginHooks.isDraggableTransformers;
    var _seg_eventRange = seg.eventRange, def = _seg_eventRange.def, ui = _seg_eventRange.ui;
    var val = ui.startEditable;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = transformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transformer = _step.value;
            val = transformer(val, def, ui, context);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return val;
}
function $8c023e653ef8da49$var$computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function $8c023e653ef8da49$var$computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function $8c023e653ef8da49$export$993a080e5cb62d74(seg, timeFormat, context, defaultDisplayEventTime, defaultDisplayEventEnd, startOverride, endOverride) {
    var dateEnv = context.dateEnv, options = context.options;
    var displayEventTime = options.displayEventTime, displayEventEnd = options.displayEventEnd;
    var eventDef = seg.eventRange.def;
    var eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) displayEventTime = defaultDisplayEventTime !== false;
    if (displayEventEnd == null) displayEventEnd = defaultDisplayEventEnd !== false;
    var wholeEventStart = eventInstance.range.start;
    var wholeEventEnd = eventInstance.range.end;
    var segStart = startOverride || seg.start || seg.eventRange.range.start;
    var segEnd = endOverride || seg.end || seg.eventRange.range.end;
    var isStartDay = $8c023e653ef8da49$export$9e5f44173e64f162(wholeEventStart).valueOf() === $8c023e653ef8da49$export$9e5f44173e64f162(segStart).valueOf();
    var isEndDay = $8c023e653ef8da49$export$9e5f44173e64f162($8c023e653ef8da49$export$136fd86de524d3c2(wholeEventEnd, -1)).valueOf() === $8c023e653ef8da49$export$9e5f44173e64f162($8c023e653ef8da49$export$136fd86de524d3c2(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) return dateEnv.formatRange(segStart, segEnd, timeFormat, {
            forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
            forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
        });
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo
        });
    }
    return "";
}
function $8c023e653ef8da49$export$6dabbe08653f866f(seg, todayRange, nowDate) {
    var segRange = seg.eventRange.range;
    return {
        isPast: segRange.end < (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && $8c023e653ef8da49$export$7f8ddf7c7c20b3cd(todayRange, segRange.start)
    };
}
function $8c023e653ef8da49$var$getEventClassNames(props) {
    var classNames = [
        "fc-event"
    ];
    if (props.isMirror) classNames.push("fc-event-mirror");
    if (props.isDraggable) classNames.push("fc-event-draggable");
    if (props.isStartResizable || props.isEndResizable) classNames.push("fc-event-resizable");
    if (props.isDragging) classNames.push("fc-event-dragging");
    if (props.isResizing) classNames.push("fc-event-resizing");
    if (props.isSelected) classNames.push("fc-event-selected");
    if (props.isStart) classNames.push("fc-event-start");
    if (props.isEnd) classNames.push("fc-event-end");
    if (props.isPast) classNames.push("fc-event-past");
    if (props.isToday) classNames.push("fc-event-today");
    if (props.isFuture) classNames.push("fc-event-future");
    return classNames;
}
function $8c023e653ef8da49$export$1314441b8d04e1d5(eventRange) {
    return eventRange.instance ? eventRange.instance.instanceId : "".concat(eventRange.def.defId, ":").concat(eventRange.range.start.toISOString());
// inverse-background events don't have specific instances. TODO: better solution
}
function $8c023e653ef8da49$export$e0c3a065614c6254(seg, context) {
    var _seg_eventRange = seg.eventRange, def = _seg_eventRange.def, instance = _seg_eventRange.instance;
    var url = def.url;
    if (url) return {
        href: url
    };
    var emitter = context.emitter, options = context.options;
    var eventInteractive = options.eventInteractive;
    if (eventInteractive == null) {
        eventInteractive = def.interactive;
        if (eventInteractive == null) eventInteractive = Boolean(emitter.hasHandlers("eventClick"));
    }
    // mock what happens in EventClicking
    if (eventInteractive) // only attach keyboard-related handlers because click handler is already done in EventClicking
    return $8c023e653ef8da49$var$createAriaKeyboardAttrs(function(ev) {
        emitter.trigger("eventClick", {
            el: ev.target,
            event: new $8c023e653ef8da49$export$34aec0b863436764(context, def, instance),
            jsEvent: ev,
            view: context.viewApi
        });
    });
    return {};
}
var $8c023e653ef8da49$var$STANDARD_PROPS = {
    start: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    end: $8c023e653ef8da49$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
function $8c023e653ef8da49$var$parseDateSpan(raw, dateEnv, defaultDuration) {
    var span = $8c023e653ef8da49$var$parseOpenDateSpan(raw, dateEnv);
    var range = span.range;
    if (!range.start) return null;
    if (!range.end) {
        if (defaultDuration == null) return null;
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/ function $8c023e653ef8da49$var$parseOpenDateSpan(raw, dateEnv) {
    var _refineProps = $8c023e653ef8da49$export$f38c853ae54ed474(raw, $8c023e653ef8da49$var$STANDARD_PROPS), standardProps = _refineProps.refined, extra = _refineProps.extra;
    var startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    var endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    var allDay = standardProps.allDay;
    if (allDay == null) allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
    return Object.assign({
        range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null
        },
        allDay: allDay
    }, extra);
}
function $8c023e653ef8da49$export$151db275011178c4(span0, span1) {
    return $8c023e653ef8da49$export$f074adc9fbd50943(span0.range, span1.range) && span0.allDay === span1.allDay && $8c023e653ef8da49$var$isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function $8c023e653ef8da49$var$isSpanPropsEqual(span0, span1) {
    for(var propName in span1)if (propName !== "range" && propName !== "allDay") {
        if (span0[propName] !== span1[propName]) return false;
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for(var propName1 in span0){
        if (!(propName1 in span1)) return false;
    }
    return true;
}
function $8c023e653ef8da49$var$buildDateSpanApi(span, dateEnv) {
    return Object.assign(Object.assign({}, $8c023e653ef8da49$var$buildRangeApi(span.range, dateEnv, span.allDay)), {
        allDay: span.allDay
    });
}
function $8c023e653ef8da49$export$882b5998b3b9117c(range, dateEnv, omitTime) {
    return Object.assign(Object.assign({}, $8c023e653ef8da49$var$buildRangeApi(range, dateEnv, omitTime)), {
        timeZone: dateEnv.timeZone
    });
}
function $8c023e653ef8da49$var$buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, {
            omitTime: omitTime
        }),
        endStr: dateEnv.formatIso(range.end, {
            omitTime: omitTime
        })
    };
}
function $8c023e653ef8da49$var$fabricateEventRange(dateSpan, eventUiBases, context) {
    var res = $8c023e653ef8da49$export$ab83b03e4111b1d0({
        editable: false
    }, context);
    var def = $8c023e653ef8da49$export$21579262ef46735b(res.refined, res.extra, "", dateSpan.allDay, true, context);
    return {
        def: def,
        ui: $8c023e653ef8da49$var$compileEventUi(def, eventUiBases),
        instance: $8c023e653ef8da49$export$3b513254972cfc9c(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true
    };
}
/*
given a function that resolves a result asynchronously.
the function can either call passed-in success and failure callbacks,
or it can return a promise.
if you need to pass additional params to func, bind them first.
*/ function $8c023e653ef8da49$export$3b14a55fb2447963(func, normalizedSuccessCallback, normalizedFailureCallback) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    var isResolved = false;
    var wrappedSuccess = function wrappedSuccess(res) {
        if (!isResolved) {
            isResolved = true;
            normalizedSuccessCallback(res);
        }
    };
    var wrappedFailure = function wrappedFailure(error) {
        if (!isResolved) {
            isResolved = true;
            normalizedFailureCallback(error);
        }
    };
    var res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === "function") res.then(wrappedSuccess, wrappedFailure);
}
var $8c023e653ef8da49$export$ee7c8ad385a60b7b = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dACZV._)(JsonRequestError, Error1);
    var _super = (0, $jhb1H._)(JsonRequestError);
    function JsonRequestError(message, response) {
        (0, $5kWiG._)(this, JsonRequestError);
        var _this;
        _this = _super.call(this, message);
        _this.response = response;
        return _this;
    }
    return JsonRequestError;
}((0, $9CX8V._)(Error));
function $8c023e653ef8da49$export$43caf9889c228507(method, url, params) {
    method = method.toUpperCase();
    var fetchOptions = {
        method: method
    };
    if (method === "GET") url += (url.indexOf("?") === -1 ? "?" : "&") + new URLSearchParams(params);
    else {
        fetchOptions.body = new URLSearchParams(params);
        fetchOptions.headers = {
            "Content-Type": "application/x-www-form-urlencoded"
        };
    }
    return fetch(url, fetchOptions).then(function(fetchRes) {
        if (fetchRes.ok) return fetchRes.json().then(function(parsedResponse) {
            return [
                parsedResponse,
                fetchRes
            ];
        }, function() {
            throw new $8c023e653ef8da49$export$ee7c8ad385a60b7b("Failure parsing JSON", fetchRes);
        });
        else throw new $8c023e653ef8da49$export$ee7c8ad385a60b7b("Request failed", fetchRes);
    });
}
var $8c023e653ef8da49$var$canVGrowWithinCell;
function $8c023e653ef8da49$export$667d3bf0c5f83305() {
    if ($8c023e653ef8da49$var$canVGrowWithinCell == null) $8c023e653ef8da49$var$canVGrowWithinCell = $8c023e653ef8da49$var$computeCanVGrowWithinCell();
    return $8c023e653ef8da49$var$canVGrowWithinCell;
}
function $8c023e653ef8da49$var$computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === "undefined") return true;
    var el = document.createElement("div");
    el.style.position = "absolute";
    el.style.top = "0px";
    el.style.left = "0px";
    el.innerHTML = "<table><tr><td><div></div></td></tr></table>";
    el.querySelector("table").style.height = "100px";
    el.querySelector("div").style.height = "100%";
    document.body.appendChild(el);
    var div = el.querySelector("div");
    var possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}
var $8c023e653ef8da49$export$555508cbc6add439 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(CalendarRoot, BaseComponent);
    var _super = (0, $jhb1H._)(CalendarRoot);
    function CalendarRoot() {
        (0, $5kWiG._)(this, CalendarRoot);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.state = {
            forPrint: false
        };
        _this.handleBeforePrint = function() {
            _this.setState({
                forPrint: true
            });
        };
        _this.handleAfterPrint = function() {
            _this.setState({
                forPrint: false
            });
        };
        return _this;
    }
    (0, $hHaEF._)(CalendarRoot, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var options = props.options;
                var forPrint = this.state.forPrint;
                var isHeightAuto = forPrint || options.height === "auto" || options.contentHeight === "auto";
                var height = !isHeightAuto && options.height != null ? options.height : "";
                var classNames = [
                    "fc",
                    forPrint ? "fc-media-print" : "fc-media-screen",
                    "fc-direction-".concat(options.direction),
                    props.theme.getClass("root")
                ];
                if (!$8c023e653ef8da49$export$667d3bf0c5f83305()) classNames.push("fc-liquid-hack");
                return props.children(classNames, height, isHeightAuto, forPrint);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var emitter = this.props.emitter;
                emitter.on("_beforeprint", this.handleBeforePrint);
                emitter.on("_afterprint", this.handleAfterPrint);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var emitter = this.props.emitter;
                emitter.off("_beforeprint", this.handleBeforePrint);
                emitter.off("_afterprint", this.handleAfterPrint);
            }
        }
    ]);
    return CalendarRoot;
}($8c023e653ef8da49$export$ef35774e6d314e91);
var $8c023e653ef8da49$export$dc98b0b04f4c7758 = /*#__PURE__*/ function() {
    "use strict";
    function Interaction(settings) {
        (0, $5kWiG._)(this, Interaction);
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
    (0, $hHaEF._)(Interaction, [
        {
            key: "destroy",
            value: function destroy() {}
        }
    ]);
    return Interaction;
}();
function $8c023e653ef8da49$export$2e2af4578d910ddf(component, input) {
    return {
        component: component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null
    };
}
function $8c023e653ef8da49$export$aff10ba49ece4b91(settings) {
    return (0, $8EGc6._)({}, settings.component.uid, settings);
}
// global state
var $8c023e653ef8da49$export$a93c5207d687da10 = {};
var $8c023e653ef8da49$export$a9c996f45e5784d0 = /*#__PURE__*/ function() {
    "use strict";
    function CalendarImpl() {
        (0, $5kWiG._)(this, CalendarImpl);
    }
    (0, $hHaEF._)(CalendarImpl, [
        {
            key: "getCurrentData",
            value: function getCurrentData() {
                return this.currentDataManager.getCurrentData();
            }
        },
        {
            key: "dispatch",
            value: function dispatch(action) {
                this.currentDataManager.dispatch(action);
            }
        },
        {
            key: "view",
            get: function get() {
                return this.getCurrentData().viewApi;
            }
        },
        {
            key: "batchRendering",
            value: function batchRendering(callback) {
                callback();
            }
        },
        {
            key: "updateSize",
            value: function updateSize() {
                this.trigger("_resize", true);
            }
        },
        {
            // Options
            // -----------------------------------------------------------------------------------------------------------------
            key: "setOption",
            value: function setOption(name, val) {
                this.dispatch({
                    type: "SET_OPTION",
                    optionName: name,
                    rawOptionValue: val
                });
            }
        },
        {
            key: "getOption",
            value: function getOption(name) {
                return this.currentDataManager.currentCalendarOptionsInput[name];
            }
        },
        {
            key: "getAvailableLocaleCodes",
            value: function getAvailableLocaleCodes() {
                return Object.keys(this.getCurrentData().availableRawLocales);
            }
        },
        {
            // Trigger
            // -----------------------------------------------------------------------------------------------------------------
            key: "on",
            value: function on(handlerName, handler) {
                var currentDataManager = this.currentDataManager;
                if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) currentDataManager.emitter.on(handlerName, handler);
                else console.warn("Unknown listener name '".concat(handlerName, "'"));
            }
        },
        {
            key: "off",
            value: function off(handlerName, handler) {
                this.currentDataManager.emitter.off(handlerName, handler);
            }
        },
        {
            // not meant for public use
            key: "trigger",
            value: function trigger(handlerName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this_currentDataManager_emitter;
                (_this_currentDataManager_emitter = this.currentDataManager.emitter).trigger.apply(_this_currentDataManager_emitter, [
                    handlerName
                ].concat((0, $5TJQB._)(args)));
            }
        },
        {
            // View
            // -----------------------------------------------------------------------------------------------------------------
            key: "changeView",
            value: function changeView(viewType, dateOrRange) {
                var _this = this;
                this.batchRendering(function() {
                    _this.unselect();
                    if (dateOrRange) {
                        if (dateOrRange.start && dateOrRange.end) {
                            _this.dispatch({
                                type: "CHANGE_VIEW_TYPE",
                                viewType: viewType
                            });
                            _this.dispatch({
                                type: "SET_OPTION",
                                optionName: "visibleRange",
                                rawOptionValue: dateOrRange
                            });
                        } else {
                            var dateEnv = _this.getCurrentData().dateEnv;
                            _this.dispatch({
                                type: "CHANGE_VIEW_TYPE",
                                viewType: viewType,
                                dateMarker: dateEnv.createMarker(dateOrRange)
                            });
                        }
                    } else _this.dispatch({
                        type: "CHANGE_VIEW_TYPE",
                        viewType: viewType
                    });
                });
            }
        },
        {
            // Forces navigation to a view for the given date.
            // `viewType` can be a specific view name or a generic one like "week" or "day".
            // needs to change
            key: "zoomTo",
            value: function zoomTo(dateMarker, viewType) {
                var state = this.getCurrentData();
                var spec;
                viewType = viewType || "day"; // day is default zoom
                spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
                this.unselect();
                if (spec) this.dispatch({
                    type: "CHANGE_VIEW_TYPE",
                    viewType: spec.type,
                    dateMarker: dateMarker
                });
                else this.dispatch({
                    type: "CHANGE_DATE",
                    dateMarker: dateMarker
                });
            }
        },
        {
            // Given a duration singular unit, like "week" or "day", finds a matching view spec.
            // Preference is given to views that have corresponding buttons.
            key: "getUnitViewSpec",
            value: function getUnitViewSpec(unit) {
                var _this_getCurrentData = this.getCurrentData(), viewSpecs = _this_getCurrentData.viewSpecs, toolbarConfig = _this_getCurrentData.toolbarConfig;
                var viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
                var i;
                var spec;
                for(var viewType in viewSpecs)viewTypes.push(viewType);
                for(i = 0; i < viewTypes.length; i += 1){
                    spec = viewSpecs[viewTypes[i]];
                    if (spec) {
                        if (spec.singleUnit === unit) return spec;
                    }
                }
                return null;
            }
        },
        {
            // Current Date
            // -----------------------------------------------------------------------------------------------------------------
            key: "prev",
            value: function prev() {
                this.unselect();
                this.dispatch({
                    type: "PREV"
                });
            }
        },
        {
            key: "next",
            value: function next() {
                this.unselect();
                this.dispatch({
                    type: "NEXT"
                });
            }
        },
        {
            key: "prevYear",
            value: function prevYear() {
                var state = this.getCurrentData();
                this.unselect();
                this.dispatch({
                    type: "CHANGE_DATE",
                    dateMarker: state.dateEnv.addYears(state.currentDate, -1)
                });
            }
        },
        {
            key: "nextYear",
            value: function nextYear() {
                var state = this.getCurrentData();
                this.unselect();
                this.dispatch({
                    type: "CHANGE_DATE",
                    dateMarker: state.dateEnv.addYears(state.currentDate, 1)
                });
            }
        },
        {
            key: "today",
            value: function today() {
                var state = this.getCurrentData();
                this.unselect();
                this.dispatch({
                    type: "CHANGE_DATE",
                    dateMarker: $8c023e653ef8da49$export$c3950d9923825c02(state.calendarOptions.now, state.dateEnv)
                });
            }
        },
        {
            key: "gotoDate",
            value: function gotoDate(zonedDateInput) {
                var state = this.getCurrentData();
                this.unselect();
                this.dispatch({
                    type: "CHANGE_DATE",
                    dateMarker: state.dateEnv.createMarker(zonedDateInput)
                });
            }
        },
        {
            key: "incrementDate",
            value: function incrementDate(deltaInput) {
                var state = this.getCurrentData();
                var delta = $8c023e653ef8da49$export$4368d992c4eafac0(deltaInput);
                if (delta) {
                    this.unselect();
                    this.dispatch({
                        type: "CHANGE_DATE",
                        dateMarker: state.dateEnv.add(state.currentDate, delta)
                    });
                }
            }
        },
        {
            key: "getDate",
            value: function getDate() {
                var state = this.getCurrentData();
                return state.dateEnv.toDate(state.currentDate);
            }
        },
        {
            // Date Formatting Utils
            // -----------------------------------------------------------------------------------------------------------------
            key: "formatDate",
            value: function formatDate(d, formatter) {
                var dateEnv = this.getCurrentData().dateEnv;
                return dateEnv.format(dateEnv.createMarker(d), $8c023e653ef8da49$export$d141bba7fdc215a3(formatter));
            }
        },
        {
            // `settings` is for formatter AND isEndExclusive
            key: "formatRange",
            value: function formatRange(d0, d1, settings) {
                var dateEnv = this.getCurrentData().dateEnv;
                return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), $8c023e653ef8da49$export$d141bba7fdc215a3(settings), settings);
            }
        },
        {
            key: "formatIso",
            value: function formatIso(d, omitTime) {
                var dateEnv = this.getCurrentData().dateEnv;
                return dateEnv.formatIso(dateEnv.createMarker(d), {
                    omitTime: omitTime
                });
            }
        },
        {
            // Date Selection / Event Selection / DayClick
            // -----------------------------------------------------------------------------------------------------------------
            key: "select",
            value: function select(dateOrObj, endDate) {
                var selectionInput;
                if (endDate == null) {
                    if (dateOrObj.start != null) selectionInput = dateOrObj;
                    else selectionInput = {
                        start: dateOrObj,
                        end: null
                    };
                } else selectionInput = {
                    start: dateOrObj,
                    end: endDate
                };
                var state = this.getCurrentData();
                var selection = $8c023e653ef8da49$var$parseDateSpan(selectionInput, state.dateEnv, $8c023e653ef8da49$export$4368d992c4eafac0({
                    days: 1
                }));
                if (selection) {
                    this.dispatch({
                        type: "SELECT_DATES",
                        selection: selection
                    });
                    $8c023e653ef8da49$export$9ddbdd0bfc5623a(selection, null, state);
                }
            }
        },
        {
            key: "unselect",
            value: function unselect(pev) {
                var state = this.getCurrentData();
                if (state.dateSelection) {
                    this.dispatch({
                        type: "UNSELECT_DATES"
                    });
                    $8c023e653ef8da49$var$triggerDateUnselect(pev, state);
                }
            }
        },
        {
            // Public Events API
            // -----------------------------------------------------------------------------------------------------------------
            key: "addEvent",
            value: function addEvent(eventInput, sourceInput) {
                if (eventInput instanceof $8c023e653ef8da49$export$34aec0b863436764) {
                    var def = eventInput._def;
                    var instance = eventInput._instance;
                    var currentData = this.getCurrentData();
                    // not already present? don't want to add an old snapshot
                    if (!currentData.eventStore.defs[def.defId]) {
                        this.dispatch({
                            type: "ADD_EVENTS",
                            eventStore: $8c023e653ef8da49$export$9d0e2d13d04f7070({
                                def: def,
                                instance: instance
                            })
                        });
                        this.triggerEventAdd(eventInput);
                    }
                    return eventInput;
                }
                var state = this.getCurrentData();
                var eventSource;
                var ref;
                if (sourceInput instanceof $8c023e653ef8da49$var$EventSourceImpl) eventSource = sourceInput.internalEventSource;
                else if (typeof sourceInput === "boolean") {
                    if (sourceInput) ref = (0, $5TLNx._)($8c023e653ef8da49$export$90a7f3efeed30595(state.eventSources), 1), eventSource = ref[0], ref;
                } else if (sourceInput != null) {
                    var sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
                    if (!sourceApi) {
                        console.warn('Could not find an event source with ID "'.concat(sourceInput, '"')); // TODO: test
                        return null;
                    }
                    eventSource = sourceApi.internalEventSource;
                }
                var tuple = $8c023e653ef8da49$var$parseEvent(eventInput, eventSource, state, false);
                if (tuple) {
                    var newEventApi = new $8c023e653ef8da49$export$34aec0b863436764(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
                    this.dispatch({
                        type: "ADD_EVENTS",
                        eventStore: $8c023e653ef8da49$export$9d0e2d13d04f7070(tuple)
                    });
                    this.triggerEventAdd(newEventApi);
                    return newEventApi;
                }
                return null;
            }
        },
        {
            key: "triggerEventAdd",
            value: function triggerEventAdd(eventApi) {
                var _this = this;
                var emitter = this.getCurrentData().emitter;
                emitter.trigger("eventAdd", {
                    event: eventApi,
                    relatedEvents: [],
                    revert: function() {
                        _this.dispatch({
                            type: "REMOVE_EVENTS",
                            eventStore: $8c023e653ef8da49$var$eventApiToStore(eventApi)
                        });
                    }
                });
            }
        },
        {
            // TODO: optimize
            key: "getEventById",
            value: function getEventById(id) {
                var state = this.getCurrentData();
                var _state_eventStore = state.eventStore, defs = _state_eventStore.defs, instances = _state_eventStore.instances;
                id = String(id);
                for(var defId in defs){
                    var def = defs[defId];
                    if (def.publicId === id) {
                        if (def.recurringDef) return new $8c023e653ef8da49$export$34aec0b863436764(state, def, null);
                        for(var instanceId in instances){
                            var instance = instances[instanceId];
                            if (instance.defId === def.defId) return new $8c023e653ef8da49$export$34aec0b863436764(state, def, instance);
                        }
                    }
                }
                return null;
            }
        },
        {
            key: "getEvents",
            value: function getEvents() {
                var currentData = this.getCurrentData();
                return $8c023e653ef8da49$export$efccba1c4a2ef57b(currentData.eventStore, currentData);
            }
        },
        {
            key: "removeAllEvents",
            value: function removeAllEvents() {
                this.dispatch({
                    type: "REMOVE_ALL_EVENTS"
                });
            }
        },
        {
            // Public Event Sources API
            // -----------------------------------------------------------------------------------------------------------------
            key: "getEventSources",
            value: function getEventSources() {
                var state = this.getCurrentData();
                var sourceHash = state.eventSources;
                var sourceApis = [];
                for(var internalId in sourceHash)sourceApis.push(new $8c023e653ef8da49$var$EventSourceImpl(state, sourceHash[internalId]));
                return sourceApis;
            }
        },
        {
            key: "getEventSourceById",
            value: function getEventSourceById(id) {
                var state = this.getCurrentData();
                var sourceHash = state.eventSources;
                id = String(id);
                for(var sourceId in sourceHash){
                    if (sourceHash[sourceId].publicId === id) return new $8c023e653ef8da49$var$EventSourceImpl(state, sourceHash[sourceId]);
                }
                return null;
            }
        },
        {
            key: "addEventSource",
            value: function addEventSource(sourceInput) {
                var state = this.getCurrentData();
                if (sourceInput instanceof $8c023e653ef8da49$var$EventSourceImpl) {
                    // not already present? don't want to add an old snapshot
                    if (!state.eventSources[sourceInput.internalEventSource.sourceId]) this.dispatch({
                        type: "ADD_EVENT_SOURCES",
                        sources: [
                            sourceInput.internalEventSource
                        ]
                    });
                    return sourceInput;
                }
                var eventSource = $8c023e653ef8da49$export$ffb5f4729a158638(sourceInput, state);
                if (eventSource) {
                    this.dispatch({
                        type: "ADD_EVENT_SOURCES",
                        sources: [
                            eventSource
                        ]
                    });
                    return new $8c023e653ef8da49$var$EventSourceImpl(state, eventSource);
                }
                return null;
            }
        },
        {
            key: "removeAllEventSources",
            value: function removeAllEventSources() {
                this.dispatch({
                    type: "REMOVE_ALL_EVENT_SOURCES"
                });
            }
        },
        {
            key: "refetchEvents",
            value: function refetchEvents() {
                this.dispatch({
                    type: "FETCH_EVENT_SOURCES",
                    isRefetch: true
                });
            }
        },
        {
            // Scroll
            // -----------------------------------------------------------------------------------------------------------------
            key: "scrollToTime",
            value: function scrollToTime(timeInput) {
                var time = $8c023e653ef8da49$export$4368d992c4eafac0(timeInput);
                if (time) this.trigger("_scrollRequest", {
                    time: time
                });
            }
        }
    ]);
    return CalendarImpl;
}();
function $8c023e653ef8da49$export$cf2f7c5792f80b46(point, rect) {
    return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function $8c023e653ef8da49$export$158acd800e1ef08b(rect1, rect2) {
    var res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) return res;
    return false;
}
function $8c023e653ef8da49$export$a05254e7c3aeba6e(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function $8c023e653ef8da49$export$53a70dd1ebbae346(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
// Returns a point that is the center of the given rectangle
function $8c023e653ef8da49$export$a33b77bbdbb8366c(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function $8c023e653ef8da49$export$b9a6b53f9be3734(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
var $8c023e653ef8da49$var$EMPTY_EVENT_STORE = $8c023e653ef8da49$export$9bb611d729802a56(); // for purecomponents. TODO: keep elsewhere
var $8c023e653ef8da49$export$e171bab687b50e0 = /*#__PURE__*/ function() {
    "use strict";
    function Splitter() {
        (0, $5kWiG._)(this, Splitter);
        this.getKeysForEventDefs = $8c023e653ef8da49$export$df995fae86a55f06(this._getKeysForEventDefs);
        this.splitDateSelection = $8c023e653ef8da49$export$df995fae86a55f06(this._splitDateSpan);
        this.splitEventStore = $8c023e653ef8da49$export$df995fae86a55f06(this._splitEventStore);
        this.splitIndividualUi = $8c023e653ef8da49$export$df995fae86a55f06(this._splitIndividualUi);
        this.splitEventDrag = $8c023e653ef8da49$export$df995fae86a55f06(this._splitInteraction);
        this.splitEventResize = $8c023e653ef8da49$export$df995fae86a55f06(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
    (0, $hHaEF._)(Splitter, [
        {
            key: "splitProps",
            value: function splitProps(props) {
                var _this = this;
                var keyInfos = this.getKeyInfo(props);
                var defKeys = this.getKeysForEventDefs(props.eventStore);
                var dateSelections = this.splitDateSelection(props.dateSelection);
                var individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
                var eventStores = this.splitEventStore(props.eventStore, defKeys);
                var eventDrags = this.splitEventDrag(props.eventDrag);
                var eventResizes = this.splitEventResize(props.eventResize);
                var splitProps = {};
                this.eventUiBuilders = $8c023e653ef8da49$export$407448d2b89b1813(keyInfos, function(info, key) {
                    return _this.eventUiBuilders[key] || $8c023e653ef8da49$export$df995fae86a55f06($8c023e653ef8da49$var$buildEventUiForKey);
                });
                for(var key in keyInfos){
                    var keyInfo = keyInfos[key];
                    var eventStore = eventStores[key] || $8c023e653ef8da49$var$EMPTY_EVENT_STORE;
                    var buildEventUi = this.eventUiBuilders[key];
                    splitProps[key] = {
                        businessHours: keyInfo.businessHours || props.businessHours,
                        dateSelection: dateSelections[key] || null,
                        eventStore: eventStore,
                        eventUiBases: buildEventUi(props.eventUiBases[""], keyInfo.ui, individualUi[key]),
                        eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : "",
                        eventDrag: eventDrags[key] || null,
                        eventResize: eventResizes[key] || null
                    };
                }
                return splitProps;
            }
        },
        {
            key: "_splitDateSpan",
            value: function _splitDateSpan(dateSpan) {
                var dateSpans = {};
                if (dateSpan) {
                    var keys = this.getKeysForDateSpan(dateSpan);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            dateSpans[key] = dateSpan;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return dateSpans;
            }
        },
        {
            key: "_getKeysForEventDefs",
            value: function _getKeysForEventDefs(eventStore) {
                var _this = this;
                return $8c023e653ef8da49$export$407448d2b89b1813(eventStore.defs, function(eventDef) {
                    return _this.getKeysForEventDef(eventDef);
                });
            }
        },
        {
            key: "_splitEventStore",
            value: function _splitEventStore(eventStore, defKeys) {
                var defs = eventStore.defs, instances = eventStore.instances;
                var splitStores = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                for(var defId in defs)try {
                    for(var _iterator = defKeys[defId][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (!splitStores[key]) splitStores[key] = $8c023e653ef8da49$export$9bb611d729802a56();
                        splitStores[key].defs[defId] = defs[defId];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                for(var instanceId in instances){
                    var instance = instances[instanceId];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = defKeys[instance.defId][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var key1 = _step1.value;
                            if (splitStores[key1]) splitStores[key1].instances[instanceId] = instance;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                return splitStores;
            }
        },
        {
            key: "_splitIndividualUi",
            value: function _splitIndividualUi(eventUiBases, defKeys) {
                var splitHashes = {};
                for(var defId in eventUiBases){
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (defId) try {
                        for(var _iterator = defKeys[defId][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            if (!splitHashes[key]) splitHashes[key] = {};
                            splitHashes[key][defId] = eventUiBases[defId];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return splitHashes;
            }
        },
        {
            key: "_splitInteraction",
            value: function _splitInteraction(interaction) {
                var splitStates = {};
                if (interaction) {
                    var affectedStores = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
                    // can't rely on defKeys because event data is mutated
                    var mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
                    var mutatedStores = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
                    var populate = function(key) {
                        if (!splitStates[key]) splitStates[key] = {
                            affectedEvents: affectedStores[key] || $8c023e653ef8da49$var$EMPTY_EVENT_STORE,
                            mutatedEvents: mutatedStores[key] || $8c023e653ef8da49$var$EMPTY_EVENT_STORE,
                            isEvent: interaction.isEvent
                        };
                    };
                    for(var key in affectedStores)populate(key);
                    for(var key1 in mutatedStores)populate(key1);
                }
                return splitStates;
            }
        }
    ]);
    return Splitter;
}();
function $8c023e653ef8da49$var$buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    var baseParts = [];
    if (allUi) baseParts.push(allUi);
    if (eventUiForKey) baseParts.push(eventUiForKey);
    var stuff = {
        "": $8c023e653ef8da49$export$1a8f5705751d8277(baseParts)
    };
    if (individualUi) Object.assign(stuff, individualUi);
    return stuff;
}
function $8c023e653ef8da49$export$a17c37559e1db147(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && !$8c023e653ef8da49$export$7f8ddf7c7c20b3cd(dateProfile.activeRange, date)),
        isOther: Boolean(dateProfile && !$8c023e653ef8da49$export$7f8ddf7c7c20b3cd(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && $8c023e653ef8da49$export$7f8ddf7c7c20b3cd(todayRange, date)),
        isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
        isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
    };
}
function $8c023e653ef8da49$export$527e9aa3390079e9(meta, theme) {
    var classNames = [
        "fc-day",
        "fc-day-".concat($8c023e653ef8da49$var$DAY_IDS[meta.dow])
    ];
    if (meta.isDisabled) classNames.push("fc-day-disabled");
    else {
        if (meta.isToday) {
            classNames.push("fc-day-today");
            classNames.push(theme.getClass("today"));
        }
        if (meta.isPast) classNames.push("fc-day-past");
        if (meta.isFuture) classNames.push("fc-day-future");
        if (meta.isOther) classNames.push("fc-day-other");
    }
    return classNames;
}
function $8c023e653ef8da49$export$fef3dfd9bad05307(meta, theme) {
    var classNames = [
        "fc-slot",
        "fc-slot-".concat($8c023e653ef8da49$var$DAY_IDS[meta.dow])
    ];
    if (meta.isDisabled) classNames.push("fc-slot-disabled");
    else {
        if (meta.isToday) {
            classNames.push("fc-slot-today");
            classNames.push(theme.getClass("today"));
        }
        if (meta.isPast) classNames.push("fc-slot-past");
        if (meta.isFuture) classNames.push("fc-slot-future");
    }
    return classNames;
}
var $8c023e653ef8da49$var$DAY_FORMAT = $8c023e653ef8da49$export$d141bba7fdc215a3({
    year: "numeric",
    month: "long",
    day: "numeric"
});
var $8c023e653ef8da49$var$WEEK_FORMAT = $8c023e653ef8da49$export$d141bba7fdc215a3({
    week: "long"
});
function $8c023e653ef8da49$export$8c78c7c36408ea29(context, dateMarker) {
    var viewType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "day", isTabbable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var dateEnv = context.dateEnv, options = context.options, calendarApi = context.calendarApi;
    var dateStr = dateEnv.format(dateMarker, viewType === "week" ? $8c023e653ef8da49$var$WEEK_FORMAT : $8c023e653ef8da49$var$DAY_FORMAT);
    if (options.navLinks) {
        var zonedDate = dateEnv.toDate(dateMarker);
        var handleInteraction = function(ev) {
            var customAction = viewType === "day" ? options.navLinkDayClick : viewType === "week" ? options.navLinkWeekClick : null;
            if (typeof customAction === "function") customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
            else {
                if (typeof customAction === "string") viewType = customAction;
                calendarApi.zoomTo(dateMarker, viewType);
            }
        };
        return Object.assign({
            title: $8c023e653ef8da49$export$342063e11d6c3cad(options.navLinkHint, [
                dateStr,
                zonedDate
            ], dateStr),
            "data-navlink": ""
        }, isTabbable ? $8c023e653ef8da49$var$createAriaClickAttrs(handleInteraction) : {
            onClick: handleInteraction
        });
    }
    return {
        "aria-label": dateStr
    };
}
var $8c023e653ef8da49$var$_isRtlScrollbarOnLeft = null;
function $8c023e653ef8da49$export$6735ce526161c7bd() {
    if ($8c023e653ef8da49$var$_isRtlScrollbarOnLeft === null) $8c023e653ef8da49$var$_isRtlScrollbarOnLeft = $8c023e653ef8da49$var$computeIsRtlScrollbarOnLeft();
    return $8c023e653ef8da49$var$_isRtlScrollbarOnLeft;
}
function $8c023e653ef8da49$var$computeIsRtlScrollbarOnLeft() {
    var outerEl = document.createElement("div");
    $8c023e653ef8da49$export$2ed0fc6709e59212(outerEl, {
        position: "absolute",
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: "scroll",
        direction: "rtl"
    });
    outerEl.innerHTML = "<div></div>";
    document.body.appendChild(outerEl);
    var innerEl = outerEl.firstChild;
    var res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    $8c023e653ef8da49$export$c03999cb2f36933f(outerEl);
    return res;
}
var $8c023e653ef8da49$var$_scrollbarWidths;
function $8c023e653ef8da49$export$c7ca7e4bc4f8a16e() {
    if (!$8c023e653ef8da49$var$_scrollbarWidths) $8c023e653ef8da49$var$_scrollbarWidths = $8c023e653ef8da49$var$computeScrollbarWidths();
    return $8c023e653ef8da49$var$_scrollbarWidths;
}
function $8c023e653ef8da49$var$computeScrollbarWidths() {
    var el = document.createElement("div");
    el.style.overflow = "scroll";
    el.style.position = "absolute";
    el.style.top = "-9999px";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    var res = $8c023e653ef8da49$var$computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function $8c023e653ef8da49$var$computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth
    };
}
function $8c023e653ef8da49$export$39c1cc7c062529d4(el) {
    var getPadding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var computedStyle = window.getComputedStyle(el);
    var borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    var borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    var borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    var borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    var badScrollbarWidths = $8c023e653ef8da49$var$computeScrollbarWidthsForEl(el); // includes border!
    var scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    var scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    var res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0
    };
    if ($8c023e653ef8da49$export$6735ce526161c7bd() && computedStyle.direction === "rtl") res.scrollbarLeft = scrollbarLeftRight;
    else res.scrollbarRight = scrollbarLeftRight;
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function $8c023e653ef8da49$export$53c86fa97d611818(el) {
    var goWithinPadding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, doFromWindowViewport = arguments.length > 2 ? arguments[2] : void 0;
    var outerRect = doFromWindowViewport ? el.getBoundingClientRect() : $8c023e653ef8da49$export$c18d01048907ea92(el);
    var edges = $8c023e653ef8da49$export$39c1cc7c062529d4(el, goWithinPadding);
    var res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function $8c023e653ef8da49$export$c18d01048907ea92(el) {
    var rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.pageXOffset,
        top: rect.top + window.pageYOffset,
        right: rect.right + window.pageXOffset,
        bottom: rect.bottom + window.pageYOffset
    };
}
function $8c023e653ef8da49$var$computeClippedClientRect(el) {
    var clippingParents = $8c023e653ef8da49$export$7a0bdf7d4a91ea88(el);
    var rect = el.getBoundingClientRect();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = clippingParents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var clippingParent = _step.value;
            var intersection = $8c023e653ef8da49$export$158acd800e1ef08b(rect, clippingParent.getBoundingClientRect());
            if (intersection) rect = intersection;
            else return null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return rect;
}
// does not return window
function $8c023e653ef8da49$export$7a0bdf7d4a91ea88(el) {
    var parents = [];
    while(el instanceof HTMLElement){
        var computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === "fixed") break;
        if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) parents.push(el);
        el = el.parentNode;
    }
    return parents;
}
/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/ var $8c023e653ef8da49$export$7060da4b5db56fb9 = /*#__PURE__*/ function() {
    "use strict";
    function PositionCache(originEl, els, isHorizontal, isVertical) {
        (0, $5kWiG._)(this, PositionCache);
        this.els = els;
        var originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) this.buildElHorizontals(originClientRect.left);
        if (isVertical) this.buildElVerticals(originClientRect.top);
    }
    (0, $hHaEF._)(PositionCache, [
        {
            // Populates the left/right internal coordinate arrays
            key: "buildElHorizontals",
            value: function buildElHorizontals(originClientLeft) {
                var lefts = [];
                var rights = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.els[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var el = _step.value;
                        var rect = el.getBoundingClientRect();
                        lefts.push(rect.left - originClientLeft);
                        rights.push(rect.right - originClientLeft);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.lefts = lefts;
                this.rights = rights;
            }
        },
        {
            // Populates the top/bottom internal coordinate arrays
            key: "buildElVerticals",
            value: function buildElVerticals(originClientTop) {
                var tops = [];
                var bottoms = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.els[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var el = _step.value;
                        var rect = el.getBoundingClientRect();
                        tops.push(rect.top - originClientTop);
                        bottoms.push(rect.bottom - originClientTop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.tops = tops;
                this.bottoms = bottoms;
            }
        },
        {
            // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
            // If no intersection is made, returns undefined.
            key: "leftToIndex",
            value: function leftToIndex(leftPosition) {
                var _this = this, lefts = _this.lefts, rights = _this.rights;
                var len = lefts.length;
                var i;
                for(i = 0; i < len; i += 1){
                    if (leftPosition >= lefts[i] && leftPosition < rights[i]) return i;
                }
                return undefined; // TODO: better
            }
        },
        {
            // Given a top offset (from document top), returns the index of the el that it vertically intersects.
            // If no intersection is made, returns undefined.
            key: "topToIndex",
            value: function topToIndex(topPosition) {
                var _this = this, tops = _this.tops, bottoms = _this.bottoms;
                var len = tops.length;
                var i;
                for(i = 0; i < len; i += 1){
                    if (topPosition >= tops[i] && topPosition < bottoms[i]) return i;
                }
                return undefined; // TODO: better
            }
        },
        {
            // Gets the width of the element at the given index
            key: "getWidth",
            value: function getWidth(leftIndex) {
                return this.rights[leftIndex] - this.lefts[leftIndex];
            }
        },
        {
            // Gets the height of the element at the given index
            key: "getHeight",
            value: function getHeight(topIndex) {
                return this.bottoms[topIndex] - this.tops[topIndex];
            }
        },
        {
            key: "similarTo",
            value: function similarTo(otherCache) {
                return $8c023e653ef8da49$var$similarNumArrays(this.tops || [], otherCache.tops || []) && $8c023e653ef8da49$var$similarNumArrays(this.bottoms || [], otherCache.bottoms || []) && $8c023e653ef8da49$var$similarNumArrays(this.lefts || [], otherCache.lefts || []) && $8c023e653ef8da49$var$similarNumArrays(this.rights || [], otherCache.rights || []);
            }
        }
    ]);
    return PositionCache;
}();
function $8c023e653ef8da49$var$similarNumArrays(a, b) {
    var len = a.length;
    if (len !== b.length) return false;
    for(var i = 0; i < len; i++){
        if (Math.round(a[i]) !== Math.round(b[i])) return false;
    }
    return true;
}
/* eslint max-classes-per-file: "off" */ /*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/ var $8c023e653ef8da49$export$c5d1328b37d47994 = /*#__PURE__*/ function() {
    "use strict";
    function ScrollController() {
        (0, $5kWiG._)(this, ScrollController);
    }
    (0, $hHaEF._)(ScrollController, [
        {
            key: "getMaxScrollTop",
            value: function getMaxScrollTop() {
                return this.getScrollHeight() - this.getClientHeight();
            }
        },
        {
            key: "getMaxScrollLeft",
            value: function getMaxScrollLeft() {
                return this.getScrollWidth() - this.getClientWidth();
            }
        },
        {
            key: "canScrollVertically",
            value: function canScrollVertically() {
                return this.getMaxScrollTop() > 0;
            }
        },
        {
            key: "canScrollHorizontally",
            value: function canScrollHorizontally() {
                return this.getMaxScrollLeft() > 0;
            }
        },
        {
            key: "canScrollUp",
            value: function canScrollUp() {
                return this.getScrollTop() > 0;
            }
        },
        {
            key: "canScrollDown",
            value: function canScrollDown() {
                return this.getScrollTop() < this.getMaxScrollTop();
            }
        },
        {
            key: "canScrollLeft",
            value: function canScrollLeft() {
                return this.getScrollLeft() > 0;
            }
        },
        {
            key: "canScrollRight",
            value: function canScrollRight() {
                return this.getScrollLeft() < this.getMaxScrollLeft();
            }
        }
    ]);
    return ScrollController;
}();
var $8c023e653ef8da49$export$d22783b3c2400a3a = /*#__PURE__*/ function(ScrollController) {
    "use strict";
    (0, $dACZV._)(ElementScrollController, ScrollController);
    var _super = (0, $jhb1H._)(ElementScrollController);
    function ElementScrollController(el) {
        (0, $5kWiG._)(this, ElementScrollController);
        var _this;
        _this = _super.call(this);
        _this.el = el;
        return _this;
    }
    (0, $hHaEF._)(ElementScrollController, [
        {
            key: "getScrollTop",
            value: function getScrollTop() {
                return this.el.scrollTop;
            }
        },
        {
            key: "getScrollLeft",
            value: function getScrollLeft() {
                return this.el.scrollLeft;
            }
        },
        {
            key: "setScrollTop",
            value: function setScrollTop(top) {
                this.el.scrollTop = top;
            }
        },
        {
            key: "setScrollLeft",
            value: function setScrollLeft(left) {
                this.el.scrollLeft = left;
            }
        },
        {
            key: "getScrollWidth",
            value: function getScrollWidth() {
                return this.el.scrollWidth;
            }
        },
        {
            key: "getScrollHeight",
            value: function getScrollHeight() {
                return this.el.scrollHeight;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight() {
                return this.el.clientHeight;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth() {
                return this.el.clientWidth;
            }
        }
    ]);
    return ElementScrollController;
}($8c023e653ef8da49$export$c5d1328b37d47994);
var $8c023e653ef8da49$export$7f557e5eb95176c2 = /*#__PURE__*/ function(ScrollController) {
    "use strict";
    (0, $dACZV._)(WindowScrollController, ScrollController);
    var _super = (0, $jhb1H._)(WindowScrollController);
    function WindowScrollController() {
        (0, $5kWiG._)(this, WindowScrollController);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(WindowScrollController, [
        {
            key: "getScrollTop",
            value: function getScrollTop() {
                return window.pageYOffset;
            }
        },
        {
            key: "getScrollLeft",
            value: function getScrollLeft() {
                return window.pageXOffset;
            }
        },
        {
            key: "setScrollTop",
            value: function setScrollTop(n) {
                window.scroll(window.pageXOffset, n);
            }
        },
        {
            key: "setScrollLeft",
            value: function setScrollLeft(n) {
                window.scroll(n, window.pageYOffset);
            }
        },
        {
            key: "getScrollWidth",
            value: function getScrollWidth() {
                return document.documentElement.scrollWidth;
            }
        },
        {
            key: "getScrollHeight",
            value: function getScrollHeight() {
                return document.documentElement.scrollHeight;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight() {
                return document.documentElement.clientHeight;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth() {
                return document.documentElement.clientWidth;
            }
        }
    ]);
    return WindowScrollController;
}($8c023e653ef8da49$export$c5d1328b37d47994);
/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/ var $8c023e653ef8da49$export$51b138e5a065c2bb = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(DateComponent, BaseComponent);
    var _super = (0, $jhb1H._)(DateComponent);
    function DateComponent() {
        (0, $5kWiG._)(this, DateComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.uid = $8c023e653ef8da49$export$39b482c5e57630a8();
        return _this;
    }
    (0, $hHaEF._)(DateComponent, [
        {
            // Hit System
            // -----------------------------------------------------------------------------------------------------------------
            key: "prepareHits",
            value: function prepareHits() {}
        },
        {
            key: "queryHit",
            value: function queryHit(positionLeft, positionTop, elWidth, elHeight) {
                return null; // this should be abstract
            }
        },
        {
            // Pointer Interaction Utils
            // -----------------------------------------------------------------------------------------------------------------
            key: "isValidSegDownEl",
            value: function isValidSegDownEl(el) {
                return !this.props.eventDrag && // HACK
                !this.props.eventResize && // HACK
                !$8c023e653ef8da49$export$3d8c2f653ac9d0b9(el, ".fc-event-mirror");
            }
        },
        {
            key: "isValidDateDownEl",
            value: function isValidDateDownEl(el) {
                return !$8c023e653ef8da49$export$3d8c2f653ac9d0b9(el, ".fc-event:not(.fc-bg-event)") && !$8c023e653ef8da49$export$3d8c2f653ac9d0b9(el, ".fc-more-link") && // a "more.." link
                !$8c023e653ef8da49$export$3d8c2f653ac9d0b9(el, "a[data-navlink]") && // a clickable nav link
                !$8c023e653ef8da49$export$3d8c2f653ac9d0b9(el, ".fc-popover"); // hack
            }
        }
    ]);
    return DateComponent;
}($8c023e653ef8da49$export$ef35774e6d314e91);
var $8c023e653ef8da49$export$766bf7dcfb630b6c = function NamedTimeZoneImpl(timeZoneName) {
    "use strict";
    (0, $5kWiG._)(this, NamedTimeZoneImpl);
    this.timeZoneName = timeZoneName;
};
var $8c023e653ef8da49$export$2e63b696b2c9441b = /*#__PURE__*/ function() {
    "use strict";
    function SegHierarchy() {
        var getEntryThickness = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(entry) {
            // should return an integer
            return entry.thickness;
        };
        (0, $5kWiG._)(this, SegHierarchy);
        this.getEntryThickness = getEntryThickness;
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
    (0, $hHaEF._)(SegHierarchy, [
        {
            key: "addSegs",
            value: function addSegs(inputs) {
                var hiddenEntries = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var input = _step.value;
                        this.insertEntry(input, hiddenEntries);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return hiddenEntries;
            }
        },
        {
            key: "insertEntry",
            value: function insertEntry(entry, hiddenEntries) {
                var insertion = this.findInsertion(entry);
                if (this.isInsertionValid(insertion, entry)) {
                    this.insertEntryAt(entry, insertion);
                    return 1;
                }
                return this.handleInvalidInsertion(insertion, entry, hiddenEntries);
            }
        },
        {
            key: "isInsertionValid",
            value: function isInsertionValid(insertion, entry) {
                return (this.maxCoord === -1 || insertion.levelCoord + this.getEntryThickness(entry) <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
            }
        },
        {
            // returns number of new entries inserted
            key: "handleInvalidInsertion",
            value: function handleInvalidInsertion(insertion, entry, hiddenEntries) {
                if (this.allowReslicing && insertion.touchingEntry) return this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
                hiddenEntries.push(entry);
                return 0;
            }
        },
        {
            key: "splitEntry",
            value: function splitEntry(entry, barrier, hiddenEntries) {
                var partCnt = 0;
                var splitHiddenEntries = [];
                var entrySpan = entry.span;
                var barrierSpan = barrier.span;
                if (entrySpan.start < barrierSpan.start) partCnt += this.insertEntry({
                    index: entry.index,
                    thickness: entry.thickness,
                    span: {
                        start: entrySpan.start,
                        end: barrierSpan.start
                    }
                }, splitHiddenEntries);
                if (entrySpan.end > barrierSpan.end) partCnt += this.insertEntry({
                    index: entry.index,
                    thickness: entry.thickness,
                    span: {
                        start: barrierSpan.end,
                        end: entrySpan.end
                    }
                }, splitHiddenEntries);
                if (partCnt) {
                    var _hiddenEntries;
                    (_hiddenEntries = hiddenEntries).push.apply(_hiddenEntries, [
                        {
                            index: entry.index,
                            thickness: entry.thickness,
                            span: $8c023e653ef8da49$export$b2bcef12bcefba04(barrierSpan, entrySpan)
                        }
                    ].concat((0, $5TJQB._)(splitHiddenEntries)));
                    return partCnt;
                }
                hiddenEntries.push(entry);
                return 0;
            }
        },
        {
            key: "insertEntryAt",
            value: function insertEntryAt(entry, insertion) {
                var _this = this, entriesByLevel = _this.entriesByLevel, levelCoords = _this.levelCoords;
                if (insertion.lateral === -1) {
                    // create a new level
                    $8c023e653ef8da49$var$insertAt(levelCoords, insertion.level, insertion.levelCoord);
                    $8c023e653ef8da49$var$insertAt(entriesByLevel, insertion.level, [
                        entry
                    ]);
                } else // insert into existing level
                $8c023e653ef8da49$var$insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
                this.stackCnts[$8c023e653ef8da49$export$eb84e45a33f6ba7c(entry)] = insertion.stackCnt;
            }
        },
        {
            key: "findInsertion",
            value: function findInsertion(newEntry) {
                var _this = this, levelCoords = _this.levelCoords, entriesByLevel = _this.entriesByLevel, strictOrder = _this.strictOrder, stackCnts = _this.stackCnts;
                var levelCnt = levelCoords.length;
                var candidateCoord = 0;
                var touchingLevel = -1;
                var touchingLateral = -1;
                var touchingEntry = null;
                var stackCnt = 0;
                for(var trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1){
                    var trackingCoord = levelCoords[trackingLevel];
                    // if the current level is past the placed entry, we have found a good empty space and can stop.
                    // if strictOrder, keep finding more lateral intersections.
                    if (!strictOrder && trackingCoord >= candidateCoord + this.getEntryThickness(newEntry)) break;
                    var trackingEntries = entriesByLevel[trackingLevel];
                    var trackingEntry = void 0;
                    var searchRes = $8c023e653ef8da49$export$b0165a7e514844(trackingEntries, newEntry.span.start, $8c023e653ef8da49$export$d76842aa27385215); // find first entry after newEntry's end
                    var lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
                    while((trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
                    trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
                    ){
                        var trackingEntryBottom = trackingCoord + this.getEntryThickness(trackingEntry);
                        // intersects into the top of the candidate?
                        if (trackingEntryBottom > candidateCoord) {
                            candidateCoord = trackingEntryBottom;
                            touchingEntry = trackingEntry;
                            touchingLevel = trackingLevel;
                            touchingLateral = lateralIndex;
                        }
                        // butts up against top of candidate? (will happen if just intersected as well)
                        if (trackingEntryBottom === candidateCoord) // accumulate the highest possible stackCnt of the trackingEntries that butt up
                        stackCnt = Math.max(stackCnt, stackCnts[$8c023e653ef8da49$export$eb84e45a33f6ba7c(trackingEntry)] + 1);
                        lateralIndex += 1;
                    }
                }
                // the destination level will be after touchingEntry's level. find it
                var destLevel = 0;
                if (touchingEntry) {
                    destLevel = touchingLevel + 1;
                    while(destLevel < levelCnt && levelCoords[destLevel] < candidateCoord)destLevel += 1;
                }
                // if adding to an existing level, find where to insert
                var destLateral = -1;
                if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) destLateral = $8c023e653ef8da49$export$b0165a7e514844(entriesByLevel[destLevel], newEntry.span.end, $8c023e653ef8da49$export$d76842aa27385215)[0];
                return {
                    touchingLevel: touchingLevel,
                    touchingLateral: touchingLateral,
                    touchingEntry: touchingEntry,
                    stackCnt: stackCnt,
                    levelCoord: candidateCoord,
                    level: destLevel,
                    lateral: destLateral
                };
            }
        },
        {
            // sorted by levelCoord (lowest to highest)
            key: "toRects",
            value: function toRects() {
                var _this = this, entriesByLevel = _this.entriesByLevel, levelCoords = _this.levelCoords;
                var levelCnt = entriesByLevel.length;
                var rects = [];
                for(var level = 0; level < levelCnt; level += 1){
                    var entries = entriesByLevel[level];
                    var levelCoord = levelCoords[level];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            rects.push(Object.assign(Object.assign({}, entry), {
                                thickness: this.getEntryThickness(entry),
                                levelCoord: levelCoord
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return rects;
            }
        }
    ]);
    return SegHierarchy;
}();
function $8c023e653ef8da49$export$d76842aa27385215(entry) {
    return entry.span.end;
}
function $8c023e653ef8da49$export$eb84e45a33f6ba7c(entry) {
    return entry.index + ":" + entry.span.start;
}
// returns groups with entries sorted by input order
function $8c023e653ef8da49$export$381353cf1dd55255(entries) {
    var merges = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            var filteredMerges = [];
            var hungryMerge = {
                span: entry.span,
                entries: [
                    entry
                ]
            };
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = merges[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var merge = _step1.value;
                    if ($8c023e653ef8da49$export$b2bcef12bcefba04(merge.span, hungryMerge.span)) hungryMerge = {
                        entries: merge.entries.concat(hungryMerge.entries),
                        span: $8c023e653ef8da49$var$joinSpans(merge.span, hungryMerge.span)
                    };
                    else filteredMerges.push(merge);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            filteredMerges.push(hungryMerge);
            merges = filteredMerges;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return merges;
}
function $8c023e653ef8da49$var$joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end)
    };
}
function $8c023e653ef8da49$export$b2bcef12bcefba04(span0, span1) {
    var start = Math.max(span0.start, span1.start);
    var end = Math.min(span0.end, span1.end);
    if (start < end) return {
        start: start,
        end: end
    };
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function $8c023e653ef8da49$var$insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function $8c023e653ef8da49$export$b0165a7e514844(a, searchVal, getItemVal) {
    var startIndex = 0;
    var endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) return [
        0,
        0
    ];
    if (searchVal > getItemVal(a[endIndex - 1])) return [
        endIndex,
        0
    ];
    while(startIndex < endIndex){
        var middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        var middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) endIndex = middleIndex;
        else if (searchVal > middleVal) startIndex = middleIndex + 1;
        else return [
            middleIndex,
            1
        ];
    }
    return [
        startIndex,
        0
    ];
}
/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/ var $8c023e653ef8da49$export$60bb826a6acf3081 = /*#__PURE__*/ function() {
    "use strict";
    function ElementDragging(el, selector) {
        (0, $5kWiG._)(this, ElementDragging);
        this.emitter = new $8c023e653ef8da49$export$d66501df72047452();
    }
    (0, $hHaEF._)(ElementDragging, [
        {
            key: "destroy",
            value: function destroy() {}
        },
        {
            key: "setMirrorIsVisible",
            value: function setMirrorIsVisible(bool) {
            // optional if subclass doesn't want to support a mirror
            }
        },
        {
            key: "setMirrorNeedsRevert",
            value: function setMirrorNeedsRevert(bool) {
            // optional if subclass doesn't want to support a mirror
            }
        },
        {
            key: "setAutoScrollEnabled",
            value: function setAutoScrollEnabled(bool) {
            // optional
            }
        }
    ]);
    return ElementDragging;
}();
// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
var $8c023e653ef8da49$export$27d1aff6bea49709 = {};
/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/ var $8c023e653ef8da49$var$DRAG_META_REFINERS = {
    startTime: $8c023e653ef8da49$export$4368d992c4eafac0,
    duration: $8c023e653ef8da49$export$4368d992c4eafac0,
    create: Boolean,
    sourceId: String
};
function $8c023e653ef8da49$export$1abb261478089fe6(raw) {
    var _refineProps = $8c023e653ef8da49$export$f38c853ae54ed474(raw, $8c023e653ef8da49$var$DRAG_META_REFINERS), refined = _refineProps.refined, extra = _refineProps.extra;
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra
    };
}
// Computes a default column header formatting string if `colFormat` is not explicitly defined
function $8c023e653ef8da49$export$1ddf2d01943a3512(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) return $8c023e653ef8da49$export$d141bba7fdc215a3({
        weekday: "short"
    }); // "Sat"
    if (dayCnt > 1) return $8c023e653ef8da49$export$d141bba7fdc215a3({
        weekday: "short",
        month: "numeric",
        day: "numeric",
        omitCommas: true
    }); // "Sat 11/12"
    return $8c023e653ef8da49$export$d141bba7fdc215a3({
        weekday: "long"
    }); // "Saturday"
}
var $8c023e653ef8da49$var$CLASS_NAME = "fc-col-header-cell"; // do the cushion too? no
function $8c023e653ef8da49$var$renderInner$1(renderProps) {
    return renderProps.text;
}
// BAD name for this class now. used in the Header
var $8c023e653ef8da49$export$ebb8f7cd71856fb9 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(TableDateCell, BaseComponent);
    var _super = (0, $jhb1H._)(TableDateCell);
    function TableDateCell() {
        (0, $5kWiG._)(this, TableDateCell);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(TableDateCell, [
        {
            key: "render",
            value: function render() {
                var _this_context = this.context, dateEnv = _this_context.dateEnv, options = _this_context.options, theme = _this_context.theme, viewApi = _this_context.viewApi;
                var props = this.props;
                var date = props.date, dateProfile = props.dateProfile;
                var dayMeta = $8c023e653ef8da49$export$a17c37559e1db147(date, props.todayRange, null, dateProfile);
                var classNames = [
                    $8c023e653ef8da49$var$CLASS_NAME
                ].concat($8c023e653ef8da49$export$527e9aa3390079e9(dayMeta, theme));
                var text = dateEnv.format(date, props.dayHeaderFormat);
                // if colCnt is 1, we are already in a day-view and don't need a navlink
                var navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? $8c023e653ef8da49$export$8c78c7c36408ea29(this.context, date) : {};
                var renderProps = Object.assign(Object.assign(Object.assign({
                    date: dateEnv.toDate(date),
                    view: viewApi
                }, props.extraRenderProps), {
                    text: text
                }), dayMeta);
                return (0, $kgSvt.createElement)($8c023e653ef8da49$export$e7094788287c5e9b, {
                    elTag: "th",
                    elClasses: classNames,
                    elAttrs: Object.assign({
                        role: "columnheader",
                        colSpan: props.colSpan,
                        "data-date": !dayMeta.isDisabled ? $8c023e653ef8da49$export$5dbe06c6d8c68cfb(date) : undefined
                    }, props.extraDataAttrs),
                    renderProps: renderProps,
                    generatorName: "dayHeaderContent",
                    customGenerator: options.dayHeaderContent,
                    defaultGenerator: $8c023e653ef8da49$var$renderInner$1,
                    classNameGenerator: options.dayHeaderClassNames,
                    didMount: options.dayHeaderDidMount,
                    willUnmount: options.dayHeaderWillUnmount
                }, function(InnerContainer) {
                    return (0, $kgSvt.createElement)("div", {
                        className: "fc-scrollgrid-sync-inner"
                    }, !dayMeta.isDisabled && (0, $kgSvt.createElement)(InnerContainer, {
                        elTag: "a",
                        elAttrs: navLinkAttrs,
                        elClasses: [
                            "fc-col-header-cell-cushion",
                            props.isSticky && "fc-sticky"
                        ]
                    }));
                });
            }
        }
    ]);
    return TableDateCell;
}($8c023e653ef8da49$export$ef35774e6d314e91);
var $8c023e653ef8da49$var$WEEKDAY_FORMAT = $8c023e653ef8da49$export$d141bba7fdc215a3({
    weekday: "long"
});
var $8c023e653ef8da49$export$45aabb5431c2d04f = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(TableDowCell, BaseComponent);
    var _super = (0, $jhb1H._)(TableDowCell);
    function TableDowCell() {
        (0, $5kWiG._)(this, TableDowCell);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(TableDowCell, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var _this_context = this.context, dateEnv = _this_context.dateEnv, theme = _this_context.theme, viewApi = _this_context.viewApi, options = _this_context.options;
                var date = $8c023e653ef8da49$export$625550452a3fa3ec(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
                var dateMeta = {
                    dow: props.dow,
                    isDisabled: false,
                    isFuture: false,
                    isPast: false,
                    isToday: false,
                    isOther: false
                };
                var text = dateEnv.format(date, props.dayHeaderFormat);
                var renderProps = Object.assign(Object.assign(Object.assign(Object.assign({
                    date: date
                }, dateMeta), {
                    view: viewApi
                }), props.extraRenderProps), {
                    text: text
                });
                return (0, $kgSvt.createElement)($8c023e653ef8da49$export$e7094788287c5e9b, {
                    elTag: "th",
                    elClasses: [
                        $8c023e653ef8da49$var$CLASS_NAME
                    ].concat((0, $5TJQB._)($8c023e653ef8da49$export$527e9aa3390079e9(dateMeta, theme)), (0, $5TJQB._)(props.extraClassNames || [])),
                    elAttrs: Object.assign({
                        role: "columnheader",
                        colSpan: props.colSpan
                    }, props.extraDataAttrs),
                    renderProps: renderProps,
                    generatorName: "dayHeaderContent",
                    customGenerator: options.dayHeaderContent,
                    defaultGenerator: $8c023e653ef8da49$var$renderInner$1,
                    classNameGenerator: options.dayHeaderClassNames,
                    didMount: options.dayHeaderDidMount,
                    willUnmount: options.dayHeaderWillUnmount
                }, function(InnerContent) {
                    return (0, $kgSvt.createElement)("div", {
                        className: "fc-scrollgrid-sync-inner"
                    }, (0, $kgSvt.createElement)(InnerContent, {
                        elTag: "a",
                        elClasses: [
                            "fc-col-header-cell-cushion",
                            props.isSticky && "fc-sticky"
                        ],
                        elAttrs: {
                            "aria-label": dateEnv.format(date, $8c023e653ef8da49$var$WEEKDAY_FORMAT)
                        }
                    }));
                });
            }
        }
    ]);
    return TableDowCell;
}($8c023e653ef8da49$export$ef35774e6d314e91);
var $8c023e653ef8da49$export$6e4b1d19c6e2e012 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $dACZV._)(NowTimer, Component);
    var _super = (0, $jhb1H._)(NowTimer);
    function NowTimer(props, context) {
        (0, $5kWiG._)(this, NowTimer);
        var _this;
        _this = _super.call(this, props, context);
        _this.initialNowDate = $8c023e653ef8da49$export$c3950d9923825c02(context.options.now, context.dateEnv);
        _this.initialNowQueriedMs = new Date().valueOf();
        _this.state = _this.computeTiming().currentState;
        return _this;
    }
    (0, $hHaEF._)(NowTimer, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, state = _this.state;
                return props.children(state.nowDate, state.todayRange);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setTimeout();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.unit !== this.props.unit) {
                    this.clearTimeout();
                    this.setTimeout();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.clearTimeout();
            }
        },
        {
            key: "computeTiming",
            value: function computeTiming() {
                var _this = this, props = _this.props, context = _this.context;
                var unroundedNow = $8c023e653ef8da49$export$136fd86de524d3c2(this.initialNowDate, new Date().valueOf() - this.initialNowQueriedMs);
                var currentUnitStart = context.dateEnv.startOf(unroundedNow, props.unit);
                var nextUnitStart = context.dateEnv.add(currentUnitStart, $8c023e653ef8da49$export$4368d992c4eafac0(1, props.unit));
                var waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
                // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
                // ensure no longer than a day
                waitMs = Math.min(86400000, waitMs);
                return {
                    currentState: {
                        nowDate: currentUnitStart,
                        todayRange: $8c023e653ef8da49$var$buildDayRange(currentUnitStart)
                    },
                    nextState: {
                        nowDate: nextUnitStart,
                        todayRange: $8c023e653ef8da49$var$buildDayRange(nextUnitStart)
                    },
                    waitMs: waitMs
                };
            }
        },
        {
            key: "setTimeout",
            value: function setTimeout1() {
                var _this = this;
                var _this_computeTiming = this.computeTiming(), nextState = _this_computeTiming.nextState, waitMs = _this_computeTiming.waitMs;
                this.timeoutId = setTimeout(function() {
                    _this.setState(nextState, function() {
                        _this.setTimeout();
                    });
                }, waitMs);
            }
        },
        {
            key: "clearTimeout",
            value: function clearTimeout1() {
                if (this.timeoutId) clearTimeout(this.timeoutId);
            }
        }
    ]);
    return NowTimer;
}((0, $kgSvt.Component));
$8c023e653ef8da49$export$6e4b1d19c6e2e012.contextType = $8c023e653ef8da49$export$e7c866399fa523f5;
function $8c023e653ef8da49$var$buildDayRange(date) {
    var start = $8c023e653ef8da49$export$9e5f44173e64f162(date);
    var end = $8c023e653ef8da49$export$625550452a3fa3ec(start, 1);
    return {
        start: start,
        end: end
    };
}
var $8c023e653ef8da49$export$ebc5e65867841cbe = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(DayHeader, BaseComponent);
    var _super = (0, $jhb1H._)(DayHeader);
    function DayHeader() {
        (0, $5kWiG._)(this, DayHeader);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.createDayHeaderFormatter = $8c023e653ef8da49$export$df995fae86a55f06($8c023e653ef8da49$var$createDayHeaderFormatter);
        return _this;
    }
    (0, $hHaEF._)(DayHeader, [
        {
            key: "render",
            value: function render() {
                var context = this.context;
                var _this_props = this.props, dates = _this_props.dates, dateProfile = _this_props.dateProfile, datesRepDistinctDays = _this_props.datesRepDistinctDays, renderIntro = _this_props.renderIntro;
                var dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
                return (0, $kgSvt.createElement)($8c023e653ef8da49$export$6e4b1d19c6e2e012, {
                    unit: "day"
                }, function(nowDate, todayRange) {
                    return (0, $kgSvt.createElement)("tr", {
                        role: "row"
                    }, renderIntro && renderIntro("day"), dates.map(function(date) {
                        return datesRepDistinctDays ? (0, $kgSvt.createElement)($8c023e653ef8da49$export$ebb8f7cd71856fb9, {
                            key: date.toISOString(),
                            date: date,
                            dateProfile: dateProfile,
                            todayRange: todayRange,
                            colCnt: dates.length,
                            dayHeaderFormat: dayHeaderFormat
                        }) : (0, $kgSvt.createElement)($8c023e653ef8da49$export$45aabb5431c2d04f, {
                            key: date.getUTCDay(),
                            dow: date.getUTCDay(),
                            dayHeaderFormat: dayHeaderFormat
                        });
                    }));
                });
            }
        }
    ]);
    return DayHeader;
}($8c023e653ef8da49$export$ef35774e6d314e91);
function $8c023e653ef8da49$var$createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || $8c023e653ef8da49$export$1ddf2d01943a3512(datesRepDistinctDays, dateCnt);
}
var $8c023e653ef8da49$export$2538633961795d6b = /*#__PURE__*/ function() {
    "use strict";
    function DaySeriesModel(range, dateProfileGenerator) {
        (0, $5kWiG._)(this, DaySeriesModel);
        var date = range.start;
        var end = range.end;
        var indices = [];
        var dates = [];
        var dayIndex = -1;
        while(date < end){
            if (dateProfileGenerator.isHiddenDay(date)) indices.push(dayIndex + 0.5); // mark that it's between indices
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = $8c023e653ef8da49$export$625550452a3fa3ec(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
    (0, $hHaEF._)(DaySeriesModel, [
        {
            key: "sliceRange",
            value: function sliceRange(range) {
                var firstIndex = this.getDateDayIndex(range.start); // inclusive first index
                var lastIndex = this.getDateDayIndex($8c023e653ef8da49$export$625550452a3fa3ec(range.end, -1)); // inclusive last index
                var clippedFirstIndex = Math.max(0, firstIndex);
                var clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
                // deal with in-between indices
                clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
                clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
                if (clippedFirstIndex <= clippedLastIndex) return {
                    firstIndex: clippedFirstIndex,
                    lastIndex: clippedLastIndex,
                    isStart: firstIndex === clippedFirstIndex,
                    isEnd: lastIndex === clippedLastIndex
                };
                return null;
            }
        },
        {
            // Given a date, returns its chronolocial cell-index from the first cell of the grid.
            // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
            // If before the first offset, returns a negative number.
            // If after the last offset, returns an offset past the last cell offset.
            // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
            key: "getDateDayIndex",
            value: function getDateDayIndex(date) {
                var indices = this.indices;
                var dayOffset = Math.floor($8c023e653ef8da49$export$a36fb7d24305ed9d(this.dates[0], date));
                if (dayOffset < 0) return indices[0] - 1;
                if (dayOffset >= indices.length) return indices[indices.length - 1] + 1;
                return indices[dayOffset];
            }
        }
    ]);
    return DaySeriesModel;
}();
var $8c023e653ef8da49$export$dabba94403d45c8e = /*#__PURE__*/ function() {
    "use strict";
    function DayTableModel(daySeries, breakOnWeeks) {
        (0, $5kWiG._)(this, DayTableModel);
        var dates = daySeries.dates;
        var daysPerRow;
        var firstDay;
        var rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for(daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1){
                if (dates[daysPerRow].getUTCDay() === firstDay) break;
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        } else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
    (0, $hHaEF._)(DayTableModel, [
        {
            key: "buildCells",
            value: function buildCells() {
                var rows = [];
                for(var row = 0; row < this.rowCnt; row += 1){
                    var cells = [];
                    for(var col = 0; col < this.colCnt; col += 1)cells.push(this.buildCell(row, col));
                    rows.push(cells);
                }
                return rows;
            }
        },
        {
            key: "buildCell",
            value: function buildCell(row, col) {
                var date = this.daySeries.dates[row * this.colCnt + col];
                return {
                    key: date.toISOString(),
                    date: date
                };
            }
        },
        {
            key: "buildHeaderDates",
            value: function buildHeaderDates() {
                var dates = [];
                for(var col = 0; col < this.colCnt; col += 1)dates.push(this.cells[0][col].date);
                return dates;
            }
        },
        {
            key: "sliceRange",
            value: function sliceRange(range) {
                var colCnt = this.colCnt;
                var seriesSeg = this.daySeries.sliceRange(range);
                var segs = [];
                if (seriesSeg) {
                    var firstIndex = seriesSeg.firstIndex, lastIndex = seriesSeg.lastIndex;
                    var index = firstIndex;
                    while(index <= lastIndex){
                        var row = Math.floor(index / colCnt);
                        var nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                        segs.push({
                            row: row,
                            firstCol: index % colCnt,
                            lastCol: (nextIndex - 1) % colCnt,
                            isStart: seriesSeg.isStart && index === firstIndex,
                            isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
                        });
                        index = nextIndex;
                    }
                }
                return segs;
            }
        }
    ]);
    return DayTableModel;
}();
var $8c023e653ef8da49$export$6b179bb11f7fd3a0 = /*#__PURE__*/ function() {
    "use strict";
    function Slicer() {
        (0, $5kWiG._)(this, Slicer);
        this.sliceBusinessHours = $8c023e653ef8da49$export$df995fae86a55f06(this._sliceBusinessHours);
        this.sliceDateSelection = $8c023e653ef8da49$export$df995fae86a55f06(this._sliceDateSpan);
        this.sliceEventStore = $8c023e653ef8da49$export$df995fae86a55f06(this._sliceEventStore);
        this.sliceEventDrag = $8c023e653ef8da49$export$df995fae86a55f06(this._sliceInteraction);
        this.sliceEventResize = $8c023e653ef8da49$export$df995fae86a55f06(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
    (0, $hHaEF._)(Slicer, [
        {
            key: "sliceProps",
            value: function sliceProps(props, dateProfile, nextDayThreshold, context) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                var eventUiBases = props.eventUiBases;
                var eventSegs = this.sliceEventStore.apply(this, [
                    props.eventStore,
                    eventUiBases,
                    dateProfile,
                    nextDayThreshold
                ].concat((0, $5TJQB._)(extraArgs)));
                return {
                    dateSelectionSegs: this.sliceDateSelection.apply(this, [
                        props.dateSelection,
                        dateProfile,
                        nextDayThreshold,
                        eventUiBases,
                        context
                    ].concat((0, $5TJQB._)(extraArgs))),
                    businessHourSegs: this.sliceBusinessHours.apply(this, [
                        props.businessHours,
                        dateProfile,
                        nextDayThreshold,
                        context
                    ].concat((0, $5TJQB._)(extraArgs))),
                    fgEventSegs: eventSegs.fg,
                    bgEventSegs: eventSegs.bg,
                    eventDrag: this.sliceEventDrag.apply(this, [
                        props.eventDrag,
                        eventUiBases,
                        dateProfile,
                        nextDayThreshold
                    ].concat((0, $5TJQB._)(extraArgs))),
                    eventResize: this.sliceEventResize.apply(this, [
                        props.eventResize,
                        eventUiBases,
                        dateProfile,
                        nextDayThreshold
                    ].concat((0, $5TJQB._)(extraArgs))),
                    eventSelection: props.eventSelection
                }; // TODO: give interactionSegs?
            }
        },
        {
            key: "sliceNowDate",
            value: function sliceNowDate(date, dateProfile, nextDayThreshold, context) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                return this._sliceDateSpan.apply(this, [
                    {
                        range: {
                            start: date,
                            end: $8c023e653ef8da49$export$136fd86de524d3c2(date, 1)
                        },
                        allDay: false
                    },
                    dateProfile,
                    nextDayThreshold,
                    {},
                    context
                ].concat((0, $5TJQB._)(extraArgs)));
            }
        },
        {
            key: "_sliceBusinessHours",
            value: function _sliceBusinessHours(businessHours, dateProfile, nextDayThreshold, context) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                if (!businessHours) return [];
                return this._sliceEventStore.apply(this, [
                    $8c023e653ef8da49$var$expandRecurring(businessHours, $8c023e653ef8da49$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context),
                    {},
                    dateProfile,
                    nextDayThreshold
                ].concat((0, $5TJQB._)(extraArgs))).bg;
            }
        },
        {
            key: "_sliceEventStore",
            value: function _sliceEventStore(eventStore, eventUiBases, dateProfile, nextDayThreshold) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                if (eventStore) {
                    var rangeRes = $8c023e653ef8da49$export$c9170ad7d4cd7e57(eventStore, eventUiBases, $8c023e653ef8da49$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
                    return {
                        bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                        fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
                    };
                }
                return {
                    bg: [],
                    fg: []
                };
            }
        },
        {
            key: "_sliceInteraction",
            value: function _sliceInteraction(interaction, eventUiBases, dateProfile, nextDayThreshold) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                if (!interaction) return null;
                var rangeRes = $8c023e653ef8da49$export$c9170ad7d4cd7e57(interaction.mutatedEvents, eventUiBases, $8c023e653ef8da49$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
                return {
                    segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
                    affectedInstances: interaction.affectedEvents.instances,
                    isEvent: interaction.isEvent
                };
            }
        },
        {
            key: "_sliceDateSpan",
            value: function _sliceDateSpan(dateSpan, dateProfile, nextDayThreshold, eventUiBases, context) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++){
                    extraArgs[_key - 5] = arguments[_key];
                }
                if (!dateSpan) return [];
                var activeRange = $8c023e653ef8da49$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold));
                var activeDateSpanRange = $8c023e653ef8da49$export$ae1af26003f05816(dateSpan.range, activeRange);
                if (activeDateSpanRange) {
                    dateSpan = Object.assign(Object.assign({}, dateSpan), {
                        range: activeDateSpanRange
                    });
                    var eventRange = $8c023e653ef8da49$var$fabricateEventRange(dateSpan, eventUiBases, context);
                    var segs = this.sliceRange.apply(this, [
                        dateSpan.range
                    ].concat((0, $5TJQB._)(extraArgs)));
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var seg = _step.value;
                            seg.eventRange = eventRange;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return segs;
                }
                return [];
            }
        },
        {
            /*
    "complete" seg means it has component and eventRange
    */ key: "sliceEventRanges",
            value: function sliceEventRanges(eventRanges, extraArgs) {
                var _segs;
                var segs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = eventRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var eventRange = _step.value;
                        (_segs = segs).push.apply(_segs, (0, $5TJQB._)(this.sliceEventRange(eventRange, extraArgs)));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return segs;
            }
        },
        {
            /*
    "complete" seg means it has component and eventRange
    */ key: "sliceEventRange",
            value: function sliceEventRange(eventRange, extraArgs) {
                var dateRange = eventRange.range;
                // hack to make multi-day events that are being force-displayed as list-items to take up only one day
                if (this.forceDayIfListItem && eventRange.ui.display === "list-item") dateRange = {
                    start: dateRange.start,
                    end: $8c023e653ef8da49$export$625550452a3fa3ec(dateRange.start, 1)
                };
                var segs = this.sliceRange.apply(this, [
                    dateRange
                ].concat((0, $5TJQB._)(extraArgs)));
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var seg = _step.value;
                        seg.eventRange = eventRange;
                        seg.isStart = eventRange.isStart && seg.isStart;
                        seg.isEnd = eventRange.isEnd && seg.isEnd;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return segs;
            }
        }
    ]);
    return Slicer;
}();
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/ function $8c023e653ef8da49$var$computeActiveRange(dateProfile, isComponentAllDay) {
    var range = dateProfile.activeRange;
    if (isComponentAllDay) return range;
    return {
        start: $8c023e653ef8da49$export$136fd86de524d3c2(range.start, dateProfile.slotMinTime.milliseconds),
        end: $8c023e653ef8da49$export$136fd86de524d3c2(range.end, dateProfile.slotMaxTime.milliseconds - 864e5)
    };
}
// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function $8c023e653ef8da49$export$c667925124dac624(interaction, dateProfile, context) {
    var instances = interaction.mutatedEvents.instances;
    for(var instanceId in instances){
        if (!$8c023e653ef8da49$export$4ae495d48253603d(dateProfile.validRange, instances[instanceId].range)) return false;
    }
    return $8c023e653ef8da49$var$isNewPropsValid({
        eventDrag: interaction
    }, context); // HACK: the eventDrag props is used for ALL interactions
}
function $8c023e653ef8da49$export$c69d65aa55814164(dateSelection, dateProfile, context) {
    if (!$8c023e653ef8da49$export$4ae495d48253603d(dateProfile.validRange, dateSelection.range)) return false;
    return $8c023e653ef8da49$var$isNewPropsValid({
        dateSelection: dateSelection
    }, context);
}
function $8c023e653ef8da49$var$isNewPropsValid(newProps, context) {
    var calendarState = context.getCurrentData();
    var props = Object.assign({
        businessHours: calendarState.businessHours,
        dateSelection: "",
        eventStore: calendarState.eventStore,
        eventUiBases: calendarState.eventUiBases,
        eventSelection: "",
        eventDrag: null,
        eventResize: null
    }, newProps);
    return (context.pluginHooks.isPropsValid || $8c023e653ef8da49$export$545a72cc0d3f00b0)(props, context);
}
function $8c023e653ef8da49$export$545a72cc0d3f00b0(state, context) {
    var dateSpanMeta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, filterConfig = arguments.length > 3 ? arguments[3] : void 0;
    if (state.eventDrag && !$8c023e653ef8da49$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    if (state.dateSelection && !$8c023e653ef8da49$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function $8c023e653ef8da49$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    var currentState = context.getCurrentData();
    var interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    var subjectEventStore = interaction.mutatedEvents;
    var subjectDefs = subjectEventStore.defs;
    var subjectInstances = subjectEventStore.instances;
    var subjectConfigs = $8c023e653ef8da49$var$compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
        "": currentState.selectionConfig
    });
    if (filterConfig) subjectConfigs = $8c023e653ef8da49$export$407448d2b89b1813(subjectConfigs, filterConfig);
    // exclude the subject events. TODO: exclude defs too?
    var otherEventStore = $8c023e653ef8da49$var$excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    var otherDefs = otherEventStore.defs;
    var otherInstances = otherEventStore.instances;
    var otherConfigs = $8c023e653ef8da49$var$compileEventUis(otherDefs, state.eventUiBases);
    for(var subjectInstanceId in subjectInstances){
        var subjectInstance = subjectInstances[subjectInstanceId];
        var subjectRange = subjectInstance.range;
        var subjectConfig = subjectConfigs[subjectInstance.defId];
        var subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!$8c023e653ef8da49$var$allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) return false;
        // overlap
        var eventOverlap = context.options.eventOverlap;
        var eventOverlapFunc = typeof eventOverlap === "function" ? eventOverlap : null;
        for(var otherInstanceId in otherInstances){
            var otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if ($8c023e653ef8da49$export$ad4aebacdcaf47f8(subjectRange, otherInstance.range)) {
                var otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) return false;
                if (subjectConfig.overlap === false) return false;
                if (eventOverlapFunc && !eventOverlapFunc(new $8c023e653ef8da49$export$34aec0b863436764(context, otherDefs[otherInstance.defId], otherInstance), new $8c023e653ef8da49$export$34aec0b863436764(context, subjectDef, subjectInstance))) return false;
            }
        }
        // allow (a function)
        var calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = subjectConfig.allows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var subjectAllow = _step.value;
                var subjectDateSpan = Object.assign(Object.assign({}, dateSpanMeta), {
                    range: subjectInstance.range,
                    allDay: subjectDef.allDay
                });
                var origDef = calendarEventStore.defs[subjectDef.defId];
                var origInstance = calendarEventStore.instances[subjectInstanceId];
                var eventApi = void 0;
                if (origDef) eventApi = new $8c023e653ef8da49$export$34aec0b863436764(context, origDef, origInstance);
                else eventApi = new $8c023e653ef8da49$export$34aec0b863436764(context, subjectDef); // no instance, because had no dates
                if (!subjectAllow($8c023e653ef8da49$var$buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function $8c023e653ef8da49$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    var relevantEventStore = state.eventStore;
    var relevantDefs = relevantEventStore.defs;
    var relevantInstances = relevantEventStore.instances;
    var selection = state.dateSelection;
    var selectionRange = selection.range;
    var selectionConfig = context.getCurrentData().selectionConfig;
    if (filterConfig) selectionConfig = filterConfig(selectionConfig);
    // constraint
    if (!$8c023e653ef8da49$var$allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) return false;
    // overlap
    var selectOverlap = context.options.selectOverlap;
    var selectOverlapFunc = typeof selectOverlap === "function" ? selectOverlap : null;
    for(var relevantInstanceId in relevantInstances){
        var relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if ($8c023e653ef8da49$export$ad4aebacdcaf47f8(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) return false;
            if (selectOverlapFunc && !selectOverlapFunc(new $8c023e653ef8da49$export$34aec0b863436764(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) return false;
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // allow (a function)
        for(var _iterator = selectionConfig.allows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var selectionAllow = _step.value;
            var fullDateSpan = Object.assign(Object.assign({}, dateSpanMeta), selection);
            if (!selectionAllow($8c023e653ef8da49$var$buildDateSpanApiWithContext(fullDateSpan, context), null)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function $8c023e653ef8da49$var$allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = constraints[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var constraint = _step.value;
            if (!$8c023e653ef8da49$var$anyRangesContainRange($8c023e653ef8da49$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $8c023e653ef8da49$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    if (constraint === "businessHours") return $8c023e653ef8da49$var$eventStoreToRanges($8c023e653ef8da49$var$expandRecurring(businessHoursUnexpanded, subjectRange, context));
    if (typeof constraint === "string") return $8c023e653ef8da49$var$eventStoreToRanges($8c023e653ef8da49$var$filterEventStoreDefs(otherEventStore, function(eventDef) {
        return eventDef.groupId === constraint;
    }));
    if (typeof constraint === "object" && constraint) return $8c023e653ef8da49$var$eventStoreToRanges($8c023e653ef8da49$var$expandRecurring(constraint, subjectRange, context));
    return []; // if it's false
}
// TODO: move to event-store file?
function $8c023e653ef8da49$var$eventStoreToRanges(eventStore) {
    var instances = eventStore.instances;
    var ranges = [];
    for(var instanceId in instances)ranges.push(instances[instanceId].range);
    return ranges;
}
// TODO: move to geom file?
function $8c023e653ef8da49$var$anyRangesContainRange(outerRanges, innerRange) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = outerRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var outerRange = _step.value;
            if ($8c023e653ef8da49$export$4ae495d48253603d(outerRange, innerRange)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
var $8c023e653ef8da49$var$VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
var $8c023e653ef8da49$export$807f1ba34db587c7 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(Scroller, BaseComponent);
    var _super = (0, $jhb1H._)(Scroller);
    function Scroller() {
        (0, $5kWiG._)(this, Scroller);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.handleEl = function(el) {
            _this.el = el;
            $8c023e653ef8da49$export$8743009a87fcb00f(_this.props.elRef, el);
        };
        return _this;
    }
    (0, $hHaEF._)(Scroller, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var liquid = props.liquid, liquidIsAbsolute = props.liquidIsAbsolute;
                var isAbsolute = liquid && liquidIsAbsolute;
                var className = [
                    "fc-scroller"
                ];
                if (liquid) {
                    if (liquidIsAbsolute) className.push("fc-scroller-liquid-absolute");
                    else className.push("fc-scroller-liquid");
                }
                return (0, $kgSvt.createElement)("div", {
                    ref: this.handleEl,
                    className: className.join(" "),
                    style: {
                        overflowX: props.overflowX,
                        overflowY: props.overflowY,
                        left: isAbsolute && -(props.overcomeLeft || 0) || "",
                        right: isAbsolute && -(props.overcomeRight || 0) || "",
                        bottom: isAbsolute && -(props.overcomeBottom || 0) || "",
                        marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || "",
                        marginRight: !isAbsolute && -(props.overcomeRight || 0) || "",
                        marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || "",
                        maxHeight: props.maxHeight || ""
                    }
                }, props.children);
            }
        },
        {
            key: "needsXScrolling",
            value: function needsXScrolling() {
                if ($8c023e653ef8da49$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return false;
                // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
                // much more reliable to see if children are taller than the scroller, even tho doesn't account for
                // inner-child margins and absolute positioning
                var el = this.el;
                var realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
                var children = el.children;
                for(var i = 0; i < children.length; i += 1){
                    var childEl = children[i];
                    if (childEl.getBoundingClientRect().width > realClientWidth) return true;
                }
                return false;
            }
        },
        {
            key: "needsYScrolling",
            value: function needsYScrolling() {
                if ($8c023e653ef8da49$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return false;
                // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
                // much more reliable to see if children are taller than the scroller, even tho doesn't account for
                // inner-child margins and absolute positioning
                var el = this.el;
                var realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
                var children = el.children;
                for(var i = 0; i < children.length; i += 1){
                    var childEl = children[i];
                    if (childEl.getBoundingClientRect().height > realClientHeight) return true;
                }
                return false;
            }
        },
        {
            key: "getXScrollbarWidth",
            value: function getXScrollbarWidth() {
                if ($8c023e653ef8da49$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return 0;
                return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
            }
        },
        {
            key: "getYScrollbarWidth",
            value: function getYScrollbarWidth() {
                if ($8c023e653ef8da49$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return 0;
                return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
            }
        }
    ]);
    return Scroller;
}($8c023e653ef8da49$export$ef35774e6d314e91);
/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/ var $8c023e653ef8da49$export$49e6ee724f7f1ace = /*#__PURE__*/ function() {
    "use strict";
    function RefMap(masterCallback) {
        var _this = this;
        (0, $5kWiG._)(this, RefMap);
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = function(val, key) {
            var depths = _this.depths, currentMap = _this.currentMap;
            var removed = false;
            var added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = key in currentMap;
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            } else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete _this.callbackMap[key];
                    removed = true;
                }
            }
            if (_this.masterCallback) {
                if (removed) _this.masterCallback(null, String(key));
                if (added) _this.masterCallback(val, String(key));
            }
        };
    }
    (0, $hHaEF._)(RefMap, [
        {
            key: "createRef",
            value: function createRef(key) {
                var _this = this;
                var refCallback = this.callbackMap[key];
                if (!refCallback) refCallback = this.callbackMap[key] = function(val) {
                    _this.handleValue(val, String(key));
                };
                return refCallback;
            }
        },
        {
            // TODO: check callers that don't care about order. should use getAll instead
            // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
            // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
            key: "collect",
            value: function collect(startIndex, endIndex, step) {
                return $8c023e653ef8da49$export$91477dc880baac21(this.currentMap, startIndex, endIndex, step);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return $8c023e653ef8da49$export$90a7f3efeed30595(this.currentMap);
            }
        }
    ]);
    return RefMap;
}();
function $8c023e653ef8da49$export$f5339a28e56d1baf(chunkEls) {
    var shrinkCells = $8c023e653ef8da49$export$9f4f30ee63539e24(chunkEls, ".fc-scrollgrid-shrink");
    var largestWidth = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = shrinkCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var shrinkCell = _step.value;
            largestWidth = Math.max(largestWidth, $8c023e653ef8da49$var$computeSmallestCellWidth(shrinkCell));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function $8c023e653ef8da49$export$4f33f238a5c1ad77(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function $8c023e653ef8da49$export$7fe88b5920ffddd2(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
    $8c023e653ef8da49$export$4f33f238a5c1ad77(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function $8c023e653ef8da49$export$df7c425476ed4f2(sectionConfig, chunkConfig, arg, isHeader) {
    var expandRows = arg.expandRows;
    var content = typeof chunkConfig.content === "function" ? chunkConfig.content(arg) : (0, $kgSvt.createElement)("table", {
        role: "presentation",
        className: [
            chunkConfig.tableClassName,
            sectionConfig.syncRowHeights ? "fc-scrollgrid-sync-table" : ""
        ].join(" "),
        style: {
            minWidth: arg.tableMinWidth,
            width: arg.clientWidth,
            height: expandRows ? arg.clientHeight : ""
        }
    }, arg.tableColGroupNode, (0, $kgSvt.createElement)(isHeader ? "thead" : "tbody", {
        role: "presentation"
    }, typeof chunkConfig.rowContent === "function" ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
    return content;
}
function $8c023e653ef8da49$export$4ad369a19af21c23(cols0, cols1) {
    return $8c023e653ef8da49$export$23f2a1d2818174ef(cols0, cols1, $8c023e653ef8da49$export$a9c23c6ac3fc3eca);
}
function $8c023e653ef8da49$export$101619b11a34a0bd(cols, shrinkWidth) {
    var colNodes = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */ for(var _iterator = cols[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var colProps = _step.value;
            var span = colProps.span || 1;
            for(var i = 0; i < span; i += 1)colNodes.push((0, $kgSvt.createElement)("col", {
                style: {
                    width: colProps.width === "shrink" ? $8c023e653ef8da49$export$1ec7a8278ebd1290(shrinkWidth) : colProps.width || "",
                    minWidth: colProps.minWidth || ""
                }
            }));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $kgSvt.createElement).apply(void 0, [
        "colgroup",
        {}
    ].concat((0, $5TJQB._)(colNodes)));
}
function $8c023e653ef8da49$export$1ec7a8278ebd1290(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */ return shrinkWidth == null ? 4 : shrinkWidth;
}
function $8c023e653ef8da49$export$65ab0ebced932b79(cols) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cols[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var col = _step.value;
            if (col.width === "shrink") return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $8c023e653ef8da49$export$60e660859c376841(liquid, context) {
    var classNames = [
        "fc-scrollgrid",
        context.theme.getClass("table")
    ];
    if (liquid) classNames.push("fc-scrollgrid-liquid");
    return classNames;
}
function $8c023e653ef8da49$export$df838d0240c938cf(sectionConfig, wholeTableVGrow) {
    var classNames = [
        "fc-scrollgrid-section",
        "fc-scrollgrid-section-".concat(sectionConfig.type),
        sectionConfig.className
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) classNames.push("fc-scrollgrid-section-liquid");
    if (sectionConfig.isSticky) classNames.push("fc-scrollgrid-section-sticky");
    return classNames;
}
function $8c023e653ef8da49$export$89e9012e902952b6(arg) {
    return (0, $kgSvt.createElement)("div", {
        className: "fc-scrollgrid-sticky-shim",
        style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth
        }
    });
}
function $8c023e653ef8da49$export$a1edd97dd51cd48d(options) {
    var stickyHeaderDates = options.stickyHeaderDates;
    if (stickyHeaderDates == null || stickyHeaderDates === "auto") stickyHeaderDates = options.height === "auto" || options.viewHeight === "auto";
    return stickyHeaderDates;
}
function $8c023e653ef8da49$export$54c4fabc2291e9c0(options) {
    var stickyFooterScrollbar = options.stickyFooterScrollbar;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === "auto") stickyFooterScrollbar = options.height === "auto" || options.viewHeight === "auto";
    return stickyFooterScrollbar;
}
var $8c023e653ef8da49$export$add49c223b9ce4ea = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(SimpleScrollGrid, BaseComponent);
    var _super = (0, $jhb1H._)(SimpleScrollGrid);
    function SimpleScrollGrid() {
        (0, $5kWiG._)(this, SimpleScrollGrid);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.processCols = $8c023e653ef8da49$export$df995fae86a55f06(function(a) {
            return a;
        }, $8c023e653ef8da49$export$4ad369a19af21c23); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        _this.renderMicroColGroup = $8c023e653ef8da49$export$df995fae86a55f06($8c023e653ef8da49$export$101619b11a34a0bd);
        _this.scrollerRefs = new $8c023e653ef8da49$export$49e6ee724f7f1ace();
        _this.scrollerElRefs = new $8c023e653ef8da49$export$49e6ee724f7f1ace(_this._handleScrollerEl.bind((0, $1K4o4._)(_this)));
        _this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {}
        };
        // TODO: can do a really simple print-view. dont need to join rows
        _this.handleSizing = function() {
            _this.safeSetState(Object.assign({
                shrinkWidth: _this.computeShrinkWidth()
            }, _this.computeScrollerDims()));
        };
        return _this;
    }
    (0, $hHaEF._)(SimpleScrollGrid, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, state = _this.state, context = _this.context;
                var sectionConfigs = props.sections || [];
                var cols = this.processCols(props.cols);
                var microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
                var classNames = $8c023e653ef8da49$export$60e660859c376841(props.liquid, context);
                if (props.collapsibleWidth) classNames.push("fc-scrollgrid-collapsible");
                // TODO: make DRY
                var configCnt = sectionConfigs.length;
                var configI = 0;
                var currentConfig;
                var headSectionNodes = [];
                var bodySectionNodes = [];
                var footSectionNodes = [];
                while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "header"){
                    headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
                    configI += 1;
                }
                while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "body"){
                    bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
                    configI += 1;
                }
                while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "footer"){
                    footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
                    configI += 1;
                }
                // firefox bug: when setting height on table and there is a thead or tfoot,
                // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
                // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
                // if so, use a simpler dom structure, jam everything into a lone tbody.
                var isBuggy = !$8c023e653ef8da49$export$667d3bf0c5f83305();
                var roleAttrs = {
                    role: "rowgroup"
                };
                return (0, $kgSvt.createElement)("table", {
                    role: "grid",
                    className: classNames.join(" "),
                    style: {
                        height: props.height
                    }
                }, Boolean(!isBuggy && headSectionNodes.length) && (0, $kgSvt.createElement).apply(void 0, [
                    "thead",
                    roleAttrs
                ].concat((0, $5TJQB._)(headSectionNodes))), Boolean(!isBuggy && bodySectionNodes.length) && (0, $kgSvt.createElement).apply(void 0, [
                    "tbody",
                    roleAttrs
                ].concat((0, $5TJQB._)(bodySectionNodes))), Boolean(!isBuggy && footSectionNodes.length) && (0, $kgSvt.createElement).apply(void 0, [
                    "tfoot",
                    roleAttrs
                ].concat((0, $5TJQB._)(footSectionNodes))), isBuggy && (0, $kgSvt.createElement).apply(void 0, [
                    "tbody",
                    roleAttrs
                ].concat((0, $5TJQB._)(headSectionNodes), (0, $5TJQB._)(bodySectionNodes), (0, $5TJQB._)(footSectionNodes))));
            }
        },
        {
            key: "renderSection",
            value: function renderSection(sectionConfig, microColGroupNode, isHeader) {
                if ("outerContent" in sectionConfig) return (0, $kgSvt.createElement)((0, $kgSvt.Fragment), {
                    key: sectionConfig.key
                }, sectionConfig.outerContent);
                return (0, $kgSvt.createElement)("tr", {
                    key: sectionConfig.key,
                    role: "presentation",
                    className: $8c023e653ef8da49$export$df838d0240c938cf(sectionConfig, this.props.liquid).join(" ")
                }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
            }
        },
        {
            key: "renderChunkTd",
            value: function renderChunkTd(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
                if ("outerContent" in chunkConfig) return chunkConfig.outerContent;
                var props = this.props;
                var _this_state = this.state, forceYScrollbars = _this_state.forceYScrollbars, scrollerClientWidths = _this_state.scrollerClientWidths, scrollerClientHeights = _this_state.scrollerClientHeights;
                var needsYScrolling = $8c023e653ef8da49$export$7fe88b5920ffddd2(props, sectionConfig); // TODO: do lazily. do in section config?
                var isLiquid = $8c023e653ef8da49$export$4f33f238a5c1ad77(props, sectionConfig);
                // for `!props.liquid` - is WHOLE scrollgrid natural height?
                // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
                var overflowY = !props.liquid ? "visible" : forceYScrollbars ? "scroll" : !needsYScrolling ? "hidden" : "auto";
                var sectionKey = sectionConfig.key;
                var content = $8c023e653ef8da49$export$df7c425476ed4f2(sectionConfig, chunkConfig, {
                    tableColGroupNode: microColGroupNode,
                    tableMinWidth: "",
                    clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
                    clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
                    expandRows: sectionConfig.expandRows,
                    syncRowHeights: false,
                    rowSyncHeights: [],
                    reportRowHeightChange: function() {}
                }, isHeader);
                return (0, $kgSvt.createElement)(isHeader ? "th" : "td", {
                    ref: chunkConfig.elRef,
                    role: "presentation"
                }, (0, $kgSvt.createElement)("div", {
                    className: "fc-scroller-harness".concat(isLiquid ? " fc-scroller-harness-liquid" : "")
                }, (0, $kgSvt.createElement)($8c023e653ef8da49$export$807f1ba34db587c7, {
                    ref: this.scrollerRefs.createRef(sectionKey),
                    elRef: this.scrollerElRefs.createRef(sectionKey),
                    overflowY: overflowY,
                    overflowX: !props.liquid ? "visible" : "hidden" /* natural height? */ ,
                    maxHeight: sectionConfig.maxHeight,
                    liquid: isLiquid,
                    liquidIsAbsolute: true
                }, content)));
            }
        },
        {
            key: "_handleScrollerEl",
            value: function _handleScrollerEl(scrollerEl, key) {
                var section = $8c023e653ef8da49$var$getSectionByKey(this.props.sections, key);
                if (section) $8c023e653ef8da49$export$8743009a87fcb00f(section.chunk.scrollerElRef, scrollerEl);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.handleSizing();
                this.context.addResizeHandler(this.handleSizing);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                // TODO: need better solution when state contains non-sizing things
                this.handleSizing();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.context.removeResizeHandler(this.handleSizing);
            }
        },
        {
            key: "computeShrinkWidth",
            value: function computeShrinkWidth1() {
                return $8c023e653ef8da49$export$65ab0ebced932b79(this.props.cols) ? $8c023e653ef8da49$export$f5339a28e56d1baf(this.scrollerElRefs.getAll()) : 0;
            }
        },
        {
            key: "computeScrollerDims",
            value: function computeScrollerDims() {
                var scrollbarWidth = $8c023e653ef8da49$export$c7ca7e4bc4f8a16e();
                var _this = this, scrollerRefs = _this.scrollerRefs, scrollerElRefs = _this.scrollerElRefs;
                var forceYScrollbars = false;
                var scrollerClientWidths = {};
                var scrollerClientHeights = {};
                for(var sectionKey in scrollerRefs.currentMap){
                    var scroller = scrollerRefs.currentMap[sectionKey];
                    if (scroller && scroller.needsYScrolling()) {
                        forceYScrollbars = true;
                        break;
                    }
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.props.sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var section = _step.value;
                        var sectionKey1 = section.key;
                        var scrollerEl = scrollerElRefs.currentMap[sectionKey1];
                        if (scrollerEl) {
                            var harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                            scrollerClientWidths[sectionKey1] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                             : 0));
                            scrollerClientHeights[sectionKey1] = Math.floor(harnessEl.getBoundingClientRect().height);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    forceYScrollbars: forceYScrollbars,
                    scrollerClientWidths: scrollerClientWidths,
                    scrollerClientHeights: scrollerClientHeights
                };
            }
        }
    ]);
    return SimpleScrollGrid;
}($8c023e653ef8da49$export$ef35774e6d314e91);
$8c023e653ef8da49$export$add49c223b9ce4ea.addStateEquality({
    scrollerClientWidths: $8c023e653ef8da49$export$a9c23c6ac3fc3eca,
    scrollerClientHeights: $8c023e653ef8da49$export$a9c23c6ac3fc3eca
});
function $8c023e653ef8da49$var$getSectionByKey(sections, key) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var section = _step.value;
            if (section.key === key) return section;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
var $8c023e653ef8da49$export$1343a74baacb0543 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(EventContainer, BaseComponent);
    var _super = (0, $jhb1H._)(EventContainer);
    function EventContainer() {
        (0, $5kWiG._)(this, EventContainer);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.handleEl = function(el) {
            _this.el = el;
            if (el) $8c023e653ef8da49$var$setElSeg(el, _this.props.seg);
        };
        return _this;
    }
    (0, $hHaEF._)(EventContainer, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var seg = props.seg;
                var eventRange = seg.eventRange;
                var ui = eventRange.ui;
                var renderProps = {
                    event: new $8c023e653ef8da49$export$34aec0b863436764(context, eventRange.def, eventRange.instance),
                    view: context.viewApi,
                    timeText: props.timeText,
                    textColor: ui.textColor,
                    backgroundColor: ui.backgroundColor,
                    borderColor: ui.borderColor,
                    isDraggable: !props.disableDragging && $8c023e653ef8da49$var$computeSegDraggable(seg, context),
                    isStartResizable: !props.disableResizing && $8c023e653ef8da49$var$computeSegStartResizable(seg, context),
                    isEndResizable: !props.disableResizing && $8c023e653ef8da49$var$computeSegEndResizable(seg),
                    isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
                    isStart: Boolean(seg.isStart),
                    isEnd: Boolean(seg.isEnd),
                    isPast: Boolean(props.isPast),
                    isFuture: Boolean(props.isFuture),
                    isToday: Boolean(props.isToday),
                    isSelected: Boolean(props.isSelected),
                    isDragging: Boolean(props.isDragging),
                    isResizing: Boolean(props.isResizing)
                };
                return (0, $kgSvt.createElement)($8c023e653ef8da49$export$e7094788287c5e9b, Object.assign({}, props /* contains children */ , {
                    elRef: this.handleEl,
                    elClasses: (0, $5TJQB._)($8c023e653ef8da49$var$getEventClassNames(renderProps)).concat((0, $5TJQB._)(seg.eventRange.ui.classNames), (0, $5TJQB._)(props.elClasses || [])),
                    renderProps: renderProps,
                    generatorName: "eventContent",
                    customGenerator: options.eventContent,
                    defaultGenerator: props.defaultGenerator,
                    classNameGenerator: options.eventClassNames,
                    didMount: options.eventDidMount,
                    willUnmount: options.eventWillUnmount
                }));
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.el && this.props.seg !== prevProps.seg) $8c023e653ef8da49$var$setElSeg(this.el, this.props.seg);
            }
        }
    ]);
    return EventContainer;
}($8c023e653ef8da49$export$ef35774e6d314e91);
// should not be a purecomponent
var $8c023e653ef8da49$export$d92db8a7dc823bb0 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(StandardEvent, BaseComponent);
    var _super = (0, $jhb1H._)(StandardEvent);
    function StandardEvent() {
        (0, $5kWiG._)(this, StandardEvent);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(StandardEvent, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var seg = props.seg;
                var ui = seg.eventRange.ui;
                var timeFormat = options.eventTimeFormat || props.defaultTimeFormat;
                var timeText = $8c023e653ef8da49$export$993a080e5cb62d74(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
                return (0, $kgSvt.createElement)($8c023e653ef8da49$export$1343a74baacb0543, Object.assign({}, props /* includes elRef */ , {
                    elTag: "a",
                    elStyle: {
                        borderColor: ui.borderColor,
                        backgroundColor: ui.backgroundColor
                    },
                    elAttrs: $8c023e653ef8da49$export$e0c3a065614c6254(seg, context),
                    defaultGenerator: $8c023e653ef8da49$var$renderInnerContent$1,
                    timeText: timeText
                }), function(InnerContent, eventContentArg) {
                    return (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, (0, $kgSvt.createElement)(InnerContent, {
                        elTag: "div",
                        elClasses: [
                            "fc-event-main"
                        ],
                        elStyle: {
                            color: eventContentArg.textColor
                        }
                    }), Boolean(eventContentArg.isStartResizable) && (0, $kgSvt.createElement)("div", {
                        className: "fc-event-resizer fc-event-resizer-start"
                    }), Boolean(eventContentArg.isEndResizable) && (0, $kgSvt.createElement)("div", {
                        className: "fc-event-resizer fc-event-resizer-end"
                    }));
                });
            }
        }
    ]);
    return StandardEvent;
}($8c023e653ef8da49$export$ef35774e6d314e91);
function $8c023e653ef8da49$var$renderInnerContent$1(innerProps) {
    return (0, $kgSvt.createElement)("div", {
        className: "fc-event-main-frame"
    }, innerProps.timeText && (0, $kgSvt.createElement)("div", {
        className: "fc-event-time"
    }, innerProps.timeText), (0, $kgSvt.createElement)("div", {
        className: "fc-event-title-container"
    }, (0, $kgSvt.createElement)("div", {
        className: "fc-event-title fc-sticky"
    }, innerProps.event.title || (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, "\xa0"))));
}
var $8c023e653ef8da49$export$c1df809846363ebe = function(props) {
    return (0, $kgSvt.createElement)($8c023e653ef8da49$export$e7c866399fa523f5.Consumer, null, function(context) {
        var options = context.options;
        var renderProps = {
            isAxis: props.isAxis,
            date: context.dateEnv.toDate(props.date),
            view: context.viewApi
        };
        return (0, $kgSvt.createElement)($8c023e653ef8da49$export$e7094788287c5e9b, Object.assign({}, props /* includes children */ , {
            elTag: props.elTag || "div",
            renderProps: renderProps,
            generatorName: "nowIndicatorContent",
            customGenerator: options.nowIndicatorContent,
            classNameGenerator: options.nowIndicatorClassNames,
            didMount: options.nowIndicatorDidMount,
            willUnmount: options.nowIndicatorWillUnmount
        }));
    });
};
var $8c023e653ef8da49$var$DAY_NUM_FORMAT = $8c023e653ef8da49$export$d141bba7fdc215a3({
    day: "numeric"
});
var $8c023e653ef8da49$export$b975d55abac2bbe3 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(DayCellContainer, BaseComponent);
    var _super = (0, $jhb1H._)(DayCellContainer);
    function DayCellContainer() {
        (0, $5kWiG._)(this, DayCellContainer);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.refineRenderProps = $8c023e653ef8da49$export$ebd11618f299a286($8c023e653ef8da49$var$refineRenderProps);
        return _this;
    }
    (0, $hHaEF._)(DayCellContainer, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var renderProps = this.refineRenderProps({
                    date: props.date,
                    dateProfile: props.dateProfile,
                    todayRange: props.todayRange,
                    isMonthStart: props.isMonthStart || false,
                    showDayNumber: props.showDayNumber,
                    extraRenderProps: props.extraRenderProps,
                    viewApi: context.viewApi,
                    dateEnv: context.dateEnv,
                    monthStartFormat: options.monthStartFormat
                });
                return (0, $kgSvt.createElement)($8c023e653ef8da49$export$e7094788287c5e9b, Object.assign({}, props /* includes children */ , {
                    elClasses: (0, $5TJQB._)($8c023e653ef8da49$export$527e9aa3390079e9(renderProps, context.theme)).concat((0, $5TJQB._)(props.elClasses || [])),
                    elAttrs: Object.assign(Object.assign({}, props.elAttrs), renderProps.isDisabled ? {} : {
                        "data-date": $8c023e653ef8da49$export$5dbe06c6d8c68cfb(props.date)
                    }),
                    renderProps: renderProps,
                    generatorName: "dayCellContent",
                    customGenerator: options.dayCellContent,
                    defaultGenerator: props.defaultGenerator,
                    classNameGenerator: // don't use custom classNames if disabled
                    renderProps.isDisabled ? undefined : options.dayCellClassNames,
                    didMount: options.dayCellDidMount,
                    willUnmount: options.dayCellWillUnmount
                }));
            }
        }
    ]);
    return DayCellContainer;
}($8c023e653ef8da49$export$ef35774e6d314e91);
function $8c023e653ef8da49$export$b02498c06ddfef28(options) {
    return Boolean(options.dayCellContent || $8c023e653ef8da49$var$hasCustomRenderingHandler("dayCellContent", options));
}
function $8c023e653ef8da49$var$refineRenderProps(raw) {
    var date = raw.date, dateEnv = raw.dateEnv, dateProfile = raw.dateProfile, isMonthStart = raw.isMonthStart;
    var dayMeta = $8c023e653ef8da49$export$a17c37559e1db147(date, raw.todayRange, null, dateProfile);
    var dayNumberText = raw.showDayNumber ? dateEnv.format(date, isMonthStart ? raw.monthStartFormat : $8c023e653ef8da49$var$DAY_NUM_FORMAT) : "";
    return Object.assign(Object.assign(Object.assign({
        date: dateEnv.toDate(date),
        view: raw.viewApi
    }, dayMeta), {
        isMonthStart: isMonthStart,
        dayNumberText: dayNumberText
    }), raw.extraRenderProps);
}
var $8c023e653ef8da49$export$cd571ca6d1702b73 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(BgEvent, BaseComponent);
    var _super = (0, $jhb1H._)(BgEvent);
    function BgEvent() {
        (0, $5kWiG._)(this, BgEvent);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(BgEvent, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var seg = props.seg;
                return (0, $kgSvt.createElement)($8c023e653ef8da49$export$1343a74baacb0543, {
                    elTag: "div",
                    elClasses: [
                        "fc-bg-event"
                    ],
                    elStyle: {
                        backgroundColor: seg.eventRange.ui.backgroundColor
                    },
                    defaultGenerator: $8c023e653ef8da49$var$renderInnerContent,
                    seg: seg,
                    timeText: "",
                    isDragging: false,
                    isResizing: false,
                    isDateSelecting: false,
                    isSelected: false,
                    isPast: props.isPast,
                    isFuture: props.isFuture,
                    isToday: props.isToday,
                    disableDragging: true,
                    disableResizing: true
                });
            }
        }
    ]);
    return BgEvent;
}($8c023e653ef8da49$export$ef35774e6d314e91);
function $8c023e653ef8da49$var$renderInnerContent(props) {
    var title = props.event.title;
    return title && (0, $kgSvt.createElement)("div", {
        className: "fc-event-title"
    }, props.event.title);
}
function $8c023e653ef8da49$export$87b6ab1c2cb8b955(fillType) {
    return (0, $kgSvt.createElement)("div", {
        className: "fc-".concat(fillType)
    });
}
var $8c023e653ef8da49$export$a3c9165b94390bcd = function(props) {
    return (0, $kgSvt.createElement)($8c023e653ef8da49$export$e7c866399fa523f5.Consumer, null, function(context) {
        var dateEnv = context.dateEnv, options = context.options;
        var date = props.date;
        var format = options.weekNumberFormat || props.defaultFormat;
        var num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
        var text = dateEnv.format(date, format);
        var renderProps = {
            num: num,
            text: text,
            date: date
        };
        return (0, $kgSvt.createElement)($8c023e653ef8da49$export$e7094788287c5e9b // why isn't WeekNumberContentArg being auto-detected?
        , Object.assign({}, props /* includes children */ , {
            renderProps: renderProps,
            generatorName: "weekNumberContent",
            customGenerator: options.weekNumberContent,
            defaultGenerator: $8c023e653ef8da49$var$renderInner,
            classNameGenerator: options.weekNumberClassNames,
            didMount: options.weekNumberDidMount,
            willUnmount: options.weekNumberWillUnmount
        }));
    });
};
function $8c023e653ef8da49$var$renderInner(innerProps) {
    return innerProps.text;
}
var $8c023e653ef8da49$var$PADDING_FROM_VIEWPORT = 10;
var $8c023e653ef8da49$var$Popover = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(Popover, BaseComponent);
    var _super = (0, $jhb1H._)(Popover);
    function Popover() {
        (0, $5kWiG._)(this, Popover);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.state = {
            titleId: $8c023e653ef8da49$export$a8550f7dbe79f93a()
        };
        _this.handleRootEl = function(el) {
            _this.rootEl = el;
            if (_this.props.elRef) $8c023e653ef8da49$export$8743009a87fcb00f(_this.props.elRef, el);
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        _this.handleDocumentMouseDown = function(ev) {
            // only hide the popover if the click happened outside the popover
            var target = $8c023e653ef8da49$export$738ab4df8bf92ae9(ev);
            if (!_this.rootEl.contains(target)) _this.handleCloseClick();
        };
        _this.handleDocumentKeyDown = function(ev) {
            if (ev.key === "Escape") _this.handleCloseClick();
        };
        _this.handleCloseClick = function() {
            var onClose = _this.props.onClose;
            if (onClose) onClose();
        };
        return _this;
    }
    (0, $hHaEF._)(Popover, [
        {
            key: "render",
            value: function render() {
                var _this_context = this.context, theme = _this_context.theme, options = _this_context.options;
                var _this = this, props = _this.props, state = _this.state;
                var classNames = [
                    "fc-popover",
                    theme.getClass("popover")
                ].concat(props.extraClassNames || []);
                return (0, $8p1MK.createPortal)((0, $kgSvt.createElement)("div", Object.assign({}, props.extraAttrs, {
                    id: props.id,
                    className: classNames.join(" "),
                    "aria-labelledby": state.titleId,
                    ref: this.handleRootEl
                }), (0, $kgSvt.createElement)("div", {
                    className: "fc-popover-header " + theme.getClass("popoverHeader")
                }, (0, $kgSvt.createElement)("span", {
                    className: "fc-popover-title",
                    id: state.titleId
                }, props.title), (0, $kgSvt.createElement)("span", {
                    className: "fc-popover-close " + theme.getIconClass("close"),
                    title: options.closeHint,
                    onClick: this.handleCloseClick
                })), (0, $kgSvt.createElement)("div", {
                    className: "fc-popover-body " + theme.getClass("popoverContent")
                }, props.children)), props.parentEl);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("mousedown", this.handleDocumentMouseDown);
                document.addEventListener("keydown", this.handleDocumentKeyDown);
                this.updateSize();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("mousedown", this.handleDocumentMouseDown);
                document.removeEventListener("keydown", this.handleDocumentKeyDown);
            }
        },
        {
            key: "updateSize",
            value: function updateSize() {
                var isRtl = this.context.isRtl;
                var _this_props = this.props, alignmentEl = _this_props.alignmentEl, alignGridTop = _this_props.alignGridTop;
                var rootEl = this.rootEl;
                var alignmentRect = $8c023e653ef8da49$var$computeClippedClientRect(alignmentEl);
                if (alignmentRect) {
                    var popoverDims = rootEl.getBoundingClientRect();
                    // position relative to viewport
                    var popoverTop = alignGridTop ? $8c023e653ef8da49$export$3d8c2f653ac9d0b9(alignmentEl, ".fc-scrollgrid").getBoundingClientRect().top : alignmentRect.top;
                    var popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
                    // constrain
                    popoverTop = Math.max(popoverTop, $8c023e653ef8da49$var$PADDING_FROM_VIEWPORT);
                    popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - $8c023e653ef8da49$var$PADDING_FROM_VIEWPORT - popoverDims.width);
                    popoverLeft = Math.max(popoverLeft, $8c023e653ef8da49$var$PADDING_FROM_VIEWPORT);
                    var origin = rootEl.offsetParent.getBoundingClientRect();
                    $8c023e653ef8da49$export$2ed0fc6709e59212(rootEl, {
                        top: popoverTop - origin.top,
                        left: popoverLeft - origin.left
                    });
                }
            }
        }
    ]);
    return Popover;
}($8c023e653ef8da49$export$ef35774e6d314e91);
var $8c023e653ef8da49$var$MorePopover = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $dACZV._)(MorePopover, DateComponent);
    var _super = (0, $jhb1H._)(MorePopover);
    function MorePopover() {
        (0, $5kWiG._)(this, MorePopover);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.handleRootEl = function(rootEl) {
            _this.rootEl = rootEl;
            if (rootEl) _this.context.registerInteractiveComponent((0, $1K4o4._)(_this), {
                el: rootEl,
                useEventCenter: false
            });
            else _this.context.unregisterInteractiveComponent((0, $1K4o4._)(_this));
        };
        return _this;
    }
    (0, $hHaEF._)(MorePopover, [
        {
            key: "render",
            value: function render() {
                var _this_context = this.context, options = _this_context.options, dateEnv = _this_context.dateEnv;
                var props = this.props;
                var startDate = props.startDate, todayRange = props.todayRange, dateProfile = props.dateProfile;
                var title = dateEnv.format(startDate, options.dayPopoverFormat);
                return (0, $kgSvt.createElement)($8c023e653ef8da49$export$b975d55abac2bbe3, {
                    elRef: this.handleRootEl,
                    date: startDate,
                    dateProfile: dateProfile,
                    todayRange: todayRange
                }, function(InnerContent, renderProps, elAttrs) {
                    return (0, $kgSvt.createElement)($8c023e653ef8da49$var$Popover, {
                        elRef: elAttrs.ref,
                        id: props.id,
                        title: title,
                        extraClassNames: [
                            "fc-more-popover"
                        ].concat(elAttrs.className || []),
                        extraAttrs: elAttrs /* TODO: make these time-based when not whole-day? */ ,
                        parentEl: props.parentEl,
                        alignmentEl: props.alignmentEl,
                        alignGridTop: props.alignGridTop,
                        onClose: props.onClose
                    }, $8c023e653ef8da49$export$b02498c06ddfef28(options) && (0, $kgSvt.createElement)(InnerContent, {
                        elTag: "div",
                        elClasses: [
                            "fc-more-popover-misc"
                        ]
                    }), props.children);
                });
            }
        },
        {
            key: "queryHit",
            value: function queryHit(positionLeft, positionTop, elWidth, elHeight) {
                var _this = this, rootEl = _this.rootEl, props = _this.props;
                if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) return {
                    dateProfile: props.dateProfile,
                    dateSpan: Object.assign({
                        allDay: !props.forceTimed,
                        range: {
                            start: props.startDate,
                            end: props.endDate
                        }
                    }, props.extraDateSpan),
                    dayEl: rootEl,
                    rect: {
                        left: 0,
                        top: 0,
                        right: elWidth,
                        bottom: elHeight
                    },
                    layer: 1
                };
                return null;
            }
        }
    ]);
    return MorePopover;
}($8c023e653ef8da49$export$51b138e5a065c2bb);
var $8c023e653ef8da49$export$cbfbec548517f2b6 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(MoreLinkContainer, BaseComponent);
    var _super = (0, $jhb1H._)(MoreLinkContainer);
    function MoreLinkContainer() {
        (0, $5kWiG._)(this, MoreLinkContainer);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.state = {
            isPopoverOpen: false,
            popoverId: $8c023e653ef8da49$export$a8550f7dbe79f93a()
        };
        _this.handleLinkEl = function(linkEl) {
            _this.linkEl = linkEl;
            if (_this.props.elRef) $8c023e653ef8da49$export$8743009a87fcb00f(_this.props.elRef, linkEl);
        };
        _this.handleClick = function(ev) {
            var buildPublicSeg = function buildPublicSeg(seg) {
                var _seg_eventRange = seg.eventRange, def = _seg_eventRange.def, instance = _seg_eventRange.instance, range = _seg_eventRange.range;
                return {
                    event: new $8c023e653ef8da49$export$34aec0b863436764(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd
                };
            };
            var _$_assert_this_initialized = (0, $1K4o4._)(_this), props = _$_assert_this_initialized.props, context = _$_assert_this_initialized.context;
            var moreLinkClick = context.options.moreLinkClick;
            var date = $8c023e653ef8da49$var$computeRange(props).start;
            if (typeof moreLinkClick === "function") moreLinkClick = moreLinkClick({
                date: date,
                allDay: Boolean(props.allDayDate),
                allSegs: props.allSegs.map(buildPublicSeg),
                hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                jsEvent: ev,
                view: context.viewApi
            });
            if (!moreLinkClick || moreLinkClick === "popover") _this.setState({
                isPopoverOpen: true
            });
            else if (typeof moreLinkClick === "string") context.calendarApi.zoomTo(date, moreLinkClick);
        };
        _this.handlePopoverClose = function() {
            _this.setState({
                isPopoverOpen: false
            });
        };
        return _this;
    }
    (0, $hHaEF._)(MoreLinkContainer, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this1 = this, props = _this1.props, state = _this1.state;
                return (0, $kgSvt.createElement)($8c023e653ef8da49$export$e7c866399fa523f5.Consumer, null, function(context) {
                    var viewApi = context.viewApi, options = context.options, calendarApi = context.calendarApi;
                    var moreLinkText = options.moreLinkText;
                    var moreCnt = props.moreCnt;
                    var range = $8c023e653ef8da49$var$computeRange(props);
                    var text = typeof moreLinkText === "function" // TODO: eventually use formatWithOrdinals
                     ? moreLinkText.call(calendarApi, moreCnt) : "+".concat(moreCnt, " ").concat(moreLinkText);
                    var hint = $8c023e653ef8da49$export$342063e11d6c3cad(options.moreLinkHint, [
                        moreCnt
                    ], text);
                    var renderProps = {
                        num: moreCnt,
                        shortText: "+".concat(moreCnt),
                        text: text,
                        view: viewApi
                    };
                    return (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, Boolean(props.moreCnt) && (0, $kgSvt.createElement)($8c023e653ef8da49$export$e7094788287c5e9b, {
                        elTag: props.elTag || "a",
                        elRef: _this.handleLinkEl,
                        elClasses: (0, $5TJQB._)(props.elClasses || []).concat([
                            "fc-more-link"
                        ]),
                        elStyle: props.elStyle,
                        elAttrs: Object.assign(Object.assign(Object.assign({}, props.elAttrs), $8c023e653ef8da49$var$createAriaClickAttrs(_this.handleClick)), {
                            title: hint,
                            "aria-expanded": state.isPopoverOpen,
                            "aria-controls": state.isPopoverOpen ? state.popoverId : ""
                        }),
                        renderProps: renderProps,
                        generatorName: "moreLinkContent",
                        customGenerator: options.moreLinkContent,
                        defaultGenerator: props.defaultGenerator || $8c023e653ef8da49$var$renderMoreLinkInner,
                        classNameGenerator: options.moreLinkClassNames,
                        didMount: options.moreLinkDidMount,
                        willUnmount: options.moreLinkWillUnmount
                    }, props.children), state.isPopoverOpen && (0, $kgSvt.createElement)($8c023e653ef8da49$var$MorePopover, {
                        id: state.popoverId,
                        startDate: range.start,
                        endDate: range.end,
                        dateProfile: props.dateProfile,
                        todayRange: props.todayRange,
                        extraDateSpan: props.extraDateSpan,
                        parentEl: _this.parentEl,
                        alignmentEl: props.alignmentElRef ? props.alignmentElRef.current : _this.linkEl,
                        alignGridTop: props.alignGridTop,
                        forceTimed: props.forceTimed,
                        onClose: _this.handlePopoverClose
                    }, props.popoverContent()));
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateParentEl();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateParentEl();
            }
        },
        {
            key: "updateParentEl",
            value: function updateParentEl() {
                if (this.linkEl) this.parentEl = $8c023e653ef8da49$export$3d8c2f653ac9d0b9(this.linkEl, ".fc-view-harness");
            }
        }
    ]);
    return MoreLinkContainer;
}($8c023e653ef8da49$export$ef35774e6d314e91);
function $8c023e653ef8da49$var$renderMoreLinkInner(props) {
    return props.text;
}
function $8c023e653ef8da49$var$computeRange(props) {
    if (props.allDayDate) return {
        start: props.allDayDate,
        end: $8c023e653ef8da49$export$625550452a3fa3ec(props.allDayDate, 1)
    };
    var hiddenSegs = props.hiddenSegs;
    return {
        start: $8c023e653ef8da49$export$bde1ed0f60b38f2f(hiddenSegs),
        end: $8c023e653ef8da49$var$computeLatestSegEnd(hiddenSegs)
    };
}
function $8c023e653ef8da49$export$bde1ed0f60b38f2f(segs) {
    return segs.reduce($8c023e653ef8da49$var$pickEarliestStart).eventRange.range.start;
}
function $8c023e653ef8da49$var$pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function $8c023e653ef8da49$var$computeLatestSegEnd(segs) {
    return segs.reduce($8c023e653ef8da49$var$pickLatestEnd).eventRange.range.end;
}
function $8c023e653ef8da49$var$pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}
var $8c023e653ef8da49$var$Store = /*#__PURE__*/ function() {
    "use strict";
    function Store() {
        (0, $5kWiG._)(this, Store);
        this.handlers = [];
    }
    (0, $hHaEF._)(Store, [
        {
            key: "set",
            value: function set(value) {
                this.currentValue = value;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var handler = _step.value;
                        handler(value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "subscribe",
            value: function subscribe(handler) {
                this.handlers.push(handler);
                if (this.currentValue !== undefined) handler(this.currentValue);
            }
        }
    ]);
    return Store;
}();
/*
Subscribers will get a LIST of CustomRenderings
*/ var $8c023e653ef8da49$export$aea64bc1b6f8f415 = /*#__PURE__*/ function(Store) {
    "use strict";
    (0, $dACZV._)(CustomRenderingStore, Store);
    var _super = (0, $jhb1H._)(CustomRenderingStore);
    function CustomRenderingStore() {
        (0, $5kWiG._)(this, CustomRenderingStore);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.map = new Map();
        return _this;
    }
    (0, $hHaEF._)(CustomRenderingStore, [
        {
            // for consistent order
            key: "handle",
            value: function handle(customRendering) {
                var map = this.map;
                var updated = false;
                if (customRendering.isActive) {
                    map.set(customRendering.id, customRendering);
                    updated = true;
                } else if (map.has(customRendering.id)) {
                    map["delete"](customRendering.id);
                    updated = true;
                }
                if (updated) this.set(map);
            }
        }
    ]);
    return CustomRenderingStore;
}($8c023e653ef8da49$var$Store);

});
parcelRegister("9CX8V", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $70258a40475198fa$export$2466d533fda16e33; });

var $hY4ef = parcelRequire("hY4ef");

var $8wb0B = parcelRequire("8wb0B");

var $lDUJq = parcelRequire("lDUJq");

var $aLByk = parcelRequire("aLByk");
function $70258a40475198fa$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $70258a40475198fa$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $lDUJq._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $hY4ef._construct)(Class, arguments, (0, $8wb0B._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $aLByk._set_prototype_of)(Wrapper, Class);
    };
    return $70258a40475198fa$export$2466d533fda16e33(Class);
}

});
parcelRegister("hY4ef", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $d14b520517fe2a9a$export$2d841144c5f8c4ab; });

var $drer0 = parcelRequire("drer0");

var $aLByk = parcelRequire("aLByk");
function $d14b520517fe2a9a$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $drer0._is_native_reflect_construct)()) $d14b520517fe2a9a$export$2d841144c5f8c4ab = Reflect.construct;
    else $d14b520517fe2a9a$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $aLByk._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $d14b520517fe2a9a$export$2d841144c5f8c4ab.apply(null, arguments);
}

});

parcelRegister("lDUJq", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $fc193f3cc488c98e$export$514eda94019f4334; });
function $fc193f3cc488c98e$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("kgSvt", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $ec1f9527888545d6$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "isValidElement", function () { return $ec1f9527888545d6$export$a8257692ac88316c; });
$parcel$export(module.exports, "createElement", function () { return $ec1f9527888545d6$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $ec1f9527888545d6$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $ec1f9527888545d6$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $ec1f9527888545d6$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $ec1f9527888545d6$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $ec1f9527888545d6$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $ec1f9527888545d6$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $ec1f9527888545d6$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $ec1f9527888545d6$export$fd42f52fd3ae1109; });

var $2lB2g = parcelRequire("2lB2g");
var $ec1f9527888545d6$var$n, $ec1f9527888545d6$export$41c562ebe57d11e2, $ec1f9527888545d6$var$u, $ec1f9527888545d6$export$a8257692ac88316c, $ec1f9527888545d6$var$t, $ec1f9527888545d6$var$r, $ec1f9527888545d6$var$o, $ec1f9527888545d6$var$f, $ec1f9527888545d6$var$e, $ec1f9527888545d6$var$c = {}, $ec1f9527888545d6$var$s = [], $ec1f9527888545d6$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $ec1f9527888545d6$var$h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $ec1f9527888545d6$var$v(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $ec1f9527888545d6$export$c8a8987d4410bf2d(l, u, i) {
    var t, r, o, f = {};
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $ec1f9527888545d6$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === f[o] && (f[o] = l.defaultProps[o]);
    return $ec1f9527888545d6$var$p(l, f, t, r, null);
}
function $ec1f9527888545d6$var$p(n, i, t, r, o) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++$ec1f9527888545d6$var$u : o
    };
    return null == o && null != $ec1f9527888545d6$export$41c562ebe57d11e2.vnode && $ec1f9527888545d6$export$41c562ebe57d11e2.vnode(f), f;
}
function $ec1f9527888545d6$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $ec1f9527888545d6$export$ffb0004e005737fa(n) {
    return n.children;
}
function $ec1f9527888545d6$var$k(n, l, u, i, t) {
    var r;
    for(r in u)"children" === r || "key" === r || r in l || $ec1f9527888545d6$var$g(n, r, null, u[r], i);
    for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || $ec1f9527888545d6$var$g(n, r, l[r], u[r], i);
}
function $ec1f9527888545d6$var$b(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $ec1f9527888545d6$var$a.test(l) ? u : u + "px";
}
function $ec1f9527888545d6$var$g(n, l, u, i, t) {
    var r;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $ec1f9527888545d6$var$b(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $ec1f9527888545d6$var$b(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) r = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? i || n.addEventListener(l, r ? $ec1f9527888545d6$var$w : $ec1f9527888545d6$var$m, r) : n.removeEventListener(l, r ? $ec1f9527888545d6$var$w : $ec1f9527888545d6$var$m, r);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && -1 == l.indexOf("-") ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $ec1f9527888545d6$var$m(n) {
    $ec1f9527888545d6$var$t = !0;
    try {
        return this.l[n.type + !1]($ec1f9527888545d6$export$41c562ebe57d11e2.event ? $ec1f9527888545d6$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $ec1f9527888545d6$var$t = !1;
    }
}
function $ec1f9527888545d6$var$w(n) {
    $ec1f9527888545d6$var$t = !0;
    try {
        return this.l[n.type + !0]($ec1f9527888545d6$export$41c562ebe57d11e2.event ? $ec1f9527888545d6$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $ec1f9527888545d6$var$t = !1;
    }
}
function $ec1f9527888545d6$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $ec1f9527888545d6$var$A(n, l) {
    if (null == l) return n.__ ? $ec1f9527888545d6$var$A(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $ec1f9527888545d6$var$A(n) : null;
}
function $ec1f9527888545d6$var$P(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $ec1f9527888545d6$var$P(n);
    }
}
function $ec1f9527888545d6$var$C(n) {
    $ec1f9527888545d6$var$t ? setTimeout(n) : $ec1f9527888545d6$var$f(n);
}
function $ec1f9527888545d6$var$T(n) {
    (!n.__d && (n.__d = !0) && $ec1f9527888545d6$var$r.push(n) && !$ec1f9527888545d6$var$$.__r++ || $ec1f9527888545d6$var$o !== $ec1f9527888545d6$export$41c562ebe57d11e2.debounceRendering) && (($ec1f9527888545d6$var$o = $ec1f9527888545d6$export$41c562ebe57d11e2.debounceRendering) || $ec1f9527888545d6$var$C)($ec1f9527888545d6$var$$);
}
function $ec1f9527888545d6$var$$() {
    var n, l, u, i, t, o, f, e;
    for($ec1f9527888545d6$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }); n = $ec1f9527888545d6$var$r.shift();)n.__d && (l = $ec1f9527888545d6$var$r.length, i = void 0, t = void 0, f = (o = (u = n).__v).__e, (e = u.__P) && (i = [], (t = $ec1f9527888545d6$var$h({}, o)).__v = o.__v + 1, $ec1f9527888545d6$var$M(e, o, t, u.__n, void 0 !== e.ownerSVGElement, null != o.__h ? [
        f
    ] : null, i, null == f ? $ec1f9527888545d6$var$A(o) : f, o.__h), $ec1f9527888545d6$var$N(i, o), o.__e != f && $ec1f9527888545d6$var$P(o)), $ec1f9527888545d6$var$r.length > l && $ec1f9527888545d6$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }));
    $ec1f9527888545d6$var$$.__r = 0;
}
function $ec1f9527888545d6$var$H(n, l, u, i, t, r, o, f, e, a) {
    var h, v, y, d, k, b, g, m = i && i.__k || $ec1f9527888545d6$var$s, w = m.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (d = u.__k[h] = null == (d = l[h]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == (typeof d === "undefined" ? "undefined" : (0, $2lB2g._)(d)) ? $ec1f9527888545d6$var$p(null, d, null, null, d) : Array.isArray(d) ? $ec1f9527888545d6$var$p($ec1f9527888545d6$export$ffb0004e005737fa, {
        children: d
    }, null, null, null) : d.__b > 0 ? $ec1f9527888545d6$var$p(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : d)) {
        if (d.__ = u, d.__b = u.__b + 1, null === (y = m[h]) || y && d.key == y.key && d.type === y.type) m[h] = void 0;
        else for(v = 0; v < w; v++){
            if ((y = m[v]) && d.key == y.key && d.type === y.type) {
                m[v] = void 0;
                break;
            }
            y = null;
        }
        $ec1f9527888545d6$var$M(n, d, y = y || $ec1f9527888545d6$var$c, t, r, o, f, e, a), k = d.__e, (v = d.ref) && y.ref != v && (g || (g = []), y.ref && g.push(y.ref, null, d), g.push(v, d.__c || k, d)), null != k ? (null == b && (b = k), "function" == typeof d.type && d.__k === y.__k ? d.__d = e = $ec1f9527888545d6$var$I(d, e, n) : e = $ec1f9527888545d6$var$z(n, d, y, m, k, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = $ec1f9527888545d6$var$A(y));
    }
    for(u.__e = b, h = w; h--;)null != m[h] && ("function" == typeof u.type && null != m[h].__e && m[h].__e == u.__d && (u.__d = $ec1f9527888545d6$var$L(i).nextSibling), $ec1f9527888545d6$var$q(m[h], m[h]));
    if (g) for(h = 0; h < g.length; h++)$ec1f9527888545d6$var$S(g[h], g[++h], g[++h]);
}
function $ec1f9527888545d6$var$I(n, l, u) {
    for(var i, t = n.__k, r = 0; t && r < t.length; r++)(i = t[r]) && (i.__ = n, l = "function" == typeof i.type ? $ec1f9527888545d6$var$I(i, l, u) : $ec1f9527888545d6$var$z(u, i, i, t, i.__e, l));
    return l;
}
function $ec1f9527888545d6$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $ec1f9527888545d6$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $ec1f9527888545d6$var$z(n, l, u, i, t, r) {
    var o, f, e;
    if (void 0 !== l.__d) o = l.__d, l.__d = void 0;
    else if (null == u || t != r || null == t.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(t), o = null;
    else {
        for(f = r, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, r), o = r;
    }
    return void 0 !== o ? o : t.nextSibling;
}
function $ec1f9527888545d6$var$L(n) {
    var l, u, i;
    if (null == n.type || "string" == typeof n.type) return n.__e;
    if (n.__k) {
        for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = $ec1f9527888545d6$var$L(u))) return i;
    }
    return null;
}
function $ec1f9527888545d6$var$M(n, u, i, t, r, o, f, e, c) {
    var s, a, v, y, p, d, k, b, g, m, w, A, P, C, T, _$$ = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, o = [
        e
    ]), (s = $ec1f9527888545d6$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof _$$) {
            if (b = u.props, g = (s = _$$.contextType) && t[s.__c], m = s ? g ? g.props.value : s.__ : t, i.__c ? k = (a = u.__c = i.__c).__ = a.__E : ("prototype" in _$$ && _$$.prototype.render ? u.__c = a = new _$$(b, m) : (u.__c = a = new $ec1f9527888545d6$export$16fa2f45be04daa8(b, m), a.constructor = _$$, a.render = $ec1f9527888545d6$var$B), g && g.sub(a), a.props = b, a.state || (a.state = {}), a.context = m, a.__n = t, v = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != _$$.getDerivedStateFromProps && (a.__s == a.state && (a.__s = $ec1f9527888545d6$var$h({}, a.__s)), $ec1f9527888545d6$var$h(a.__s, _$$.getDerivedStateFromProps(b, a.__s))), y = a.props, p = a.state, a.__v = u, v) null == _$$.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
            else {
                if (null == _$$.getDerivedStateFromProps && b !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(b, m), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(b, a.__s, m) || u.__v === i.__v) {
                    for(u.__v !== i.__v && (a.props = b, a.state = a.__s, a.__d = !1), u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), w = 0; w < a._sb.length; w++)a.__h.push(a._sb[w]);
                    a._sb = [], a.__h.length && f.push(a);
                    break n;
                }
                null != a.componentWillUpdate && a.componentWillUpdate(b, a.__s, m), null != a.componentDidUpdate && a.__h.push(function() {
                    a.componentDidUpdate(y, p, d);
                });
            }
            if (a.context = m, a.props = b, a.__P = n, A = $ec1f9527888545d6$export$41c562ebe57d11e2.__r, P = 0, "prototype" in _$$ && _$$.prototype.render) {
                for(a.state = a.__s, a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                a._sb = [];
            } else do a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
            while (a.__d && ++P < 25);
            a.state = a.__s, null != a.getChildContext && (t = $ec1f9527888545d6$var$h($ec1f9527888545d6$var$h({}, t), a.getChildContext())), v || null == a.getSnapshotBeforeUpdate || (d = a.getSnapshotBeforeUpdate(y, p)), T = null != s && s.type === $ec1f9527888545d6$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $ec1f9527888545d6$var$H(n, Array.isArray(T) ? T : [
                T
            ], u, i, t, r, o, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), k && (a.__E = a.__ = null), a.__e = !1;
        } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $ec1f9527888545d6$var$O(i.__e, u, i, t, r, o, f, c);
        (s = $ec1f9527888545d6$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != o) && (u.__e = e, u.__h = !!c, o[o.indexOf(e)] = null), $ec1f9527888545d6$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $ec1f9527888545d6$var$N(n, u) {
    $ec1f9527888545d6$export$41c562ebe57d11e2.__c && $ec1f9527888545d6$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $ec1f9527888545d6$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $ec1f9527888545d6$var$O(l, u, i, t, r, o, f, e) {
    var s, a, h, y = i.props, p = u.props, d = u.type, _$_ = 0;
    if ("svg" === d && (r = !0), null != o) {
        for(; _$_ < o.length; _$_++)if ((s = o[_$_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, o[_$_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = r ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), o = null, e = !1;
    }
    if (null === d) y === p || e && l.data === p || (l.data = p);
    else {
        if (o = o && $ec1f9527888545d6$var$n.call(l.childNodes), a = (y = i.props || $ec1f9527888545d6$var$c).dangerouslySetInnerHTML, h = p.dangerouslySetInnerHTML, !e) {
            if (null != o) for(y = {}, _$_ = 0; _$_ < l.attributes.length; _$_++)y[l.attributes[_$_].name] = l.attributes[_$_].value;
            (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
        }
        if ($ec1f9527888545d6$var$k(l, p, y, r, e), h) u.__k = [];
        else if (_$_ = u.props.children, $ec1f9527888545d6$var$H(l, Array.isArray(_$_) ? _$_ : [
            _$_
        ], u, i, t, r && "foreignObject" !== d, o, f, o ? o[0] : i.__k && $ec1f9527888545d6$var$A(i, 0), e), null != o) for(_$_ = o.length; _$_--;)null != o[_$_] && $ec1f9527888545d6$var$v(o[_$_]);
        e || ("value" in p && void 0 !== (_$_ = p.value) && (_$_ !== l.value || "progress" === d && !_$_ || "option" === d && _$_ !== y.value) && $ec1f9527888545d6$var$g(l, "value", _$_, y.value, !1), "checked" in p && void 0 !== (_$_ = p.checked) && _$_ !== l.checked && $ec1f9527888545d6$var$g(l, "checked", _$_, y.checked, !1));
    }
    return l;
}
function $ec1f9527888545d6$var$S(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $ec1f9527888545d6$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $ec1f9527888545d6$var$q(n, u, i) {
    var t, r;
    if ($ec1f9527888545d6$export$41c562ebe57d11e2.unmount && $ec1f9527888545d6$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $ec1f9527888545d6$var$S(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $ec1f9527888545d6$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(r = 0; r < t.length; r++)t[r] && $ec1f9527888545d6$var$q(t[r], u, i || "function" != typeof n.type);
    i || null == n.__e || $ec1f9527888545d6$var$v(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $ec1f9527888545d6$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $ec1f9527888545d6$export$b3890eb0ae9dca99(u, i, t) {
    var r, o, f;
    $ec1f9527888545d6$export$41c562ebe57d11e2.__ && $ec1f9527888545d6$export$41c562ebe57d11e2.__(u, i), o = (r = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $ec1f9527888545d6$var$M(i, u = (!r && t || i).__k = $ec1f9527888545d6$export$c8a8987d4410bf2d($ec1f9527888545d6$export$ffb0004e005737fa, null, [
        u
    ]), o || $ec1f9527888545d6$var$c, $ec1f9527888545d6$var$c, void 0 !== i.ownerSVGElement, !r && t ? [
        t
    ] : o ? null : i.firstChild ? $ec1f9527888545d6$var$n.call(i.childNodes) : null, f, !r && t ? t : o ? o.__e : i.firstChild, r), $ec1f9527888545d6$var$N(f, u);
}
function $ec1f9527888545d6$export$fa8d919ba61d84db(n, l) {
    $ec1f9527888545d6$export$b3890eb0ae9dca99(n, l, $ec1f9527888545d6$export$fa8d919ba61d84db);
}
function $ec1f9527888545d6$export$e530037191fcd5d7(l, u, i) {
    var t, r, o, f = $ec1f9527888545d6$var$h({}, l.props);
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $ec1f9527888545d6$var$n.call(arguments, 2) : i), $ec1f9527888545d6$var$p(l.type, f, t || l.key, r || l.ref, null);
}
function $ec1f9527888545d6$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $ec1f9527888545d6$var$e++,
        __: n,
        Consumer: function Consumer(n, l) {
            return n.children(l);
        },
        Provider: function Provider(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $ec1f9527888545d6$var$T(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var _$l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), _$l && _$l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$ec1f9527888545d6$var$n = $ec1f9527888545d6$var$s.slice, $ec1f9527888545d6$export$41c562ebe57d11e2 = {
    __e: function __e(n, l, u, i) {
        for(var t, r, o; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((r = t.constructor) && null != r.getDerivedStateFromError && (t.setState(r.getDerivedStateFromError(n)), o = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), o = t.__d), o) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $ec1f9527888545d6$var$u = 0, $ec1f9527888545d6$export$a8257692ac88316c = function i(n) {
    return null != n && void 0 === n.constructor;
}, $ec1f9527888545d6$var$t = !1, $ec1f9527888545d6$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $ec1f9527888545d6$var$h({}, this.state), "function" == typeof n && (n = n($ec1f9527888545d6$var$h({}, u), this.props)), n && $ec1f9527888545d6$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $ec1f9527888545d6$var$T(this));
}, $ec1f9527888545d6$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $ec1f9527888545d6$var$T(this));
}, $ec1f9527888545d6$export$16fa2f45be04daa8.prototype.render = $ec1f9527888545d6$export$ffb0004e005737fa, $ec1f9527888545d6$var$r = [], $ec1f9527888545d6$var$f = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $ec1f9527888545d6$var$$.__r = 0, $ec1f9527888545d6$var$e = 0;

});

parcelRegister("8p1MK", function(module, exports) {

$parcel$export(module.exports, "createPortal", function () { return $61e20b0bb26f17bf$export$d39a5bbd09211389; });

var $2lB2g = parcelRequire("2lB2g");

var $kgSvt = parcelRequire("kgSvt");

var $bgnQu = parcelRequire("bgnQu");
function $61e20b0bb26f17bf$var$g(n, t) {
    for(var _$e in t)n[_$e] = t[_$e];
    return n;
}
function $61e20b0bb26f17bf$var$C(n, t) {
    for(var _$e in n)if ("__source" !== _$e && !(_$e in t)) return !0;
    for(var _$r in t)if ("__source" !== _$r && n[_$r] !== t[_$r]) return !0;
    return !1;
}
function $61e20b0bb26f17bf$var$E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function $61e20b0bb26f17bf$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $61e20b0bb26f17bf$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var _$t = this.props.ref, _$r = _$t == n.ref;
        return !_$r && _$t && (_$t.call ? _$t(null) : _$t.current = null), e ? !e(this.props, n) || !_$r : $61e20b0bb26f17bf$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $kgSvt.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($61e20b0bb26f17bf$export$221d75b3f55bb0bd.prototype = new (0, $kgSvt.Component)).isPureReactComponent = !0, $61e20b0bb26f17bf$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $61e20b0bb26f17bf$var$C(this.props, n) || $61e20b0bb26f17bf$var$C(this.state, t);
};
var $61e20b0bb26f17bf$var$x = (0, $kgSvt.options).__b;
(0, $kgSvt.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $61e20b0bb26f17bf$var$x && $61e20b0bb26f17bf$var$x(n);
};
var $61e20b0bb26f17bf$var$N = "undefined" != typeof Symbol && Symbol["for"] && Symbol["for"]("react.forward_ref") || 3911;
function $61e20b0bb26f17bf$export$257a8862b851cb5b(n) {
    function t(t) {
        var _$e = $61e20b0bb26f17bf$var$g({}, t);
        return delete _$e.ref, n(_$e, t.ref || null);
    }
    return t.$$typeof = $61e20b0bb26f17bf$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $61e20b0bb26f17bf$var$A = function A(n, t) {
    return null == n ? null : (0, $kgSvt.toChildArray)((0, $kgSvt.toChildArray)(n).map(t));
}, $61e20b0bb26f17bf$export$dca3b0875bd9a954 = {
    map: $61e20b0bb26f17bf$var$A,
    forEach: $61e20b0bb26f17bf$var$A,
    count: function count(n) {
        return n ? (0, $kgSvt.toChildArray)(n).length : 0;
    },
    only: function only(n) {
        var _$t = (0, $kgSvt.toChildArray)(n);
        if (1 !== _$t.length) throw "Children.only";
        return _$t[0];
    },
    toArray: (0, $kgSvt.toChildArray)
}, $61e20b0bb26f17bf$var$T = (0, $kgSvt.options).__e;
(0, $kgSvt.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var _$u, o = t; o = o.__;)if ((_$u = o.__c) && _$u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), _$u.__c(n, t);
    }
    $61e20b0bb26f17bf$var$T(n, t, e, r);
};
var $61e20b0bb26f17bf$var$I = (0, $kgSvt.options).unmount;
function $61e20b0bb26f17bf$var$L(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $61e20b0bb26f17bf$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $61e20b0bb26f17bf$var$L(n, t, e);
    })), n;
}
function $61e20b0bb26f17bf$var$U(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $61e20b0bb26f17bf$var$U(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $61e20b0bb26f17bf$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $61e20b0bb26f17bf$var$F(n) {
    var _$t = n.__.__c;
    return _$t && _$t.__a && _$t.__a(n);
}
function $61e20b0bb26f17bf$export$488013bae63b21da(n) {
    var _$e, _$r, _$u;
    function o(o) {
        if (_$e || (_$e = n()).then(function(n) {
            _$r = n["default"] || n;
        }, function(n) {
            _$u = n;
        }), _$u) throw _$u;
        if (!_$r) throw _$e;
        return (0, $kgSvt.createElement)(_$r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $61e20b0bb26f17bf$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $kgSvt.options).unmount = function(n) {
    var _$t = n.__c;
    _$t && _$t.__R && _$t.__R(), _$t && !0 === n.__h && (n.type = null), $61e20b0bb26f17bf$var$I && $61e20b0bb26f17bf$var$I(n);
}, ($61e20b0bb26f17bf$export$74bf444e3cd11ea5.prototype = new (0, $kgSvt.Component)).__c = function(n, t) {
    var _$e = t.__c, _$r = this;
    null == _$r.t && (_$r.t = []), _$r.t.push(_$e);
    var _$u = $61e20b0bb26f17bf$var$F(_$r.__v), o = !1, i = function i() {
        o || (o = !0, _$e.__R = null, _$u ? _$u(_$l) : _$l());
    };
    _$e.__R = i;
    var _$l = function l() {
        if (!--_$r.__u) {
            if (_$r.state.__a) {
                var _$n = _$r.state.__a;
                _$r.__v.__k[0] = $61e20b0bb26f17bf$var$U(_$n, _$n.__c.__P, _$n.__c.__O);
            }
            var _$t;
            for(_$r.setState({
                __a: _$r.__b = null
            }); _$t = _$r.t.pop();)_$t.forceUpdate();
        }
    }, _$c = !0 === t.__h;
    _$r.__u++ || _$c || _$r.setState({
        __a: _$r.__b = _$r.__v.__k[0]
    }), n.then(i, i);
}, $61e20b0bb26f17bf$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $61e20b0bb26f17bf$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var _$r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $61e20b0bb26f17bf$var$L(this.__b, _$r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, n.fallback);
    return i && (i.__h = null), [
        (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $61e20b0bb26f17bf$var$W = function W(n, t, e) {
    if (++e[1] === e[0] && n.o["delete"](t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $61e20b0bb26f17bf$var$P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $61e20b0bb26f17bf$var$$(n) {
    var _$e = this, _$r = n.i;
    _$e.componentWillUnmount = function() {
        (0, $kgSvt.render)(null, _$e.l), _$e.l = null, _$e.i = null;
    }, _$e.i && _$e.i !== _$r && _$e.componentWillUnmount(), n.__v ? (_$e.l || (_$e.i = _$r, _$e.l = {
        nodeType: 1,
        parentNode: _$r,
        childNodes: [],
        appendChild: function appendChild(n) {
            this.childNodes.push(n), _$e.i.appendChild(n);
        },
        insertBefore: function insertBefore(n, t) {
            this.childNodes.push(n), _$e.i.appendChild(n);
        },
        removeChild: function removeChild(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), _$e.i.removeChild(n);
        }
    }), (0, $kgSvt.render)((0, $kgSvt.createElement)($61e20b0bb26f17bf$var$P, {
        context: _$e.context
    }, n.__v), _$e.l)) : _$e.l && _$e.componentWillUnmount();
}
function $61e20b0bb26f17bf$export$d39a5bbd09211389(n, e) {
    var _$r = (0, $kgSvt.createElement)($61e20b0bb26f17bf$var$$, {
        __v: n,
        i: e
    });
    return _$r.containerInfo = e, _$r;
}
($61e20b0bb26f17bf$export$998bcd577473dd93.prototype = new (0, $kgSvt.Component)).__a = function(n) {
    var _$t = this, _$e = $61e20b0bb26f17bf$var$F(_$t.__v), _$r = _$t.o.get(n);
    return _$r[0]++, function(u) {
        var o = function o() {
            _$t.props.revealOrder ? (_$r.push(u), $61e20b0bb26f17bf$var$W(_$t, n, _$r)) : u();
        };
        _$e ? _$e(o) : o();
    };
}, $61e20b0bb26f17bf$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var _$t = (0, $kgSvt.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && _$t.reverse();
    for(var _$e = _$t.length; _$e--;)this.o.set(_$t[_$e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $61e20b0bb26f17bf$export$998bcd577473dd93.prototype.componentDidUpdate = $61e20b0bb26f17bf$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var _$n = this;
    this.o.forEach(function(t, e) {
        $61e20b0bb26f17bf$var$W(_$n, e, t);
    });
};
var $61e20b0bb26f17bf$var$z = "undefined" != typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103, $61e20b0bb26f17bf$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $61e20b0bb26f17bf$var$H = "undefined" != typeof document, $61e20b0bb26f17bf$var$Z = function Z(n) {
    return ("undefined" != typeof Symbol && "symbol" == (0, $2lB2g._)(Symbol()) ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $61e20b0bb26f17bf$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $kgSvt.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $61e20b0bb26f17bf$export$fa8d919ba61d84db(n, t, e) {
    return (0, $kgSvt.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $kgSvt.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $kgSvt.Component).prototype, t, {
        configurable: !0,
        get: function get() {
            return this["UNSAFE_" + t];
        },
        set: function set(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $61e20b0bb26f17bf$var$G = (0, $kgSvt.options).event;
function $61e20b0bb26f17bf$var$J() {}
function $61e20b0bb26f17bf$var$K() {
    return this.cancelBubble;
}
function $61e20b0bb26f17bf$var$Q() {
    return this.defaultPrevented;
}
(0, $kgSvt.options).event = function(n) {
    return $61e20b0bb26f17bf$var$G && (n = $61e20b0bb26f17bf$var$G(n)), n.persist = $61e20b0bb26f17bf$var$J, n.isPropagationStopped = $61e20b0bb26f17bf$var$K, n.isDefaultPrevented = $61e20b0bb26f17bf$var$Q, n.nativeEvent = n;
};
var $61e20b0bb26f17bf$var$X, $61e20b0bb26f17bf$var$nn = {
    configurable: !0,
    get: function get() {
        return this["class"];
    }
}, $61e20b0bb26f17bf$var$tn = (0, $kgSvt.options).vnode;
(0, $kgSvt.options).vnode = function(n) {
    var _$t = n.type, _$e = n.props, _$u = _$e;
    if ("string" == typeof _$t) {
        var o = -1 === _$t.indexOf("-");
        for(var i in _$u = {}, _$e){
            var _$l = _$e[i];
            $61e20b0bb26f17bf$var$H && "children" === i && "noscript" === _$t || "value" === i && "defaultValue" in _$e && null == _$l || ("defaultValue" === i && "value" in _$e && null == _$e.value ? i = "value" : "download" === i && !0 === _$l ? _$l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + _$t) && !$61e20b0bb26f17bf$var$Z(_$e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && $61e20b0bb26f17bf$var$B.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === _$l && (_$l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), _$u[i] && (i = "oninputCapture")), _$u[i] = _$l);
        }
        "select" == _$t && _$u.multiple && Array.isArray(_$u.value) && (_$u.value = (0, $kgSvt.toChildArray)(_$e.children).forEach(function(n) {
            n.props.selected = -1 != _$u.value.indexOf(n.props.value);
        })), "select" == _$t && null != _$u.defaultValue && (_$u.value = (0, $kgSvt.toChildArray)(_$e.children).forEach(function(n) {
            n.props.selected = _$u.multiple ? -1 != _$u.defaultValue.indexOf(n.props.value) : _$u.defaultValue == n.props.value;
        })), n.props = _$u, _$e["class"] != _$e.className && ($61e20b0bb26f17bf$var$nn.enumerable = "className" in _$e, null != _$e.className && (_$u["class"] = _$e.className), Object.defineProperty(_$u, "className", $61e20b0bb26f17bf$var$nn));
    }
    n.$$typeof = $61e20b0bb26f17bf$var$z, $61e20b0bb26f17bf$var$tn && $61e20b0bb26f17bf$var$tn(n);
};
var $61e20b0bb26f17bf$var$en = (0, $kgSvt.options).__r;
(0, $kgSvt.options).__r = function(n) {
    $61e20b0bb26f17bf$var$en && $61e20b0bb26f17bf$var$en(n), $61e20b0bb26f17bf$var$X = n.__c;
};
var $61e20b0bb26f17bf$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function readContext(n) {
                return $61e20b0bb26f17bf$var$X.__n[n.__c].props.value;
            }
        }
    }
}, $61e20b0bb26f17bf$export$83d89fbfd8236492 = "17.0.2";
function $61e20b0bb26f17bf$export$d38cd72104c1f0e9(n) {
    return (0, $kgSvt.createElement).bind(null, n);
}
function $61e20b0bb26f17bf$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $61e20b0bb26f17bf$var$z;
}
function $61e20b0bb26f17bf$export$e530037191fcd5d7(n) {
    return $61e20b0bb26f17bf$export$a8257692ac88316c(n) ? (0, $kgSvt.cloneElement).apply(null, arguments) : n;
}
function $61e20b0bb26f17bf$export$502457920280e6be(n) {
    return !!n.__k && ((0, $kgSvt.render)(null, n), !0);
}
function $61e20b0bb26f17bf$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $61e20b0bb26f17bf$export$c78a37762a8d58e1 = function sn(n, t) {
    return n(t);
}, $61e20b0bb26f17bf$export$cd75ccfd720a3cd4 = function hn(n, t) {
    return n(t);
}, $61e20b0bb26f17bf$export$5f8d39834fd61797 = (0, $kgSvt.Fragment);
function $61e20b0bb26f17bf$export$7568632d0d33d16d(n) {
    n();
}
function $61e20b0bb26f17bf$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $61e20b0bb26f17bf$export$7b286972b8d8ccbf() {
    return [
        !1,
        $61e20b0bb26f17bf$export$7568632d0d33d16d
    ];
}
var $61e20b0bb26f17bf$export$aaabe4eda9ed9969 = (0, $bgnQu.useLayoutEffect);
function $61e20b0bb26f17bf$export$306c0aa65ff9ec16(n, t) {
    var _$e = t(), _$r = (0, $bgnQu.useState)({
        h: {
            __: _$e,
            v: t
        }
    }), _$u = _$r[0].h, o = _$r[1];
    return (0, $bgnQu.useLayoutEffect)(function() {
        _$u.__ = _$e, _$u.v = t, $61e20b0bb26f17bf$var$E(_$u.__, t()) || o({
            h: _$u
        });
    }, [
        n,
        _$e,
        t
    ]), (0, $bgnQu.useEffect)(function() {
        return $61e20b0bb26f17bf$var$E(_$u.__, _$u.v()) || o({
            h: _$u
        }), n(function() {
            $61e20b0bb26f17bf$var$E(_$u.__, _$u.v()) || o({
                h: _$u
            });
        });
    }, [
        n
    ]), _$e;
}
var $61e20b0bb26f17bf$export$2e2bcd8739ae039 = {
    useState: (0, $bgnQu.useState),
    useId: (0, $bgnQu.useId),
    useReducer: (0, $bgnQu.useReducer),
    useEffect: (0, $bgnQu.useEffect),
    useLayoutEffect: (0, $bgnQu.useLayoutEffect),
    useInsertionEffect: $61e20b0bb26f17bf$export$aaabe4eda9ed9969,
    useTransition: $61e20b0bb26f17bf$export$7b286972b8d8ccbf,
    useDeferredValue: $61e20b0bb26f17bf$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $61e20b0bb26f17bf$export$306c0aa65ff9ec16,
    startTransition: $61e20b0bb26f17bf$export$7568632d0d33d16d,
    useRef: (0, $bgnQu.useRef),
    useImperativeHandle: (0, $bgnQu.useImperativeHandle),
    useMemo: (0, $bgnQu.useMemo),
    useCallback: (0, $bgnQu.useCallback),
    useContext: (0, $bgnQu.useContext),
    useDebugValue: (0, $bgnQu.useDebugValue),
    version: "17.0.2",
    Children: $61e20b0bb26f17bf$export$dca3b0875bd9a954,
    render: $61e20b0bb26f17bf$export$b3890eb0ae9dca99,
    hydrate: $61e20b0bb26f17bf$export$fa8d919ba61d84db,
    unmountComponentAtNode: $61e20b0bb26f17bf$export$502457920280e6be,
    createPortal: $61e20b0bb26f17bf$export$d39a5bbd09211389,
    createElement: (0, $kgSvt.createElement),
    createContext: (0, $kgSvt.createContext),
    createFactory: $61e20b0bb26f17bf$export$d38cd72104c1f0e9,
    cloneElement: $61e20b0bb26f17bf$export$e530037191fcd5d7,
    createRef: (0, $kgSvt.createRef),
    Fragment: (0, $kgSvt.Fragment),
    isValidElement: $61e20b0bb26f17bf$export$a8257692ac88316c,
    findDOMNode: $61e20b0bb26f17bf$export$466bfc07425424d5,
    Component: (0, $kgSvt.Component),
    PureComponent: $61e20b0bb26f17bf$export$221d75b3f55bb0bd,
    memo: $61e20b0bb26f17bf$export$7c73462e0d25e514,
    forwardRef: $61e20b0bb26f17bf$export$257a8862b851cb5b,
    flushSync: $61e20b0bb26f17bf$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $61e20b0bb26f17bf$export$c78a37762a8d58e1,
    StrictMode: $61e20b0bb26f17bf$export$5f8d39834fd61797,
    Suspense: $61e20b0bb26f17bf$export$74bf444e3cd11ea5,
    SuspenseList: $61e20b0bb26f17bf$export$998bcd577473dd93,
    lazy: $61e20b0bb26f17bf$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $61e20b0bb26f17bf$export$ae55be85d98224ed
};

});
parcelRegister("bgnQu", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $8333af972440e88a$export$60241385465d0a34; });
$parcel$export(module.exports, "useReducer", function () { return $8333af972440e88a$export$13e3392192263954; });
$parcel$export(module.exports, "useEffect", function () { return $8333af972440e88a$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $8333af972440e88a$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "useRef", function () { return $8333af972440e88a$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $8333af972440e88a$export$1538c33de8887b59; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $8333af972440e88a$export$d5a552a76deda3c2; });
$parcel$export(module.exports, "useCallback", function () { return $8333af972440e88a$export$35808ee640e87ca7; });
$parcel$export(module.exports, "useContext", function () { return $8333af972440e88a$export$fae74005e78b1a27; });
$parcel$export(module.exports, "useDebugValue", function () { return $8333af972440e88a$export$dc8fbce3eb94dc1e; });
$parcel$export(module.exports, "useId", function () { return $8333af972440e88a$export$f680877a34711e37; });

var $kgSvt = parcelRequire("kgSvt");
var $8333af972440e88a$var$t, $8333af972440e88a$var$r, $8333af972440e88a$var$u, $8333af972440e88a$var$i, $8333af972440e88a$var$o = 0, $8333af972440e88a$var$f = [], $8333af972440e88a$var$c = [], $8333af972440e88a$var$e = (0, $kgSvt.options).__b, $8333af972440e88a$var$a = (0, $kgSvt.options).__r, $8333af972440e88a$var$v = (0, $kgSvt.options).diffed, $8333af972440e88a$var$l = (0, $kgSvt.options).__c, $8333af972440e88a$var$m = (0, $kgSvt.options).unmount;
function $8333af972440e88a$var$d(t, u) {
    (0, $kgSvt.options).__h && (0, $kgSvt.options).__h($8333af972440e88a$var$r, t, $8333af972440e88a$var$o || u), $8333af972440e88a$var$o = 0;
    var i = $8333af972440e88a$var$r.__H || ($8333af972440e88a$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $8333af972440e88a$var$c
    }), i.__[t];
}
function $8333af972440e88a$export$60241385465d0a34(n) {
    return $8333af972440e88a$var$o = 1, $8333af972440e88a$export$13e3392192263954($8333af972440e88a$var$B, n);
}
function $8333af972440e88a$export$13e3392192263954(n, u, i) {
    var o = $8333af972440e88a$var$d($8333af972440e88a$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $8333af972440e88a$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $8333af972440e88a$var$r, !$8333af972440e88a$var$r.u)) {
        $8333af972440e88a$var$r.u = !0;
        var f = $8333af972440e88a$var$r.shouldComponentUpdate;
        $8333af972440e88a$var$r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var _$u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (_$u.every(function(n) {
                return !n.__N;
            })) return !f || f.call(this, n, t, r);
            var _$i = !1;
            return _$u.forEach(function(n) {
                if (n.__N) {
                    var _$t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, _$t !== n.__[0] && (_$i = !0);
                }
            }), !(!_$i && o.__c.props === n) && (!f || f.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function $8333af972440e88a$export$6d9c69b0de29b591(u, i) {
    var o = $8333af972440e88a$var$d($8333af972440e88a$var$t++, 3);
    !(0, $kgSvt.options).__s && $8333af972440e88a$var$z(o.__H, i) && (o.__ = u, o.i = i, $8333af972440e88a$var$r.__H.__h.push(o));
}
function $8333af972440e88a$export$e5c5a5f917a5871c(u, i) {
    var o = $8333af972440e88a$var$d($8333af972440e88a$var$t++, 4);
    !(0, $kgSvt.options).__s && $8333af972440e88a$var$z(o.__H, i) && (o.__ = u, o.i = i, $8333af972440e88a$var$r.__h.push(o));
}
function $8333af972440e88a$export$b8f5890fc79d6aca(n) {
    return $8333af972440e88a$var$o = 5, $8333af972440e88a$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $8333af972440e88a$export$d5a552a76deda3c2(n, t, r) {
    $8333af972440e88a$var$o = 6, $8333af972440e88a$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $8333af972440e88a$export$1538c33de8887b59(n, r) {
    var u = $8333af972440e88a$var$d($8333af972440e88a$var$t++, 7);
    return $8333af972440e88a$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $8333af972440e88a$export$35808ee640e87ca7(n, t) {
    return $8333af972440e88a$var$o = 8, $8333af972440e88a$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $8333af972440e88a$export$fae74005e78b1a27(n) {
    var u = $8333af972440e88a$var$r.context[n.__c], i = $8333af972440e88a$var$d($8333af972440e88a$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($8333af972440e88a$var$r)), u.props.value) : n.__;
}
function $8333af972440e88a$export$dc8fbce3eb94dc1e(t, r) {
    (0, $kgSvt.options).useDebugValue && (0, $kgSvt.options).useDebugValue(r ? r(t) : t);
}
function $8333af972440e88a$export$c052f6604b7d51fe(n) {
    var u = $8333af972440e88a$var$d($8333af972440e88a$var$t++, 10), i = $8333af972440e88a$export$60241385465d0a34();
    return u.__ = n, $8333af972440e88a$var$r.componentDidCatch || ($8333af972440e88a$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $8333af972440e88a$export$f680877a34711e37() {
    var _$n = $8333af972440e88a$var$d($8333af972440e88a$var$t++, 11);
    if (!_$n.__) {
        for(var u = $8333af972440e88a$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        _$n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return _$n.__;
}
function $8333af972440e88a$var$b() {
    for(var t; t = $8333af972440e88a$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($8333af972440e88a$var$k), t.__H.__h.forEach($8333af972440e88a$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $kgSvt.options).__e(r, t.__v);
    }
}
(0, $kgSvt.options).__b = function(n) {
    $8333af972440e88a$var$r = null, $8333af972440e88a$var$e && $8333af972440e88a$var$e(n);
}, (0, $kgSvt.options).__r = function(n) {
    $8333af972440e88a$var$a && $8333af972440e88a$var$a(n), $8333af972440e88a$var$t = 0;
    var i = ($8333af972440e88a$var$r = n.__c).__H;
    i && ($8333af972440e88a$var$u === $8333af972440e88a$var$r ? (i.__h = [], $8333af972440e88a$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $8333af972440e88a$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($8333af972440e88a$var$k), i.__h.forEach($8333af972440e88a$var$w), i.__h = [])), $8333af972440e88a$var$u = $8333af972440e88a$var$r;
}, (0, $kgSvt.options).diffed = function(t) {
    $8333af972440e88a$var$v && $8333af972440e88a$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $8333af972440e88a$var$f.push(o) && $8333af972440e88a$var$i === (0, $kgSvt.options).requestAnimationFrame || (($8333af972440e88a$var$i = (0, $kgSvt.options).requestAnimationFrame) || $8333af972440e88a$var$j)($8333af972440e88a$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $8333af972440e88a$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $8333af972440e88a$var$c;
    })), $8333af972440e88a$var$u = $8333af972440e88a$var$r = null;
}, (0, $kgSvt.options).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($8333af972440e88a$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $8333af972440e88a$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $kgSvt.options).__e(u, t.__v);
        }
    }), $8333af972440e88a$var$l && $8333af972440e88a$var$l(t, r);
}, (0, $kgSvt.options).unmount = function(t) {
    $8333af972440e88a$var$m && $8333af972440e88a$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $8333af972440e88a$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $kgSvt.options).__e(r, u.__v));
};
var $8333af972440e88a$var$g = "function" == typeof requestAnimationFrame;
function $8333af972440e88a$var$j(n) {
    var t, r = function r() {
        clearTimeout(u), $8333af972440e88a$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $8333af972440e88a$var$g && (t = requestAnimationFrame(r));
}
function $8333af972440e88a$var$k(n) {
    var t = $8333af972440e88a$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $8333af972440e88a$var$r = t;
}
function $8333af972440e88a$var$w(n) {
    var t = $8333af972440e88a$var$r;
    n.__c = n.__(), $8333af972440e88a$var$r = t;
}
function $8333af972440e88a$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $8333af972440e88a$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});




parcelRegister("fTHFs", function(module, exports) {

$parcel$export(module.exports, "DayTimeColsView", function () { return DayTimeColsView; });

var $1K4o4 = parcelRequire("1K4o4");

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $dACZV = parcelRequire("dACZV");

var $5TJQB = parcelRequire("5TJQB");

var $jhb1H = parcelRequire("jhb1H");

var $c1gko = parcelRequire("c1gko");

var $kgSvt = parcelRequire("kgSvt");

var $gbAcq = parcelRequire("gbAcq");
var css_248z = '.fc-v-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-v-event .fc-event-main{color:var(--fc-event-text-color);height:100%}.fc-v-event .fc-event-main-frame{display:flex;flex-direction:column;height:100%}.fc-v-event .fc-event-time{flex-grow:0;flex-shrink:0;max-height:100%;overflow:hidden}.fc-v-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-height:0}.fc-v-event .fc-event-title{bottom:0;max-height:100%;overflow:hidden;top:0}.fc-v-event:not(.fc-event-start){border-top-left-radius:0;border-top-right-radius:0;border-top-width:0}.fc-v-event:not(.fc-event-end){border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-width:0}.fc-v-event.fc-event-selected:before{left:-10px;right:-10px}.fc-v-event .fc-event-resizer-start{cursor:n-resize}.fc-v-event .fc-event-resizer-end{cursor:s-resize}.fc-v-event:not(.fc-event-selected) .fc-event-resizer{height:var(--fc-event-resizer-thickness);left:0;right:0}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start{top:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer{left:50%;margin-left:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-start{top:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc .fc-timegrid .fc-daygrid-body{z-index:2}.fc .fc-timegrid-divider{padding:0 0 2px}.fc .fc-timegrid-body{min-height:100%;position:relative;z-index:1}.fc .fc-timegrid-axis-chunk{position:relative}.fc .fc-timegrid-axis-chunk>table,.fc .fc-timegrid-slots{position:relative;z-index:1}.fc .fc-timegrid-slot{border-bottom:0;height:1.5em}.fc .fc-timegrid-slot:empty:before{content:"\\00a0"}.fc .fc-timegrid-slot-minor{border-top-style:dotted}.fc .fc-timegrid-slot-label-cushion{display:inline-block;white-space:nowrap}.fc .fc-timegrid-slot-label{vertical-align:middle}.fc .fc-timegrid-axis-cushion,.fc .fc-timegrid-slot-label-cushion{padding:0 4px}.fc .fc-timegrid-axis-frame-liquid{height:100%}.fc .fc-timegrid-axis-frame{align-items:center;display:flex;justify-content:flex-end;overflow:hidden}.fc .fc-timegrid-axis-cushion{flex-shrink:0;max-width:60px}.fc-direction-ltr .fc-timegrid-slot-label-frame{text-align:right}.fc-direction-rtl .fc-timegrid-slot-label-frame{text-align:left}.fc-liquid-hack .fc-timegrid-axis-frame-liquid{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-timegrid-col-frame{min-height:100%;position:relative}.fc-media-screen.fc-liquid-hack .fc-timegrid-col-frame{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols{bottom:0;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols>table{height:100%}.fc-media-screen .fc-timegrid-col-bg,.fc-media-screen .fc-timegrid-col-events,.fc-media-screen .fc-timegrid-now-indicator-container{left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col-bg{z-index:2}.fc .fc-timegrid-col-bg .fc-non-business{z-index:1}.fc .fc-timegrid-col-bg .fc-bg-event{z-index:2}.fc .fc-timegrid-col-bg .fc-highlight{z-index:3}.fc .fc-timegrid-bg-harness{left:0;position:absolute;right:0}.fc .fc-timegrid-col-events{z-index:3}.fc .fc-timegrid-now-indicator-container{bottom:0;overflow:hidden}.fc-direction-ltr .fc-timegrid-col-events{margin:0 2.5% 0 2px}.fc-direction-rtl .fc-timegrid-col-events{margin:0 2px 0 2.5%}.fc-timegrid-event-harness{position:absolute}.fc-timegrid-event-harness>.fc-timegrid-event{bottom:0;left:0;position:absolute;right:0;top:0}.fc-timegrid-event-harness-inset .fc-timegrid-event,.fc-timegrid-event.fc-event-mirror,.fc-timegrid-more-link{box-shadow:0 0 0 1px var(--fc-page-bg-color)}.fc-timegrid-event,.fc-timegrid-more-link{border-radius:3px;font-size:var(--fc-small-font-size)}.fc-timegrid-event{margin-bottom:1px}.fc-timegrid-event .fc-event-main{padding:1px 1px 0}.fc-timegrid-event .fc-event-time{font-size:var(--fc-small-font-size);margin-bottom:1px;white-space:nowrap}.fc-timegrid-event-short .fc-event-main-frame{flex-direction:row;overflow:hidden}.fc-timegrid-event-short .fc-event-time:after{content:"\\00a0-\\00a0"}.fc-timegrid-event-short .fc-event-title{font-size:var(--fc-small-font-size)}.fc-timegrid-more-link{background:var(--fc-more-link-bg-color);color:var(--fc-more-link-text-color);cursor:pointer;margin-bottom:1px;position:absolute;z-index:9999}.fc-timegrid-more-link-inner{padding:3px 2px;top:0}.fc-direction-ltr .fc-timegrid-more-link{right:0}.fc-direction-rtl .fc-timegrid-more-link{left:0}.fc .fc-timegrid-now-indicator-line{border-color:var(--fc-now-indicator-color);border-style:solid;border-width:1px 0 0;left:0;position:absolute;right:0;z-index:4}.fc .fc-timegrid-now-indicator-arrow{border-color:var(--fc-now-indicator-color);border-style:solid;margin-top:-5px;position:absolute;z-index:4}.fc-direction-ltr .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 0 5px 6px;left:0}.fc-direction-rtl .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 6px 5px 0;right:0}';
(0, $c1gko.cw)(css_248z);
var AllDaySplitter = /*#__PURE__*/ function(Splitter) {
    "use strict";
    (0, $dACZV._)(AllDaySplitter, Splitter);
    var _super = (0, $jhb1H._)(AllDaySplitter);
    function AllDaySplitter() {
        (0, $5kWiG._)(this, AllDaySplitter);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(AllDaySplitter, [
        {
            key: "getKeyInfo",
            value: function getKeyInfo() {
                return {
                    allDay: {},
                    timed: {}
                };
            }
        },
        {
            key: "getKeysForDateSpan",
            value: function getKeysForDateSpan(dateSpan) {
                if (dateSpan.allDay) return [
                    "allDay"
                ];
                return [
                    "timed"
                ];
            }
        },
        {
            key: "getKeysForEventDef",
            value: function getKeysForEventDef(eventDef) {
                if (!eventDef.allDay) return [
                    "timed"
                ];
                if ((0, $c1gko.bP)(eventDef)) return [
                    "timed",
                    "allDay"
                ];
                return [
                    "allDay"
                ];
            }
        }
    ]);
    return AllDaySplitter;
}((0, $c1gko.aY));
var DEFAULT_SLAT_LABEL_FORMAT = (0, $c1gko.x)({
    hour: "numeric",
    minute: "2-digit",
    omitZeroMinute: true,
    meridiem: "short"
});
function TimeColsAxisCell(props) {
    var classNames = [
        "fc-timegrid-slot",
        "fc-timegrid-slot-label",
        props.isLabeled ? "fc-scrollgrid-shrink" : "fc-timegrid-slot-minor"
    ];
    return (0, $kgSvt.createElement)((0, $c1gko.V).Consumer, null, function(context) {
        if (!props.isLabeled) return (0, $kgSvt.createElement)("td", {
            className: classNames.join(" "),
            "data-time": props.isoTimeStr
        });
        var dateEnv = context.dateEnv, options = context.options, viewApi = context.viewApi;
        var labelFormat = options.slotLabelFormat == null ? DEFAULT_SLAT_LABEL_FORMAT : Array.isArray(options.slotLabelFormat) ? (0, $c1gko.x)(options.slotLabelFormat[0]) : (0, $c1gko.x)(options.slotLabelFormat);
        var renderProps = {
            level: 0,
            time: props.time,
            date: dateEnv.toDate(props.date),
            view: viewApi,
            text: dateEnv.format(props.date, labelFormat)
        };
        return (0, $kgSvt.createElement)((0, $c1gko.C), {
            elTag: "td",
            elClasses: classNames,
            elAttrs: {
                "data-time": props.isoTimeStr
            },
            renderProps: renderProps,
            generatorName: "slotLabelContent",
            customGenerator: options.slotLabelContent,
            defaultGenerator: renderInnerContent,
            classNameGenerator: options.slotLabelClassNames,
            didMount: options.slotLabelDidMount,
            willUnmount: options.slotLabelWillUnmount
        }, function(InnerContent) {
            return (0, $kgSvt.createElement)("div", {
                className: "fc-timegrid-slot-label-frame fc-scrollgrid-shrink-frame"
            }, (0, $kgSvt.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    "fc-timegrid-slot-label-cushion",
                    "fc-scrollgrid-shrink-cushion"
                ]
            }));
        });
    });
}
function renderInnerContent(props) {
    return props.text;
}
var TimeBodyAxis = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(TimeBodyAxis, BaseComponent);
    var _super = (0, $jhb1H._)(TimeBodyAxis);
    function TimeBodyAxis() {
        (0, $5kWiG._)(this, TimeBodyAxis);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(TimeBodyAxis, [
        {
            key: "render",
            value: function render() {
                return this.props.slatMetas.map(function(slatMeta) {
                    return (0, $kgSvt.createElement)("tr", {
                        key: slatMeta.key
                    }, (0, $kgSvt.createElement)(TimeColsAxisCell, Object.assign({}, slatMeta)));
                });
            }
        }
    ]);
    return TimeBodyAxis;
}((0, $c1gko.B));
var DEFAULT_WEEK_NUM_FORMAT = (0, $c1gko.x)({
    week: "short"
});
var AUTO_ALL_DAY_MAX_EVENT_ROWS = 5;
var TimeColsView = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $dACZV._)(TimeColsView, DateComponent);
    var _super = (0, $jhb1H._)(TimeColsView);
    function TimeColsView() {
        (0, $5kWiG._)(this, TimeColsView);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.allDaySplitter = new AllDaySplitter(); // for use by subclasses
        _this.headerElRef = (0, $kgSvt.createRef)();
        _this.rootElRef = (0, $kgSvt.createRef)();
        _this.scrollerElRef = (0, $kgSvt.createRef)();
        _this.state = {
            slatCoords: null
        };
        _this.handleScrollTopRequest = function(scrollTop) {
            var scrollerEl = _this.scrollerElRef.current;
            if (scrollerEl) scrollerEl.scrollTop = scrollTop;
        };
        /* Header Render Methods
        ------------------------------------------------------------------------------------------------------------------*/ _this.renderHeadAxis = function(rowKey) {
            var frameHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
            var options = _this.context.options;
            var dateProfile = _this.props.dateProfile;
            var range = dateProfile.renderRange;
            var dayCnt = (0, $c1gko.bl)(range.start, range.end);
            // only do in day views (to avoid doing in week views that dont need it)
            var navLinkAttrs = dayCnt === 1 ? (0, $c1gko.b0)(_this.context, range.start, "week") : {};
            if (options.weekNumbers && rowKey === "day") return (0, $kgSvt.createElement)((0, $c1gko.cq), {
                elTag: "th",
                elClasses: [
                    "fc-timegrid-axis",
                    "fc-scrollgrid-shrink"
                ],
                elAttrs: {
                    "aria-hidden": true
                },
                date: range.start,
                defaultFormat: DEFAULT_WEEK_NUM_FORMAT
            }, function(InnerContent) {
                return (0, $kgSvt.createElement)("div", {
                    className: [
                        "fc-timegrid-axis-frame",
                        "fc-scrollgrid-shrink-frame",
                        "fc-timegrid-axis-frame-liquid"
                    ].join(" "),
                    style: {
                        height: frameHeight
                    }
                }, (0, $kgSvt.createElement)(InnerContent, {
                    elTag: "a",
                    elClasses: [
                        "fc-timegrid-axis-cushion",
                        "fc-scrollgrid-shrink-cushion",
                        "fc-scrollgrid-sync-inner"
                    ],
                    elAttrs: navLinkAttrs
                }));
            });
            return (0, $kgSvt.createElement)("th", {
                "aria-hidden": true,
                className: "fc-timegrid-axis"
            }, (0, $kgSvt.createElement)("div", {
                className: "fc-timegrid-axis-frame",
                style: {
                    height: frameHeight
                }
            }));
        };
        /* Table Component Render Methods
        ------------------------------------------------------------------------------------------------------------------*/ // only a one-way height sync. we don't send the axis inner-content height to the DayGrid,
        // but DayGrid still needs to have classNames on inner elements in order to measure.
        _this.renderTableRowAxis = function(rowHeight) {
            var _this_context = _this.context, options = _this_context.options, viewApi = _this_context.viewApi;
            var renderProps = {
                text: options.allDayText,
                view: viewApi
            };
            return(// TODO: make reusable hook. used in list view too
            (0, $kgSvt.createElement)((0, $c1gko.C), {
                elTag: "td",
                elClasses: [
                    "fc-timegrid-axis",
                    "fc-scrollgrid-shrink"
                ],
                elAttrs: {
                    "aria-hidden": true
                },
                renderProps: renderProps,
                generatorName: "allDayContent",
                customGenerator: options.allDayContent,
                defaultGenerator: renderAllDayInner,
                classNameGenerator: options.allDayClassNames,
                didMount: options.allDayDidMount,
                willUnmount: options.allDayWillUnmount
            }, function(InnerContent) {
                return (0, $kgSvt.createElement)("div", {
                    className: [
                        "fc-timegrid-axis-frame",
                        "fc-scrollgrid-shrink-frame",
                        rowHeight == null ? " fc-timegrid-axis-frame-liquid" : ""
                    ].join(" "),
                    style: {
                        height: rowHeight
                    }
                }, (0, $kgSvt.createElement)(InnerContent, {
                    elTag: "span",
                    elClasses: [
                        "fc-timegrid-axis-cushion",
                        "fc-scrollgrid-shrink-cushion",
                        "fc-scrollgrid-sync-inner"
                    ]
                }));
            }));
        };
        _this.handleSlatCoords = function(slatCoords) {
            _this.setState({
                slatCoords: slatCoords
            });
        };
        return _this;
    }
    (0, $hHaEF._)(TimeColsView, [
        {
            // rendering
            // ----------------------------------------------------------------------------------------------------
            key: "renderSimpleLayout",
            value: function renderSimpleLayout(headerRowContent, allDayContent, timeContent) {
                var _this = this, context = _this.context, props = _this.props;
                var sections = [];
                var stickyHeaderDates = (0, $c1gko.cc)(context.options);
                if (headerRowContent) sections.push({
                    type: "header",
                    key: "header",
                    isSticky: stickyHeaderDates,
                    chunk: {
                        elRef: this.headerElRef,
                        tableClassName: "fc-col-header",
                        rowContent: headerRowContent
                    }
                });
                if (allDayContent) {
                    sections.push({
                        type: "body",
                        key: "all-day",
                        chunk: {
                            content: allDayContent
                        }
                    });
                    sections.push({
                        type: "body",
                        key: "all-day-divider",
                        outerContent: (0, $kgSvt.createElement)("tr", {
                            role: "presentation",
                            className: "fc-scrollgrid-section"
                        }, (0, $kgSvt.createElement)("td", {
                            className: "fc-timegrid-divider " + context.theme.getClass("tableCellShaded")
                        }))
                    });
                }
                sections.push({
                    type: "body",
                    key: "body",
                    liquid: true,
                    expandRows: Boolean(context.options.expandRows),
                    chunk: {
                        scrollerElRef: this.scrollerElRef,
                        content: timeContent
                    }
                });
                return (0, $kgSvt.createElement)((0, $c1gko.ct), {
                    elRef: this.rootElRef,
                    elClasses: [
                        "fc-timegrid"
                    ],
                    viewSpec: context.viewSpec
                }, (0, $kgSvt.createElement)((0, $c1gko.b$), {
                    liquid: !props.isHeightAuto && !props.forPrint,
                    collapsibleWidth: props.forPrint,
                    cols: [
                        {
                            width: "shrink"
                        }
                    ],
                    sections: sections
                }));
            }
        },
        {
            key: "renderHScrollLayout",
            value: function renderHScrollLayout(headerRowContent, allDayContent, timeContent, colCnt, dayMinWidth, slatMetas, slatCoords) {
                var _this = this;
                var ScrollGrid = this.context.pluginHooks.scrollGridImpl;
                if (!ScrollGrid) throw new Error("No ScrollGrid implementation");
                var _this1 = this, context = _this1.context, props = _this1.props;
                var stickyHeaderDates = !props.forPrint && (0, $c1gko.cc)(context.options);
                var stickyFooterScrollbar = !props.forPrint && (0, $c1gko.cb)(context.options);
                var sections = [];
                if (headerRowContent) sections.push({
                    type: "header",
                    key: "header",
                    isSticky: stickyHeaderDates,
                    syncRowHeights: true,
                    chunks: [
                        {
                            key: "axis",
                            rowContent: function(arg) {
                                return (0, $kgSvt.createElement)("tr", {
                                    role: "presentation"
                                }, _this.renderHeadAxis("day", arg.rowSyncHeights[0]));
                            }
                        },
                        {
                            key: "cols",
                            elRef: this.headerElRef,
                            tableClassName: "fc-col-header",
                            rowContent: headerRowContent
                        }
                    ]
                });
                if (allDayContent) {
                    sections.push({
                        type: "body",
                        key: "all-day",
                        syncRowHeights: true,
                        chunks: [
                            {
                                key: "axis",
                                rowContent: function(contentArg) {
                                    return (0, $kgSvt.createElement)("tr", {
                                        role: "presentation"
                                    }, _this.renderTableRowAxis(contentArg.rowSyncHeights[0]));
                                }
                            },
                            {
                                key: "cols",
                                content: allDayContent
                            }
                        ]
                    });
                    sections.push({
                        key: "all-day-divider",
                        type: "body",
                        outerContent: (0, $kgSvt.createElement)("tr", {
                            role: "presentation",
                            className: "fc-scrollgrid-section"
                        }, (0, $kgSvt.createElement)("td", {
                            colSpan: 2,
                            className: "fc-timegrid-divider " + context.theme.getClass("tableCellShaded")
                        }))
                    });
                }
                var isNowIndicator = context.options.nowIndicator;
                sections.push({
                    type: "body",
                    key: "body",
                    liquid: true,
                    expandRows: Boolean(context.options.expandRows),
                    chunks: [
                        {
                            key: "axis",
                            content: function(arg) {
                                return(// TODO: make this now-indicator arrow more DRY with TimeColsContent
                                (0, $kgSvt.createElement)("div", {
                                    className: "fc-timegrid-axis-chunk"
                                }, (0, $kgSvt.createElement)("table", {
                                    "aria-hidden": true,
                                    style: {
                                        height: arg.expandRows ? arg.clientHeight : ""
                                    }
                                }, arg.tableColGroupNode, (0, $kgSvt.createElement)("tbody", null, (0, $kgSvt.createElement)(TimeBodyAxis, {
                                    slatMetas: slatMetas
                                }))), (0, $kgSvt.createElement)("div", {
                                    className: "fc-timegrid-now-indicator-container"
                                }, (0, $kgSvt.createElement)((0, $c1gko.ch), {
                                    unit: isNowIndicator ? "minute" : "day" /* hacky */ 
                                }, function(nowDate) {
                                    var nowIndicatorTop = isNowIndicator && slatCoords && slatCoords.safeComputeTop(nowDate); // might return void
                                    if (typeof nowIndicatorTop === "number") return (0, $kgSvt.createElement)((0, $c1gko.ck), {
                                        elClasses: [
                                            "fc-timegrid-now-indicator-arrow"
                                        ],
                                        elStyle: {
                                            top: nowIndicatorTop
                                        },
                                        isAxis: true,
                                        date: nowDate
                                    });
                                    return null;
                                }))));
                            }
                        },
                        {
                            key: "cols",
                            scrollerElRef: this.scrollerElRef,
                            content: timeContent
                        }
                    ]
                });
                if (stickyFooterScrollbar) sections.push({
                    key: "footer",
                    type: "footer",
                    isSticky: true,
                    chunks: [
                        {
                            key: "axis",
                            content: (0, $c1gko.ca)
                        },
                        {
                            key: "cols",
                            content: (0, $c1gko.ca)
                        }
                    ]
                });
                return (0, $kgSvt.createElement)((0, $c1gko.ct), {
                    elRef: this.rootElRef,
                    elClasses: [
                        "fc-timegrid"
                    ],
                    viewSpec: context.viewSpec
                }, (0, $kgSvt.createElement)(ScrollGrid, {
                    liquid: !props.isHeightAuto && !props.forPrint,
                    forPrint: props.forPrint,
                    collapsibleWidth: false,
                    colGroups: [
                        {
                            width: "shrink",
                            cols: [
                                {
                                    width: "shrink"
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    span: colCnt,
                                    minWidth: dayMinWidth
                                }
                            ]
                        }
                    ],
                    sections: sections
                }));
            }
        },
        {
            /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/ key: "getAllDayMaxEventProps",
            value: function getAllDayMaxEventProps() {
                var _this_context_options = this.context.options, dayMaxEvents = _this_context_options.dayMaxEvents, dayMaxEventRows = _this_context_options.dayMaxEventRows;
                if (dayMaxEvents === true || dayMaxEventRows === true) {
                    dayMaxEvents = undefined;
                    dayMaxEventRows = AUTO_ALL_DAY_MAX_EVENT_ROWS; // make sure "auto" goes to a real number
                }
                return {
                    dayMaxEvents: dayMaxEvents,
                    dayMaxEventRows: dayMaxEventRows
                };
            }
        }
    ]);
    return TimeColsView;
}((0, $c1gko.be));
function renderAllDayInner(renderProps) {
    return renderProps.text;
}
var TimeColsSlatsCoords = /*#__PURE__*/ function() {
    "use strict";
    function TimeColsSlatsCoords(positions, dateProfile, slotDuration) {
        (0, $5kWiG._)(this, TimeColsSlatsCoords);
        this.positions = positions;
        this.dateProfile = dateProfile;
        this.slotDuration = slotDuration;
    }
    (0, $hHaEF._)(TimeColsSlatsCoords, [
        {
            key: "safeComputeTop",
            value: function safeComputeTop(date) {
                var dateProfile = this.dateProfile;
                if ((0, $c1gko.H)(dateProfile.currentRange, date)) {
                    var startOfDayDate = (0, $c1gko.q)(date);
                    var timeMs = date.valueOf() - startOfDayDate.valueOf();
                    if (timeMs >= (0, $c1gko.bs)(dateProfile.slotMinTime) && timeMs < (0, $c1gko.bs)(dateProfile.slotMaxTime)) return this.computeTimeTop((0, $c1gko.d)(timeMs));
                }
                return null;
            }
        },
        {
            // Computes the top coordinate, relative to the bounds of the grid, of the given date.
            // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
            key: "computeDateTop",
            value: function computeDateTop(when, startOfDayDate) {
                if (!startOfDayDate) startOfDayDate = (0, $c1gko.q)(when);
                return this.computeTimeTop((0, $c1gko.d)(when.valueOf() - startOfDayDate.valueOf()));
            }
        },
        {
            // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
            // This is a makeshify way to compute the time-top. Assumes all slatMetas dates are uniform.
            // Eventually allow computation with arbirary slat dates.
            key: "computeTimeTop",
            value: function computeTimeTop(duration) {
                var _this = this, positions = _this.positions, dateProfile = _this.dateProfile;
                var len = positions.els.length;
                // floating-point value of # of slots covered
                var slatCoverage = (duration.milliseconds - (0, $c1gko.bs)(dateProfile.slotMinTime)) / (0, $c1gko.bs)(this.slotDuration);
                var slatIndex;
                var slatRemainder;
                // compute a floating-point number for how many slats should be progressed through.
                // from 0 to number of slats (inclusive)
                // constrained because slotMinTime/slotMaxTime might be customized.
                slatCoverage = Math.max(0, slatCoverage);
                slatCoverage = Math.min(len, slatCoverage);
                // an integer index of the furthest whole slat
                // from 0 to number slats (*exclusive*, so len-1)
                slatIndex = Math.floor(slatCoverage);
                slatIndex = Math.min(slatIndex, len - 1);
                // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
                // could be 1.0 if slatCoverage is covering *all* the slots
                slatRemainder = slatCoverage - slatIndex;
                return positions.tops[slatIndex] + positions.getHeight(slatIndex) * slatRemainder;
            }
        }
    ]);
    return TimeColsSlatsCoords;
}();
var TimeColsSlatsBody = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(TimeColsSlatsBody, BaseComponent);
    var _super = (0, $jhb1H._)(TimeColsSlatsBody);
    function TimeColsSlatsBody() {
        (0, $5kWiG._)(this, TimeColsSlatsBody);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(TimeColsSlatsBody, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var slatElRefs = props.slatElRefs;
                return (0, $kgSvt.createElement)("tbody", null, props.slatMetas.map(function(slatMeta, i) {
                    var renderProps = {
                        time: slatMeta.time,
                        date: context.dateEnv.toDate(slatMeta.date),
                        view: context.viewApi
                    };
                    return (0, $kgSvt.createElement)("tr", {
                        key: slatMeta.key,
                        ref: slatElRefs.createRef(slatMeta.key)
                    }, props.axis && (0, $kgSvt.createElement)(TimeColsAxisCell, Object.assign({}, slatMeta)), (0, $kgSvt.createElement)((0, $c1gko.C), {
                        elTag: "td",
                        elClasses: [
                            "fc-timegrid-slot",
                            "fc-timegrid-slot-lane",
                            !slatMeta.isLabeled && "fc-timegrid-slot-minor"
                        ],
                        elAttrs: {
                            "data-time": slatMeta.isoTimeStr
                        },
                        renderProps: renderProps,
                        generatorName: "slotLaneContent",
                        customGenerator: options.slotLaneContent,
                        classNameGenerator: options.slotLaneClassNames,
                        didMount: options.slotLaneDidMount,
                        willUnmount: options.slotLaneWillUnmount
                    }));
                }));
            }
        }
    ]);
    return TimeColsSlatsBody;
}((0, $c1gko.B));
/*
for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
*/ var TimeColsSlats = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(TimeColsSlats, BaseComponent);
    var _super = (0, $jhb1H._)(TimeColsSlats);
    function TimeColsSlats() {
        (0, $5kWiG._)(this, TimeColsSlats);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.rootElRef = (0, $kgSvt.createRef)();
        _this.slatElRefs = new (0, $c1gko.cf)();
        return _this;
    }
    (0, $hHaEF._)(TimeColsSlats, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                return (0, $kgSvt.createElement)("div", {
                    ref: this.rootElRef,
                    className: "fc-timegrid-slots"
                }, (0, $kgSvt.createElement)("table", {
                    "aria-hidden": true,
                    className: context.theme.getClass("table"),
                    style: {
                        minWidth: props.tableMinWidth,
                        width: props.clientWidth,
                        height: props.minHeight
                    }
                }, props.tableColGroupNode /* relies on there only being a single <col> for the axis */ , (0, $kgSvt.createElement)(TimeColsSlatsBody, {
                    slatElRefs: this.slatElRefs,
                    axis: props.axis,
                    slatMetas: props.slatMetas
                })));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateSizing();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateSizing();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.props.onCoords) this.props.onCoords(null);
            }
        },
        {
            key: "updateSizing",
            value: function updateSizing() {
                var _this = this, context = _this.context, props = _this.props;
                if (props.onCoords && props.clientWidth !== null // means sizing has stabilized
                ) {
                    var rootEl = this.rootElRef.current;
                    if (rootEl.offsetHeight) props.onCoords(new TimeColsSlatsCoords(new (0, $c1gko.ba)(this.rootElRef.current, collectSlatEls(this.slatElRefs.currentMap, props.slatMetas), false, true), this.props.dateProfile, context.options.slotDuration));
                }
            }
        }
    ]);
    return TimeColsSlats;
}((0, $c1gko.B));
function collectSlatEls(elMap, slatMetas) {
    return slatMetas.map(function(slatMeta) {
        return elMap[slatMeta.key];
    });
}
function splitSegsByCol(segs, colCnt) {
    var segsByCol = [];
    var i;
    for(i = 0; i < colCnt; i += 1)segsByCol.push([]);
    if (segs) for(i = 0; i < segs.length; i += 1)segsByCol[segs[i].col].push(segs[i]);
    return segsByCol;
}
function splitInteractionByCol(ui, colCnt) {
    var byRow = [];
    if (!ui) for(var i = 0; i < colCnt; i += 1)byRow[i] = null;
    else {
        for(var i1 = 0; i1 < colCnt; i1 += 1)byRow[i1] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ui.segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var seg = _step.value;
                byRow[seg.col].segs.push(seg);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return byRow;
}
var TimeColMoreLink = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(TimeColMoreLink, BaseComponent);
    var _super = (0, $jhb1H._)(TimeColMoreLink);
    function TimeColMoreLink() {
        (0, $5kWiG._)(this, TimeColMoreLink);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(TimeColMoreLink, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                return (0, $kgSvt.createElement)((0, $c1gko.cr), {
                    elClasses: [
                        "fc-timegrid-more-link"
                    ],
                    elStyle: {
                        top: props.top,
                        bottom: props.bottom
                    },
                    allDayDate: null,
                    moreCnt: props.hiddenSegs.length,
                    allSegs: props.hiddenSegs,
                    hiddenSegs: props.hiddenSegs,
                    extraDateSpan: props.extraDateSpan,
                    dateProfile: props.dateProfile,
                    todayRange: props.todayRange,
                    popoverContent: function() {
                        return renderPlainFgSegs(props.hiddenSegs, props);
                    },
                    defaultGenerator: renderMoreLinkInner,
                    forceTimed: true
                }, function(InnerContent) {
                    return (0, $kgSvt.createElement)(InnerContent, {
                        elTag: "div",
                        elClasses: [
                            "fc-timegrid-more-link-inner",
                            "fc-sticky"
                        ]
                    });
                });
            }
        }
    ]);
    return TimeColMoreLink;
}((0, $c1gko.B));
function renderMoreLinkInner(props) {
    return props.shortText;
}
// segInputs assumed sorted
function buildPositioning(segInputs, strictOrder, maxStackCnt) {
    var hierarchy = new (0, $c1gko.bA)();
    if (strictOrder != null) hierarchy.strictOrder = strictOrder;
    if (maxStackCnt != null) hierarchy.maxStackCnt = maxStackCnt;
    var hiddenEntries = hierarchy.addSegs(segInputs);
    var hiddenGroups = (0, $c1gko.bE)(hiddenEntries);
    var web = buildWeb(hierarchy);
    web = stretchWeb(web, 1); // all levelCoords/thickness will have 0.0-1.0
    var segRects = webToRects(web);
    return {
        segRects: segRects,
        hiddenGroups: hiddenGroups
    };
}
function buildWeb(hierarchy) {
    var entriesByLevel = hierarchy.entriesByLevel;
    var buildNode = cacheable(function(level, lateral) {
        return level + ":" + lateral;
    }, function(level, lateral) {
        var siblingRange = findNextLevelSegs(hierarchy, level, lateral);
        var nextLevelRes = buildNodes(siblingRange, buildNode);
        var entry = entriesByLevel[level][lateral];
        return [
            Object.assign(Object.assign({}, entry), {
                nextLevelNodes: nextLevelRes[0]
            }),
            entry.thickness + nextLevelRes[1]
        ];
    });
    return buildNodes(entriesByLevel.length ? {
        level: 0,
        lateralStart: 0,
        lateralEnd: entriesByLevel[0].length
    } : null, buildNode)[0];
}
function buildNodes(siblingRange, buildNode) {
    if (!siblingRange) return [
        [],
        0
    ];
    var level = siblingRange.level, lateralStart = siblingRange.lateralStart, lateralEnd = siblingRange.lateralEnd;
    var lateral = lateralStart;
    var pairs = [];
    while(lateral < lateralEnd){
        pairs.push(buildNode(level, lateral));
        lateral += 1;
    }
    pairs.sort(cmpDescPressures);
    return [
        pairs.map(extractNode),
        pairs[0][1]
    ];
}
function cmpDescPressures(a, b) {
    return b[1] - a[1];
}
function extractNode(a) {
    return a[0];
}
function findNextLevelSegs(hierarchy, subjectLevel, subjectLateral) {
    var levelCoords = hierarchy.levelCoords, entriesByLevel = hierarchy.entriesByLevel;
    var subjectEntry = entriesByLevel[subjectLevel][subjectLateral];
    var afterSubject = levelCoords[subjectLevel] + subjectEntry.thickness;
    var levelCnt = levelCoords.length;
    var level = subjectLevel;
    // skip past levels that are too high up
    for(; level < levelCnt && levelCoords[level] < afterSubject; level += 1); // do nothing
    for(; level < levelCnt; level += 1){
        var entries = entriesByLevel[level];
        var entry = void 0;
        var searchIndex = (0, $c1gko.bD)(entries, subjectEntry.span.start, (0, $c1gko.bC));
        var lateralStart = searchIndex[0] + searchIndex[1]; // if exact match (which doesn't collide), go to next one
        var lateralEnd = lateralStart;
        while((entry = entries[lateralEnd]) && // but not past the whole seg list
        entry.span.start < subjectEntry.span.end)lateralEnd += 1;
        if (lateralStart < lateralEnd) return {
            level: level,
            lateralStart: lateralStart,
            lateralEnd: lateralEnd
        };
    }
    return null;
}
function stretchWeb(topLevelNodes, totalThickness) {
    var stretchNode = cacheable(function(node, startCoord, prevThickness) {
        return (0, $c1gko.bB)(node);
    }, function(node, startCoord, prevThickness) {
        var nextLevelNodes = node.nextLevelNodes, thickness = node.thickness;
        var allThickness = thickness + prevThickness;
        var thicknessFraction = thickness / allThickness;
        var endCoord;
        var newChildren = [];
        if (!nextLevelNodes.length) endCoord = totalThickness;
        else {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = nextLevelNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var childNode = _step.value;
                    if (endCoord === undefined) {
                        var res = stretchNode(childNode, startCoord, allThickness);
                        endCoord = res[0];
                        newChildren.push(res[1]);
                    } else {
                        var res1 = stretchNode(childNode, endCoord, 0);
                        newChildren.push(res1[1]);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        var newThickness = (endCoord - startCoord) * thicknessFraction;
        return [
            endCoord - newThickness,
            Object.assign(Object.assign({}, node), {
                thickness: newThickness,
                nextLevelNodes: newChildren
            })
        ];
    });
    return topLevelNodes.map(function(node) {
        return stretchNode(node, 0, 0)[1];
    });
}
// not sorted in any particular order
function webToRects(topLevelNodes) {
    var rects = [];
    var processNode = cacheable(function(node, levelCoord, stackDepth) {
        return (0, $c1gko.bB)(node);
    }, function(node, levelCoord, stackDepth) {
        var rect = Object.assign(Object.assign({}, node), {
            levelCoord: levelCoord,
            stackDepth: stackDepth,
            stackForward: 0
        });
        rects.push(rect);
        return rect.stackForward = processNodes(node.nextLevelNodes, levelCoord + node.thickness, stackDepth + 1) + 1;
    });
    function processNodes(nodes, levelCoord, stackDepth) {
        var stackForward = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                stackForward = Math.max(processNode(node, levelCoord, stackDepth), stackForward);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return stackForward;
    }
    processNodes(topLevelNodes, 0, 0);
    return rects; // TODO: sort rects by levelCoord to be consistent with toRects?
}
// TODO: move to general util
function cacheable(keyFunc, workFunc) {
    var cache = {};
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var key = keyFunc.apply(void 0, (0, $5TJQB._)(args));
        return key in cache ? cache[key] : cache[key] = workFunc.apply(void 0, (0, $5TJQB._)(args));
    };
}
function computeSegVCoords(segs, colDate) {
    var slatCoords = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, eventMinHeight = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var vcoords = [];
    if (slatCoords) for(var i = 0; i < segs.length; i += 1){
        var seg = segs[i];
        var spanStart = slatCoords.computeDateTop(seg.start, colDate);
        var spanEnd = Math.max(spanStart + (eventMinHeight || 0), slatCoords.computeDateTop(seg.end, colDate));
        vcoords.push({
            start: Math.round(spanStart),
            end: Math.round(spanEnd)
        });
    }
    return vcoords;
}
function computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack) {
    var segInputs = [];
    var dumbSegs = []; // segs without coords
    for(var i = 0; i < segs.length; i += 1){
        var vcoords = segVCoords[i];
        if (vcoords) segInputs.push({
            index: i,
            thickness: 1,
            span: vcoords
        });
        else dumbSegs.push(segs[i]);
    }
    var _buildPositioning = buildPositioning(segInputs, eventOrderStrict, eventMaxStack), segRects = _buildPositioning.segRects, hiddenGroups = _buildPositioning.hiddenGroups;
    var segPlacements = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segRects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segRect = _step.value;
            segPlacements.push({
                seg: segs[segRect.index],
                rect: segRect
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = dumbSegs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var dumbSeg = _step1.value;
            segPlacements.push({
                seg: dumbSeg,
                rect: null
            });
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return {
        segPlacements: segPlacements,
        hiddenGroups: hiddenGroups
    };
}
var DEFAULT_TIME_FORMAT = (0, $c1gko.x)({
    hour: "numeric",
    minute: "2-digit",
    meridiem: false
});
var TimeColEvent = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(TimeColEvent, BaseComponent);
    var _super = (0, $jhb1H._)(TimeColEvent);
    function TimeColEvent() {
        (0, $5kWiG._)(this, TimeColEvent);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(TimeColEvent, [
        {
            key: "render",
            value: function render() {
                return (0, $kgSvt.createElement)((0, $c1gko.cj), Object.assign({}, this.props, {
                    elClasses: [
                        "fc-timegrid-event",
                        "fc-v-event",
                        this.props.isShort && "fc-timegrid-event-short"
                    ],
                    defaultTimeFormat: DEFAULT_TIME_FORMAT
                }));
            }
        }
    ]);
    return TimeColEvent;
}((0, $c1gko.B));
var TimeCol = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(TimeCol, BaseComponent);
    var _super = (0, $jhb1H._)(TimeCol);
    function TimeCol() {
        (0, $5kWiG._)(this, TimeCol);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.sortEventSegs = (0, $c1gko.z)((0, $c1gko.bR));
        return _this;
    }
    (0, $hHaEF._)(TimeCol, [
        {
            // TODO: memoize event-placement?
            key: "render",
            value: function render() {
                var _this = this;
                var _this1 = this, props = _this1.props, context = _this1.context;
                var options = context.options;
                var isSelectMirror = options.selectMirror;
                var mirrorSegs = props.eventDrag && props.eventDrag.segs || props.eventResize && props.eventResize.segs || isSelectMirror && props.dateSelectionSegs || [];
                var interactionAffectedInstances = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
                var sortedFgSegs = this.sortEventSegs(props.fgEventSegs, options.eventOrder);
                return (0, $kgSvt.createElement)((0, $c1gko.cl), {
                    elTag: "td",
                    elRef: props.elRef,
                    elClasses: [
                        "fc-timegrid-col"
                    ].concat((0, $5TJQB._)(props.extraClassNames || [])),
                    elAttrs: Object.assign({
                        role: "gridcell"
                    }, props.extraDataAttrs),
                    date: props.date,
                    dateProfile: props.dateProfile,
                    todayRange: props.todayRange,
                    extraRenderProps: props.extraRenderProps
                }, function(InnerContent) {
                    return (0, $kgSvt.createElement)("div", {
                        className: "fc-timegrid-col-frame"
                    }, (0, $kgSvt.createElement)("div", {
                        className: "fc-timegrid-col-bg"
                    }, _this.renderFillSegs(props.businessHourSegs, "non-business"), _this.renderFillSegs(props.bgEventSegs, "bg-event"), _this.renderFillSegs(props.dateSelectionSegs, "highlight")), (0, $kgSvt.createElement)("div", {
                        className: "fc-timegrid-col-events"
                    }, _this.renderFgSegs(sortedFgSegs, interactionAffectedInstances, false, false, false)), (0, $kgSvt.createElement)("div", {
                        className: "fc-timegrid-col-events"
                    }, _this.renderFgSegs(mirrorSegs, {}, Boolean(props.eventDrag), Boolean(props.eventResize), Boolean(isSelectMirror), "mirror")), (0, $kgSvt.createElement)("div", {
                        className: "fc-timegrid-now-indicator-container"
                    }, _this.renderNowIndicator(props.nowIndicatorSegs)), (0, $c1gko.cm)(options) && (0, $kgSvt.createElement)(InnerContent, {
                        elTag: "div",
                        elClasses: [
                            "fc-timegrid-col-misc"
                        ]
                    }));
                });
            }
        },
        {
            key: "renderFgSegs",
            value: function renderFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey) {
                var props = this.props;
                if (props.forPrint) return renderPlainFgSegs(sortedFgSegs, props);
                return this.renderPositionedFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey);
            }
        },
        {
            key: "renderPositionedFgSegs",
            value: function renderPositionedFgSegs(segs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey) {
                var _this = this;
                var _this_context_options = this.context.options, eventMaxStack = _this_context_options.eventMaxStack, eventShortHeight = _this_context_options.eventShortHeight, eventOrderStrict = _this_context_options.eventOrderStrict, eventMinHeight = _this_context_options.eventMinHeight;
                var _this_props = this.props, date = _this_props.date, slatCoords = _this_props.slatCoords, eventSelection = _this_props.eventSelection, todayRange = _this_props.todayRange, nowDate = _this_props.nowDate;
                var isMirror = isDragging || isResizing || isDateSelecting;
                var segVCoords = computeSegVCoords(segs, date, slatCoords, eventMinHeight);
                var _computeFgSegPlacements = computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack), segPlacements = _computeFgSegPlacements.segPlacements, hiddenGroups = _computeFgSegPlacements.hiddenGroups;
                return (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, this.renderHiddenGroups(hiddenGroups, segs), segPlacements.map(function(segPlacement) {
                    var seg = segPlacement.seg, rect = segPlacement.rect;
                    var instanceId = seg.eventRange.instance.instanceId;
                    var isVisible = isMirror || Boolean(!segIsInvisible[instanceId] && rect);
                    var vStyle = computeSegVStyle(rect && rect.span);
                    var hStyle = !isMirror && rect ? _this.computeSegHStyle(rect) : {
                        left: 0,
                        right: 0
                    };
                    var isInset = Boolean(rect) && rect.stackForward > 0;
                    var isShort = Boolean(rect) && rect.span.end - rect.span.start < eventShortHeight; // look at other places for this problem
                    return (0, $kgSvt.createElement)("div", {
                        className: "fc-timegrid-event-harness" + (isInset ? " fc-timegrid-event-harness-inset" : ""),
                        key: forcedKey || instanceId,
                        style: Object.assign(Object.assign({
                            visibility: isVisible ? "" : "hidden"
                        }, vStyle), hStyle)
                    }, (0, $kgSvt.createElement)(TimeColEvent, Object.assign({
                        seg: seg,
                        isDragging: isDragging,
                        isResizing: isResizing,
                        isDateSelecting: isDateSelecting,
                        isSelected: instanceId === eventSelection,
                        isShort: isShort
                    }, (0, $c1gko.bS)(seg, todayRange, nowDate))));
                }));
            }
        },
        {
            // will already have eventMinHeight applied because segInputs already had it
            key: "renderHiddenGroups",
            value: function renderHiddenGroups(hiddenGroups, segs) {
                var _this_props = this.props, extraDateSpan = _this_props.extraDateSpan, dateProfile = _this_props.dateProfile, todayRange = _this_props.todayRange, nowDate = _this_props.nowDate, eventSelection = _this_props.eventSelection, eventDrag = _this_props.eventDrag, eventResize = _this_props.eventResize;
                return (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, hiddenGroups.map(function(hiddenGroup) {
                    var positionCss = computeSegVStyle(hiddenGroup.span);
                    var hiddenSegs = compileSegsFromEntries(hiddenGroup.entries, segs);
                    return (0, $kgSvt.createElement)(TimeColMoreLink, {
                        key: (0, $c1gko.bw)((0, $c1gko.cs)(hiddenSegs)),
                        hiddenSegs: hiddenSegs,
                        top: positionCss.top,
                        bottom: positionCss.bottom,
                        extraDateSpan: extraDateSpan,
                        dateProfile: dateProfile,
                        todayRange: todayRange,
                        nowDate: nowDate,
                        eventSelection: eventSelection,
                        eventDrag: eventDrag,
                        eventResize: eventResize
                    });
                }));
            }
        },
        {
            key: "renderFillSegs",
            value: function renderFillSegs(segs, fillType) {
                var _this = this, props = _this.props, context = _this.context;
                var segVCoords = computeSegVCoords(segs, props.date, props.slatCoords, context.options.eventMinHeight); // don't assume all populated
                var children = segVCoords.map(function(vcoords, i) {
                    var seg = segs[i];
                    return (0, $kgSvt.createElement)("div", {
                        key: (0, $c1gko.bT)(seg.eventRange),
                        className: "fc-timegrid-bg-harness",
                        style: computeSegVStyle(vcoords)
                    }, fillType === "bg-event" ? (0, $kgSvt.createElement)((0, $c1gko.cp), Object.assign({
                        seg: seg
                    }, (0, $c1gko.bS)(seg, props.todayRange, props.nowDate))) : (0, $c1gko.co)(fillType));
                });
                return (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, children);
            }
        },
        {
            key: "renderNowIndicator",
            value: function renderNowIndicator(segs) {
                var _this_props = this.props, slatCoords = _this_props.slatCoords, date = _this_props.date;
                if (!slatCoords) return null;
                return segs.map(function(seg, i) {
                    return (0, $kgSvt.createElement)((0, $c1gko.ck), {
                        // key doesn't matter. will only ever be one
                        key: i,
                        elClasses: [
                            "fc-timegrid-now-indicator-line"
                        ],
                        elStyle: {
                            top: slatCoords.computeDateTop(seg.start, date)
                        },
                        isAxis: false,
                        date: date
                    });
                });
            }
        },
        {
            key: "computeSegHStyle",
            value: function computeSegHStyle(segHCoords) {
                var _this_context = this.context, isRtl = _this_context.isRtl, options = _this_context.options;
                var shouldOverlap = options.slotEventOverlap;
                var nearCoord = segHCoords.levelCoord; // the left side if LTR. the right side if RTL. floating-point
                var farCoord = segHCoords.levelCoord + segHCoords.thickness; // the right side if LTR. the left side if RTL. floating-point
                var left; // amount of space from left edge, a fraction of the total width
                var right; // amount of space from right edge, a fraction of the total width
                if (shouldOverlap) // double the width, but don't go beyond the maximum forward coordinate (1.0)
                farCoord = Math.min(1, nearCoord + (farCoord - nearCoord) * 2);
                if (isRtl) {
                    left = 1 - farCoord;
                    right = nearCoord;
                } else {
                    left = nearCoord;
                    right = 1 - farCoord;
                }
                var props = {
                    zIndex: segHCoords.stackDepth + 1,
                    left: left * 100 + "%",
                    right: right * 100 + "%"
                };
                if (shouldOverlap && !segHCoords.stackForward) // add padding to the edge so that forward stacked events don't cover the resizer's icon
                props[isRtl ? "marginLeft" : "marginRight"] = 20; // 10 is a guesstimate of the icon's width
                return props;
            }
        }
    ]);
    return TimeCol;
}((0, $c1gko.B));
function renderPlainFgSegs(sortedFgSegs, param) {
    var todayRange = param.todayRange, nowDate = param.nowDate, eventSelection = param.eventSelection, eventDrag = param.eventDrag, eventResize = param.eventResize;
    var hiddenInstances = (eventDrag ? eventDrag.affectedInstances : null) || (eventResize ? eventResize.affectedInstances : null) || {};
    return (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, sortedFgSegs.map(function(seg) {
        var instanceId = seg.eventRange.instance.instanceId;
        return (0, $kgSvt.createElement)("div", {
            key: instanceId,
            style: {
                visibility: hiddenInstances[instanceId] ? "hidden" : ""
            }
        }, (0, $kgSvt.createElement)(TimeColEvent, Object.assign({
            seg: seg,
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: instanceId === eventSelection,
            isShort: false
        }, (0, $c1gko.bS)(seg, todayRange, nowDate))));
    }));
}
function computeSegVStyle(segVCoords) {
    if (!segVCoords) return {
        top: "",
        bottom: ""
    };
    return {
        top: segVCoords.start,
        bottom: -segVCoords.end
    };
}
function compileSegsFromEntries(segEntries, allSegs) {
    return segEntries.map(function(segEntry) {
        return allSegs[segEntry.index];
    });
}
var TimeColsContent = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(TimeColsContent, BaseComponent);
    var _super = (0, $jhb1H._)(TimeColsContent);
    function TimeColsContent() {
        (0, $5kWiG._)(this, TimeColsContent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.splitFgEventSegs = (0, $c1gko.z)(splitSegsByCol);
        _this.splitBgEventSegs = (0, $c1gko.z)(splitSegsByCol);
        _this.splitBusinessHourSegs = (0, $c1gko.z)(splitSegsByCol);
        _this.splitNowIndicatorSegs = (0, $c1gko.z)(splitSegsByCol);
        _this.splitDateSelectionSegs = (0, $c1gko.z)(splitSegsByCol);
        _this.splitEventDrag = (0, $c1gko.z)(splitInteractionByCol);
        _this.splitEventResize = (0, $c1gko.z)(splitInteractionByCol);
        _this.rootElRef = (0, $kgSvt.createRef)();
        _this.cellElRefs = new (0, $c1gko.cf)();
        return _this;
    }
    (0, $hHaEF._)(TimeColsContent, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this1 = this, props = _this1.props, context = _this1.context;
                var nowIndicatorTop = context.options.nowIndicator && props.slatCoords && props.slatCoords.safeComputeTop(props.nowDate); // might return void
                var colCnt = props.cells.length;
                var fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, colCnt);
                var bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, colCnt);
                var businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, colCnt);
                var nowIndicatorSegsByRow = this.splitNowIndicatorSegs(props.nowIndicatorSegs, colCnt);
                var dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, colCnt);
                var eventDragByRow = this.splitEventDrag(props.eventDrag, colCnt);
                var eventResizeByRow = this.splitEventResize(props.eventResize, colCnt);
                return (0, $kgSvt.createElement)("div", {
                    className: "fc-timegrid-cols",
                    ref: this.rootElRef
                }, (0, $kgSvt.createElement)("table", {
                    role: "presentation",
                    style: {
                        minWidth: props.tableMinWidth,
                        width: props.clientWidth
                    }
                }, props.tableColGroupNode, (0, $kgSvt.createElement)("tbody", {
                    role: "presentation"
                }, (0, $kgSvt.createElement)("tr", {
                    role: "row"
                }, props.axis && (0, $kgSvt.createElement)("td", {
                    "aria-hidden": true,
                    className: "fc-timegrid-col fc-timegrid-axis"
                }, (0, $kgSvt.createElement)("div", {
                    className: "fc-timegrid-col-frame"
                }, (0, $kgSvt.createElement)("div", {
                    className: "fc-timegrid-now-indicator-container"
                }, typeof nowIndicatorTop === "number" && (0, $kgSvt.createElement)((0, $c1gko.ck), {
                    elClasses: [
                        "fc-timegrid-now-indicator-arrow"
                    ],
                    elStyle: {
                        top: nowIndicatorTop
                    },
                    isAxis: true,
                    date: props.nowDate
                })))), props.cells.map(function(cell, i) {
                    return (0, $kgSvt.createElement)(TimeCol, {
                        key: cell.key,
                        elRef: _this.cellElRefs.createRef(cell.key),
                        dateProfile: props.dateProfile,
                        date: cell.date,
                        nowDate: props.nowDate,
                        todayRange: props.todayRange,
                        extraRenderProps: cell.extraRenderProps,
                        extraDataAttrs: cell.extraDataAttrs,
                        extraClassNames: cell.extraClassNames,
                        extraDateSpan: cell.extraDateSpan,
                        fgEventSegs: fgEventSegsByRow[i],
                        bgEventSegs: bgEventSegsByRow[i],
                        businessHourSegs: businessHourSegsByRow[i],
                        nowIndicatorSegs: nowIndicatorSegsByRow[i],
                        dateSelectionSegs: dateSelectionSegsByRow[i],
                        eventDrag: eventDragByRow[i],
                        eventResize: eventResizeByRow[i],
                        slatCoords: props.slatCoords,
                        eventSelection: props.eventSelection,
                        forPrint: props.forPrint
                    });
                })))));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateCoords();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateCoords();
            }
        },
        {
            key: "updateCoords",
            value: function updateCoords() {
                var props = this.props;
                if (props.onColCoords && props.clientWidth !== null // means sizing has stabilized
                ) props.onColCoords(new (0, $c1gko.ba)(this.rootElRef.current, collectCellEls(this.cellElRefs.currentMap, props.cells), true, false));
            }
        }
    ]);
    return TimeColsContent;
}((0, $c1gko.B));
function collectCellEls(elMap, cells) {
    return cells.map(function(cell) {
        return elMap[cell.key];
    });
}
/* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/ var TimeCols = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $dACZV._)(TimeCols, DateComponent);
    var _super = (0, $jhb1H._)(TimeCols);
    function TimeCols() {
        (0, $5kWiG._)(this, TimeCols);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.processSlotOptions = (0, $c1gko.z)(processSlotOptions);
        _this.state = {
            slatCoords: null
        };
        _this.handleRootEl = function(el) {
            if (el) _this.context.registerInteractiveComponent((0, $1K4o4._)(_this), {
                el: el,
                isHitComboAllowed: _this.props.isHitComboAllowed
            });
            else _this.context.unregisterInteractiveComponent((0, $1K4o4._)(_this));
        };
        _this.handleScrollRequest = function(request) {
            var onScrollTopRequest = _this.props.onScrollTopRequest;
            var slatCoords = _this.state.slatCoords;
            if (onScrollTopRequest && slatCoords) {
                if (request.time) {
                    var top = slatCoords.computeTimeTop(request.time);
                    top = Math.ceil(top); // zoom can give weird floating-point values. rather scroll a little bit further
                    if (top) top += 1; // to overcome top border that slots beyond the first have. looks better
                    onScrollTopRequest(top);
                }
                return true;
            }
            return false;
        };
        _this.handleColCoords = function(colCoords) {
            _this.colCoords = colCoords;
        };
        _this.handleSlatCoords = function(slatCoords) {
            _this.setState({
                slatCoords: slatCoords
            });
            if (_this.props.onSlatCoords) _this.props.onSlatCoords(slatCoords);
        };
        return _this;
    }
    (0, $hHaEF._)(TimeCols, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, state = _this.state;
                return (0, $kgSvt.createElement)("div", {
                    className: "fc-timegrid-body",
                    ref: this.handleRootEl,
                    style: {
                        // these props are important to give this wrapper correct dimensions for interactions
                        // TODO: if we set it here, can we avoid giving to inner tables?
                        width: props.clientWidth,
                        minWidth: props.tableMinWidth
                    }
                }, (0, $kgSvt.createElement)(TimeColsSlats, {
                    axis: props.axis,
                    dateProfile: props.dateProfile,
                    slatMetas: props.slatMetas,
                    clientWidth: props.clientWidth,
                    minHeight: props.expandRows ? props.clientHeight : "",
                    tableMinWidth: props.tableMinWidth,
                    tableColGroupNode: props.axis ? props.tableColGroupNode : null,
                    onCoords: this.handleSlatCoords
                }), (0, $kgSvt.createElement)(TimeColsContent, {
                    cells: props.cells,
                    axis: props.axis,
                    dateProfile: props.dateProfile,
                    businessHourSegs: props.businessHourSegs,
                    bgEventSegs: props.bgEventSegs,
                    fgEventSegs: props.fgEventSegs,
                    dateSelectionSegs: props.dateSelectionSegs,
                    eventSelection: props.eventSelection,
                    eventDrag: props.eventDrag,
                    eventResize: props.eventResize,
                    todayRange: props.todayRange,
                    nowDate: props.nowDate,
                    nowIndicatorSegs: props.nowIndicatorSegs,
                    clientWidth: props.clientWidth,
                    tableMinWidth: props.tableMinWidth,
                    tableColGroupNode: props.tableColGroupNode,
                    slatCoords: state.slatCoords,
                    onColCoords: this.handleColCoords,
                    forPrint: props.forPrint
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                this.scrollResponder.update(prevProps.dateProfile !== this.props.dateProfile);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.scrollResponder.detach();
            }
        },
        {
            key: "queryHit",
            value: function queryHit(positionLeft, positionTop) {
                var _this_context = this.context, dateEnv = _this_context.dateEnv, options = _this_context.options;
                var colCoords = this.colCoords;
                var dateProfile = this.props.dateProfile;
                var slatCoords = this.state.slatCoords;
                var _this_processSlotOptions = this.processSlotOptions(this.props.slotDuration, options.snapDuration), snapDuration = _this_processSlotOptions.snapDuration, snapsPerSlot = _this_processSlotOptions.snapsPerSlot;
                var colIndex = colCoords.leftToIndex(positionLeft);
                var slatIndex = slatCoords.positions.topToIndex(positionTop);
                if (colIndex != null && slatIndex != null) {
                    var cell = this.props.cells[colIndex];
                    var slatTop = slatCoords.positions.tops[slatIndex];
                    var slatHeight = slatCoords.positions.getHeight(slatIndex);
                    var partial = (positionTop - slatTop) / slatHeight; // floating point number between 0 and 1
                    var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
                    var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
                    var dayDate = this.props.cells[colIndex].date;
                    var time = (0, $c1gko.bp)(dateProfile.slotMinTime, (0, $c1gko.bo)(snapDuration, snapIndex));
                    var start = dateEnv.add(dayDate, time);
                    var end = dateEnv.add(start, snapDuration);
                    return {
                        dateProfile: dateProfile,
                        dateSpan: Object.assign({
                            range: {
                                start: start,
                                end: end
                            },
                            allDay: false
                        }, cell.extraDateSpan),
                        dayEl: colCoords.els[colIndex],
                        rect: {
                            left: colCoords.lefts[colIndex],
                            right: colCoords.rights[colIndex],
                            top: slatTop,
                            bottom: slatTop + slatHeight
                        },
                        layer: 0
                    };
                }
                return null;
            }
        }
    ]);
    return TimeCols;
}((0, $c1gko.be));
function processSlotOptions(slotDuration, snapDurationOverride) {
    var snapDuration = snapDurationOverride || slotDuration;
    var snapsPerSlot = (0, $c1gko.bt)(slotDuration, snapDuration);
    if (snapsPerSlot === null) {
        snapDuration = slotDuration;
        snapsPerSlot = 1;
    // TODO: say warning?
    }
    return {
        snapDuration: snapDuration,
        snapsPerSlot: snapsPerSlot
    };
}
var DayTimeColsSlicer = /*#__PURE__*/ function(Slicer) {
    "use strict";
    (0, $dACZV._)(DayTimeColsSlicer, Slicer);
    var _super = (0, $jhb1H._)(DayTimeColsSlicer);
    function DayTimeColsSlicer() {
        (0, $5kWiG._)(this, DayTimeColsSlicer);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(DayTimeColsSlicer, [
        {
            key: "sliceRange",
            value: function sliceRange(range, dayRanges) {
                var segs = [];
                for(var col = 0; col < dayRanges.length; col += 1){
                    var segRange = (0, $c1gko.o)(range, dayRanges[col]);
                    if (segRange) segs.push({
                        start: segRange.start,
                        end: segRange.end,
                        isStart: segRange.start.valueOf() === range.start.valueOf(),
                        isEnd: segRange.end.valueOf() === range.end.valueOf(),
                        col: col
                    });
                }
                return segs;
            }
        }
    ]);
    return DayTimeColsSlicer;
}((0, $c1gko.bW));
var DayTimeCols = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $dACZV._)(DayTimeCols, DateComponent);
    var _super = (0, $jhb1H._)(DayTimeCols);
    function DayTimeCols() {
        (0, $5kWiG._)(this, DayTimeCols);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.buildDayRanges = (0, $c1gko.z)(buildDayRanges);
        _this.slicer = new DayTimeColsSlicer();
        _this.timeColsRef = (0, $kgSvt.createRef)();
        return _this;
    }
    (0, $hHaEF._)(DayTimeCols, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this1 = this, props = _this1.props, context = _this1.context;
                var dateProfile = props.dateProfile, dayTableModel = props.dayTableModel;
                var _context_options = context.options, nowIndicator = _context_options.nowIndicator, nextDayThreshold = _context_options.nextDayThreshold;
                var dayRanges = this.buildDayRanges(dayTableModel, dateProfile, context.dateEnv);
                // give it the first row of cells
                // TODO: would move this further down hierarchy, but sliceNowDate needs it
                return (0, $kgSvt.createElement)((0, $c1gko.ch), {
                    unit: nowIndicator ? "minute" : "day"
                }, function(nowDate, todayRange) {
                    return (0, $kgSvt.createElement)(TimeCols, Object.assign({
                        ref: _this.timeColsRef
                    }, _this.slicer.sliceProps(props, dateProfile, null, context, dayRanges), {
                        forPrint: props.forPrint,
                        axis: props.axis,
                        dateProfile: dateProfile,
                        slatMetas: props.slatMetas,
                        slotDuration: props.slotDuration,
                        cells: dayTableModel.cells[0],
                        tableColGroupNode: props.tableColGroupNode,
                        tableMinWidth: props.tableMinWidth,
                        clientWidth: props.clientWidth,
                        clientHeight: props.clientHeight,
                        expandRows: props.expandRows,
                        nowDate: nowDate,
                        nowIndicatorSegs: nowIndicator && _this.slicer.sliceNowDate(nowDate, dateProfile, nextDayThreshold, context, dayRanges),
                        todayRange: todayRange,
                        onScrollTopRequest: props.onScrollTopRequest,
                        onSlatCoords: props.onSlatCoords
                    }));
                });
            }
        }
    ]);
    return DayTimeCols;
}((0, $c1gko.be));
function buildDayRanges(dayTableModel, dateProfile, dateEnv) {
    var ranges = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = dayTableModel.headerDates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var date = _step.value;
            ranges.push({
                start: dateEnv.add(date, dateProfile.slotMinTime),
                end: dateEnv.add(date, dateProfile.slotMaxTime)
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return ranges;
}
// potential nice values for the slot-duration and interval-duration
// from largest to smallest
var STOCK_SUB_DURATIONS = [
    {
        hours: 1
    },
    {
        minutes: 30
    },
    {
        minutes: 15
    },
    {
        seconds: 30
    },
    {
        seconds: 15
    }
];
function buildSlatMetas(slotMinTime, slotMaxTime, explicitLabelInterval, slotDuration, dateEnv) {
    var dayStart = new Date(0);
    var slatTime = slotMinTime;
    var slatIterator = (0, $c1gko.d)(0);
    var labelInterval = explicitLabelInterval || computeLabelInterval(slotDuration);
    var metas = [];
    while((0, $c1gko.bs)(slatTime) < (0, $c1gko.bs)(slotMaxTime)){
        var date = dateEnv.add(dayStart, slatTime);
        var isLabeled = (0, $c1gko.bt)(slatIterator, labelInterval) !== null;
        metas.push({
            date: date,
            time: slatTime,
            key: date.toISOString(),
            isoTimeStr: (0, $c1gko.bu)(date),
            isLabeled: isLabeled
        });
        slatTime = (0, $c1gko.bp)(slatTime, slotDuration);
        slatIterator = (0, $c1gko.bp)(slatIterator, slotDuration);
    }
    return metas;
}
// Computes an automatic value for slotLabelInterval
function computeLabelInterval(slotDuration) {
    var i;
    var labelInterval;
    var slotsPerLabel;
    // find the smallest stock label interval that results in more than one slots-per-label
    for(i = STOCK_SUB_DURATIONS.length - 1; i >= 0; i -= 1){
        labelInterval = (0, $c1gko.d)(STOCK_SUB_DURATIONS[i]);
        slotsPerLabel = (0, $c1gko.bt)(labelInterval, slotDuration);
        if (slotsPerLabel !== null && slotsPerLabel > 1) return labelInterval;
    }
    return slotDuration; // fall back
}
var DayTimeColsView = /*#__PURE__*/ function(TimeColsView) {
    "use strict";
    (0, $dACZV._)(DayTimeColsView, TimeColsView);
    var _super = (0, $jhb1H._)(DayTimeColsView);
    function DayTimeColsView() {
        (0, $5kWiG._)(this, DayTimeColsView);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.buildTimeColsModel = (0, $c1gko.z)(buildTimeColsModel);
        _this.buildSlatMetas = (0, $c1gko.z)(buildSlatMetas);
        return _this;
    }
    (0, $hHaEF._)(DayTimeColsView, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_context = this.context, options = _this_context.options, dateEnv = _this_context.dateEnv, dateProfileGenerator = _this_context.dateProfileGenerator;
                var props = this.props;
                var dateProfile = props.dateProfile;
                var dayTableModel = this.buildTimeColsModel(dateProfile, dateProfileGenerator);
                var splitProps = this.allDaySplitter.splitProps(props);
                var slatMetas = this.buildSlatMetas(dateProfile.slotMinTime, dateProfile.slotMaxTime, options.slotLabelInterval, options.slotDuration, dateEnv);
                var dayMinWidth = options.dayMinWidth;
                var hasAttachedAxis = !dayMinWidth;
                var hasDetachedAxis = dayMinWidth;
                var headerContent = options.dayHeaders && (0, $kgSvt.createElement)((0, $c1gko.bK), {
                    dates: dayTableModel.headerDates,
                    dateProfile: dateProfile,
                    datesRepDistinctDays: true,
                    renderIntro: hasAttachedAxis ? this.renderHeadAxis : null
                });
                var allDayContent = options.allDaySlot !== false && function(contentArg) {
                    return (0, $kgSvt.createElement)((0, $gbAcq.DayTable), Object.assign({}, splitProps.allDay, {
                        dateProfile: dateProfile,
                        dayTableModel: dayTableModel,
                        nextDayThreshold: options.nextDayThreshold,
                        tableMinWidth: contentArg.tableMinWidth,
                        colGroupNode: contentArg.tableColGroupNode,
                        renderRowIntro: hasAttachedAxis ? _this.renderTableRowAxis : null,
                        showWeekNumbers: false,
                        expandRows: false,
                        headerAlignElRef: _this.headerElRef,
                        clientWidth: contentArg.clientWidth,
                        clientHeight: contentArg.clientHeight,
                        forPrint: props.forPrint
                    }, _this.getAllDayMaxEventProps()));
                };
                var timeGridContent = function(contentArg) {
                    return (0, $kgSvt.createElement)(DayTimeCols, Object.assign({}, splitProps.timed, {
                        dayTableModel: dayTableModel,
                        dateProfile: dateProfile,
                        axis: hasAttachedAxis,
                        slotDuration: options.slotDuration,
                        slatMetas: slatMetas,
                        forPrint: props.forPrint,
                        tableColGroupNode: contentArg.tableColGroupNode,
                        tableMinWidth: contentArg.tableMinWidth,
                        clientWidth: contentArg.clientWidth,
                        clientHeight: contentArg.clientHeight,
                        onSlatCoords: _this.handleSlatCoords,
                        expandRows: contentArg.expandRows,
                        onScrollTopRequest: _this.handleScrollTopRequest
                    }));
                };
                return hasDetachedAxis ? this.renderHScrollLayout(headerContent, allDayContent, timeGridContent, dayTableModel.colCnt, dayMinWidth, slatMetas, this.state.slatCoords) : this.renderSimpleLayout(headerContent, allDayContent, timeGridContent);
            }
        }
    ]);
    return DayTimeColsView;
}(TimeColsView);
function buildTimeColsModel(dateProfile, dateProfileGenerator) {
    var daySeries = new (0, $c1gko.bO)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $c1gko.bV)(daySeries, false);
}

});

parcelRegister("Loi7S", function(module, exports) {

$parcel$export(module.exports, "createNotes", function () { return $08e73ba89a2710b5$export$a6281618eba5c8a8; });
$parcel$export(module.exports, "editNotes", function () { return $08e73ba89a2710b5$export$4f3d4ef8cc12870; });
$parcel$export(module.exports, "createTodos", function () { return $08e73ba89a2710b5$export$d73c8b8ba60e493f; });
$parcel$export(module.exports, "editTodos", function () { return $08e73ba89a2710b5$export$298a394e1066cd97; });
$parcel$export(module.exports, "createScrumBoard", function () { return $08e73ba89a2710b5$export$fdfb1371bb41f6ab; });
$parcel$export(module.exports, "createNewList", function () { return $08e73ba89a2710b5$export$6819fc501dde6d24; });
$parcel$export(module.exports, "createEvent", function () { return $08e73ba89a2710b5$export$c30017717ce2168e; });
var $08e73ba89a2710b5$export$846d0d105943fb86 = {
    notes: []
};
var $08e73ba89a2710b5$export$bd1c7d1f0790489f = {
    scrumboard: [],
    todo: [],
    settings: {}
};
var $08e73ba89a2710b5$var$generateShortId = function generateShortId(length) {
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var result = "";
    for(var i = 0; i < length; i++){
        var randomIndex = Math.floor(Math.random() * chars.length);
        result += chars.charAt(randomIndex);
    }
    return result;
};
var $08e73ba89a2710b5$export$a6281618eba5c8a8 = function createNotes() {
    var today = new Date().toISOString();
    var noteTitle = document.getElementById("n-title").value;
    var noteDescription = document.getElementById("n-description").value;
    var noteTag = document.getElementById("n-tags").value;
    var shortId = $08e73ba89a2710b5$var$generateShortId(5);
    var data = {
        id: shortId,
        title: noteTitle,
        description: noteDescription,
        tag: noteTag,
        date: today,
        favorited: 0
    };
    $08e73ba89a2710b5$export$846d0d105943fb86.notes.push(data);
    return data;
};
var $08e73ba89a2710b5$export$4f3d4ef8cc12870 = function editNotes(noteId, favorited) {
    var today = new Date().toISOString();
    var noteTitle = document.getElementById("n-title").value;
    var noteDescription = document.getElementById("n-description").value;
    var noteTag = document.getElementById("n-tags").value;
    var data = {
        id: noteId,
        title: noteTitle,
        description: noteDescription,
        tag: noteTag,
        date: today,
        favorited: favorited
    };
    return data;
};
var $08e73ba89a2710b5$export$d73c8b8ba60e493f = function createTodos(quill) {
    var today = new Date().toISOString();
    var todoTitle = document.getElementById("task-text").value;
    // const todoDescription = quill.getText().trim();
    var todoDescription = quill.root.innerHTML;
    var todoPriority = document.getElementById("priority").value;
    var shortId = $08e73ba89a2710b5$var$generateShortId(5);
    var data = {
        id: shortId,
        title: todoTitle,
        description: todoDescription,
        priority: todoPriority,
        important: 0,
        completed: 0,
        trash: 0,
        date: today
    };
    return data;
};
var $08e73ba89a2710b5$export$298a394e1066cd97 = function editTodos(quill, options) {
    var today = new Date().toISOString();
    var todoTitle = document.getElementById("task-text").value;
    // const todoDescription = quill.getText().trim();
    var todoDescription = quill.root.innerHTML;
    var todoPriority = document.getElementById("priority").value;
    var data = {
        id: options.todoId,
        title: todoTitle,
        description: todoDescription,
        priority: todoPriority,
        important: options.important,
        completed: options.completed,
        trash: options.trash,
        date: today
    };
    return data;
};
var $08e73ba89a2710b5$export$fdfb1371bb41f6ab = function createScrumBoard(options) {
    var isEdit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth());
    var yyyy = today.getFullYear();
    // prettier-ignore
    var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    today = dd + " " + monthNames[mm] + ", " + yyyy;
    var taskTitle = document.getElementById("s-task").value;
    var taskText = document.getElementById("s-text").value;
    var progress = document.getElementById("s-progress").value;
    var shortId = $08e73ba89a2710b5$var$generateShortId(5);
    var data = {
        id: isEdit ? options.id : shortId,
        title: taskTitle,
        description: taskText,
        tasksection: options.tasksection,
        order: options.order,
        progress: progress,
        date: today
    };
    return data;
};
var $08e73ba89a2710b5$export$6819fc501dde6d24 = function createNewList() {
    var isEdit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, order = arguments.length > 2 ? arguments[2] : void 0;
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    today = "".concat(mm, ".").concat(dd, ".").concat(yyyy);
    var listId = $08e73ba89a2710b5$var$generateShortId(5);
    var listTitle = document.getElementById("s-list-name").value;
    var listTitleLower = listTitle.toLowerCase();
    var listTitleRemoveWhiteSpaces = listTitleLower.split(" ").join("_");
    var listSectionDataAttr = "s-".concat(listTitleRemoveWhiteSpaces, "-").concat(listId);
    var data = {
        id: isEdit ? options.section : listSectionDataAttr,
        title: listTitle,
        order: isEdit ? options.order : order,
        date: today
    };
    return data;
};
var $08e73ba89a2710b5$export$c30017717ce2168e = function createEvent() {
    var isEdit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, OldEventId = arguments.length > 1 ? arguments[1] : void 0;
    var getModalCheckedRadioBtnEl = document.querySelector('input[name="event-level"]:checked');
    var getTitleValue = document.querySelector("#event-title").value;
    var setModalStartDateValue = document.querySelector("#event-start-date").value;
    var setModalEndDateValue = document.querySelector("#event-end-date").value;
    var setModalUrlValue = document.querySelector("#event-url").value;
    var getModalCheckedRadioBtnValue = getModalCheckedRadioBtnEl !== null ? getModalCheckedRadioBtnEl.value : "";
    var eventID = $08e73ba89a2710b5$var$generateShortId(5);
    var data = {
        id: isEdit ? OldEventId : eventID,
        title: getTitleValue,
        start: setModalStartDateValue,
        end: setModalEndDateValue,
        url: setModalUrlValue,
        allDay: false,
        extendedProps: {
            calendar: getModalCheckedRadioBtnValue
        }
    };
    return data;
};

});

parcelRegister("2B8he", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e45751d69314b77$export$2e2bcd8739ae039; });

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $8EGc6 = parcelRequire("8EGc6");

var $iFe8d = parcelRequire("iFe8d");

var $4HRPq = parcelRequire("4HRPq");

var $1e45751d69314b77$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function appView() {
        (0, $5kWiG._)(this, appView);
        (0, $8EGc6._)(this, "_noteContainer", document.querySelector("#ct"));
        (0, $8EGc6._)(this, "_data", void 0);
    }
    (0, $hHaEF._)(appView, [
        {
            key: "openModal",
            value: function openModal(element) {
                $(element).modal("show");
                $("#btn-n-save").hide();
                $("#btn-n-add").show();
            }
        },
        {
            key: "showContentModal",
            value: function showContentModal(title, description, element) {
                document.querySelector(".task-heading").textContent = title;
                document.querySelector(".task-text").innerHTML = description;
                $(element).modal("show");
            }
        },
        {
            key: "successMessageInfo",
            value: function successMessageInfo(message) {
                var notyf = new (0, $iFe8d.Notyf)((0, $4HRPq.INOTIFYOPTIONS));
                notyf.success(message);
            }
        },
        {
            key: "failedMessageInfo",
            value: function failedMessageInfo(message) {
                var notyf = new (0, $iFe8d.Notyf)((0, $4HRPq.INOTIFYOPTIONS));
                notyf.error(message);
            }
        },
        {
            key: "closeModal",
            value: function closeModal(element, message) {
                var info = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                info ? this.successMessageInfo(message) : this.failedMessageInfo(message);
                $(element).modal("hide");
            }
        },
        {
            key: "formatDate",
            value: function formatDate(date) {
                var newDate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var locale = navigator.language;
                var calcDayPassed = function(date1, date2) {
                    return Math.round(Math.abs(date2 - date1) / 86400000);
                };
                var formatSingleDate = function(dateElement) {
                    var newDate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var dateStr = newDate ? dateElement : dateElement.textContent;
                    var dayPassed = calcDayPassed(new Date(), new Date(dateStr));
                    if (dayPassed === 0) return "Today";
                    if (dayPassed === 1) return "Yesterday";
                    if (dayPassed <= 7) return "".concat(dayPassed, " days ago");
                    return new Intl.DateTimeFormat(locale).format(new Date(dateStr));
                };
                if (newDate) {
                    var formattedDate = formatSingleDate(date, true);
                    return formattedDate;
                } else {
                    var dateElements = document.querySelectorAll(".meta-time");
                    if (dateElements) dateElements.forEach(function(dateElement) {
                        var formattedDate = formatSingleDate(dateElement);
                        dateElement.textContent = formattedDate;
                    });
                }
            }
        },
        {
            // renderErrorMessage(message = this._errorMsg) {
            //   if (!this._parentElement) return;
            //   const markup = `
            //     <div class="col-12 empty-note">
            //       <div class="alert alert-background alert-dismissible fade show mb-4" role="alert">
            //           <strong>${message}</strong>
            //       </div>
            //     </div>
            //   `;
            //   this._parentElement.insertAdjacentHTML('afterbegin', markup);
            // }
            key: "renderErrorMessage",
            value: function renderErrorMessage() {
                var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._errorMsg;
                if (!this._parentElement) return;
                var markup = '\n      <div class="col-12 empty-note">\n        <div class="alert alert-background alert-dismissible fade show mb-4" role="alert">\n            <strong>'.concat(message, "</strong>\n        </div>\n      </div>\n    ");
                var searchEl = this._parentElement.querySelector(".search");
                searchEl.insertAdjacentHTML("afterend", markup);
            }
        },
        {
            key: "removeEmptyContainer",
            value: function removeEmptyContainer() {
                var emptyNote = document.querySelector(".empty-note");
                if (!emptyNote) return;
                if (emptyNote) emptyNote.remove();
            }
        },
        {
            key: "limitCharacters",
            value: function limitCharacters(inputString, limit) {
                if (inputString.length <= limit) return inputString;
                else return inputString.substring(0, limit) + "...";
            }
        },
        {
            key: "update",
            value: function update(data, markup, containerElement) {
                this._data = data;
                var newMarkup = markup;
                var newDOM = document.createRange().createContextualFragment(newMarkup);
                var newElement = newDOM.querySelector(this._containterItem);
                var curHTML = containerElement.innerHTML;
                var newHTML = newElement.innerHTML;
                if (curHTML !== newHTML) containerElement.innerHTML = newHTML;
            }
        },
        {
            key: "sortDataByTimestamp",
            value: function sortDataByTimestamp(data) {
                return data.sort(function(a, b) {
                    return a.timestamp - b.timestamp;
                });
            }
        },
        {
            // getElementsByAttribute(attributeName, attributeValue) {
            //   const selector = `[data-${attributeName}="${attributeValue}"]`;
            //   return document.querySelectorAll(selector);
            // }
            key: "getElementsByAttribute",
            value: function getElementsByAttribute(attributeName, attributeValue, excludedClass) {
                var selector = "[data-".concat(attributeName, '="').concat(attributeValue, '"]:not(.').concat(excludedClass, ")");
                return document.querySelectorAll(selector);
            }
        },
        {
            key: "toggleMenuViews",
            value: function toggleMenuViews() {
                var _this = this;
                var self = this;
                this._listBtns.forEach(function(btn) {
                    btn.addEventListener("click", (function() {
                        var btnId = btn.id;
                        var elementsToShow;
                        if ([
                            "warning",
                            "danger",
                            "primary"
                        ].includes(btn.id)) elementsToShow = self.getElementsByAttribute("priority", btnId, "todo-task-trash");
                        else elementsToShow = document.querySelectorAll("." + btnId);
                        var elementsArray = Array.from(elementsToShow);
                        elementsArray.forEach(function(el) {
                            el.classList.add("fade-in");
                            el.style.display = "block";
                            setTimeout(function() {
                                el.classList.remove("fade-in");
                            }, 300);
                        });
                        var allElements = document.querySelectorAll("#ct > div");
                        allElements.forEach(function(el) {
                            if (!elementsArray.includes(el)) el.style.display = "none";
                        });
                        this._listBtns.forEach(function(btn) {
                            return btn.classList.remove("active");
                        });
                        btn.classList.add("active");
                    }).bind(_this));
                });
            }
        },
        {
            key: "validateInput",
            value: function validateInput(validationField, titleInput, descriptionInput) {
                var isValid = true;
                if (titleInput) {
                    var titleInputValue = titleInput.value;
                    if (titleInputValue === "") {
                        validationField[0].innerHTML = "Title Required";
                        validationField[0].style.display = "block";
                        isValid = false;
                    } else if (titleInputValue.length > this._titleMaxLength) {
                        validationField[0].innerHTML = "Max Length is ".concat(this._titleMaxLength.toString(), " characters");
                        validationField[0].style.display = "block";
                        isValid = false;
                    } else validationField[0].style.display = "none";
                }
                if (descriptionInput) {
                    var descriptionInputValue = this._isQuill ? this._quill.getText().trim() : descriptionInput.value;
                    if (descriptionInputValue === "") {
                        validationField[1].innerHTML = "Description Required";
                        validationField[1].style.display = "block";
                        isValid = false;
                    } else if (descriptionInputValue.length > this._descriptionMaxLength) {
                        validationField[1].innerHTML = "Max Length is ".concat(this._descriptionMaxLength.toString(), " characters");
                        validationField[1].style.display = "block";
                        isValid = false;
                    } else validationField[1].style.display = "none";
                }
                return isValid;
            }
        },
        {
            key: "openNoteModal",
            value: function openNoteModal(element, title, description) {
                this.openModal(element);
                title = document.querySelector("#n-title");
                title.setAttribute("maxlength", this._titleMaxLength.toString());
                description = document.querySelector("#n-description");
                description.setAttribute("maxlength", this._descriptionMaxLength.toString());
            }
        },
        {
            key: "_searchLists",
            value: function _searchLists(element) {
                document.querySelector(".input-search").addEventListener("keyup", function() {
                    var searchTerm = this.value.toLowerCase();
                    var todoItems = element;
                    todoItems.forEach(function(item) {
                        var itemText = item.textContent.toLowerCase();
                        if (itemText.includes(searchTerm)) item.style.display = "block";
                        else item.style.display = "none";
                    });
                });
            }
        },
        {
            key: "formatTime",
            value: function formatTime(timestamp) {
                var date = new Date(timestamp);
                var timeOptions = {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false
                };
                return new Intl.DateTimeFormat("en-US", timeOptions).format(date);
            }
        },
        {
            key: "relativeTime",
            value: function relativeTime(timestamp) {
                var now = new Date();
                var timeDifference = now - timestamp;
                var minutesDifference = Math.floor(timeDifference / 60000);
                var hoursDifference = Math.floor(timeDifference / 3600000);
                if (minutesDifference < 1) return "Just now";
                else if (minutesDifference < 60) return "".concat(minutesDifference, " minute").concat(minutesDifference > 1 ? "s" : "", " ago");
                else if (hoursDifference < 24) return "".concat(hoursDifference, " hour").concat(hoursDifference > 1 ? "s" : "", " ago");
                else return this.formatTime(timestamp);
            }
        }
    ]);
    return appView;
}();

});
parcelRegister("iFe8d", function(module, exports) {

$parcel$export(module.exports, "Notyf", function () { return $0381a95d2c185104$export$146ebdf5fc143718; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $0381a95d2c185104$var$__assign = function __assign1() {
    $0381a95d2c185104$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0381a95d2c185104$var$__assign.apply(this, arguments);
};
var $0381a95d2c185104$export$1efaef7de3802058 = /** @class */ function() {
    function NotyfNotification(options) {
        this.options = options;
        this.listeners = {};
    }
    NotyfNotification.prototype.on = function(eventType, cb) {
        var callbacks = this.listeners[eventType] || [];
        this.listeners[eventType] = callbacks.concat([
            cb
        ]);
    };
    NotyfNotification.prototype.triggerEvent = function(eventType, event) {
        var _this = this;
        var callbacks = this.listeners[eventType] || [];
        callbacks.forEach(function(cb) {
            return cb({
                target: _this,
                event: event
            });
        });
    };
    return NotyfNotification;
}();
var $0381a95d2c185104$export$2324fc501d2ffc65;
(function(NotyfArrayEvent) {
    NotyfArrayEvent[NotyfArrayEvent["Add"] = 0] = "Add";
    NotyfArrayEvent[NotyfArrayEvent["Remove"] = 1] = "Remove";
})($0381a95d2c185104$export$2324fc501d2ffc65 || ($0381a95d2c185104$export$2324fc501d2ffc65 = {}));
var $0381a95d2c185104$export$7763ebb8bf460cea = /** @class */ function() {
    function NotyfArray() {
        this.notifications = [];
    }
    NotyfArray.prototype.push = function(elem) {
        this.notifications.push(elem);
        this.updateFn(elem, $0381a95d2c185104$export$2324fc501d2ffc65.Add, this.notifications);
    };
    NotyfArray.prototype.splice = function(index, num) {
        var elem = this.notifications.splice(index, num)[0];
        this.updateFn(elem, $0381a95d2c185104$export$2324fc501d2ffc65.Remove, this.notifications);
        return elem;
    };
    NotyfArray.prototype.indexOf = function(elem) {
        return this.notifications.indexOf(elem);
    };
    NotyfArray.prototype.onUpdate = function(fn) {
        this.updateFn = fn;
    };
    return NotyfArray;
}();
var $0381a95d2c185104$export$776308576d349339;
(function(NotyfEvent) {
    NotyfEvent["Dismiss"] = "dismiss";
    NotyfEvent["Click"] = "click";
})($0381a95d2c185104$export$776308576d349339 || ($0381a95d2c185104$export$776308576d349339 = {}));
var $0381a95d2c185104$export$93ca5d3f8675ae4c = {
    types: [
        {
            type: "success",
            className: "notyf__toast--success",
            backgroundColor: "#3dc763",
            icon: {
                className: "notyf__icon--success",
                tagName: "i"
            }
        },
        {
            type: "error",
            className: "notyf__toast--error",
            backgroundColor: "#ed3d3d",
            icon: {
                className: "notyf__icon--error",
                tagName: "i"
            }
        }
    ],
    duration: 2000,
    ripple: true,
    position: {
        x: "right",
        y: "bottom"
    },
    dismissible: false
};
var $0381a95d2c185104$export$75d30b0f81ca0e5f = /** @class */ function() {
    function NotyfView() {
        this.notifications = [];
        this.events = {};
        this.X_POSITION_FLEX_MAP = {
            left: "flex-start",
            center: "center",
            right: "flex-end"
        };
        this.Y_POSITION_FLEX_MAP = {
            top: "flex-start",
            center: "center",
            bottom: "flex-end"
        };
        // Creates the main notifications container
        var docFrag = document.createDocumentFragment();
        var notyfContainer = this._createHTMLElement({
            tagName: "div",
            className: "notyf"
        });
        docFrag.appendChild(notyfContainer);
        document.body.appendChild(docFrag);
        this.container = notyfContainer;
        // Identifies the main animation end event
        this.animationEndEventName = this._getAnimationEndEventName();
        this._createA11yContainer();
    }
    NotyfView.prototype.on = function(event, cb) {
        var _a;
        this.events = $0381a95d2c185104$var$__assign($0381a95d2c185104$var$__assign({}, this.events), (_a = {}, _a[event] = cb, _a));
    };
    NotyfView.prototype.update = function(notification, type) {
        if (type === $0381a95d2c185104$export$2324fc501d2ffc65.Add) this.addNotification(notification);
        else if (type === $0381a95d2c185104$export$2324fc501d2ffc65.Remove) this.removeNotification(notification);
    };
    NotyfView.prototype.removeNotification = function(notification) {
        var _this = this;
        var renderedNotification = this._popRenderedNotification(notification);
        var node;
        if (!renderedNotification) return;
        node = renderedNotification.node;
        node.classList.add("notyf__toast--disappear");
        var handleEvent;
        node.addEventListener(this.animationEndEventName, handleEvent = function(event) {
            if (event.target === node) {
                node.removeEventListener(_this.animationEndEventName, handleEvent);
                _this.container.removeChild(node);
            }
        });
    };
    NotyfView.prototype.addNotification = function(notification) {
        var node = this._renderNotification(notification);
        this.notifications.push({
            notification: notification,
            node: node
        });
        // For a11y purposes, we still want to announce that there's a notification in the screen
        // even if it comes with no message.
        this._announce(notification.options.message || "Notification");
    };
    NotyfView.prototype._renderNotification = function(notification) {
        var _a;
        var card = this._buildNotificationCard(notification);
        var className = notification.options.className;
        if (className) (_a = card.classList).add.apply(_a, className.split(" "));
        this.container.appendChild(card);
        return card;
    };
    NotyfView.prototype._popRenderedNotification = function(notification) {
        var idx = -1;
        for(var i = 0; i < this.notifications.length && idx < 0; i++)if (this.notifications[i].notification === notification) idx = i;
        if (idx !== -1) return this.notifications.splice(idx, 1)[0];
        return;
    };
    NotyfView.prototype.getXPosition = function(options) {
        var _a;
        return ((_a = options === null || options === void 0 ? void 0 : options.position) === null || _a === void 0 ? void 0 : _a.x) || "right";
    };
    NotyfView.prototype.getYPosition = function(options) {
        var _a;
        return ((_a = options === null || options === void 0 ? void 0 : options.position) === null || _a === void 0 ? void 0 : _a.y) || "bottom";
    };
    NotyfView.prototype.adjustContainerAlignment = function(options) {
        var align = this.X_POSITION_FLEX_MAP[this.getXPosition(options)];
        var justify = this.Y_POSITION_FLEX_MAP[this.getYPosition(options)];
        var style = this.container.style;
        style.setProperty("justify-content", justify);
        style.setProperty("align-items", align);
    };
    NotyfView.prototype._buildNotificationCard = function(notification) {
        var _this = this;
        var options = notification.options;
        var iconOpts = options.icon;
        // Adjust container according to position (e.g. top-left, bottom-center, etc)
        this.adjustContainerAlignment(options);
        // Create elements
        var notificationElem = this._createHTMLElement({
            tagName: "div",
            className: "notyf__toast"
        });
        var ripple = this._createHTMLElement({
            tagName: "div",
            className: "notyf__ripple"
        });
        var wrapper = this._createHTMLElement({
            tagName: "div",
            className: "notyf__wrapper"
        });
        var message = this._createHTMLElement({
            tagName: "div",
            className: "notyf__message"
        });
        message.innerHTML = options.message || "";
        var mainColor = options.background || options.backgroundColor;
        // Build the icon and append it to the card
        if (iconOpts) {
            var iconContainer = this._createHTMLElement({
                tagName: "div",
                className: "notyf__icon"
            });
            if (typeof iconOpts === "string" || iconOpts instanceof String) iconContainer.innerHTML = new String(iconOpts).valueOf();
            if (typeof iconOpts === "object") {
                var _a = iconOpts.tagName, tagName = _a === void 0 ? "i" : _a, className_1 = iconOpts.className, text = iconOpts.text, _b = iconOpts.color, color = _b === void 0 ? mainColor : _b;
                var iconElement = this._createHTMLElement({
                    tagName: tagName,
                    className: className_1,
                    text: text
                });
                if (color) iconElement.style.color = color;
                iconContainer.appendChild(iconElement);
            }
            wrapper.appendChild(iconContainer);
        }
        wrapper.appendChild(message);
        notificationElem.appendChild(wrapper);
        // Add ripple if applicable, else just paint the full toast
        if (mainColor) {
            if (options.ripple) {
                ripple.style.background = mainColor;
                notificationElem.appendChild(ripple);
            } else notificationElem.style.background = mainColor;
        }
        // Add dismiss button
        if (options.dismissible) {
            var dismissWrapper = this._createHTMLElement({
                tagName: "div",
                className: "notyf__dismiss"
            });
            var dismissButton = this._createHTMLElement({
                tagName: "button",
                className: "notyf__dismiss-btn"
            });
            dismissWrapper.appendChild(dismissButton);
            wrapper.appendChild(dismissWrapper);
            notificationElem.classList.add("notyf__toast--dismissible");
            dismissButton.addEventListener("click", function(event) {
                var _a, _b;
                (_b = (_a = _this.events)[$0381a95d2c185104$export$776308576d349339.Dismiss]) === null || _b === void 0 || _b.call(_a, {
                    target: notification,
                    event: event
                });
                event.stopPropagation();
            });
        }
        notificationElem.addEventListener("click", function(event) {
            var _a, _b;
            return (_b = (_a = _this.events)[$0381a95d2c185104$export$776308576d349339.Click]) === null || _b === void 0 ? void 0 : _b.call(_a, {
                target: notification,
                event: event
            });
        });
        // Adjust margins depending on whether its an upper or lower notification
        var className = this.getYPosition(options) === "top" ? "upper" : "lower";
        notificationElem.classList.add("notyf__toast--" + className);
        return notificationElem;
    };
    NotyfView.prototype._createHTMLElement = function(_a) {
        var tagName = _a.tagName, className = _a.className, text = _a.text;
        var elem = document.createElement(tagName);
        if (className) elem.className = className;
        elem.textContent = text || null;
        return elem;
    };
    /**
     * Creates an invisible container which will announce the notyfs to
     * screen readers
     */ NotyfView.prototype._createA11yContainer = function() {
        var a11yContainer = this._createHTMLElement({
            tagName: "div",
            className: "notyf-announcer"
        });
        a11yContainer.setAttribute("aria-atomic", "true");
        a11yContainer.setAttribute("aria-live", "polite");
        // Set the a11y container to be visible hidden. Can't use display: none as
        // screen readers won't read it.
        a11yContainer.style.border = "0";
        a11yContainer.style.clip = "rect(0 0 0 0)";
        a11yContainer.style.height = "1px";
        a11yContainer.style.margin = "-1px";
        a11yContainer.style.overflow = "hidden";
        a11yContainer.style.padding = "0";
        a11yContainer.style.position = "absolute";
        a11yContainer.style.width = "1px";
        a11yContainer.style.outline = "0";
        document.body.appendChild(a11yContainer);
        this.a11yContainer = a11yContainer;
    };
    /**
     * Announces a message to screenreaders.
     */ NotyfView.prototype._announce = function(message) {
        var _this = this;
        this.a11yContainer.textContent = "";
        // This 100ms timeout is necessary for some browser + screen-reader combinations:
        // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
        // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
        //   second time without clearing and then using a non-zero delay.
        // (using JAWS 17 at time of this writing).
        // https://github.com/angular/material2/blob/master/src/cdk/a11y/live-announcer/live-announcer.ts
        setTimeout(function() {
            _this.a11yContainer.textContent = message;
        }, 100);
    };
    /**
     * Determine which animationend event is supported
     */ NotyfView.prototype._getAnimationEndEventName = function() {
        var el = document.createElement("_fake");
        var transitions = {
            MozTransition: "animationend",
            OTransition: "oAnimationEnd",
            WebkitTransition: "webkitAnimationEnd",
            transition: "animationend"
        };
        var t;
        for(t in transitions){
            if (el.style[t] !== undefined) return transitions[t];
        }
        // No supported animation end event. Using "animationend" as a fallback
        return "animationend";
    };
    return NotyfView;
}();
/**
 * Main controller class. Defines the main Notyf API.
 */ var $0381a95d2c185104$export$146ebdf5fc143718 = /** @class */ function() {
    function Notyf(opts) {
        var _this = this;
        this.dismiss = this._removeNotification;
        this.notifications = new $0381a95d2c185104$export$7763ebb8bf460cea();
        this.view = new $0381a95d2c185104$export$75d30b0f81ca0e5f();
        var types = this.registerTypes(opts);
        this.options = $0381a95d2c185104$var$__assign($0381a95d2c185104$var$__assign({}, $0381a95d2c185104$export$93ca5d3f8675ae4c), opts);
        this.options.types = types;
        this.notifications.onUpdate(function(elem, type) {
            return _this.view.update(elem, type);
        });
        this.view.on($0381a95d2c185104$export$776308576d349339.Dismiss, function(_a) {
            var target = _a.target, event = _a.event;
            _this._removeNotification(target);
            // tslint:disable-next-line: no-string-literal
            target["triggerEvent"]($0381a95d2c185104$export$776308576d349339.Dismiss, event);
        });
        // tslint:disable-next-line: no-string-literal
        this.view.on($0381a95d2c185104$export$776308576d349339.Click, function(_a) {
            var target = _a.target, event = _a.event;
            return target["triggerEvent"]($0381a95d2c185104$export$776308576d349339.Click, event);
        });
    }
    Notyf.prototype.error = function(payload) {
        var options = this.normalizeOptions("error", payload);
        return this.open(options);
    };
    Notyf.prototype.success = function(payload) {
        var options = this.normalizeOptions("success", payload);
        return this.open(options);
    };
    Notyf.prototype.open = function(options) {
        var defaultOpts = this.options.types.find(function(_a) {
            var type = _a.type;
            return type === options.type;
        }) || {};
        var config = $0381a95d2c185104$var$__assign($0381a95d2c185104$var$__assign({}, defaultOpts), options);
        this.assignProps([
            "ripple",
            "position",
            "dismissible"
        ], config);
        var notification = new $0381a95d2c185104$export$1efaef7de3802058(config);
        this._pushNotification(notification);
        return notification;
    };
    Notyf.prototype.dismissAll = function() {
        while(this.notifications.splice(0, 1));
    };
    /**
     * Assigns properties to a config object based on two rules:
     * 1. If the config object already sets that prop, leave it as so
     * 2. Otherwise, use the default prop from the global options
     *
     * It's intended to build the final config object to open a notification. e.g. if
     * 'dismissible' is not set, then use the value from the global config.
     *
     * @param props - properties to be assigned to the config object
     * @param config - object whose properties need to be set
     */ Notyf.prototype.assignProps = function(props, config) {
        var _this = this;
        props.forEach(function(prop) {
            // intentional double equality to check for both null and undefined
            config[prop] = config[prop] == null ? _this.options[prop] : config[prop];
        });
    };
    Notyf.prototype._pushNotification = function(notification) {
        var _this = this;
        this.notifications.push(notification);
        var duration = notification.options.duration !== undefined ? notification.options.duration : this.options.duration;
        if (duration) setTimeout(function() {
            return _this._removeNotification(notification);
        }, duration);
    };
    Notyf.prototype._removeNotification = function(notification) {
        var index = this.notifications.indexOf(notification);
        if (index !== -1) this.notifications.splice(index, 1);
    };
    Notyf.prototype.normalizeOptions = function(type, payload) {
        var options = {
            type: type
        };
        if (typeof payload === "string") options.message = payload;
        else if (typeof payload === "object") options = $0381a95d2c185104$var$__assign($0381a95d2c185104$var$__assign({}, options), payload);
        return options;
    };
    Notyf.prototype.registerTypes = function(opts) {
        var incomingTypes = (opts && opts.types || []).slice();
        var finalDefaultTypes = $0381a95d2c185104$export$93ca5d3f8675ae4c.types.map(function(defaultType) {
            // find if there's a default type within the user input's types, if so, it means the user
            // wants to change some of the default settings
            var userTypeIdx = -1;
            incomingTypes.forEach(function(t, idx) {
                if (t.type === defaultType.type) userTypeIdx = idx;
            });
            var userType = userTypeIdx !== -1 ? incomingTypes.splice(userTypeIdx, 1)[0] : {};
            return $0381a95d2c185104$var$__assign($0381a95d2c185104$var$__assign({}, defaultType), userType);
        });
        return finalDefaultTypes.concat(incomingTypes);
    };
    return Notyf;
}();

});

parcelRegister("4HRPq", function(module, exports) {

$parcel$export(module.exports, "INOTIFYOPTIONS", function () { return $36d4eec9b22e9454$export$3f56b780a80dcd80; });
$parcel$export(module.exports, "QUILLMINIMAL", function () { return $36d4eec9b22e9454$export$240e4485d72f5b4e; });
$parcel$export(module.exports, "NOTE_TITLE_LIMIT", function () { return $36d4eec9b22e9454$export$1be8c9395db43b9b; });
$parcel$export(module.exports, "NOTE_DESCRIPTION_LIMIT", function () { return $36d4eec9b22e9454$export$5301cce93579062b; });
$parcel$export(module.exports, "TODO_TITLE_LIMIT", function () { return $36d4eec9b22e9454$export$202853bc628c98c7; });
$parcel$export(module.exports, "NOTESUCESS", function () { return $36d4eec9b22e9454$export$c1280595736bf572; });
$parcel$export(module.exports, "TODOSUCESS", function () { return $36d4eec9b22e9454$export$40940b9c33388522; });
$parcel$export(module.exports, "EVENTSUCCESS", function () { return $36d4eec9b22e9454$export$4b22566567bbb5d6; });
$parcel$export(module.exports, "SUCCESSUPDATE", function () { return $36d4eec9b22e9454$export$e45321636a194a9a; });
$parcel$export(module.exports, "FAILEDMESSAGE", function () { return $36d4eec9b22e9454$export$36ffa4b10e71942a; });
$parcel$export(module.exports, "NOCOMPLETEDTASK", function () { return $36d4eec9b22e9454$export$c60c757a22837bdc; });
$parcel$export(module.exports, "NOIMPORTANTTASK", function () { return $36d4eec9b22e9454$export$1a7d56787008644b; });
$parcel$export(module.exports, "EMPTYTASK", function () { return $36d4eec9b22e9454$export$63af7a20c8ab639a; });
$parcel$export(module.exports, "ITEMSDELETED", function () { return $36d4eec9b22e9454$export$1bc4a4cdeb833492; });
$parcel$export(module.exports, "LISTDELETECONFIRM", function () { return $36d4eec9b22e9454$export$e38a12d391799cf0; });
var $36d4eec9b22e9454$export$3f56b780a80dcd80 = {
    duration: 3000,
    position: {
        x: "right",
        y: "top"
    }
};
var $36d4eec9b22e9454$export$9d68c9423d2aefec = [
    [
        "bold",
        "italic",
        "underline",
        "strike"
    ],
    [
        "blockquote",
        "code-block"
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        }
    ],
    [
        {
            list: "ordered"
        },
        {
            list: "bullet"
        }
    ],
    [
        {
            script: "sub"
        },
        {
            script: "super"
        }
    ],
    [
        {
            indent: "-1"
        },
        {
            indent: "+1"
        }
    ],
    [
        {
            direction: "rtl"
        }
    ],
    [
        {
            size: [
                "small",
                false,
                "large",
                "huge"
            ]
        }
    ],
    [
        {
            header: [
                1,
                2,
                3,
                4,
                5,
                6,
                false
            ]
        }
    ],
    [
        {
            font: []
        }
    ],
    [
        "clean"
    ]
];
var $36d4eec9b22e9454$export$240e4485d72f5b4e = [
    [
        {
            header: [
                1,
                2,
                false
            ]
        }
    ],
    [
        "bold",
        "italic",
        "underline"
    ],
    [
        {
            list: "ordered"
        },
        {
            list: "bullet"
        },
        {
            indent: "-1"
        },
        {
            indent: "+1"
        },
        "code-block"
    ]
];
var $36d4eec9b22e9454$export$f2512d20085329c2 = 100;
var $36d4eec9b22e9454$export$c159fa2f4b7f4c29 = 500;
var $36d4eec9b22e9454$export$1be8c9395db43b9b = 25;
var $36d4eec9b22e9454$export$5301cce93579062b = 100;
var $36d4eec9b22e9454$export$202853bc628c98c7 = 33;
var $36d4eec9b22e9454$export$ac93d7dce274932b = 100;
var $36d4eec9b22e9454$export$c1280595736bf572 = "Note was created successfully";
var $36d4eec9b22e9454$export$40940b9c33388522 = "Task was created successfully";
var $36d4eec9b22e9454$export$4b22566567bbb5d6 = "Event was created successfully";
var $36d4eec9b22e9454$export$e45321636a194a9a = "data updated successfully";
var $36d4eec9b22e9454$export$36ffa4b10e71942a = "Something went wrong";
var $36d4eec9b22e9454$export$c60c757a22837bdc = "No Completed Task Yet.";
var $36d4eec9b22e9454$export$1a7d56787008644b = "No Marked Important Task Yet.";
var $36d4eec9b22e9454$export$63af7a20c8ab639a = "Empty Tasks, Add a new Task!";
var $36d4eec9b22e9454$export$1bc4a4cdeb833492 = "Item(s) was deleted successfully";
var $36d4eec9b22e9454$export$e38a12d391799cf0 = "If you delete the list it will be gone forever. Are you sure you want to proceed?";

});


parcelRegister("gpGF7", function(module, exports) {

$parcel$export(module.exports, "addItemtoDatabase", function () { return $bf3012f26aea2752$export$82f40b3dcec5fdbf; });
$parcel$export(module.exports, "getAllItemsFromDatabase", function () { return $bf3012f26aea2752$export$32ed9b603c1c0fba; });
$parcel$export(module.exports, "deleteItemFromDatabase", function () { return $bf3012f26aea2752$export$93b0377360880ace; });
$parcel$export(module.exports, "deleteMultipleItemsFromDatabase", function () { return $bf3012f26aea2752$export$1d46c37b4dca7572; });
$parcel$export(module.exports, "getObjectStoreLength", function () { return $bf3012f26aea2752$export$f6d7fed6eef7925; });
$parcel$export(module.exports, "updateItemInDatabase", function () { return $bf3012f26aea2752$export$85414c0f46549544; });
$parcel$export(module.exports, "getItemValueFromDatabase", function () { return $bf3012f26aea2752$export$402fb77fcd6136b6; });

var $e2996 = parcelRequire("e2996");

var $gAasq = parcelRequire("gAasq");
var $bf3012f26aea2752$var$DatabaseManager = function() {
    var instance;
    function createInstance() {
        var dbName = "TaskFlow";
        var dbVersion = 1;
        return new Promise(function(resolve, reject) {
            var request = indexedDB.open(dbName, dbVersion);
            request.onupgradeneeded = function(event) {
                var db = event.target.result;
                createObjectStores(db);
            };
            request.onsuccess = function(event) {
                var db = event.target.result;
                resolve(db);
            };
            request.onerror = function(event) {
                reject(event.target.error);
            };
        });
    }
    function createObjectStores(db) {
        if (!db.objectStoreNames.contains("notes")) {
            var notesStore = db.createObjectStore("notes", {
                keyPath: "id"
            });
            notesStore.createIndex("id", "id", {
                unique: true
            });
            notesStore.createIndex("title", "title", {
                unique: false
            });
            notesStore.createIndex("description", "description", {
                unique: false
            });
            notesStore.createIndex("tag", "tag", {
                unique: false
            });
            notesStore.createIndex("favorited", "favorited", {
                unique: false
            });
            notesStore.createIndex("date", "date", {
                unique: false
            });
        }
        if (!db.objectStoreNames.contains("event")) {
            var eventStore = db.createObjectStore("event", {
                keyPath: "id"
            });
            eventStore.createIndex("id", "id", {
                unique: true
            });
            eventStore.createIndex("title", "title", {
                unique: false
            });
            eventStore.createIndex("start", "start", {
                unique: false
            });
            eventStore.createIndex("end", "end", {
                unique: false
            });
            eventStore.createIndex("extendedprops", "extendedprops", {
                unique: false
            });
            eventStore.createIndex("url", "url", {
                unique: false
            });
        }
        if (!db.objectStoreNames.contains("todo")) {
            var toDoStore = db.createObjectStore("todo", {
                keyPath: "id"
            });
            toDoStore.createIndex("id", "id", {
                unique: true
            });
            toDoStore.createIndex("title", "title", {
                unique: false
            });
            toDoStore.createIndex("description", "description", {
                unique: false
            });
            toDoStore.createIndex("priority", "priority", {
                unique: false
            });
            toDoStore.createIndex("important", "important", {
                unique: false
            });
            toDoStore.createIndex("completed", "completed", {
                unique: false
            });
            toDoStore.createIndex("trash", "trash", {
                unique: false
            });
            toDoStore.createIndex("date", "date", {
                unique: false
            });
        }
        if (!db.objectStoreNames.contains("scrumboard")) {
            var scrumStore = db.createObjectStore("scrumboard", {
                keyPath: "id"
            });
            scrumStore.createIndex("id", "id", {
                unique: true
            });
            scrumStore.createIndex("title", "title", {
                unique: false
            });
            scrumStore.createIndex("description", "description", {
                unique: false
            });
            scrumStore.createIndex("tasksection", "tasksection", {
                unique: false
            });
            scrumStore.createIndex("order", "order", {
                unique: false
            });
            scrumStore.createIndex("progress", "progress", {
                unique: false
            });
            scrumStore.createIndex("date", "date", {
                unique: false
            });
        }
        if (!db.objectStoreNames.contains("scrumlist")) {
            var scrumList = db.createObjectStore("scrumlist", {
                keyPath: "id"
            });
            var timestamp = new Date().getTime();
            scrumList.createIndex("id", "id", {
                unique: true
            });
            scrumList.createIndex("title", "title", {
                unique: false
            });
            scrumList.createIndex("order", "order", {
                unique: false
            });
            scrumList.createIndex("timestamp", "timestamp", {
                unique: false
            });
            var initialContainerOrders = [
                {
                    id: "s-new",
                    title: "New",
                    order: 0,
                    timestamp: timestamp
                },
                {
                    id: "s-in-progress",
                    title: "In Progress",
                    order: 1,
                    timestamp: timestamp
                },
                {
                    id: "s-complete",
                    title: "Complete",
                    order: 2,
                    timestamp: timestamp
                }
            ];
            initialContainerOrders.forEach(function(orderData) {
                scrumList.add(orderData);
            });
        }
    }
    return {
        getInstance: function getInstance() {
            if (!instance) instance = createInstance();
            return instance;
        }
    };
}();
var $bf3012f26aea2752$export$82f40b3dcec5fdbf = function() {
    var _ref = (0, $e2996._)(function(data, objectStoreName) {
        var db, transaction, objectStore, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!data.timestamp) data.timestamp = new Date().getTime();
                    else if (typeof data.timestamp === "string") data.timestamp = new Date(data.timestamp).getTime();
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readwrite");
                    objectStore = transaction.objectStore(objectStoreName);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            var request = objectStore.add(data);
                            request.onsuccess = function(event) {
                                resolve(data);
                            };
                            request.onerror = function(event) {
                                console.error("Error adding item:", event.target.error);
                                reject(event.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function addItemtoDatabase(data, objectStoreName) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$32ed9b603c1c0fba = function() {
    var _ref = (0, $e2996._)(function(objectStoreName, filterFunction) {
        var db, transaction, objectStore, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readonly");
                    objectStore = transaction.objectStore(objectStoreName);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            var items = [];
                            var request = objectStore.openCursor();
                            request.onsuccess = function(event) {
                                var cursor = event.target.result;
                                if (cursor) {
                                    // Check if filtering is enabled and filter by container if necessary
                                    if (!filterFunction || filterFunction(cursor.value)) items.push(cursor.value);
                                    cursor["continue"]();
                                } else resolve(items);
                            };
                            request.onerror = function(event) {
                                console.error("Error getting items:", event.target.error);
                                reject(event.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getAllItemsFromDatabase(objectStoreName, filterFunction) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$249f3d852e627de1 = function() {
    var _ref = (0, $e2996._)(function(id, objectStoreName) {
        var db, transaction, objectStore, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readonly");
                    objectStore = transaction.objectStore(objectStoreName);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            var request = objectStore.get(id);
                            request.onsuccess = function(event) {
                                var result = event.target.result;
                                resolve(result);
                            };
                            request.onerror = function(event) {
                                console.error("Error getting item:", event.target.error);
                                reject(event.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getItemFromDatabase(id, objectStoreName) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$93b0377360880ace = function() {
    var _ref = (0, $e2996._)(function(objectId, objectStoreName) {
        var db, transaction, objectStore, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readwrite");
                    objectStore = transaction.objectStore(objectStoreName);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            var request = objectStore["delete"](objectId);
                            request.onsuccess = function(e) {
                                resolve(true);
                            };
                            request.onerror = function(e) {
                                console.error("Error getting item:", e.target.error);
                                reject(e.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteItemFromDatabase(objectId, objectStoreName) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$1d46c37b4dca7572 = function() {
    var _ref = (0, $e2996._)(function(objectIds, objectStoreName) {
        var db, transaction, objectStore, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readwrite");
                    objectStore = transaction.objectStore(objectStoreName);
                    return [
                        2,
                        Promise.all(objectIds.map(function(objectId) {
                            return new Promise(function(resolve, reject) {
                                var request = objectStore["delete"](objectId);
                                request.onsuccess = function(e) {
                                    resolve(true);
                                };
                                request.onerror = function(e) {
                                    console.error("Error deleting item:", e.target.error);
                                    reject(e.target.error);
                                };
                            });
                        }))
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteMultipleItemsFromDatabase(objectIds, objectStoreName) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$f6d7fed6eef7925 = function() {
    var _ref = (0, $e2996._)(function(objectStoreName) {
        var db, transaction, objectStore, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readonly");
                    objectStore = transaction.objectStore(objectStoreName);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            var request = objectStore.openCursor();
                            var count = 0;
                            request.onsuccess = function(event) {
                                var cursor = event.target.result;
                                if (cursor) {
                                    count++;
                                    cursor["continue"]();
                                } else resolve(count);
                            };
                            request.onerror = function(event) {
                                console.error("Error counting items:", event.target.error);
                                reject(event.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getObjectStoreLength(objectStoreName) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$85414c0f46549544 = function() {
    var _ref = (0, $e2996._)(function(id, objectStoreName, newData) {
        var db, transaction, objectStore, request, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    newData.isEdited = true;
                    newData.timestamp = new Date().getTime();
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readwrite");
                    objectStore = transaction.objectStore(objectStoreName);
                    request = objectStore.get(id);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            request.onsuccess = function(event) {
                                var existingData = event.target.result;
                                var dataChanged = false;
                                for(var property in newData)if (newData.hasOwnProperty(property) && existingData[property] !== newData[property]) {
                                    existingData[property] = newData[property];
                                    // console.log(existingData[property]);
                                    dataChanged = true;
                                }
                                if (dataChanged) {
                                    var updateRequest = objectStore.put(existingData);
                                    updateRequest.onsuccess = function() {
                                        // console.log('Item updated successfully:', existingData);
                                        resolve(existingData);
                                    };
                                    updateRequest.onerror = function(event) {
                                        console.error("Error updating item:", event.target.error);
                                        reject(event.target.error);
                                    };
                                } else resolve(existingData);
                            };
                            request.onerror = function(event) {
                                console.error("Error getting item to update:", event.target.error);
                                reject(event.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function updateItemInDatabase(id, objectStoreName, newData) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$402fb77fcd6136b6 = function() {
    var _ref = (0, $e2996._)(function(id, property, objectStoreName) {
        var db, transaction, objectStore, request, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readonly");
                    objectStore = transaction.objectStore(objectStoreName);
                    request = objectStore.get(id);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            request.onsuccess = function(event) {
                                var existingData = event.target.result;
                                if (existingData && existingData.hasOwnProperty(property)) // console.log(existingData[property]);
                                resolve(existingData[property]);
                                else resolve(null);
                            };
                            request.onerror = function(event) {
                                console.error("Error getting item value:", event.target.error);
                                reject(event.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getItemValueFromDatabase(id, property, objectStoreName) {
        return _ref.apply(this, arguments);
    };
}(); //Delete Database
 // const dbName = 'TaskFlow';
 // const request = indexedDB.open(dbName);
 // request.onsuccess = function (event) {
 //   const db = event.target.result;
 //   db.close();
 //   deleteDatabase();
 // };
 // const deleteDatabase = function () {
 //   const dbName = 'TaskFlow';
 //   const request = indexedDB.deleteDatabase(dbName);
 //   request.onsuccess = function (event) {
 //     console.log('Database deleted successfully!');
 //   };
 //   request.onerror = function (event) {
 //     console.error('Error deleting database:', event.target.error);
 //   };
 // };
 // const dbName = 'TaskFlow';
 // const Dbversion = 1;
 // const storeNameToDelete = 'scrumboard';
 // const request = indexedDB.open(dbName, Dbversion);
 // request.onupgradeneeded = function (event) {
 //   const db = event.target.result;
 //   if (db.objectStoreNames.contains(storeNameToDelete)) {
 //     db.deleteObjectStore(storeNameToDelete);
 //   }
 // };
 // request.onsuccess = function (event) {
 //   console.log('Object store deleted successfully.');
 // };
 // request.onerror = function (event) {
 //   console.error('Error deleting object store:', event.target.error);
 // };

});


var $1K4o4 = parcelRequire("1K4o4");

var $e2996 = parcelRequire("e2996");

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $8EGc6 = parcelRequire("8EGc6");

var $dACZV = parcelRequire("dACZV");

var $jhb1H = parcelRequire("jhb1H");

var $gAasq = parcelRequire("gAasq");

var $1K4o4 = parcelRequire("1K4o4");

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $8EGc6 = parcelRequire("8EGc6");

var $eKxsN = parcelRequire("eKxsN");

var $8wb0B = parcelRequire("8wb0B");

var $dACZV = parcelRequire("dACZV");

var $5TLNx = parcelRequire("5TLNx");

var $5TJQB = parcelRequire("5TJQB");

var $jhb1H = parcelRequire("jhb1H");

var $c1gko = parcelRequire("c1gko");

var $kgSvt = parcelRequire("kgSvt");
parcelRequire("8p1MK");
var $e3844b7a193593a0$export$794e7bef9c0b12d9 = [];
var $e3844b7a193593a0$var$MINIMAL_RAW_EN_LOCALE = {
    code: "en",
    week: {
        dow: 0,
        doy: 4
    },
    direction: "ltr",
    buttonText: {
        prev: "prev",
        next: "next",
        prevYear: "prev year",
        nextYear: "next year",
        year: "year",
        today: "today",
        month: "month",
        week: "week",
        day: "day",
        list: "list"
    },
    weekText: "W",
    weekTextLong: "Week",
    closeHint: "Close",
    timeHint: "Time",
    eventHint: "Event",
    allDayText: "all-day",
    moreLinkText: "more",
    noEventsText: "No events to display"
};
var $e3844b7a193593a0$var$RAW_EN_LOCALE = Object.assign(Object.assign({}, $e3844b7a193593a0$var$MINIMAL_RAW_EN_LOCALE), {
    // Includes things we don't want other locales to inherit,
    // things that derive from other translatable strings.
    buttonHints: {
        prev: "Previous $0",
        next: "Next $0",
        today: function(buttonText, unit) {
            return unit === "day" ? "Today" : "This ".concat(buttonText);
        }
    },
    viewHint: "$0 view",
    navLinkHint: "Go to $0",
    moreLinkHint: function(eventCnt) {
        return "Show ".concat(eventCnt, " more event").concat(eventCnt === 1 ? "" : "s");
    }
});
function $e3844b7a193593a0$var$organizeRawLocales(explicitRawLocales) {
    var defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : "en";
    var allRawLocales = $e3844b7a193593a0$export$794e7bef9c0b12d9.concat(explicitRawLocales);
    var rawLocaleMap = {
        en: $e3844b7a193593a0$var$RAW_EN_LOCALE
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = allRawLocales[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rawLocale = _step.value;
            rawLocaleMap[rawLocale.code] = rawLocale;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        map: rawLocaleMap,
        defaultCode: defaultCode
    };
}
function $e3844b7a193593a0$var$buildLocale(inputSingular, available) {
    if (typeof inputSingular === "object" && !Array.isArray(inputSingular)) return $e3844b7a193593a0$var$parseLocale(inputSingular.code, [
        inputSingular.code
    ], inputSingular);
    return $e3844b7a193593a0$var$queryLocale(inputSingular, available);
}
function $e3844b7a193593a0$var$queryLocale(codeArg, available) {
    var codes = [].concat(codeArg || []); // will convert to array
    var raw = $e3844b7a193593a0$var$queryRawLocale(codes, available) || $e3844b7a193593a0$var$RAW_EN_LOCALE;
    return $e3844b7a193593a0$var$parseLocale(codeArg, codes, raw);
}
function $e3844b7a193593a0$var$queryRawLocale(codes, available) {
    for(var i = 0; i < codes.length; i += 1){
        var parts = codes[i].toLocaleLowerCase().split("-");
        for(var j = parts.length; j > 0; j -= 1){
            var simpleId = parts.slice(0, j).join("-");
            if (available[simpleId]) return available[simpleId];
        }
    }
    return null;
}
function $e3844b7a193593a0$var$parseLocale(codeArg, codes, raw) {
    var merged = (0, $c1gko.m)([
        $e3844b7a193593a0$var$MINIMAL_RAW_EN_LOCALE,
        raw
    ], [
        "buttonText"
    ]);
    delete merged.code; // don't want this part of the options
    var week = merged.week;
    delete merged.week;
    return {
        codeArg: codeArg,
        codes: codes,
        week: week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged
    };
}
// TODO: easier way to add new hooks? need to update a million things
function $e3844b7a193593a0$export$ae829ec7b2625219(input) {
    return {
        id: (0, $c1gko.g)(),
        name: input.name,
        premiumReleaseDate: input.premiumReleaseDate ? new Date(input.premiumReleaseDate) : undefined,
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || "",
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {}
    };
}
function $e3844b7a193593a0$var$buildPluginHooks(pluginDefs, globalDefs) {
    var currentPluginIds = {};
    var hooks = {
        premiumReleaseDate: undefined,
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: "",
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {}
    };
    function addDefs(defs) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = defs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var def = _step.value;
                var pluginName = def.name;
                var currentId = currentPluginIds[pluginName];
                if (currentId === undefined) {
                    currentPluginIds[pluginName] = def.id;
                    addDefs(def.deps);
                    hooks = $e3844b7a193593a0$var$combineHooks(hooks, def);
                } else if (currentId !== def.id) // different ID than the one already added
                console.warn("Duplicate plugin '".concat(pluginName, "'"));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (pluginDefs) addDefs(pluginDefs);
    addDefs(globalDefs);
    return hooks;
}
function $e3844b7a193593a0$var$buildBuildPluginHooks() {
    var currentOverrideDefs = [];
    var currentGlobalDefs = [];
    var currentHooks;
    return function(overrideDefs, globalDefs) {
        if (!currentHooks || !(0, $c1gko.i)(overrideDefs, currentOverrideDefs) || !(0, $c1gko.i)(globalDefs, currentGlobalDefs)) currentHooks = $e3844b7a193593a0$var$buildPluginHooks(overrideDefs, globalDefs);
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function $e3844b7a193593a0$var$combineHooks(hooks0, hooks1) {
    return {
        premiumReleaseDate: $e3844b7a193593a0$var$compareOptionalDates(hooks0.premiumReleaseDate, hooks1.premiumReleaseDate),
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: Object.assign(Object.assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: Object.assign(Object.assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: Object.assign(Object.assign({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: Object.assign(Object.assign({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: Object.assign(Object.assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        listenerRefiners: Object.assign(Object.assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: Object.assign(Object.assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: Object.assign(Object.assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers)
    };
}
function $e3844b7a193593a0$var$compareOptionalDates(date0, date1) {
    if (date0 === undefined) return date1;
    if (date1 === undefined) return date0;
    return new Date(Math.max(date0.valueOf(), date1.valueOf()));
}
var $e3844b7a193593a0$var$StandardTheme = /*#__PURE__*/ function(Theme) {
    "use strict";
    (0, $dACZV._)(StandardTheme, Theme);
    var _super = (0, $jhb1H._)(StandardTheme);
    function StandardTheme() {
        (0, $5kWiG._)(this, StandardTheme);
        return _super.apply(this, arguments);
    }
    return StandardTheme;
}((0, $c1gko.T));
$e3844b7a193593a0$var$StandardTheme.prototype.classes = {
    root: "fc-theme-standard",
    tableCellShaded: "fc-cell-shaded",
    buttonGroup: "fc-button-group",
    button: "fc-button fc-button-primary",
    buttonActive: "fc-button-active"
};
$e3844b7a193593a0$var$StandardTheme.prototype.baseIconClass = "fc-icon";
$e3844b7a193593a0$var$StandardTheme.prototype.iconClasses = {
    close: "fc-icon-x",
    prev: "fc-icon-chevron-left",
    next: "fc-icon-chevron-right",
    prevYear: "fc-icon-chevrons-left",
    nextYear: "fc-icon-chevrons-right"
};
$e3844b7a193593a0$var$StandardTheme.prototype.rtlIconClasses = {
    prev: "fc-icon-chevron-right",
    next: "fc-icon-chevron-left",
    prevYear: "fc-icon-chevrons-right",
    nextYear: "fc-icon-chevrons-left"
};
$e3844b7a193593a0$var$StandardTheme.prototype.iconOverrideOption = "buttonIcons"; // TODO: make TS-friendly
$e3844b7a193593a0$var$StandardTheme.prototype.iconOverrideCustomButtonOption = "icon";
$e3844b7a193593a0$var$StandardTheme.prototype.iconOverridePrefix = "fc-icon-";
function $e3844b7a193593a0$var$compileViewDefs(defaultConfigs, overrideConfigs) {
    var hash = {};
    var viewType;
    for(viewType in defaultConfigs)$e3844b7a193593a0$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    for(viewType in overrideConfigs)$e3844b7a193593a0$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    return hash;
}
function $e3844b7a193593a0$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) return hash[viewType];
    var viewDef = $e3844b7a193593a0$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) hash[viewType] = viewDef;
    return viewDef;
}
function $e3844b7a193593a0$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    var defaultConfig = defaultConfigs[viewType];
    var overrideConfig = overrideConfigs[viewType];
    var queryProp = function(name) {
        return defaultConfig && defaultConfig[name] !== null ? defaultConfig[name] : overrideConfig && overrideConfig[name] !== null ? overrideConfig[name] : null;
    };
    var theComponent = queryProp("component");
    var superType = queryProp("superType");
    var superDef = null;
    if (superType) {
        if (superType === viewType) throw new Error("Can't have a custom view type that references itself");
        superDef = $e3844b7a193593a0$var$ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) theComponent = superDef.component;
    if (!theComponent) return null; // don't throw a warning, might be settings for a single-unit view
    return {
        type: viewType,
        component: theComponent,
        defaults: Object.assign(Object.assign({}, superDef ? superDef.defaults : {}), defaultConfig ? defaultConfig.rawOptions : {}),
        overrides: Object.assign(Object.assign({}, superDef ? superDef.overrides : {}), overrideConfig ? overrideConfig.rawOptions : {})
    };
}
function $e3844b7a193593a0$var$parseViewConfigs(inputs) {
    return (0, $c1gko.a)(inputs, $e3844b7a193593a0$var$parseViewConfig);
}
function $e3844b7a193593a0$var$parseViewConfig(input) {
    var rawOptions = typeof input === "function" ? {
        component: input
    } : input;
    var component = rawOptions.component;
    if (rawOptions.content) // TODO: remove content/classNames/didMount/etc from options?
    component = $e3844b7a193593a0$var$createViewHookComponent(rawOptions);
    else if (component && !(component.prototype instanceof (0, $c1gko.B))) // WHY?: people were using `component` property for `content`
    // TODO: converge on one setting name
    component = $e3844b7a193593a0$var$createViewHookComponent(Object.assign(Object.assign({}, rawOptions), {
        content: component
    }));
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions: rawOptions
    };
}
function $e3844b7a193593a0$var$createViewHookComponent(options) {
    return function(viewProps) {
        return (0, $kgSvt.createElement)((0, $c1gko.V).Consumer, null, function(context) {
            return (0, $kgSvt.createElement)((0, $c1gko.C), {
                elTag: "div",
                elClasses: (0, $c1gko.b)(context.viewSpec),
                renderProps: Object.assign(Object.assign({}, viewProps), {
                    nextDayThreshold: context.options.nextDayThreshold
                }),
                generatorName: undefined,
                customGenerator: options.content,
                classNameGenerator: options.classNames,
                didMount: options.didMount,
                willUnmount: options.willUnmount
            });
        });
    };
}
function $e3844b7a193593a0$var$buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    var defaultConfigs = $e3844b7a193593a0$var$parseViewConfigs(defaultInputs);
    var overrideConfigs = $e3844b7a193593a0$var$parseViewConfigs(optionOverrides.views);
    var viewDefs = $e3844b7a193593a0$var$compileViewDefs(defaultConfigs, overrideConfigs);
    return (0, $c1gko.a)(viewDefs, function(viewDef) {
        return $e3844b7a193593a0$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults);
    });
}
function $e3844b7a193593a0$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    var durationInput = viewDef.overrides.duration || viewDef.defaults.duration || dynamicOptionOverrides.duration || optionOverrides.duration;
    var duration = null;
    var durationUnit = "";
    var singleUnit = "";
    var singleUnitOverrides = {};
    if (durationInput) {
        duration = $e3844b7a193593a0$var$createDurationCached(durationInput);
        if (duration) {
            var denom = (0, $c1gko.c)(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    var queryButtonText = function(optionsSubset) {
        var buttonTextMap = optionsSubset.buttonText || {};
        var buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) return buttonTextMap[buttonTextKey];
        if (buttonTextMap[viewDef.type] != null) return buttonTextMap[viewDef.type];
        if (buttonTextMap[singleUnit] != null) return buttonTextMap[singleUnit];
        return null;
    };
    var queryButtonTitle = function(optionsSubset) {
        var buttonHints = optionsSubset.buttonHints || {};
        var buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
        if (buttonKey != null && buttonHints[buttonKey] != null) return buttonHints[buttonKey];
        if (buttonHints[viewDef.type] != null) return buttonHints[viewDef.type];
        if (buttonHints[singleUnit] != null) return buttonHints[singleUnit];
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration: duration,
        durationUnit: durationUnit,
        singleUnit: singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: Object.assign(Object.assign({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) || queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
        viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) || viewDef.defaults.buttonText || queryButtonText((0, $c1gko.e)) || viewDef.type,
        // not DRY
        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) || queryButtonTitle(optionOverrides) || viewDef.overrides.buttonHint,
        buttonTitleDefault: queryButtonTitle(localeDefaults) || viewDef.defaults.buttonHint || queryButtonTitle((0, $c1gko.e))
    };
}
// hack to get memoization working
var $e3844b7a193593a0$var$durationInputMap = {};
function $e3844b7a193593a0$var$createDurationCached(durationInput) {
    var json = JSON.stringify(durationInput);
    var res = $e3844b7a193593a0$var$durationInputMap[json];
    if (res === undefined) {
        res = (0, $c1gko.d)(durationInput);
        $e3844b7a193593a0$var$durationInputMap[json] = res;
    }
    return res;
}
function $e3844b7a193593a0$var$reduceViewType(viewType, action) {
    switch(action.type){
        case "CHANGE_VIEW_TYPE":
            viewType = action.viewType;
    }
    return viewType;
}
function $e3844b7a193593a0$var$reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    switch(action.type){
        case "SET_OPTION":
            return Object.assign(Object.assign({}, dynamicOptionOverrides), (0, $8EGc6._)({}, action.optionName, action.rawOptionValue));
        default:
            return dynamicOptionOverrides;
    }
}
function $e3844b7a193593a0$var$reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    var dp;
    switch(action.type){
        case "CHANGE_VIEW_TYPE":
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case "CHANGE_DATE":
            return dateProfileGenerator.build(action.dateMarker);
        case "PREV":
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
        case "NEXT":
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
    }
    return currentDateProfile;
}
function $e3844b7a193593a0$var$initEventSources(calendarOptions, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null;
    return $e3844b7a193593a0$var$addSources({}, $e3844b7a193593a0$var$parseInitialSources(calendarOptions, context), activeRange, context);
}
function $e3844b7a193593a0$var$reduceEventSources(eventSources, action, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch(action.type){
        case "ADD_EVENT_SOURCES":
            return $e3844b7a193593a0$var$addSources(eventSources, action.sources, activeRange, context);
        case "REMOVE_EVENT_SOURCE":
            return $e3844b7a193593a0$var$removeSource(eventSources, action.sourceId);
        case "PREV":
        case "NEXT":
        case "CHANGE_DATE":
        case "CHANGE_VIEW_TYPE":
            if (dateProfile) return $e3844b7a193593a0$var$fetchDirtySources(eventSources, activeRange, context);
            return eventSources;
        case "FETCH_EVENT_SOURCES":
            return $e3844b7a193593a0$var$fetchSourcesByIds(eventSources, action.sourceIds ? (0, $c1gko.f)(action.sourceIds) : $e3844b7a193593a0$var$excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case "RECEIVE_EVENTS":
        case "RECEIVE_EVENT_ERROR":
            return $e3844b7a193593a0$var$receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case "REMOVE_ALL_EVENT_SOURCES":
            return {};
        default:
            return eventSources;
    }
}
function $e3844b7a193593a0$var$reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return $e3844b7a193593a0$var$fetchSourcesByIds(eventSources, $e3844b7a193593a0$var$excludeStaticSources(eventSources, context), activeRange, true, context);
}
function $e3844b7a193593a0$var$computeEventSourcesLoading(eventSources) {
    for(var sourceId in eventSources){
        if (eventSources[sourceId].isFetching) return true;
    }
    return false;
}
function $e3844b7a193593a0$var$addSources(eventSourceHash, sources, fetchRange, context) {
    var hash = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var source = _step.value;
            hash[source.sourceId] = source;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (fetchRange) hash = $e3844b7a193593a0$var$fetchDirtySources(hash, fetchRange, context);
    return Object.assign(Object.assign({}, eventSourceHash), hash);
}
function $e3844b7a193593a0$var$removeSource(eventSourceHash, sourceId) {
    return (0, $c1gko.h)(eventSourceHash, function(eventSource) {
        return eventSource.sourceId !== sourceId;
    });
}
function $e3844b7a193593a0$var$fetchDirtySources(sourceHash, fetchRange, context) {
    return $e3844b7a193593a0$var$fetchSourcesByIds(sourceHash, (0, $c1gko.h)(sourceHash, function(eventSource) {
        return $e3844b7a193593a0$var$isSourceDirty(eventSource, fetchRange, context);
    }), fetchRange, false, context);
}
function $e3844b7a193593a0$var$isSourceDirty(eventSource, fetchRange, context) {
    if (!$e3844b7a193593a0$var$doesSourceNeedRange(eventSource, context)) return !eventSource.latestFetchId;
    return !context.options.lazyFetching || !eventSource.fetchRange || eventSource.isFetching || // always cancel outdated in-progress fetches
    fetchRange.start < eventSource.fetchRange.start || fetchRange.end > eventSource.fetchRange.end;
}
function $e3844b7a193593a0$var$fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    var nextSources = {};
    for(var sourceId in prevSources){
        var source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) nextSources[sourceId] = $e3844b7a193593a0$var$fetchSource(source, fetchRange, isRefetch, context);
        else nextSources[sourceId] = source;
    }
    return nextSources;
}
function $e3844b7a193593a0$var$fetchSource(eventSource, fetchRange, isRefetch, context) {
    var options = context.options, calendarApi = context.calendarApi;
    var sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    var fetchId = (0, $c1gko.g)();
    sourceDef.fetch({
        eventSource: eventSource,
        range: fetchRange,
        isRefetch: isRefetch,
        context: context
    }, function(res) {
        var rawEvents = res.rawEvents;
        if (options.eventSourceSuccess) rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.response) || rawEvents;
        if (eventSource.success) rawEvents = eventSource.success.call(calendarApi, rawEvents, res.response) || rawEvents;
        context.dispatch({
            type: "RECEIVE_EVENTS",
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawEvents: rawEvents
        });
    }, function(error) {
        var errorHandled = false;
        if (options.eventSourceFailure) {
            options.eventSourceFailure.call(calendarApi, error);
            errorHandled = true;
        }
        if (eventSource.failure) {
            eventSource.failure(error);
            errorHandled = true;
        }
        if (!errorHandled) console.warn(error.message, error);
        context.dispatch({
            type: "RECEIVE_EVENT_ERROR",
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error
        });
    });
    return Object.assign(Object.assign({}, eventSource), {
        isFetching: true,
        latestFetchId: fetchId
    });
}
function $e3844b7a193593a0$var$receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    var eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId) return Object.assign(Object.assign({}, sourceHash), (0, $8EGc6._)({}, sourceId, Object.assign(Object.assign({}, eventSource), {
        isFetching: false,
        fetchRange: fetchRange
    })));
    return sourceHash;
}
function $e3844b7a193593a0$var$excludeStaticSources(eventSources, context) {
    return (0, $c1gko.h)(eventSources, function(eventSource) {
        return $e3844b7a193593a0$var$doesSourceNeedRange(eventSource, context);
    });
}
function $e3844b7a193593a0$var$parseInitialSources(rawOptions, context) {
    var refiners = (0, $c1gko.j)(context);
    var rawSources = [].concat(rawOptions.eventSources || []);
    var sources = []; // parsed
    if (rawOptions.initialEvents) rawSources.unshift(rawOptions.initialEvents);
    if (rawOptions.events) rawSources.unshift(rawOptions.events);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rawSources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rawSource = _step.value;
            var source = (0, $c1gko.p)(rawSource, context, refiners);
            if (source) sources.push(source);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return sources;
}
function $e3844b7a193593a0$var$doesSourceNeedRange(eventSource, context) {
    var defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}
function $e3844b7a193593a0$var$reduceDateSelection(currentSelection, action) {
    switch(action.type){
        case "UNSELECT_DATES":
            return null;
        case "SELECT_DATES":
            return action.selection;
        default:
            return currentSelection;
    }
}
function $e3844b7a193593a0$var$reduceSelectedEvent(currentInstanceId, action) {
    switch(action.type){
        case "UNSELECT_EVENT":
            return "";
        case "SELECT_EVENT":
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}
function $e3844b7a193593a0$var$reduceEventDrag(currentDrag, action) {
    var newDrag;
    switch(action.type){
        case "UNSET_EVENT_DRAG":
            return null;
        case "SET_EVENT_DRAG":
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent
            };
        default:
            return currentDrag;
    }
}
function $e3844b7a193593a0$var$reduceEventResize(currentResize, action) {
    var newResize;
    switch(action.type){
        case "UNSET_EVENT_RESIZE":
            return null;
        case "SET_EVENT_RESIZE":
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent
            };
        default:
            return currentResize;
    }
}
function $e3844b7a193593a0$var$parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var header = calendarOptions.headerToolbar ? $e3844b7a193593a0$var$parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    var footer = calendarOptions.footerToolbar ? $e3844b7a193593a0$var$parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    return {
        header: header,
        footer: footer
    };
}
function $e3844b7a193593a0$var$parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var sectionWidgets = {};
    var viewsWithButtons = [];
    var hasTitle = false;
    for(var sectionName in sectionStrHash){
        var _viewsWithButtons;
        var sectionStr = sectionStrHash[sectionName];
        var sectionRes = $e3844b7a193593a0$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
        sectionWidgets[sectionName] = sectionRes.widgets;
        (_viewsWithButtons = viewsWithButtons).push.apply(_viewsWithButtons, (0, $5TJQB._)(sectionRes.viewsWithButtons));
        hasTitle = hasTitle || sectionRes.hasTitle;
    }
    return {
        sectionWidgets: sectionWidgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
/*
BAD: querying icons and text here. should be done at render time
*/ function $e3844b7a193593a0$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var isRtl = calendarOptions.direction === "rtl";
    var calendarCustomButtons = calendarOptions.customButtons || {};
    var calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    var calendarButtonText = calendarOptions.buttonText || {};
    var calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
    var calendarButtonHints = calendarOptions.buttonHints || {};
    var sectionSubstrs = sectionStr ? sectionStr.split(" ") : [];
    var viewsWithButtons = [];
    var hasTitle = false;
    var widgets = sectionSubstrs.map(function(buttonGroupStr) {
        return buttonGroupStr.split(",").map(function(buttonName) {
            if (buttonName === "title") {
                hasTitle = true;
                return {
                    buttonName: buttonName
                };
            }
            var customButtonProps;
            var viewSpec;
            var buttonClick;
            var buttonIcon; // only one of these will be set
            var buttonText; // "
            var buttonHint;
            // ^ for the title="" attribute, for accessibility
            if (customButtonProps = calendarCustomButtons[buttonName]) {
                buttonClick = function(ev) {
                    if (customButtonProps.click) customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                };
                (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = customButtonProps.text);
                buttonHint = customButtonProps.hint || customButtonProps.text;
            } else if (viewSpec = viewSpecs[buttonName]) {
                viewsWithButtons.push(buttonName);
                buttonClick = function() {
                    calendarApi.changeView(buttonName);
                };
                (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = viewSpec.buttonTextDefault);
                var textFallback = viewSpec.buttonTextOverride || viewSpec.buttonTextDefault;
                buttonHint = (0, $c1gko.k)(viewSpec.buttonTitleOverride || viewSpec.buttonTitleDefault || calendarOptions.viewHint, [
                    textFallback,
                    buttonName
                ], textFallback);
            } else if (calendarApi[buttonName]) {
                buttonClick = function() {
                    calendarApi[buttonName]();
                };
                (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = calendarButtonText[buttonName]); // everything else is considered default
                if (buttonName === "prevYear" || buttonName === "nextYear") {
                    var prevOrNext = buttonName === "prevYear" ? "prev" : "next";
                    buttonHint = (0, $c1gko.k)(calendarButtonHintOverrides[prevOrNext] || calendarButtonHints[prevOrNext], [
                        calendarButtonText.year || "year",
                        "year"
                    ], calendarButtonText[buttonName]);
                } else buttonHint = function(navUnit) {
                    return (0, $c1gko.k)(calendarButtonHintOverrides[buttonName] || calendarButtonHints[buttonName], [
                        calendarButtonText[navUnit] || navUnit,
                        navUnit
                    ], calendarButtonText[buttonName]);
                };
            }
            return {
                buttonName: buttonName,
                buttonClick: buttonClick,
                buttonIcon: buttonIcon,
                buttonText: buttonText,
                buttonHint: buttonHint
            };
        });
    });
    return {
        widgets: widgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
// always represents the current view. otherwise, it'd need to change value every time date changes
var $e3844b7a193593a0$var$ViewImpl = /*#__PURE__*/ function() {
    "use strict";
    function ViewImpl(type, getCurrentData, dateEnv) {
        (0, $5kWiG._)(this, ViewImpl);
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
    (0, $hHaEF._)(ViewImpl, [
        {
            key: "calendar",
            get: function get() {
                return this.getCurrentData().calendarApi;
            }
        },
        {
            key: "title",
            get: function get() {
                return this.getCurrentData().viewTitle;
            }
        },
        {
            key: "activeStart",
            get: function get() {
                return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
            }
        },
        {
            key: "activeEnd",
            get: function get() {
                return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
            }
        },
        {
            key: "currentStart",
            get: function get() {
                return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
            }
        },
        {
            key: "currentEnd",
            get: function get() {
                return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
            }
        },
        {
            key: "getOption",
            value: function getOption(name) {
                return this.getCurrentData().options[name]; // are the view-specific options
            }
        }
    ]);
    return ViewImpl;
}();
var $e3844b7a193593a0$var$eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta: function(refined) {
        if (Array.isArray(refined.events)) return refined.events;
        return null;
    },
    fetch: function(arg, successCallback) {
        successCallback({
            rawEvents: arg.eventSource.meta
        });
    }
};
var $e3844b7a193593a0$var$arrayEventSourcePlugin = $e3844b7a193593a0$export$ae829ec7b2625219({
    name: "array-event-source",
    eventSourceDefs: [
        $e3844b7a193593a0$var$eventSourceDef$2
    ]
});
var $e3844b7a193593a0$var$eventSourceDef$1 = {
    parseMeta: function(refined) {
        if (typeof refined.events === "function") return refined.events;
        return null;
    },
    fetch: function(arg, successCallback, errorCallback) {
        var dateEnv = arg.context.dateEnv;
        var func = arg.eventSource.meta;
        (0, $c1gko.u)(func.bind(null, (0, $c1gko.l)(arg.range, dateEnv)), function(rawEvents) {
            return successCallback({
                rawEvents: rawEvents
            });
        }, errorCallback);
    }
};
var $e3844b7a193593a0$var$funcEventSourcePlugin = $e3844b7a193593a0$export$ae829ec7b2625219({
    name: "func-event-source",
    eventSourceDefs: [
        $e3844b7a193593a0$var$eventSourceDef$1
    ]
});
var $e3844b7a193593a0$var$JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: (0, $c1gko.n),
    startParam: String,
    endParam: String,
    timeZoneParam: String
};
var $e3844b7a193593a0$var$eventSourceDef = {
    parseMeta: function(refined) {
        if (refined.url && (refined.format === "json" || !refined.format)) return {
            url: refined.url,
            format: "json",
            method: (refined.method || "GET").toUpperCase(),
            extraParams: refined.extraParams,
            startParam: refined.startParam,
            endParam: refined.endParam,
            timeZoneParam: refined.timeZoneParam
        };
        return null;
    },
    fetch: function(arg, successCallback, errorCallback) {
        var meta = arg.eventSource.meta;
        var requestParams = $e3844b7a193593a0$var$buildRequestParams(meta, arg.range, arg.context);
        (0, $c1gko.r)(meta.method, meta.url, requestParams).then(function(param) {
            var _param = (0, $5TLNx._)(param, 2), rawEvents = _param[0], response = _param[1];
            successCallback({
                rawEvents: rawEvents,
                response: response
            });
        }, errorCallback);
    }
};
var $e3844b7a193593a0$var$jsonFeedEventSourcePlugin = $e3844b7a193593a0$export$ae829ec7b2625219({
    name: "json-event-source",
    eventSourceRefiners: $e3844b7a193593a0$var$JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [
        $e3844b7a193593a0$var$eventSourceDef
    ]
});
function $e3844b7a193593a0$var$buildRequestParams(meta, range, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var startParam;
    var endParam;
    var timeZoneParam;
    var customRequestParams;
    var params = {};
    startParam = meta.startParam;
    if (startParam == null) startParam = options.startParam;
    endParam = meta.endParam;
    if (endParam == null) endParam = options.endParam;
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) timeZoneParam = options.timeZoneParam;
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === "function") // supplied as a function that returns a key/value object
    customRequestParams = meta.extraParams();
    else // probably supplied as a straight key/value object
    customRequestParams = meta.extraParams || {};
    Object.assign(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== "local") params[timeZoneParam] = dateEnv.timeZone;
    return params;
}
var $e3844b7a193593a0$var$SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: (0, $c1gko.n),
    startTime: (0, $c1gko.d),
    endTime: (0, $c1gko.d),
    duration: (0, $c1gko.d),
    startRecur: (0, $c1gko.n),
    endRecur: (0, $c1gko.n)
};
var $e3844b7a193593a0$var$recurring = {
    parse: function(refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            var recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null
            };
            var duration;
            if (refined.duration) duration = refined.duration;
            if (!duration && refined.startTime && refined.endTime) duration = (0, $c1gko.s)(refined.endTime, refined.startTime);
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration: duration,
                typeData: recurringData
            };
        }
        return null;
    },
    expand: function(typeData, framingRange, dateEnv) {
        var clippedFramingRange = (0, $c1gko.o)(framingRange, {
            start: typeData.startRecur,
            end: typeData.endRecur
        });
        if (clippedFramingRange) return $e3844b7a193593a0$var$expandRanges(typeData.daysOfWeek, typeData.startTime, clippedFramingRange, dateEnv);
        return [];
    }
};
var $e3844b7a193593a0$var$simpleRecurringEventsPlugin = $e3844b7a193593a0$export$ae829ec7b2625219({
    name: "simple-recurring-event",
    recurringTypes: [
        $e3844b7a193593a0$var$recurring
    ],
    eventRefiners: $e3844b7a193593a0$var$SIMPLE_RECURRING_REFINERS
});
function $e3844b7a193593a0$var$expandRanges(daysOfWeek, startTime, framingRange, dateEnv) {
    var dowHash = daysOfWeek ? (0, $c1gko.f)(daysOfWeek) : null;
    var dayMarker = (0, $c1gko.q)(framingRange.start);
    var endMarker = framingRange.end;
    var instanceStarts = [];
    while(dayMarker < endMarker){
        var instanceStart = void 0;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) instanceStart = dateEnv.add(dayMarker, startTime);
            else instanceStart = dayMarker;
            instanceStarts.push(instanceStart);
        }
        dayMarker = (0, $c1gko.t)(dayMarker, 1);
    }
    return instanceStarts;
}
var $e3844b7a193593a0$var$changeHandlerPlugin = $e3844b7a193593a0$export$ae829ec7b2625219({
    name: "change-handler",
    optionChangeHandlers: {
        events: function(events, context) {
            $e3844b7a193593a0$var$handleEventSources([
                events
            ], context);
        },
        eventSources: $e3844b7a193593a0$var$handleEventSources
    }
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/ function $e3844b7a193593a0$var$handleEventSources(inputs, context) {
    var unfoundSources = (0, $c1gko.v)(context.getCurrentData().eventSources);
    if (unfoundSources.length === 1 && inputs.length === 1 && Array.isArray(unfoundSources[0]._raw) && Array.isArray(inputs[0])) {
        context.dispatch({
            type: "RESET_RAW_EVENTS",
            sourceId: unfoundSources[0].sourceId,
            rawEvents: inputs[0]
        });
        return;
    }
    var newInputs = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var input = _step.value;
            var inputFound = false;
            for(var i = 0; i < unfoundSources.length; i += 1)if (unfoundSources[i]._raw === input) {
                unfoundSources.splice(i, 1); // delete
                inputFound = true;
                break;
            }
            if (!inputFound) newInputs.push(input);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = unfoundSources[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var unfoundSource = _step1.value;
            context.dispatch({
                type: "REMOVE_EVENT_SOURCE",
                sourceId: unfoundSource.sourceId
            });
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = newInputs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var newInput = _step2.value;
            context.calendarApi.addEventSource(newInput);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                _iterator2["return"]();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
}
function $e3844b7a193593a0$var$handleDateProfile(dateProfile, context) {
    context.emitter.trigger("datesSet", Object.assign(Object.assign({}, (0, $c1gko.l)(dateProfile.activeRange, context.dateEnv)), {
        view: context.viewApi
    }));
}
function $e3844b7a193593a0$var$handleEventStore(eventStore, context) {
    var emitter = context.emitter;
    if (emitter.hasHandlers("eventsSet")) emitter.trigger("eventsSet", (0, $c1gko.w)(eventStore, context));
}
/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/ var $e3844b7a193593a0$export$905153d94e0757fa = [
    $e3844b7a193593a0$var$arrayEventSourcePlugin,
    $e3844b7a193593a0$var$funcEventSourcePlugin,
    $e3844b7a193593a0$var$jsonFeedEventSourcePlugin,
    $e3844b7a193593a0$var$simpleRecurringEventsPlugin,
    $e3844b7a193593a0$var$changeHandlerPlugin,
    $e3844b7a193593a0$export$ae829ec7b2625219({
        name: "misc",
        isLoadingFuncs: [
            function(state) {
                return $e3844b7a193593a0$var$computeEventSourcesLoading(state.eventSources);
            }
        ],
        propSetHandlers: {
            dateProfile: $e3844b7a193593a0$var$handleDateProfile,
            eventStore: $e3844b7a193593a0$var$handleEventStore
        }
    })
];
var $e3844b7a193593a0$var$TaskRunner = /*#__PURE__*/ function() {
    "use strict";
    function TaskRunner(runTaskOption, drainedOption) {
        (0, $5kWiG._)(this, TaskRunner);
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new (0, $c1gko.D)(this.drain.bind(this));
    }
    (0, $hHaEF._)(TaskRunner, [
        {
            key: "request",
            value: function request(task, delay) {
                this.queue.push(task);
                this.delayedRunner.request(delay);
            }
        },
        {
            key: "pause",
            value: function pause(scope) {
                this.delayedRunner.pause(scope);
            }
        },
        {
            key: "resume",
            value: function resume(scope, force) {
                this.delayedRunner.resume(scope, force);
            }
        },
        {
            key: "drain",
            value: function drain() {
                var queue = this.queue;
                while(queue.length){
                    var completedTasks = [];
                    var task = void 0;
                    while(task = queue.shift()){
                        this.runTask(task);
                        completedTasks.push(task);
                    }
                    this.drained(completedTasks);
                } // keep going, in case new tasks were added in the drained handler
            }
        },
        {
            key: "runTask",
            value: function runTask(task) {
                if (this.runTaskOption) this.runTaskOption(task);
            }
        },
        {
            key: "drained",
            value: function drained(completedTasks) {
                if (this.drainedOption) this.drainedOption(completedTasks);
            }
        }
    ]);
    return TaskRunner;
}();
// Computes what the title at the top of the calendarApi should be for this view
function $e3844b7a193593a0$var$buildTitle(dateProfile, viewOptions, dateEnv) {
    var range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) range = dateProfile.currentRange;
    else range = dateProfile.activeRange;
    return dateEnv.formatRange(range.start, range.end, (0, $c1gko.x)(viewOptions.titleFormat || $e3844b7a193593a0$var$buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function $e3844b7a193593a0$var$buildTitleFormat(dateProfile) {
    var currentRangeUnit = dateProfile.currentRangeUnit;
    if (currentRangeUnit === "year") return {
        year: "numeric"
    };
    if (currentRangeUnit === "month") return {
        year: "numeric",
        month: "long"
    }; // like "September 2014"
    var days = (0, $c1gko.y)(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) // multi-day range. shorter, like "Sep 9 - 10 2014"
    return {
        year: "numeric",
        month: "short",
        day: "numeric"
    };
    // one day. longer, like "September 9 2014"
    return {
        year: "numeric",
        month: "long",
        day: "numeric"
    };
}
// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
var $e3844b7a193593a0$var$CalendarDataManager = /*#__PURE__*/ function() {
    "use strict";
    function CalendarDataManager(props) {
        var _this = this;
        (0, $5kWiG._)(this, CalendarDataManager);
        this.computeCurrentViewData = (0, $c1gko.z)(this._computeCurrentViewData);
        this.organizeRawLocales = (0, $c1gko.z)($e3844b7a193593a0$var$organizeRawLocales);
        this.buildLocale = (0, $c1gko.z)($e3844b7a193593a0$var$buildLocale);
        this.buildPluginHooks = $e3844b7a193593a0$var$buildBuildPluginHooks();
        this.buildDateEnv = (0, $c1gko.z)($e3844b7a193593a0$var$buildDateEnv$1);
        this.buildTheme = (0, $c1gko.z)($e3844b7a193593a0$var$buildTheme);
        this.parseToolbars = (0, $c1gko.z)($e3844b7a193593a0$var$parseToolbars);
        this.buildViewSpecs = (0, $c1gko.z)($e3844b7a193593a0$var$buildViewSpecs);
        this.buildDateProfileGenerator = (0, $c1gko.A)($e3844b7a193593a0$var$buildDateProfileGenerator);
        this.buildViewApi = (0, $c1gko.z)($e3844b7a193593a0$var$buildViewApi);
        this.buildViewUiProps = (0, $c1gko.A)($e3844b7a193593a0$var$buildViewUiProps);
        this.buildEventUiBySource = (0, $c1gko.z)($e3844b7a193593a0$var$buildEventUiBySource, (0, $c1gko.E));
        this.buildEventUiBases = (0, $c1gko.z)($e3844b7a193593a0$var$buildEventUiBases);
        this.parseContextBusinessHours = (0, $c1gko.A)($e3844b7a193593a0$var$parseContextBusinessHours);
        this.buildTitle = (0, $c1gko.z)($e3844b7a193593a0$var$buildTitle);
        this.emitter = new (0, $c1gko.F)();
        this.actionRunner = new $e3844b7a193593a0$var$TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.optionsForRefining = [];
        this.optionsForHandling = [];
        this.getCurrentData = function() {
            return _this.data;
        };
        this.dispatch = function(action) {
            _this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        var dynamicOptionOverrides = {};
        var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        var currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        var currentDate = (0, $c1gko.G)(optionsData.calendarOptions, optionsData.dateEnv);
        var dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!(0, $c1gko.H)(dateProfile.activeRange, currentDate)) currentDate = dateProfile.currentRange.start;
        var calendarContext = {
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // needs to be after setThisContext
            for(var _iterator = optionsData.pluginHooks.contextInit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var callback = _step.value;
                callback(calendarContext);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // NOT DRY
        var eventSources = $e3844b7a193593a0$var$initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        var initialState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources: eventSources,
            eventUiBases: {},
            eventStore: (0, $c1gko.I)(),
            renderableEventStore: (0, $c1gko.I)(),
            dateSelection: null,
            eventSelection: "",
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig
        };
        var contextAndState = Object.assign(Object.assign({}, calendarContext), initialState);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = optionsData.pluginHooks.reducers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var reducer = _step1.value;
                Object.assign(initialState, reducer(null, null, contextAndState));
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if ($e3844b7a193593a0$var$computeIsLoading(initialState, calendarContext)) this.emitter.trigger("loading", true); // NOT DRY
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
    (0, $hHaEF._)(CalendarDataManager, [
        {
            key: "resetOptions",
            value: function resetOptions(optionOverrides, changedOptionNames) {
                var props = this.props;
                if (changedOptionNames === undefined) props.optionOverrides = optionOverrides;
                else {
                    var _this_optionsForRefining;
                    props.optionOverrides = Object.assign(Object.assign({}, props.optionOverrides || {}), optionOverrides);
                    (_this_optionsForRefining = this.optionsForRefining).push.apply(_this_optionsForRefining, (0, $5TJQB._)(changedOptionNames));
                }
                if (changedOptionNames === undefined || changedOptionNames.length) this.actionRunner.request({
                    type: "NOTHING"
                });
            }
        },
        {
            key: "_handleAction",
            value: function _handleAction(action) {
                var _this = this, props = _this.props, state = _this.state, emitter = _this.emitter;
                var dynamicOptionOverrides = $e3844b7a193593a0$var$reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
                var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
                var currentViewType = $e3844b7a193593a0$var$reduceViewType(state.currentViewType, action);
                var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
                // wire things up
                // TODO: not DRY
                props.calendarApi.currentDataManager = this;
                emitter.setThisContext(props.calendarApi);
                emitter.setOptions(currentViewData.options);
                var calendarContext = {
                    dateEnv: optionsData.dateEnv,
                    options: optionsData.calendarOptions,
                    pluginHooks: optionsData.pluginHooks,
                    calendarApi: props.calendarApi,
                    dispatch: this.dispatch,
                    emitter: emitter,
                    getCurrentData: this.getCurrentData
                };
                var currentDate = state.currentDate, dateProfile = state.dateProfile;
                if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
                currentDate = (0, $c1gko.J)(currentDate, action);
                dateProfile = $e3844b7a193593a0$var$reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
                if (action.type === "PREV" || // TODO: move this logic into DateProfileGenerator
                action.type === "NEXT" || // "
                !(0, $c1gko.H)(dateProfile.currentRange, currentDate)) currentDate = dateProfile.currentRange.start;
                var eventSources = $e3844b7a193593a0$var$reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
                var eventStore = (0, $c1gko.K)(state.eventStore, action, eventSources, dateProfile, calendarContext);
                var isEventsLoading = $e3844b7a193593a0$var$computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
                var renderableEventStore = isEventsLoading && !currentViewData.options.progressiveEventRendering ? state.renderableEventStore || eventStore : eventStore;
                var _this_buildViewUiProps = this.buildViewUiProps(calendarContext), eventUiSingleBase = _this_buildViewUiProps.eventUiSingleBase, selectionConfig = _this_buildViewUiProps.selectionConfig; // will memoize obj
                var eventUiBySource = this.buildEventUiBySource(eventSources);
                var eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
                var newState = {
                    dynamicOptionOverrides: dynamicOptionOverrides,
                    currentViewType: currentViewType,
                    currentDate: currentDate,
                    dateProfile: dateProfile,
                    eventSources: eventSources,
                    eventStore: eventStore,
                    renderableEventStore: renderableEventStore,
                    selectionConfig: selectionConfig,
                    eventUiBases: eventUiBases,
                    businessHours: this.parseContextBusinessHours(calendarContext),
                    dateSelection: $e3844b7a193593a0$var$reduceDateSelection(state.dateSelection, action),
                    eventSelection: $e3844b7a193593a0$var$reduceSelectedEvent(state.eventSelection, action),
                    eventDrag: $e3844b7a193593a0$var$reduceEventDrag(state.eventDrag, action),
                    eventResize: $e3844b7a193593a0$var$reduceEventResize(state.eventResize, action)
                };
                var contextAndState = Object.assign(Object.assign({}, calendarContext), newState);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = optionsData.pluginHooks.reducers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var reducer = _step.value;
                        Object.assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var wasLoading = $e3844b7a193593a0$var$computeIsLoading(state, calendarContext);
                var isLoading = $e3844b7a193593a0$var$computeIsLoading(newState, calendarContext);
                // TODO: use propSetHandlers in plugin system
                if (!wasLoading && isLoading) emitter.trigger("loading", true);
                else if (wasLoading && !isLoading) emitter.trigger("loading", false);
                this.state = newState;
                if (props.onAction) props.onAction(action);
            }
        },
        {
            key: "updateData",
            value: function updateData() {
                var _this = this, props = _this.props, state = _this.state;
                var oldData = this.data;
                var optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
                var currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
                var data = this.data = Object.assign(Object.assign(Object.assign({
                    viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv),
                    calendarApi: props.calendarApi,
                    dispatch: this.dispatch,
                    emitter: this.emitter,
                    getCurrentData: this.getCurrentData
                }, optionsData), currentViewData), state);
                var changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
                var oldCalendarOptions = oldData && oldData.calendarOptions;
                var newCalendarOptions = optionsData.calendarOptions;
                if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
                    if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                        // hack
                        state.eventSources = data.eventSources = $e3844b7a193593a0$var$reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                        state.eventStore = data.eventStore = (0, $c1gko.L)(data.eventStore, oldData.dateEnv, data.dateEnv);
                        state.renderableEventStore = data.renderableEventStore = (0, $c1gko.L)(data.renderableEventStore, oldData.dateEnv, data.dateEnv);
                    }
                    for(var optionName in changeHandlers)if (this.optionsForHandling.indexOf(optionName) !== -1 || oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) changeHandlers[optionName](newCalendarOptions[optionName], data);
                }
                this.optionsForHandling = [];
                if (props.onData) props.onData(data);
            }
        },
        {
            key: "computeOptionsData",
            value: function computeOptionsData(optionOverrides, dynamicOptionOverrides, calendarApi) {
                // TODO: blacklist options that are handled by optionChangeHandlers
                if (!this.optionsForRefining.length && optionOverrides === this.stableOptionOverrides && dynamicOptionOverrides === this.stableDynamicOptionOverrides) return this.stableCalendarOptionsData;
                var _this_processRawCalendarOptions = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides), refinedOptions = _this_processRawCalendarOptions.refinedOptions, pluginHooks = _this_processRawCalendarOptions.pluginHooks, localeDefaults = _this_processRawCalendarOptions.localeDefaults, availableLocaleData = _this_processRawCalendarOptions.availableLocaleData, extra = _this_processRawCalendarOptions.extra;
                $e3844b7a193593a0$var$warnUnknownOptions(extra);
                var dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
                var viewSpecs = this.buildViewSpecs(pluginHooks.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, localeDefaults);
                var theme = this.buildTheme(refinedOptions, pluginHooks);
                var toolbarConfig = this.parseToolbars(refinedOptions, this.stableOptionOverrides, theme, viewSpecs, calendarApi);
                return this.stableCalendarOptionsData = {
                    calendarOptions: refinedOptions,
                    pluginHooks: pluginHooks,
                    dateEnv: dateEnv,
                    viewSpecs: viewSpecs,
                    theme: theme,
                    toolbarConfig: toolbarConfig,
                    localeDefaults: localeDefaults,
                    availableRawLocales: availableLocaleData.map
                };
            }
        },
        {
            // always called from behind a memoizer
            key: "processRawCalendarOptions",
            value: function processRawCalendarOptions(optionOverrides, dynamicOptionOverrides) {
                var _this_optionsForHandling;
                var _mergeRawOptions = (0, $c1gko.M)([
                    (0, $c1gko.e),
                    optionOverrides,
                    dynamicOptionOverrides
                ]), locales = _mergeRawOptions.locales, locale = _mergeRawOptions.locale;
                var availableLocaleData = this.organizeRawLocales(locales);
                var availableRawLocales = availableLocaleData.map;
                var localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
                var pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], $e3844b7a193593a0$export$905153d94e0757fa);
                var refiners = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $c1gko.N)), (0, $c1gko.O)), (0, $c1gko.P)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
                var extra = {};
                var raw = (0, $c1gko.M)([
                    (0, $c1gko.e),
                    localeDefaults,
                    optionOverrides,
                    dynamicOptionOverrides
                ]);
                var refined = {};
                var currentRaw = this.currentCalendarOptionsInput;
                var currentRefined = this.currentCalendarOptionsRefined;
                var anyChanges = false;
                for(var optionName in raw){
                    if (this.optionsForRefining.indexOf(optionName) === -1 && (raw[optionName] === currentRaw[optionName] || (0, $c1gko.Q)[optionName] && optionName in currentRaw && (0, $c1gko.Q)[optionName](currentRaw[optionName], raw[optionName]))) refined[optionName] = currentRefined[optionName];
                    else if (refiners[optionName]) {
                        refined[optionName] = refiners[optionName](raw[optionName]);
                        anyChanges = true;
                    } else extra[optionName] = currentRaw[optionName];
                }
                if (anyChanges) {
                    this.currentCalendarOptionsInput = raw;
                    this.currentCalendarOptionsRefined = refined;
                    this.stableOptionOverrides = optionOverrides;
                    this.stableDynamicOptionOverrides = dynamicOptionOverrides;
                }
                (_this_optionsForHandling = this.optionsForHandling).push.apply(_this_optionsForHandling, (0, $5TJQB._)(this.optionsForRefining));
                this.optionsForRefining = [];
                return {
                    rawOptions: this.currentCalendarOptionsInput,
                    refinedOptions: this.currentCalendarOptionsRefined,
                    pluginHooks: pluginHooks,
                    availableLocaleData: availableLocaleData,
                    localeDefaults: localeDefaults,
                    extra: extra
                };
            }
        },
        {
            key: "_computeCurrentViewData",
            value: function _computeCurrentViewData(viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
                var viewSpec = optionsData.viewSpecs[viewType];
                if (!viewSpec) throw new Error('viewType "'.concat(viewType, "\" is not available. Please make sure you've loaded all neccessary plugins"));
                var _this_processRawViewOptions = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides), refinedOptions = _this_processRawViewOptions.refinedOptions, extra = _this_processRawViewOptions.extra;
                $e3844b7a193593a0$var$warnUnknownOptions(extra);
                var dateProfileGenerator = this.buildDateProfileGenerator({
                    dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
                    duration: viewSpec.duration,
                    durationUnit: viewSpec.durationUnit,
                    usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
                    dateEnv: optionsData.dateEnv,
                    calendarApi: this.props.calendarApi,
                    slotMinTime: refinedOptions.slotMinTime,
                    slotMaxTime: refinedOptions.slotMaxTime,
                    showNonCurrentDates: refinedOptions.showNonCurrentDates,
                    dayCount: refinedOptions.dayCount,
                    dateAlignment: refinedOptions.dateAlignment,
                    dateIncrement: refinedOptions.dateIncrement,
                    hiddenDays: refinedOptions.hiddenDays,
                    weekends: refinedOptions.weekends,
                    nowInput: refinedOptions.now,
                    validRangeInput: refinedOptions.validRange,
                    visibleRangeInput: refinedOptions.visibleRange,
                    fixedWeekCount: refinedOptions.fixedWeekCount
                });
                var viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
                return {
                    viewSpec: viewSpec,
                    options: refinedOptions,
                    dateProfileGenerator: dateProfileGenerator,
                    viewApi: viewApi
                };
            }
        },
        {
            key: "processRawViewOptions",
            value: function processRawViewOptions(viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
                var raw = (0, $c1gko.M)([
                    (0, $c1gko.e),
                    viewSpec.optionDefaults,
                    localeDefaults,
                    optionOverrides,
                    viewSpec.optionOverrides,
                    dynamicOptionOverrides
                ]);
                var refiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $c1gko.N)), (0, $c1gko.O)), (0, $c1gko.P)), (0, $c1gko.R)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
                var refined = {};
                var currentRaw = this.currentViewOptionsInput;
                var currentRefined = this.currentViewOptionsRefined;
                var anyChanges = false;
                var extra = {};
                for(var optionName in raw)if (raw[optionName] === currentRaw[optionName] || (0, $c1gko.Q)[optionName] && (0, $c1gko.Q)[optionName](raw[optionName], currentRaw[optionName])) refined[optionName] = currentRefined[optionName];
                else {
                    if (raw[optionName] === this.currentCalendarOptionsInput[optionName] || (0, $c1gko.Q)[optionName] && (0, $c1gko.Q)[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName])) {
                        if (optionName in this.currentCalendarOptionsRefined) refined[optionName] = this.currentCalendarOptionsRefined[optionName];
                    } else if (refiners[optionName]) refined[optionName] = refiners[optionName](raw[optionName]);
                    else extra[optionName] = raw[optionName];
                    anyChanges = true;
                }
                if (anyChanges) {
                    this.currentViewOptionsInput = raw;
                    this.currentViewOptionsRefined = refined;
                }
                return {
                    rawOptions: this.currentViewOptionsInput,
                    refinedOptions: this.currentViewOptionsRefined,
                    extra: extra
                };
            }
        }
    ]);
    return CalendarDataManager;
}();
function $e3844b7a193593a0$var$buildDateEnv$1(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    var locale = $e3844b7a193593a0$var$buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new (0, $c1gko.S)({
        calendarSystem: "gregory",
        timeZone: timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale: locale,
        weekNumberCalculation: weekNumberCalculation,
        firstDay: firstDay,
        weekText: weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator: defaultSeparator
    });
}
function $e3844b7a193593a0$var$buildTheme(options, pluginHooks) {
    var ThemeClass = pluginHooks.themeClasses[options.themeSystem] || $e3844b7a193593a0$var$StandardTheme;
    return new ThemeClass(options);
}
function $e3844b7a193593a0$var$buildDateProfileGenerator(props) {
    var DateProfileGeneratorClass = props.dateProfileGeneratorClass || (0, $c1gko.U);
    return new DateProfileGeneratorClass(props);
}
function $e3844b7a193593a0$var$buildViewApi(type, getCurrentData, dateEnv) {
    return new $e3844b7a193593a0$var$ViewImpl(type, getCurrentData, dateEnv);
}
function $e3844b7a193593a0$var$buildEventUiBySource(eventSources) {
    return (0, $c1gko.a)(eventSources, function(eventSource) {
        return eventSource.ui;
    });
}
function $e3844b7a193593a0$var$buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    var eventUiBases = {
        "": eventUiSingleBase
    };
    for(var defId in eventDefs){
        var def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) eventUiBases[defId] = eventUiBySource[def.sourceId];
    }
    return eventUiBases;
}
function $e3844b7a193593a0$var$buildViewUiProps(calendarContext) {
    var options = calendarContext.options;
    return {
        eventUiSingleBase: (0, $c1gko.W)({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === "boolean" ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor
        }, calendarContext),
        selectionConfig: (0, $c1gko.W)({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === "boolean" ? options.selectOverlap : undefined,
            allow: options.selectAllow
        }, calendarContext)
    };
}
function $e3844b7a193593a0$var$computeIsLoading(state, context) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.isLoadingFuncs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var isLoadingFunc = _step.value;
            if (isLoadingFunc(state)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $e3844b7a193593a0$var$parseContextBusinessHours(calendarContext) {
    return (0, $c1gko.X)(calendarContext.options.businessHours, calendarContext);
}
function $e3844b7a193593a0$var$warnUnknownOptions(options, viewName) {
    for(var optionName in options)console.warn("Unknown option '".concat(optionName, "'") + (viewName ? " for view '".concat(viewName, "'") : ""));
}
var $e3844b7a193593a0$var$ToolbarSection = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(ToolbarSection, BaseComponent);
    var _super = (0, $jhb1H._)(ToolbarSection);
    function ToolbarSection() {
        (0, $5kWiG._)(this, ToolbarSection);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(ToolbarSection, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var children = this.props.widgetGroups.map(function(widgetGroup) {
                    return _this.renderWidgetGroup(widgetGroup);
                });
                return (0, $kgSvt.createElement).apply(void 0, [
                    "div",
                    {
                        className: "fc-toolbar-chunk"
                    }
                ].concat((0, $5TJQB._)(children)));
            }
        },
        {
            key: "renderWidgetGroup",
            value: function renderWidgetGroup(widgetGroup) {
                var props = this.props;
                var theme = this.context.theme;
                var children = [];
                var isOnlyButtons = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = widgetGroup[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var widget = _step.value;
                        var buttonName = widget.buttonName, buttonClick = widget.buttonClick, buttonText = widget.buttonText, buttonIcon = widget.buttonIcon, buttonHint = widget.buttonHint;
                        if (buttonName === "title") {
                            isOnlyButtons = false;
                            children.push((0, $kgSvt.createElement)("h2", {
                                className: "fc-toolbar-title",
                                id: props.titleId
                            }, props.title));
                        } else {
                            var isPressed = buttonName === props.activeButton;
                            var isDisabled = !props.isTodayEnabled && buttonName === "today" || !props.isPrevEnabled && buttonName === "prev" || !props.isNextEnabled && buttonName === "next";
                            var buttonClasses = [
                                "fc-".concat(buttonName, "-button"),
                                theme.getClass("button")
                            ];
                            if (isPressed) buttonClasses.push(theme.getClass("buttonActive"));
                            children.push((0, $kgSvt.createElement)("button", {
                                type: "button",
                                title: typeof buttonHint === "function" ? buttonHint(props.navUnit) : buttonHint,
                                disabled: isDisabled,
                                "aria-pressed": isPressed,
                                className: buttonClasses.join(" "),
                                onClick: buttonClick
                            }, buttonText || (buttonIcon ? (0, $kgSvt.createElement)("span", {
                                className: buttonIcon
                            }) : "")));
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (children.length > 1) {
                    var groupClassName = isOnlyButtons && theme.getClass("buttonGroup") || "";
                    return (0, $kgSvt.createElement).apply(void 0, [
                        "div",
                        {
                            className: groupClassName
                        }
                    ].concat((0, $5TJQB._)(children)));
                }
                return children[0];
            }
        }
    ]);
    return ToolbarSection;
}((0, $c1gko.B));
var $e3844b7a193593a0$var$Toolbar = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(Toolbar, BaseComponent);
    var _super = (0, $jhb1H._)(Toolbar);
    function Toolbar() {
        (0, $5kWiG._)(this, Toolbar);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(Toolbar, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, model = _this_props.model, extraClassName = _this_props.extraClassName;
                var forceLtr = false;
                var startContent;
                var endContent;
                var sectionWidgets = model.sectionWidgets;
                var centerContent = sectionWidgets.center;
                if (sectionWidgets.left) {
                    forceLtr = true;
                    startContent = sectionWidgets.left;
                } else startContent = sectionWidgets.start;
                if (sectionWidgets.right) {
                    forceLtr = true;
                    endContent = sectionWidgets.right;
                } else endContent = sectionWidgets.end;
                var classNames = [
                    extraClassName || "",
                    "fc-toolbar",
                    forceLtr ? "fc-toolbar-ltr" : ""
                ];
                return (0, $kgSvt.createElement)("div", {
                    className: classNames.join(" ")
                }, this.renderSection("start", startContent || []), this.renderSection("center", centerContent || []), this.renderSection("end", endContent || []));
            }
        },
        {
            key: "renderSection",
            value: function renderSection(key, widgetGroups) {
                var props = this.props;
                return (0, $kgSvt.createElement)($e3844b7a193593a0$var$ToolbarSection, {
                    key: key,
                    widgetGroups: widgetGroups,
                    title: props.title,
                    navUnit: props.navUnit,
                    activeButton: props.activeButton,
                    isTodayEnabled: props.isTodayEnabled,
                    isPrevEnabled: props.isPrevEnabled,
                    isNextEnabled: props.isNextEnabled,
                    titleId: props.titleId
                });
            }
        }
    ]);
    return Toolbar;
}((0, $c1gko.B));
var $e3844b7a193593a0$var$ViewHarness = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(ViewHarness, BaseComponent);
    var _super = (0, $jhb1H._)(ViewHarness);
    function ViewHarness() {
        (0, $5kWiG._)(this, ViewHarness);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.state = {
            availableWidth: null
        };
        _this.handleEl = function(el) {
            _this.el = el;
            (0, $c1gko.Y)(_this.props.elRef, el);
            _this.updateAvailableWidth();
        };
        _this.handleResize = function() {
            _this.updateAvailableWidth();
        };
        return _this;
    }
    (0, $hHaEF._)(ViewHarness, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, state = _this.state;
                var aspectRatio = props.aspectRatio;
                var classNames = [
                    "fc-view-harness",
                    aspectRatio || props.liquid || props.height ? "fc-view-harness-active" // harness controls the height
                     : "fc-view-harness-passive"
                ];
                var height = "";
                var paddingBottom = "";
                if (aspectRatio) {
                    if (state.availableWidth !== null) height = state.availableWidth / aspectRatio;
                    else // while waiting to know availableWidth, we can't set height to *zero*
                    // because will cause lots of unnecessary scrollbars within scrollgrid.
                    // BETTER: don't start rendering ANYTHING yet until we know container width
                    // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
                    paddingBottom = "".concat(1 / aspectRatio * 100, "%");
                } else height = props.height || "";
                return (0, $kgSvt.createElement)("div", {
                    "aria-labelledby": props.labeledById,
                    ref: this.handleEl,
                    className: classNames.join(" "),
                    style: {
                        height: height,
                        paddingBottom: paddingBottom
                    }
                }, props.children);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.context.addResizeHandler(this.handleResize);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.context.removeResizeHandler(this.handleResize);
            }
        },
        {
            key: "updateAvailableWidth",
            value: function updateAvailableWidth() {
                if (this.el && // needed. but why?
                this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
                ) this.setState({
                    availableWidth: this.el.offsetWidth
                });
            }
        }
    ]);
    return ViewHarness;
}((0, $c1gko.B));
/*
Detects when the user clicks on an event within a DateComponent
*/ var $e3844b7a193593a0$var$EventClicking = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $dACZV._)(EventClicking, Interaction);
    var _super = (0, $jhb1H._)(EventClicking);
    function EventClicking(settings) {
        (0, $5kWiG._)(this, EventClicking);
        var _this;
        _this = _super.call(this, settings);
        _this.handleSegClick = function(ev, segEl) {
            var component = (0, $1K4o4._)(_this).component;
            var context = component.context;
            var seg = (0, $c1gko._)(segEl);
            if (seg && // might be the <div> surrounding the more link
            component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                var hasUrlContainer = (0, $c1gko.$)(ev.target, ".fc-event-forced-url");
                var url = hasUrlContainer ? hasUrlContainer.querySelector("a[href]").href : "";
                context.emitter.trigger("eventClick", {
                    el: segEl,
                    event: new (0, $c1gko.a0)(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
                if (url && !ev.defaultPrevented) window.location.href = url;
            }
        };
        _this.destroy = (0, $c1gko.a1)(settings.el, "click", ".fc-event", _this.handleSegClick);
        return _this;
    }
    return EventClicking;
}((0, $c1gko.Z));
/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/ var $e3844b7a193593a0$var$EventHovering = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $dACZV._)(EventHovering, Interaction);
    var _super = (0, $jhb1H._)(EventHovering);
    function EventHovering(settings) {
        (0, $5kWiG._)(this, EventHovering);
        var _this;
        _this = _super.call(this, settings);
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        _this.handleEventElRemove = function(el) {
            if (el === _this.currentSegEl) _this.handleSegLeave(null, _this.currentSegEl);
        };
        _this.handleSegEnter = function(ev, segEl) {
            if ((0, $c1gko._)(segEl)) {
                _this.currentSegEl = segEl;
                _this.triggerEvent("eventMouseEnter", ev, segEl);
            }
        };
        _this.handleSegLeave = function(ev, segEl) {
            if (_this.currentSegEl) {
                _this.currentSegEl = null;
                _this.triggerEvent("eventMouseLeave", ev, segEl);
            }
        };
        _this.removeHoverListeners = (0, $c1gko.a2)(settings.el, ".fc-event", _this.handleSegEnter, _this.handleSegLeave);
        return _this;
    }
    (0, $hHaEF._)(EventHovering, [
        {
            key: "destroy",
            value: function destroy() {
                this.removeHoverListeners();
            }
        },
        {
            key: "triggerEvent",
            value: function triggerEvent(publicEvName, ev, segEl) {
                var component = this.component;
                var context = component.context;
                var seg = (0, $c1gko._)(segEl);
                if (!ev || component.isValidSegDownEl(ev.target)) context.emitter.trigger(publicEvName, {
                    el: segEl,
                    event: new (0, $c1gko.a0)(context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
            }
        }
    ]);
    return EventHovering;
}((0, $c1gko.Z));
var $e3844b7a193593a0$var$CalendarContent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0, $dACZV._)(CalendarContent, PureComponent);
    var _super = (0, $jhb1H._)(CalendarContent);
    function CalendarContent() {
        (0, $5kWiG._)(this, CalendarContent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.buildViewContext = (0, $c1gko.z)((0, $c1gko.a4));
        _this.buildViewPropTransformers = (0, $c1gko.z)($e3844b7a193593a0$var$buildViewPropTransformers);
        _this.buildToolbarProps = (0, $c1gko.z)($e3844b7a193593a0$var$buildToolbarProps);
        _this.headerRef = (0, $kgSvt.createRef)();
        _this.footerRef = (0, $kgSvt.createRef)();
        _this.interactionsStore = {};
        // eslint-disable-next-line
        _this.state = {
            viewLabelId: (0, $c1gko.a5)()
        };
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        _this.registerInteractiveComponent = function(component, settingsInput) {
            var settings = (0, $c1gko.a6)(component, settingsInput);
            var DEFAULT_INTERACTIONS = [
                $e3844b7a193593a0$var$EventClicking,
                $e3844b7a193593a0$var$EventHovering
            ];
            var interactionClasses = DEFAULT_INTERACTIONS.concat(_this.props.pluginHooks.componentInteractions);
            var interactions = interactionClasses.map(function(TheInteractionClass) {
                return new TheInteractionClass(settings);
            });
            _this.interactionsStore[component.uid] = interactions;
            (0, $c1gko.a7)[component.uid] = settings;
        };
        _this.unregisterInteractiveComponent = function(component) {
            var listeners = _this.interactionsStore[component.uid];
            if (listeners) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener.destroy();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                delete _this.interactionsStore[component.uid];
            }
            delete (0, $c1gko.a7)[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        _this.resizeRunner = new (0, $c1gko.D)(function() {
            _this.props.emitter.trigger("_resize", true); // should window resizes be considered "forced" ?
            _this.props.emitter.trigger("windowResize", {
                view: _this.props.viewApi
            });
        });
        _this.handleWindowResize = function(ev) {
            var options = _this.props.options;
            if (options.handleWindowResize && ev.target === window // avoid jqui events
            ) _this.resizeRunner.request(options.windowResizeDelay);
        };
        return _this;
    }
    (0, $hHaEF._)(CalendarContent, [
        {
            /*
    renders INSIDE of an outer div
    */ key: "render",
            value: function render() {
                var props = this.props;
                var toolbarConfig = props.toolbarConfig, options = props.options;
                var toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, (0, $c1gko.a8)(props.options.now, props.dateEnv), props.viewTitle);
                var viewVGrow = false;
                var viewHeight = "";
                var viewAspectRatio;
                if (props.isHeightAuto || props.forPrint) viewHeight = "";
                else if (options.height != null) viewVGrow = true;
                else if (options.contentHeight != null) viewHeight = options.contentHeight;
                else viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
                var viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
                var viewLabelId = toolbarConfig.header && toolbarConfig.header.hasTitle ? this.state.viewLabelId : "";
                return (0, $kgSvt.createElement)((0, $c1gko.V).Provider, {
                    value: viewContext
                }, toolbarConfig.header && (0, $kgSvt.createElement)($e3844b7a193593a0$var$Toolbar, Object.assign({
                    ref: this.headerRef,
                    extraClassName: "fc-header-toolbar",
                    model: toolbarConfig.header,
                    titleId: viewLabelId
                }, toolbarProps)), (0, $kgSvt.createElement)($e3844b7a193593a0$var$ViewHarness, {
                    liquid: viewVGrow,
                    height: viewHeight,
                    aspectRatio: viewAspectRatio,
                    labeledById: viewLabelId
                }, this.renderView(props), this.buildAppendContent()), toolbarConfig.footer && (0, $kgSvt.createElement)($e3844b7a193593a0$var$Toolbar, Object.assign({
                    ref: this.footerRef,
                    extraClassName: "fc-footer-toolbar",
                    model: toolbarConfig.footer,
                    titleId: ""
                }, toolbarProps)));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var props = this.props;
                this.calendarInteractions = props.pluginHooks.calendarInteractions.map(function(CalendarInteractionClass) {
                    return new CalendarInteractionClass(props);
                });
                window.addEventListener("resize", this.handleWindowResize);
                var propSetHandlers = props.pluginHooks.propSetHandlers;
                for(var propName in propSetHandlers)propSetHandlers[propName](props[propName], props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var props = this.props;
                var propSetHandlers = props.pluginHooks.propSetHandlers;
                for(var propName in propSetHandlers)if (props[propName] !== prevProps[propName]) propSetHandlers[propName](props[propName], props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("resize", this.handleWindowResize);
                this.resizeRunner.clear();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.calendarInteractions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var interaction = _step.value;
                        interaction.destroy();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.props.emitter.trigger("_unmount");
            }
        },
        {
            key: "buildAppendContent",
            value: function buildAppendContent() {
                var props = this.props;
                var children = props.pluginHooks.viewContainerAppends.map(function(buildAppendContent) {
                    return buildAppendContent(props);
                });
                return (0, $kgSvt.createElement).apply(void 0, [
                    (0, $kgSvt.Fragment),
                    {}
                ].concat((0, $5TJQB._)(children)));
            }
        },
        {
            key: "renderView",
            value: function renderView(props) {
                var pluginHooks = props.pluginHooks;
                var viewSpec = props.viewSpec;
                var viewProps = {
                    dateProfile: props.dateProfile,
                    businessHours: props.businessHours,
                    eventStore: props.renderableEventStore,
                    eventUiBases: props.eventUiBases,
                    dateSelection: props.dateSelection,
                    eventSelection: props.eventSelection,
                    eventDrag: props.eventDrag,
                    eventResize: props.eventResize,
                    isHeightAuto: props.isHeightAuto,
                    forPrint: props.forPrint
                };
                var transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = transformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var transformer = _step.value;
                        Object.assign(viewProps, transformer.transform(viewProps, props));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var ViewComponent = viewSpec.component;
                return (0, $kgSvt.createElement)(ViewComponent, Object.assign({}, viewProps));
            }
        }
    ]);
    return CalendarContent;
}((0, $c1gko.a3));
function $e3844b7a193593a0$var$buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    var todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    var prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    var nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title: title,
        activeButton: viewSpec.type,
        navUnit: viewSpec.singleUnit,
        isTodayEnabled: todayInfo.isValid && !(0, $c1gko.H)(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function $e3844b7a193593a0$var$buildViewPropTransformers(theClasses) {
    return theClasses.map(function(TheClass) {
        return new TheClass();
    });
}
var $e3844b7a193593a0$export$e1aef45b828286de = /*#__PURE__*/ function(CalendarImpl) {
    "use strict";
    (0, $dACZV._)(Calendar, CalendarImpl);
    var _super = (0, $jhb1H._)(Calendar);
    function Calendar(el) {
        var optionOverrides = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $5kWiG._)(this, Calendar);
        var _this;
        _this = _super.call(this);
        _this.isRendering = false;
        _this.isRendered = false;
        _this.currentClassNames = [];
        _this.customContentRenderId = 0;
        _this.handleAction = function(action) {
            // actions we know we want to render immediately
            switch(action.type){
                case "SET_EVENT_DRAG":
                case "SET_EVENT_RESIZE":
                    _this.renderRunner.tryDrain();
            }
        };
        _this.handleData = function(data) {
            _this.currentData = data;
            _this.renderRunner.request(data.calendarOptions.rerenderDelay);
        };
        _this.handleRenderRequest = function() {
            if (_this.isRendering) {
                _this.isRendered = true;
                var currentData = (0, $1K4o4._)(_this).currentData;
                (0, $c1gko.aa)(function() {
                    (0, $kgSvt.render)((0, $kgSvt.createElement)((0, $c1gko.ab), {
                        options: currentData.calendarOptions,
                        theme: currentData.theme,
                        emitter: currentData.emitter
                    }, function(classNames, height, isHeightAuto, forPrint) {
                        _this.setClassNames(classNames);
                        _this.setHeight(height);
                        return (0, $kgSvt.createElement)((0, $c1gko.ac).Provider, {
                            value: _this.customContentRenderId
                        }, (0, $kgSvt.createElement)($e3844b7a193593a0$var$CalendarContent, Object.assign({
                            isHeightAuto: isHeightAuto,
                            forPrint: forPrint
                        }, currentData)));
                    }), _this.el);
                });
            } else if (_this.isRendered) {
                _this.isRendered = false;
                (0, $kgSvt.render)(null, _this.el);
                _this.setClassNames([]);
                _this.setHeight("");
            }
        };
        (0, $c1gko.ad)(el);
        _this.el = el;
        _this.renderRunner = new (0, $c1gko.D)(_this.handleRenderRequest);
        new $e3844b7a193593a0$var$CalendarDataManager({
            optionOverrides: optionOverrides,
            calendarApi: (0, $1K4o4._)(_this),
            onAction: _this.handleAction,
            onData: _this.handleData
        });
        return _this;
    }
    (0, $hHaEF._)(Calendar, [
        {
            key: "render",
            value: function render() {
                var wasRendering = this.isRendering;
                if (!wasRendering) this.isRendering = true;
                else this.customContentRenderId += 1;
                this.renderRunner.request();
                if (wasRendering) this.updateSize();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this.isRendering) {
                    this.isRendering = false;
                    this.renderRunner.request();
                }
            }
        },
        {
            key: "updateSize",
            value: function updateSize() {
                var _this = this;
                (0, $c1gko.aa)(function() {
                    (0, $eKxsN._)((0, $8wb0B._)(Calendar.prototype), "updateSize", _this).call(_this);
                });
            }
        },
        {
            key: "batchRendering",
            value: function batchRendering(func) {
                this.renderRunner.pause("batchRendering");
                func();
                this.renderRunner.resume("batchRendering");
            }
        },
        {
            key: "pauseRendering",
            value: function pauseRendering() {
                this.renderRunner.pause("pauseRendering");
            }
        },
        {
            key: "resumeRendering",
            value: function resumeRendering() {
                this.renderRunner.resume("pauseRendering", true);
            }
        },
        {
            key: "resetOptions",
            value: function resetOptions(optionOverrides, changedOptionNames) {
                this.currentDataManager.resetOptions(optionOverrides, changedOptionNames);
            }
        },
        {
            key: "setClassNames",
            value: function setClassNames(classNames) {
                if (!(0, $c1gko.i)(classNames, this.currentClassNames)) {
                    var classList = this.el.classList;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.currentClassNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var className = _step.value;
                            classList.remove(className);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = classNames[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var className1 = _step1.value;
                            classList.add(className1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    this.currentClassNames = classNames;
                }
            }
        },
        {
            key: "setHeight",
            value: function setHeight(height) {
                (0, $c1gko.ae)(this.el, "height", height);
            }
        }
    ]);
    return Calendar;
}((0, $c1gko.a9));
function $e3844b7a193593a0$export$3ae94a2503e890a1(dateInput) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var dateEnv = $e3844b7a193593a0$var$buildDateEnv(options);
    var formatter = (0, $c1gko.x)(options);
    var dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) return "";
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo
    });
}
function $e3844b7a193593a0$export$9b1080e2eec9158(startInput, endInput, options) {
    var dateEnv = $e3844b7a193593a0$var$buildDateEnv(typeof options === "object" && options ? options : {}); // pass in if non-null object
    var formatter = (0, $c1gko.x)(options);
    var startMeta = dateEnv.createMarkerMeta(startInput);
    var endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) return "";
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: (0, $c1gko.e).defaultRangeSeparator
    });
}
// TODO: more DRY and optimized
function $e3844b7a193593a0$var$buildDateEnv(settings) {
    var locale = $e3844b7a193593a0$var$buildLocale(settings.locale || "en", $e3844b7a193593a0$var$organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new (0, $c1gko.S)(Object.assign(Object.assign({
        timeZone: (0, $c1gko.e).timeZone,
        calendarSystem: "gregory"
    }, settings), {
        locale: locale
    }));
}
// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/ function $e3844b7a193593a0$export$3b384895d0cca0f2(props, allDay) {
    return (0, $c1gko.af)(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}
var $e3844b7a193593a0$export$83d89fbfd8236492 = "6.1.9";




var $gbAcq = parcelRequire("gbAcq");


var $bd4ac898b43cd5c3$export$2e2bcd8739ae039 = (0, $e3844b7a193593a0$export$ae829ec7b2625219)({
    name: "@fullcalendar/daygrid",
    initialView: "dayGridMonth",
    views: {
        dayGrid: {
            component: (0, $gbAcq.DayGridView),
            dateProfileGeneratorClass: (0, $gbAcq.TableDateProfileGenerator)
        },
        dayGridDay: {
            type: "dayGrid",
            duration: {
                days: 1
            }
        },
        dayGridWeek: {
            type: "dayGrid",
            duration: {
                weeks: 1
            }
        },
        dayGridMonth: {
            type: "dayGrid",
            duration: {
                months: 1
            },
            fixedWeekCount: true
        },
        dayGridYear: {
            type: "dayGrid",
            duration: {
                years: 1
            }
        }
    }
});



var $1K4o4 = parcelRequire("1K4o4");

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $dACZV = parcelRequire("dACZV");

var $5TJQB = parcelRequire("5TJQB");

var $jhb1H = parcelRequire("jhb1H");


var $c1gko = parcelRequire("c1gko");
(0, $c1gko.bI).touchMouseIgnoreWait = 500;
var $5b5f46d3160e73f6$var$ignoreMouseDepth = 0;
var $5b5f46d3160e73f6$var$listenerCnt = 0;
var $5b5f46d3160e73f6$var$isWindowTouchMoveCancelled = false;
/*
Uses a "pointer" abstraction, which monitors UI events for both mouse and touch.
Tracks when the pointer "drags" on a certain element, meaning down+move+up.

Also, tracks if there was touch-scrolling.
Also, can prevent touch-scrolling from happening.
Also, can fire pointermove events when scrolling happens underneath, even when no real pointer movement.

emits:
- pointerdown
- pointermove
- pointerup
*/ var $5b5f46d3160e73f6$var$PointerDragging = /*#__PURE__*/ function() {
    "use strict";
    function PointerDragging(containerEl) {
        var _this = this;
        (0, $5kWiG._)(this, PointerDragging);
        this.subjectEl = null;
        // options that can be directly assigned by caller
        this.selector = ""; // will cause subjectEl in all emitted events to be this element
        this.handleSelector = "";
        this.shouldIgnoreMove = false;
        this.shouldWatchScroll = true; // for simulating pointermove on scroll
        // internal states
        this.isDragging = false;
        this.isTouchDragging = false;
        this.wasTouchScroll = false;
        // Mouse
        // ----------------------------------------------------------------------------------------------------
        this.handleMouseDown = function(ev) {
            if (!_this.shouldIgnoreMouse() && $5b5f46d3160e73f6$var$isPrimaryMouseButton(ev) && _this.tryStart(ev)) {
                var pev = _this.createEventFromMouse(ev, true);
                _this.emitter.trigger("pointerdown", pev);
                _this.initScrollWatch(pev);
                if (!_this.shouldIgnoreMove) document.addEventListener("mousemove", _this.handleMouseMove);
                document.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        this.handleMouseMove = function(ev) {
            var pev = _this.createEventFromMouse(ev);
            _this.recordCoords(pev);
            _this.emitter.trigger("pointermove", pev);
        };
        this.handleMouseUp = function(ev) {
            document.removeEventListener("mousemove", _this.handleMouseMove);
            document.removeEventListener("mouseup", _this.handleMouseUp);
            _this.emitter.trigger("pointerup", _this.createEventFromMouse(ev));
            _this.cleanup(); // call last so that pointerup has access to props
        };
        // Touch
        // ----------------------------------------------------------------------------------------------------
        this.handleTouchStart = function(ev) {
            if (_this.tryStart(ev)) {
                _this.isTouchDragging = true;
                var pev = _this.createEventFromTouch(ev, true);
                _this.emitter.trigger("pointerdown", pev);
                _this.initScrollWatch(pev);
                // unlike mouse, need to attach to target, not document
                // https://stackoverflow.com/a/45760014
                var targetEl = ev.target;
                if (!_this.shouldIgnoreMove) targetEl.addEventListener("touchmove", _this.handleTouchMove);
                targetEl.addEventListener("touchend", _this.handleTouchEnd);
                targetEl.addEventListener("touchcancel", _this.handleTouchEnd); // treat it as a touch end
                // attach a handler to get called when ANY scroll action happens on the page.
                // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
                // http://stackoverflow.com/a/32954565/96342
                window.addEventListener("scroll", _this.handleTouchScroll, true);
            }
        };
        this.handleTouchMove = function(ev) {
            var pev = _this.createEventFromTouch(ev);
            _this.recordCoords(pev);
            _this.emitter.trigger("pointermove", pev);
        };
        this.handleTouchEnd = function(ev) {
            if (_this.isDragging) {
                var targetEl = ev.target;
                targetEl.removeEventListener("touchmove", _this.handleTouchMove);
                targetEl.removeEventListener("touchend", _this.handleTouchEnd);
                targetEl.removeEventListener("touchcancel", _this.handleTouchEnd);
                window.removeEventListener("scroll", _this.handleTouchScroll, true); // useCaptured=true
                _this.emitter.trigger("pointerup", _this.createEventFromTouch(ev));
                _this.cleanup(); // call last so that pointerup has access to props
                _this.isTouchDragging = false;
                $5b5f46d3160e73f6$var$startIgnoringMouse();
            }
        };
        this.handleTouchScroll = function() {
            _this.wasTouchScroll = true;
        };
        this.handleScroll = function(ev) {
            if (!_this.shouldIgnoreMove) {
                var pageX = window.pageXOffset - _this.prevScrollX + _this.prevPageX;
                var pageY = window.pageYOffset - _this.prevScrollY + _this.prevPageY;
                _this.emitter.trigger("pointermove", {
                    origEvent: ev,
                    isTouch: _this.isTouchDragging,
                    subjectEl: _this.subjectEl,
                    pageX: pageX,
                    pageY: pageY,
                    deltaX: pageX - _this.origPageX,
                    deltaY: pageY - _this.origPageY
                });
            }
        };
        this.containerEl = containerEl;
        this.emitter = new (0, $c1gko.F)();
        containerEl.addEventListener("mousedown", this.handleMouseDown);
        containerEl.addEventListener("touchstart", this.handleTouchStart, {
            passive: true
        });
        $5b5f46d3160e73f6$var$listenerCreated();
    }
    (0, $hHaEF._)(PointerDragging, [
        {
            key: "destroy",
            value: function destroy() {
                this.containerEl.removeEventListener("mousedown", this.handleMouseDown);
                this.containerEl.removeEventListener("touchstart", this.handleTouchStart, {
                    passive: true
                });
                $5b5f46d3160e73f6$var$listenerDestroyed();
            }
        },
        {
            key: "tryStart",
            value: function tryStart(ev) {
                var subjectEl = this.querySubjectEl(ev);
                var downEl = ev.target;
                if (subjectEl && (!this.handleSelector || (0, $c1gko.$)(downEl, this.handleSelector))) {
                    this.subjectEl = subjectEl;
                    this.isDragging = true; // do this first so cancelTouchScroll will work
                    this.wasTouchScroll = false;
                    return true;
                }
                return false;
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                $5b5f46d3160e73f6$var$isWindowTouchMoveCancelled = false;
                this.isDragging = false;
                this.subjectEl = null;
                // keep wasTouchScroll around for later access
                this.destroyScrollWatch();
            }
        },
        {
            key: "querySubjectEl",
            value: function querySubjectEl(ev) {
                if (this.selector) return (0, $c1gko.$)(ev.target, this.selector);
                return this.containerEl;
            }
        },
        {
            key: "shouldIgnoreMouse",
            value: function shouldIgnoreMouse() {
                return $5b5f46d3160e73f6$var$ignoreMouseDepth || this.isTouchDragging;
            }
        },
        {
            // can be called by user of this class, to cancel touch-based scrolling for the current drag
            key: "cancelTouchScroll",
            value: function cancelTouchScroll() {
                if (this.isDragging) $5b5f46d3160e73f6$var$isWindowTouchMoveCancelled = true;
            }
        },
        {
            // Scrolling that simulates pointermoves
            // ----------------------------------------------------------------------------------------------------
            key: "initScrollWatch",
            value: function initScrollWatch(ev) {
                if (this.shouldWatchScroll) {
                    this.recordCoords(ev);
                    window.addEventListener("scroll", this.handleScroll, true); // useCapture=true
                }
            }
        },
        {
            key: "recordCoords",
            value: function recordCoords(ev) {
                if (this.shouldWatchScroll) {
                    this.prevPageX = ev.pageX;
                    this.prevPageY = ev.pageY;
                    this.prevScrollX = window.pageXOffset;
                    this.prevScrollY = window.pageYOffset;
                }
            }
        },
        {
            key: "destroyScrollWatch",
            value: function destroyScrollWatch() {
                if (this.shouldWatchScroll) window.removeEventListener("scroll", this.handleScroll, true); // useCaptured=true
            }
        },
        {
            // Event Normalization
            // ----------------------------------------------------------------------------------------------------
            key: "createEventFromMouse",
            value: function createEventFromMouse(ev, isFirst) {
                var deltaX = 0;
                var deltaY = 0;
                // TODO: repeat code
                if (isFirst) {
                    this.origPageX = ev.pageX;
                    this.origPageY = ev.pageY;
                } else {
                    deltaX = ev.pageX - this.origPageX;
                    deltaY = ev.pageY - this.origPageY;
                }
                return {
                    origEvent: ev,
                    isTouch: false,
                    subjectEl: this.subjectEl,
                    pageX: ev.pageX,
                    pageY: ev.pageY,
                    deltaX: deltaX,
                    deltaY: deltaY
                };
            }
        },
        {
            key: "createEventFromTouch",
            value: function createEventFromTouch(ev, isFirst) {
                var touches = ev.touches;
                var pageX;
                var pageY;
                var deltaX = 0;
                var deltaY = 0;
                // if touch coords available, prefer,
                // because FF would give bad ev.pageX ev.pageY
                if (touches && touches.length) {
                    pageX = touches[0].pageX;
                    pageY = touches[0].pageY;
                } else {
                    pageX = ev.pageX;
                    pageY = ev.pageY;
                }
                // TODO: repeat code
                if (isFirst) {
                    this.origPageX = pageX;
                    this.origPageY = pageY;
                } else {
                    deltaX = pageX - this.origPageX;
                    deltaY = pageY - this.origPageY;
                }
                return {
                    origEvent: ev,
                    isTouch: true,
                    subjectEl: this.subjectEl,
                    pageX: pageX,
                    pageY: pageY,
                    deltaX: deltaX,
                    deltaY: deltaY
                };
            }
        }
    ]);
    return PointerDragging;
}();
// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function $5b5f46d3160e73f6$var$isPrimaryMouseButton(ev) {
    return ev.button === 0 && !ev.ctrlKey;
}
// Ignoring fake mouse events generated by touch
// ----------------------------------------------------------------------------------------------------
function $5b5f46d3160e73f6$var$startIgnoringMouse() {
    $5b5f46d3160e73f6$var$ignoreMouseDepth += 1;
    setTimeout(function() {
        $5b5f46d3160e73f6$var$ignoreMouseDepth -= 1;
    }, (0, $c1gko.bI).touchMouseIgnoreWait);
}
// We want to attach touchmove as early as possible for Safari
// ----------------------------------------------------------------------------------------------------
function $5b5f46d3160e73f6$var$listenerCreated() {
    $5b5f46d3160e73f6$var$listenerCnt += 1;
    if ($5b5f46d3160e73f6$var$listenerCnt === 1) window.addEventListener("touchmove", $5b5f46d3160e73f6$var$onWindowTouchMove, {
        passive: false
    });
}
function $5b5f46d3160e73f6$var$listenerDestroyed() {
    $5b5f46d3160e73f6$var$listenerCnt -= 1;
    if (!$5b5f46d3160e73f6$var$listenerCnt) window.removeEventListener("touchmove", $5b5f46d3160e73f6$var$onWindowTouchMove, {
        passive: false
    });
}
function $5b5f46d3160e73f6$var$onWindowTouchMove(ev) {
    if ($5b5f46d3160e73f6$var$isWindowTouchMoveCancelled) ev.preventDefault();
}
/*
An effect in which an element follows the movement of a pointer across the screen.
The moving element is a clone of some other element.
Must call start + handleMove + stop.
*/ var $5b5f46d3160e73f6$var$ElementMirror = /*#__PURE__*/ function() {
    "use strict";
    function ElementMirror() {
        (0, $5kWiG._)(this, ElementMirror);
        this.isVisible = false; // must be explicitly enabled
        this.sourceEl = null;
        this.mirrorEl = null;
        this.sourceElRect = null; // screen coords relative to viewport
        // options that can be set directly by caller
        this.parentNode = document.body; // HIGHLY SUGGESTED to set this to sidestep ShadowDOM issues
        this.zIndex = 9999;
        this.revertDuration = 0;
    }
    (0, $hHaEF._)(ElementMirror, [
        {
            key: "start",
            value: function start(sourceEl, pageX, pageY) {
                this.sourceEl = sourceEl;
                this.sourceElRect = this.sourceEl.getBoundingClientRect();
                this.origScreenX = pageX - window.pageXOffset;
                this.origScreenY = pageY - window.pageYOffset;
                this.deltaX = 0;
                this.deltaY = 0;
                this.updateElPosition();
            }
        },
        {
            key: "handleMove",
            value: function handleMove(pageX, pageY) {
                this.deltaX = pageX - window.pageXOffset - this.origScreenX;
                this.deltaY = pageY - window.pageYOffset - this.origScreenY;
                this.updateElPosition();
            }
        },
        {
            // can be called before start
            key: "setIsVisible",
            value: function setIsVisible(bool) {
                if (bool) {
                    if (!this.isVisible) {
                        if (this.mirrorEl) this.mirrorEl.style.display = "";
                        this.isVisible = bool; // needs to happen before updateElPosition
                        this.updateElPosition(); // because was not updating the position while invisible
                    }
                } else if (this.isVisible) {
                    if (this.mirrorEl) this.mirrorEl.style.display = "none";
                    this.isVisible = bool;
                }
            }
        },
        {
            // always async
            key: "stop",
            value: function stop(needsRevertAnimation, callback) {
                var _this = this;
                var done = function() {
                    _this.cleanup();
                    callback();
                };
                if (needsRevertAnimation && this.mirrorEl && this.isVisible && this.revertDuration && // if 0, transition won't work
                (this.deltaX || this.deltaY // if same coords, transition won't work
                )) this.doRevertAnimation(done, this.revertDuration);
                else setTimeout(done, 0);
            }
        },
        {
            key: "doRevertAnimation",
            value: function doRevertAnimation(callback, revertDuration) {
                var mirrorEl = this.mirrorEl;
                var finalSourceElRect = this.sourceEl.getBoundingClientRect(); // because autoscrolling might have happened
                mirrorEl.style.transition = "top " + revertDuration + "ms," + "left " + revertDuration + "ms";
                (0, $c1gko.aP)(mirrorEl, {
                    left: finalSourceElRect.left,
                    top: finalSourceElRect.top
                });
                (0, $c1gko.b2)(mirrorEl, function() {
                    mirrorEl.style.transition = "";
                    callback();
                });
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                if (this.mirrorEl) {
                    (0, $c1gko.aO)(this.mirrorEl);
                    this.mirrorEl = null;
                }
                this.sourceEl = null;
            }
        },
        {
            key: "updateElPosition",
            value: function updateElPosition() {
                if (this.sourceEl && this.isVisible) (0, $c1gko.aP)(this.getMirrorEl(), {
                    left: this.sourceElRect.left + this.deltaX,
                    top: this.sourceElRect.top + this.deltaY
                });
            }
        },
        {
            key: "getMirrorEl",
            value: function getMirrorEl() {
                var sourceElRect = this.sourceElRect;
                var mirrorEl = this.mirrorEl;
                if (!mirrorEl) {
                    mirrorEl = this.mirrorEl = this.sourceEl.cloneNode(true); // cloneChildren=true
                    // we don't want long taps or any mouse interaction causing selection/menus.
                    // would use preventSelection(), but that prevents selectstart, causing problems.
                    mirrorEl.style.userSelect = "none";
                    mirrorEl.style.webkitUserSelect = "none";
                    mirrorEl.classList.add("fc-event-dragging");
                    (0, $c1gko.aP)(mirrorEl, {
                        position: "fixed",
                        zIndex: this.zIndex,
                        visibility: "",
                        boxSizing: "border-box",
                        width: sourceElRect.right - sourceElRect.left,
                        height: sourceElRect.bottom - sourceElRect.top,
                        right: "auto",
                        bottom: "auto",
                        margin: 0
                    });
                    this.parentNode.appendChild(mirrorEl);
                }
                return mirrorEl;
            }
        }
    ]);
    return ElementMirror;
}();
/*
Is a cache for a given element's scroll information (all the info that ScrollController stores)
in addition the "client rectangle" of the element.. the area within the scrollbars.

The cache can be in one of two modes:
- doesListening:false - ignores when the container is scrolled by someone else
- doesListening:true - watch for scrolling and update the cache
*/ var $5b5f46d3160e73f6$var$ScrollGeomCache = /*#__PURE__*/ function(ScrollController) {
    "use strict";
    (0, $dACZV._)(ScrollGeomCache, ScrollController);
    var _super = (0, $jhb1H._)(ScrollGeomCache);
    function ScrollGeomCache(scrollController, doesListening) {
        (0, $5kWiG._)(this, ScrollGeomCache);
        var _this;
        _this = _super.call(this);
        _this.handleScroll = function() {
            _this.scrollTop = _this.scrollController.getScrollTop();
            _this.scrollLeft = _this.scrollController.getScrollLeft();
            _this.handleScrollChange();
        };
        _this.scrollController = scrollController;
        _this.doesListening = doesListening;
        _this.scrollTop = _this.origScrollTop = scrollController.getScrollTop();
        _this.scrollLeft = _this.origScrollLeft = scrollController.getScrollLeft();
        _this.scrollWidth = scrollController.getScrollWidth();
        _this.scrollHeight = scrollController.getScrollHeight();
        _this.clientWidth = scrollController.getClientWidth();
        _this.clientHeight = scrollController.getClientHeight();
        _this.clientRect = _this.computeClientRect(); // do last in case it needs cached values
        if (_this.doesListening) _this.getEventTarget().addEventListener("scroll", _this.handleScroll);
        return _this;
    }
    (0, $hHaEF._)(ScrollGeomCache, [
        {
            key: "destroy",
            value: function destroy() {
                if (this.doesListening) this.getEventTarget().removeEventListener("scroll", this.handleScroll);
            }
        },
        {
            key: "getScrollTop",
            value: function getScrollTop() {
                return this.scrollTop;
            }
        },
        {
            key: "getScrollLeft",
            value: function getScrollLeft() {
                return this.scrollLeft;
            }
        },
        {
            key: "setScrollTop",
            value: function setScrollTop(top) {
                this.scrollController.setScrollTop(top);
                if (!this.doesListening) {
                    // we are not relying on the element to normalize out-of-bounds scroll values
                    // so we need to sanitize ourselves
                    this.scrollTop = Math.max(Math.min(top, this.getMaxScrollTop()), 0);
                    this.handleScrollChange();
                }
            }
        },
        {
            key: "setScrollLeft",
            value: function setScrollLeft(top) {
                this.scrollController.setScrollLeft(top);
                if (!this.doesListening) {
                    // we are not relying on the element to normalize out-of-bounds scroll values
                    // so we need to sanitize ourselves
                    this.scrollLeft = Math.max(Math.min(top, this.getMaxScrollLeft()), 0);
                    this.handleScrollChange();
                }
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth() {
                return this.clientWidth;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight() {
                return this.clientHeight;
            }
        },
        {
            key: "getScrollWidth",
            value: function getScrollWidth() {
                return this.scrollWidth;
            }
        },
        {
            key: "getScrollHeight",
            value: function getScrollHeight() {
                return this.scrollHeight;
            }
        },
        {
            key: "handleScrollChange",
            value: function handleScrollChange() {}
        }
    ]);
    return ScrollGeomCache;
}((0, $c1gko.bb));
var $5b5f46d3160e73f6$var$ElementScrollGeomCache = /*#__PURE__*/ function(ScrollGeomCache) {
    "use strict";
    (0, $dACZV._)(ElementScrollGeomCache, ScrollGeomCache);
    var _super = (0, $jhb1H._)(ElementScrollGeomCache);
    function ElementScrollGeomCache(el, doesListening) {
        (0, $5kWiG._)(this, ElementScrollGeomCache);
        return _super.call(this, new (0, $c1gko.bc)(el), doesListening);
    }
    (0, $hHaEF._)(ElementScrollGeomCache, [
        {
            key: "getEventTarget",
            value: function getEventTarget() {
                return this.scrollController.el;
            }
        },
        {
            key: "computeClientRect",
            value: function computeClientRect() {
                return (0, $c1gko.b3)(this.scrollController.el);
            }
        }
    ]);
    return ElementScrollGeomCache;
}($5b5f46d3160e73f6$var$ScrollGeomCache);
var $5b5f46d3160e73f6$var$WindowScrollGeomCache = /*#__PURE__*/ function(ScrollGeomCache) {
    "use strict";
    (0, $dACZV._)(WindowScrollGeomCache, ScrollGeomCache);
    var _super = (0, $jhb1H._)(WindowScrollGeomCache);
    function WindowScrollGeomCache(doesListening) {
        (0, $5kWiG._)(this, WindowScrollGeomCache);
        return _super.call(this, new (0, $c1gko.bd)(), doesListening);
    }
    (0, $hHaEF._)(WindowScrollGeomCache, [
        {
            key: "getEventTarget",
            value: function getEventTarget() {
                return window;
            }
        },
        {
            key: "computeClientRect",
            value: function computeClientRect() {
                return {
                    left: this.scrollLeft,
                    right: this.scrollLeft + this.clientWidth,
                    top: this.scrollTop,
                    bottom: this.scrollTop + this.clientHeight
                };
            }
        },
        {
            // the window is the only scroll object that changes it's rectangle relative
            // to the document's topleft as it scrolls
            key: "handleScrollChange",
            value: function handleScrollChange() {
                this.clientRect = this.computeClientRect();
            }
        }
    ]);
    return WindowScrollGeomCache;
}($5b5f46d3160e73f6$var$ScrollGeomCache);
// If available we are using native "performance" API instead of "Date"
// Read more about it on MDN:
// https://developer.mozilla.org/en-US/docs/Web/API/Performance
var $5b5f46d3160e73f6$var$getTime = typeof performance === "function" ? performance.now : Date.now;
/*
For a pointer interaction, automatically scrolls certain scroll containers when the pointer
approaches the edge.

The caller must call start + handleMove + stop.
*/ var $5b5f46d3160e73f6$var$AutoScroller = /*#__PURE__*/ function() {
    "use strict";
    function AutoScroller() {
        var _this = this;
        (0, $5kWiG._)(this, AutoScroller);
        // options that can be set by caller
        this.isEnabled = true;
        this.scrollQuery = [
            window,
            ".fc-scroller"
        ];
        this.edgeThreshold = 50; // pixels
        this.maxVelocity = 300; // pixels per second
        // internal state
        this.pointerScreenX = null;
        this.pointerScreenY = null;
        this.isAnimating = false;
        this.scrollCaches = null;
        // protect against the initial pointerdown being too close to an edge and starting the scroll
        this.everMovedUp = false;
        this.everMovedDown = false;
        this.everMovedLeft = false;
        this.everMovedRight = false;
        this.animate = function() {
            if (_this.isAnimating) {
                var edge = _this.computeBestEdge(_this.pointerScreenX + window.pageXOffset, _this.pointerScreenY + window.pageYOffset);
                if (edge) {
                    var now = $5b5f46d3160e73f6$var$getTime();
                    _this.handleSide(edge, (now - _this.msSinceRequest) / 1000);
                    _this.requestAnimation(now);
                } else _this.isAnimating = false; // will stop animation
            }
        };
    }
    (0, $hHaEF._)(AutoScroller, [
        {
            key: "start",
            value: function start(pageX, pageY, scrollStartEl) {
                if (this.isEnabled) {
                    this.scrollCaches = this.buildCaches(scrollStartEl);
                    this.pointerScreenX = null;
                    this.pointerScreenY = null;
                    this.everMovedUp = false;
                    this.everMovedDown = false;
                    this.everMovedLeft = false;
                    this.everMovedRight = false;
                    this.handleMove(pageX, pageY);
                }
            }
        },
        {
            key: "handleMove",
            value: function handleMove(pageX, pageY) {
                if (this.isEnabled) {
                    var pointerScreenX = pageX - window.pageXOffset;
                    var pointerScreenY = pageY - window.pageYOffset;
                    var yDelta = this.pointerScreenY === null ? 0 : pointerScreenY - this.pointerScreenY;
                    var xDelta = this.pointerScreenX === null ? 0 : pointerScreenX - this.pointerScreenX;
                    if (yDelta < 0) this.everMovedUp = true;
                    else if (yDelta > 0) this.everMovedDown = true;
                    if (xDelta < 0) this.everMovedLeft = true;
                    else if (xDelta > 0) this.everMovedRight = true;
                    this.pointerScreenX = pointerScreenX;
                    this.pointerScreenY = pointerScreenY;
                    if (!this.isAnimating) {
                        this.isAnimating = true;
                        this.requestAnimation($5b5f46d3160e73f6$var$getTime());
                    }
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.isEnabled) {
                    this.isAnimating = false; // will stop animation
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.scrollCaches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var scrollCache = _step.value;
                            scrollCache.destroy();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.scrollCaches = null;
                }
            }
        },
        {
            key: "requestAnimation",
            value: function requestAnimation(now) {
                this.msSinceRequest = now;
                requestAnimationFrame(this.animate);
            }
        },
        {
            key: "handleSide",
            value: function handleSide(edge, seconds) {
                var scrollCache = edge.scrollCache;
                var edgeThreshold = this.edgeThreshold;
                var invDistance = edgeThreshold - edge.distance;
                var velocity = invDistance * invDistance / (edgeThreshold * edgeThreshold) * // quadratic
                this.maxVelocity * seconds;
                var sign = 1;
                switch(edge.name){
                    case "left":
                        sign = -1;
                    // falls through
                    case "right":
                        scrollCache.setScrollLeft(scrollCache.getScrollLeft() + velocity * sign);
                        break;
                    case "top":
                        sign = -1;
                    // falls through
                    case "bottom":
                        scrollCache.setScrollTop(scrollCache.getScrollTop() + velocity * sign);
                        break;
                }
            }
        },
        {
            // left/top are relative to document topleft
            key: "computeBestEdge",
            value: function computeBestEdge(left, top) {
                var edgeThreshold = this.edgeThreshold;
                var bestSide = null;
                var scrollCaches = this.scrollCaches || [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = scrollCaches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var scrollCache = _step.value;
                        var rect = scrollCache.clientRect;
                        var leftDist = left - rect.left;
                        var rightDist = rect.right - left;
                        var topDist = top - rect.top;
                        var bottomDist = rect.bottom - top;
                        // completely within the rect?
                        if (leftDist >= 0 && rightDist >= 0 && topDist >= 0 && bottomDist >= 0) {
                            if (topDist <= edgeThreshold && this.everMovedUp && scrollCache.canScrollUp() && (!bestSide || bestSide.distance > topDist)) bestSide = {
                                scrollCache: scrollCache,
                                name: "top",
                                distance: topDist
                            };
                            if (bottomDist <= edgeThreshold && this.everMovedDown && scrollCache.canScrollDown() && (!bestSide || bestSide.distance > bottomDist)) bestSide = {
                                scrollCache: scrollCache,
                                name: "bottom",
                                distance: bottomDist
                            };
                            if (leftDist <= edgeThreshold && this.everMovedLeft && scrollCache.canScrollLeft() && (!bestSide || bestSide.distance > leftDist)) bestSide = {
                                scrollCache: scrollCache,
                                name: "left",
                                distance: leftDist
                            };
                            if (rightDist <= edgeThreshold && this.everMovedRight && scrollCache.canScrollRight() && (!bestSide || bestSide.distance > rightDist)) bestSide = {
                                scrollCache: scrollCache,
                                name: "right",
                                distance: rightDist
                            };
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return bestSide;
            }
        },
        {
            key: "buildCaches",
            value: function buildCaches(scrollStartEl) {
                return this.queryScrollEls(scrollStartEl).map(function(el) {
                    if (el === window) return new $5b5f46d3160e73f6$var$WindowScrollGeomCache(false); // false = don't listen to user-generated scrolls
                    return new $5b5f46d3160e73f6$var$ElementScrollGeomCache(el, false); // false = don't listen to user-generated scrolls
                });
            }
        },
        {
            key: "queryScrollEls",
            value: function queryScrollEls(scrollStartEl) {
                var _els;
                var els = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.scrollQuery[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var query = _step.value;
                        if (typeof query === "object") els.push(query);
                        else (_els = els).push.apply(_els, (0, $5TJQB._)(Array.prototype.slice.call(scrollStartEl.getRootNode().querySelectorAll(query))));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return els;
            }
        }
    ]);
    return AutoScroller;
}();
/*
Monitors dragging on an element. Has a number of high-level features:
- minimum distance required before dragging
- minimum wait time ("delay") before dragging
- a mirror element that follows the pointer
*/ var $5b5f46d3160e73f6$var$FeaturefulElementDragging = /*#__PURE__*/ function(ElementDragging) {
    "use strict";
    (0, $dACZV._)(FeaturefulElementDragging, ElementDragging);
    var _super = (0, $jhb1H._)(FeaturefulElementDragging);
    function FeaturefulElementDragging(containerEl, selector) {
        (0, $5kWiG._)(this, FeaturefulElementDragging);
        var _this;
        _this = _super.call(this, containerEl);
        _this.containerEl = containerEl;
        // options that can be directly set by caller
        // the caller can also set the PointerDragging's options as well
        _this.delay = null;
        _this.minDistance = 0;
        _this.touchScrollAllowed = true; // prevents drag from starting and blocks scrolling during drag
        _this.mirrorNeedsRevert = false;
        _this.isInteracting = false; // is the user validly moving the pointer? lasts until pointerup
        _this.isDragging = false; // is it INTENTFULLY dragging? lasts until after revert animation
        _this.isDelayEnded = false;
        _this.isDistanceSurpassed = false;
        _this.delayTimeoutId = null;
        _this.onPointerDown = function(ev) {
            if (!_this.isDragging) {
                _this.isInteracting = true;
                _this.isDelayEnded = false;
                _this.isDistanceSurpassed = false;
                (0, $c1gko.ar)(document.body);
                (0, $c1gko.at)(document.body);
                // prevent links from being visited if there's an eventual drag.
                // also prevents selection in older browsers (maybe?).
                // not necessary for touch, besides, browser would complain about passiveness.
                if (!ev.isTouch) ev.origEvent.preventDefault();
                _this.emitter.trigger("pointerdown", ev);
                if (_this.isInteracting && // not destroyed via pointerdown handler
                !_this.pointer.shouldIgnoreMove) {
                    // actions related to initiating dragstart+dragmove+dragend...
                    _this.mirror.setIsVisible(false); // reset. caller must set-visible
                    _this.mirror.start(ev.subjectEl, ev.pageX, ev.pageY); // must happen on first pointer down
                    _this.startDelay(ev);
                    if (!_this.minDistance) _this.handleDistanceSurpassed(ev);
                }
            }
        };
        _this.onPointerMove = function(ev) {
            if (_this.isInteracting) {
                _this.emitter.trigger("pointermove", ev);
                if (!_this.isDistanceSurpassed) {
                    var minDistance = _this.minDistance;
                    var distanceSq; // current distance from the origin, squared
                    var deltaX = ev.deltaX, deltaY = ev.deltaY;
                    distanceSq = deltaX * deltaX + deltaY * deltaY;
                    if (distanceSq >= minDistance * minDistance) _this.handleDistanceSurpassed(ev);
                }
                if (_this.isDragging) {
                    // a real pointer move? (not one simulated by scrolling)
                    if (ev.origEvent.type !== "scroll") {
                        _this.mirror.handleMove(ev.pageX, ev.pageY);
                        _this.autoScroller.handleMove(ev.pageX, ev.pageY);
                    }
                    _this.emitter.trigger("dragmove", ev);
                }
            }
        };
        _this.onPointerUp = function(ev) {
            if (_this.isInteracting) {
                _this.isInteracting = false;
                (0, $c1gko.as)(document.body);
                (0, $c1gko.au)(document.body);
                _this.emitter.trigger("pointerup", ev); // can potentially set mirrorNeedsRevert
                if (_this.isDragging) {
                    _this.autoScroller.stop();
                    _this.tryStopDrag(ev); // which will stop the mirror
                }
                if (_this.delayTimeoutId) {
                    clearTimeout(_this.delayTimeoutId);
                    _this.delayTimeoutId = null;
                }
            }
        };
        var pointer = _this.pointer = new $5b5f46d3160e73f6$var$PointerDragging(containerEl);
        pointer.emitter.on("pointerdown", _this.onPointerDown);
        pointer.emitter.on("pointermove", _this.onPointerMove);
        pointer.emitter.on("pointerup", _this.onPointerUp);
        if (selector) pointer.selector = selector;
        _this.mirror = new $5b5f46d3160e73f6$var$ElementMirror();
        _this.autoScroller = new $5b5f46d3160e73f6$var$AutoScroller();
        return _this;
    }
    (0, $hHaEF._)(FeaturefulElementDragging, [
        {
            key: "destroy",
            value: function destroy() {
                this.pointer.destroy();
                // HACK: simulate a pointer-up to end the current drag
                // TODO: fire 'dragend' directly and stop interaction. discourage use of pointerup event (b/c might not fire)
                this.onPointerUp({});
            }
        },
        {
            key: "startDelay",
            value: function startDelay(ev) {
                var _this = this;
                if (typeof this.delay === "number") this.delayTimeoutId = setTimeout(function() {
                    _this.delayTimeoutId = null;
                    _this.handleDelayEnd(ev);
                }, this.delay); // not assignable to number!
                else this.handleDelayEnd(ev);
            }
        },
        {
            key: "handleDelayEnd",
            value: function handleDelayEnd(ev) {
                this.isDelayEnded = true;
                this.tryStartDrag(ev);
            }
        },
        {
            key: "handleDistanceSurpassed",
            value: function handleDistanceSurpassed(ev) {
                this.isDistanceSurpassed = true;
                this.tryStartDrag(ev);
            }
        },
        {
            key: "tryStartDrag",
            value: function tryStartDrag(ev) {
                if (this.isDelayEnded && this.isDistanceSurpassed) {
                    if (!this.pointer.wasTouchScroll || this.touchScrollAllowed) {
                        this.isDragging = true;
                        this.mirrorNeedsRevert = false;
                        this.autoScroller.start(ev.pageX, ev.pageY, this.containerEl);
                        this.emitter.trigger("dragstart", ev);
                        if (this.touchScrollAllowed === false) this.pointer.cancelTouchScroll();
                    }
                }
            }
        },
        {
            key: "tryStopDrag",
            value: function tryStopDrag(ev) {
                // .stop() is ALWAYS asynchronous, which we NEED because we want all pointerup events
                // that come from the document to fire beforehand. much more convenient this way.
                this.mirror.stop(this.mirrorNeedsRevert, this.stopDrag.bind(this, ev));
            }
        },
        {
            key: "stopDrag",
            value: function stopDrag(ev) {
                this.isDragging = false;
                this.emitter.trigger("dragend", ev);
            }
        },
        {
            // fill in the implementations...
            key: "setIgnoreMove",
            value: function setIgnoreMove(bool) {
                this.pointer.shouldIgnoreMove = bool;
            }
        },
        {
            key: "setMirrorIsVisible",
            value: function setMirrorIsVisible(bool) {
                this.mirror.setIsVisible(bool);
            }
        },
        {
            key: "setMirrorNeedsRevert",
            value: function setMirrorNeedsRevert(bool) {
                this.mirrorNeedsRevert = bool;
            }
        },
        {
            key: "setAutoScrollEnabled",
            value: function setAutoScrollEnabled(bool) {
                this.autoScroller.isEnabled = bool;
            }
        }
    ]);
    return FeaturefulElementDragging;
}((0, $c1gko.bH));
/*
When this class is instantiated, it records the offset of an element (relative to the document topleft),
and continues to monitor scrolling, updating the cached coordinates if it needs to.
Does not access the DOM after instantiation, so highly performant.

Also keeps track of all scrolling/overflow:hidden containers that are parents of the given element
and an determine if a given point is inside the combined clipping rectangle.
*/ var $5b5f46d3160e73f6$var$OffsetTracker = /*#__PURE__*/ function() {
    "use strict";
    function OffsetTracker(el) {
        (0, $5kWiG._)(this, OffsetTracker);
        this.origRect = (0, $c1gko.b6)(el);
        // will work fine for divs that have overflow:hidden
        this.scrollCaches = (0, $c1gko.b5)(el).map(function(scrollEl) {
            return new $5b5f46d3160e73f6$var$ElementScrollGeomCache(scrollEl, true);
        });
    }
    (0, $hHaEF._)(OffsetTracker, [
        {
            key: "destroy",
            value: function destroy() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.scrollCaches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var scrollCache = _step.value;
                        scrollCache.destroy();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "computeLeft",
            value: function computeLeft() {
                var left = this.origRect.left;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.scrollCaches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var scrollCache = _step.value;
                        left += scrollCache.origScrollLeft - scrollCache.getScrollLeft();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return left;
            }
        },
        {
            key: "computeTop",
            value: function computeTop() {
                var top = this.origRect.top;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.scrollCaches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var scrollCache = _step.value;
                        top += scrollCache.origScrollTop - scrollCache.getScrollTop();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return top;
            }
        },
        {
            key: "isWithinClipping",
            value: function isWithinClipping(pageX, pageY) {
                var point = {
                    left: pageX,
                    top: pageY
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.scrollCaches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var scrollCache = _step.value;
                        if (!$5b5f46d3160e73f6$var$isIgnoredClipping(scrollCache.getEventTarget()) && !(0, $c1gko.aF)(point, scrollCache.clientRect)) return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return true;
            }
        }
    ]);
    return OffsetTracker;
}();
// certain clipping containers should never constrain interactions, like <html> and <body>
// https://github.com/fullcalendar/fullcalendar/issues/3615
function $5b5f46d3160e73f6$var$isIgnoredClipping(node) {
    var tagName = node.tagName;
    return tagName === "HTML" || tagName === "BODY";
}
/*
Tracks movement over multiple droppable areas (aka "hits")
that exist in one or more DateComponents.
Relies on an existing draggable.

emits:
- pointerdown
- dragstart
- hitchange - fires initially, even if not over a hit
- pointerup
- (hitchange - again, to null, if ended over a hit)
- dragend
*/ var $5b5f46d3160e73f6$var$HitDragging = /*#__PURE__*/ function() {
    "use strict";
    function HitDragging(dragging, droppableStore) {
        var _this = this;
        (0, $5kWiG._)(this, HitDragging);
        // options that can be set by caller
        this.useSubjectCenter = false;
        this.requireInitial = true; // if doesn't start out on a hit, won't emit any events
        this.initialHit = null;
        this.movingHit = null;
        this.finalHit = null; // won't ever be populated if shouldIgnoreMove
        this.handlePointerDown = function(ev) {
            var _$dragging = _this.dragging;
            _this.initialHit = null;
            _this.movingHit = null;
            _this.finalHit = null;
            _this.prepareHits();
            _this.processFirstCoord(ev);
            if (_this.initialHit || !_this.requireInitial) {
                _$dragging.setIgnoreMove(false);
                // TODO: fire this before computing processFirstCoord, so listeners can cancel. this gets fired by almost every handler :(
                _this.emitter.trigger("pointerdown", ev);
            } else _$dragging.setIgnoreMove(true);
        };
        this.handleDragStart = function(ev) {
            _this.emitter.trigger("dragstart", ev);
            _this.handleMove(ev, true); // force = fire even if initially null
        };
        this.handleDragMove = function(ev) {
            _this.emitter.trigger("dragmove", ev);
            _this.handleMove(ev);
        };
        this.handlePointerUp = function(ev) {
            _this.releaseHits();
            _this.emitter.trigger("pointerup", ev);
        };
        this.handleDragEnd = function(ev) {
            if (_this.movingHit) _this.emitter.trigger("hitupdate", null, true, ev);
            _this.finalHit = _this.movingHit;
            _this.movingHit = null;
            _this.emitter.trigger("dragend", ev);
        };
        this.droppableStore = droppableStore;
        dragging.emitter.on("pointerdown", this.handlePointerDown);
        dragging.emitter.on("dragstart", this.handleDragStart);
        dragging.emitter.on("dragmove", this.handleDragMove);
        dragging.emitter.on("pointerup", this.handlePointerUp);
        dragging.emitter.on("dragend", this.handleDragEnd);
        this.dragging = dragging;
        this.emitter = new (0, $c1gko.F)();
    }
    (0, $hHaEF._)(HitDragging, [
        {
            // sets initialHit
            // sets coordAdjust
            key: "processFirstCoord",
            value: function processFirstCoord(ev) {
                var origPoint = {
                    left: ev.pageX,
                    top: ev.pageY
                };
                var adjustedPoint = origPoint;
                var subjectEl = ev.subjectEl;
                var subjectRect;
                if (subjectEl instanceof HTMLElement) {
                    subjectRect = (0, $c1gko.b6)(subjectEl);
                    adjustedPoint = (0, $c1gko.aG)(adjustedPoint, subjectRect);
                }
                var initialHit = this.initialHit = this.queryHitForOffset(adjustedPoint.left, adjustedPoint.top);
                if (initialHit) {
                    if (this.useSubjectCenter && subjectRect) {
                        var slicedSubjectRect = (0, $c1gko.aE)(subjectRect, initialHit.rect);
                        if (slicedSubjectRect) adjustedPoint = (0, $c1gko.aH)(slicedSubjectRect);
                    }
                    this.coordAdjust = (0, $c1gko.aI)(adjustedPoint, origPoint);
                } else this.coordAdjust = {
                    left: 0,
                    top: 0
                };
            }
        },
        {
            key: "handleMove",
            value: function handleMove(ev, forceHandle) {
                var hit = this.queryHitForOffset(ev.pageX + this.coordAdjust.left, ev.pageY + this.coordAdjust.top);
                if (forceHandle || !$5b5f46d3160e73f6$var$isHitsEqual(this.movingHit, hit)) {
                    this.movingHit = hit;
                    this.emitter.trigger("hitupdate", hit, false, ev);
                }
            }
        },
        {
            key: "prepareHits",
            value: function prepareHits() {
                this.offsetTrackers = (0, $c1gko.a)(this.droppableStore, function(interactionSettings) {
                    interactionSettings.component.prepareHits();
                    return new $5b5f46d3160e73f6$var$OffsetTracker(interactionSettings.el);
                });
            }
        },
        {
            key: "releaseHits",
            value: function releaseHits() {
                var offsetTrackers = this.offsetTrackers;
                for(var id in offsetTrackers)offsetTrackers[id].destroy();
                this.offsetTrackers = {};
            }
        },
        {
            key: "queryHitForOffset",
            value: function queryHitForOffset(offsetLeft, offsetTop) {
                var _this = this, droppableStore = _this.droppableStore, offsetTrackers = _this.offsetTrackers;
                var bestHit = null;
                for(var id in droppableStore){
                    var component = droppableStore[id].component;
                    var offsetTracker = offsetTrackers[id];
                    if (offsetTracker && // wasn't destroyed mid-drag
                    offsetTracker.isWithinClipping(offsetLeft, offsetTop)) {
                        var originLeft = offsetTracker.computeLeft();
                        var originTop = offsetTracker.computeTop();
                        var positionLeft = offsetLeft - originLeft;
                        var positionTop = offsetTop - originTop;
                        var origRect = offsetTracker.origRect;
                        var width = origRect.right - origRect.left;
                        var height = origRect.bottom - origRect.top;
                        if (// must be within the element's bounds
                        positionLeft >= 0 && positionLeft < width && positionTop >= 0 && positionTop < height) {
                            var hit = component.queryHit(positionLeft, positionTop, width, height);
                            if (hit && // make sure the hit is within activeRange, meaning it's not a dead cell
                            (0, $c1gko.b9)(hit.dateProfile.activeRange, hit.dateSpan.range) && (!bestHit || hit.layer > bestHit.layer)) {
                                hit.componentId = id;
                                hit.context = component.context;
                                // TODO: better way to re-orient rectangle
                                hit.rect.left += originLeft;
                                hit.rect.right += originLeft;
                                hit.rect.top += originTop;
                                hit.rect.bottom += originTop;
                                bestHit = hit;
                            }
                        }
                    }
                }
                return bestHit;
            }
        }
    ]);
    return HitDragging;
}();
function $5b5f46d3160e73f6$var$isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) return true;
    if (Boolean(hit0) !== Boolean(hit1)) return false;
    return (0, $c1gko.bf)(hit0.dateSpan, hit1.dateSpan);
}
function $5b5f46d3160e73f6$var$buildDatePointApiWithContext(dateSpan, context) {
    var props = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.datePointTransforms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transform = _step.value;
            Object.assign(props, transform(dateSpan, context));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    Object.assign(props, $5b5f46d3160e73f6$var$buildDatePointApi(dateSpan, context.dateEnv));
    return props;
}
function $5b5f46d3160e73f6$var$buildDatePointApi(span, dateEnv) {
    return {
        date: dateEnv.toDate(span.range.start),
        dateStr: dateEnv.formatIso(span.range.start, {
            omitTime: span.allDay
        }),
        allDay: span.allDay
    };
}
/*
Monitors when the user clicks on a specific date/time of a component.
A pointerdown+pointerup on the same "hit" constitutes a click.
*/ var $5b5f46d3160e73f6$var$DateClicking = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $dACZV._)(DateClicking, Interaction);
    var _super = (0, $jhb1H._)(DateClicking);
    function DateClicking(settings) {
        (0, $5kWiG._)(this, DateClicking);
        var _this;
        _this = _super.call(this, settings);
        _this.handlePointerDown = function(pev) {
            var dragging = (0, $1K4o4._)(_this).dragging;
            var downEl = pev.origEvent.target;
            // do this in pointerdown (not dragend) because DOM might be mutated by the time dragend is fired
            dragging.setIgnoreMove(!_this.component.isValidDateDownEl(downEl));
        };
        // won't even fire if moving was ignored
        _this.handleDragEnd = function(ev) {
            var component = (0, $1K4o4._)(_this).component;
            var pointer = _this.dragging.pointer;
            if (!pointer.wasTouchScroll) {
                var _this_hitDragging = _this.hitDragging, initialHit = _this_hitDragging.initialHit, finalHit = _this_hitDragging.finalHit;
                if (initialHit && finalHit && $5b5f46d3160e73f6$var$isHitsEqual(initialHit, finalHit)) {
                    var context = component.context;
                    var arg = Object.assign(Object.assign({}, $5b5f46d3160e73f6$var$buildDatePointApiWithContext(initialHit.dateSpan, context)), {
                        dayEl: initialHit.dayEl,
                        jsEvent: ev.origEvent,
                        view: context.viewApi || context.calendarApi.view
                    });
                    context.emitter.trigger("dateClick", arg);
                }
            }
        };
        // we DO want to watch pointer moves because otherwise finalHit won't get populated
        _this.dragging = new $5b5f46d3160e73f6$var$FeaturefulElementDragging(settings.el);
        _this.dragging.autoScroller.isEnabled = false;
        var hitDragging = _this.hitDragging = new $5b5f46d3160e73f6$var$HitDragging(_this.dragging, (0, $c1gko.bG)(settings));
        hitDragging.emitter.on("pointerdown", _this.handlePointerDown);
        hitDragging.emitter.on("dragend", _this.handleDragEnd);
        return _this;
    }
    (0, $hHaEF._)(DateClicking, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragging.destroy();
            }
        }
    ]);
    return DateClicking;
}((0, $c1gko.Z));
/*
Tracks when the user selects a portion of time of a component,
constituted by a drag over date cells, with a possible delay at the beginning of the drag.
*/ var $5b5f46d3160e73f6$var$DateSelecting = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $dACZV._)(DateSelecting, Interaction);
    var _super = (0, $jhb1H._)(DateSelecting);
    function DateSelecting(settings) {
        (0, $5kWiG._)(this, DateSelecting);
        var _this;
        _this = _super.call(this, settings);
        _this.dragSelection = null;
        _this.handlePointerDown = function(ev) {
            var _$_assert_this_initialized = (0, $1K4o4._)(_this), component = _$_assert_this_initialized.component, dragging = _$_assert_this_initialized.dragging;
            var options = component.context.options;
            var canSelect = options.selectable && component.isValidDateDownEl(ev.origEvent.target);
            // don't bother to watch expensive moves if component won't do selection
            dragging.setIgnoreMove(!canSelect);
            // if touch, require user to hold down
            dragging.delay = ev.isTouch ? $5b5f46d3160e73f6$var$getComponentTouchDelay$1(component) : null;
        };
        _this.handleDragStart = function(ev) {
            _this.component.context.calendarApi.unselect(ev); // unselect previous selections
        };
        _this.handleHitUpdate = function(hit, isFinal) {
            var context = _this.component.context;
            var dragSelection = null;
            var isInvalid = false;
            if (hit) {
                var initialHit = _this.hitDragging.initialHit;
                var disallowed = hit.componentId === initialHit.componentId && _this.isHitComboAllowed && !_this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) dragSelection = $5b5f46d3160e73f6$var$joinHitsIntoSelection(initialHit, hit, context.pluginHooks.dateSelectionTransformers);
                if (!dragSelection || !(0, $c1gko.b_)(dragSelection, hit.dateProfile, context)) {
                    isInvalid = true;
                    dragSelection = null;
                }
            }
            if (dragSelection) context.dispatch({
                type: "SELECT_DATES",
                selection: dragSelection
            });
            else if (!isFinal) context.dispatch({
                type: "UNSELECT_DATES"
            });
            if (!isInvalid) (0, $c1gko.aw)();
            else (0, $c1gko.ax)();
            if (!isFinal) _this.dragSelection = dragSelection; // only clear if moved away from all hits while dragging
        };
        _this.handlePointerUp = function(pev) {
            if (_this.dragSelection) {
                // selection is already rendered, so just need to report selection
                (0, $c1gko.cu)(_this.dragSelection, pev, _this.component.context);
                _this.dragSelection = null;
            }
        };
        var component = settings.component;
        var options = component.context.options;
        var dragging = _this.dragging = new $5b5f46d3160e73f6$var$FeaturefulElementDragging(settings.el);
        dragging.touchScrollAllowed = false;
        dragging.minDistance = options.selectMinDistance || 0;
        dragging.autoScroller.isEnabled = options.dragScroll;
        var hitDragging = _this.hitDragging = new $5b5f46d3160e73f6$var$HitDragging(_this.dragging, (0, $c1gko.bG)(settings));
        hitDragging.emitter.on("pointerdown", _this.handlePointerDown);
        hitDragging.emitter.on("dragstart", _this.handleDragStart);
        hitDragging.emitter.on("hitupdate", _this.handleHitUpdate);
        hitDragging.emitter.on("pointerup", _this.handlePointerUp);
        return _this;
    }
    (0, $hHaEF._)(DateSelecting, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragging.destroy();
            }
        }
    ]);
    return DateSelecting;
}((0, $c1gko.Z));
function $5b5f46d3160e73f6$var$getComponentTouchDelay$1(component) {
    var options = component.context.options;
    var delay = options.selectLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
function $5b5f46d3160e73f6$var$joinHitsIntoSelection(hit0, hit1, dateSelectionTransformers) {
    var dateSpan0 = hit0.dateSpan;
    var dateSpan1 = hit1.dateSpan;
    var ms = [
        dateSpan0.range.start,
        dateSpan0.range.end,
        dateSpan1.range.start,
        dateSpan1.range.end
    ];
    ms.sort((0, $c1gko.av));
    var props = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = dateSelectionTransformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transformer = _step.value;
            var res = transformer(hit0, hit1);
            if (res === false) return null;
            if (res) Object.assign(props, res);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    props.range = {
        start: ms[0],
        end: ms[3]
    };
    props.allDay = dateSpan0.allDay;
    return props;
}
var $5b5f46d3160e73f6$var$EventDragging = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $dACZV._)(EventDragging, Interaction);
    var _super = (0, $jhb1H._)(EventDragging);
    function EventDragging(settings) {
        (0, $5kWiG._)(this, EventDragging);
        var _this;
        _this = _super.call(this, settings);
        // internal state
        _this.subjectEl = null;
        _this.subjectSeg = null; // the seg being selected/dragged
        _this.isDragging = false;
        _this.eventRange = null;
        _this.relevantEvents = null; // the events being dragged
        _this.receivingContext = null;
        _this.validMutation = null;
        _this.mutatedRelevantEvents = null;
        _this.handlePointerDown = function(ev) {
            var origTarget = ev.origEvent.target;
            var _$_assert_this_initialized = (0, $1K4o4._)(_this), component = _$_assert_this_initialized.component, dragging = _$_assert_this_initialized.dragging;
            var mirror = dragging.mirror;
            var options = component.context.options;
            var initialContext = component.context;
            _this.subjectEl = ev.subjectEl;
            var subjectSeg = _this.subjectSeg = (0, $c1gko._)(ev.subjectEl);
            var eventRange = _this.eventRange = subjectSeg.eventRange;
            var eventInstanceId = eventRange.instance.instanceId;
            _this.relevantEvents = (0, $c1gko.aV)(initialContext.getCurrentData().eventStore, eventInstanceId);
            dragging.minDistance = ev.isTouch ? 0 : options.eventDragMinDistance;
            dragging.delay = // only do a touch delay if touch and this event hasn't been selected yet
            ev.isTouch && eventInstanceId !== component.props.eventSelection ? $5b5f46d3160e73f6$var$getComponentTouchDelay(component) : null;
            if (options.fixedMirrorParent) mirror.parentNode = options.fixedMirrorParent;
            else mirror.parentNode = (0, $c1gko.$)(origTarget, ".fc");
            mirror.revertDuration = options.dragRevertDuration;
            var isValid = component.isValidSegDownEl(origTarget) && !(0, $c1gko.$)(origTarget, ".fc-event-resizer"); // NOT on a resizer
            dragging.setIgnoreMove(!isValid);
            // disable dragging for elements that are resizable (ie, selectable)
            // but are not draggable
            _this.isDragging = isValid && ev.subjectEl.classList.contains("fc-event-draggable");
        };
        _this.handleDragStart = function(ev) {
            var initialContext = _this.component.context;
            var eventRange = _this.eventRange;
            var eventInstanceId = eventRange.instance.instanceId;
            if (ev.isTouch) // need to select a different event?
            {
                if (eventInstanceId !== _this.component.props.eventSelection) initialContext.dispatch({
                    type: "SELECT_EVENT",
                    eventInstanceId: eventInstanceId
                });
            } else // if now using mouse, but was previous touch interaction, clear selected event
            initialContext.dispatch({
                type: "UNSELECT_EVENT"
            });
            if (_this.isDragging) {
                initialContext.calendarApi.unselect(ev); // unselect *date* selection
                initialContext.emitter.trigger("eventDragStart", {
                    el: _this.subjectEl,
                    event: new (0, $c1gko.a0)(initialContext, eventRange.def, eventRange.instance),
                    jsEvent: ev.origEvent,
                    view: initialContext.viewApi
                });
            }
        };
        _this.handleHitUpdate = function(hit, isFinal) {
            if (!_this.isDragging) return;
            var relevantEvents = _this.relevantEvents;
            var initialHit = _this.hitDragging.initialHit;
            var initialContext = _this.component.context;
            // states based on new hit
            var receivingContext = null;
            var mutation = null;
            var mutatedRelevantEvents = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, $c1gko.I)(),
                isEvent: true
            };
            if (hit) {
                receivingContext = hit.context;
                var receivingOptions = receivingContext.options;
                if (initialContext === receivingContext || receivingOptions.editable && receivingOptions.droppable) {
                    mutation = $5b5f46d3160e73f6$var$computeEventMutation(initialHit, hit, receivingContext.getCurrentData().pluginHooks.eventDragMutationMassagers);
                    if (mutation) {
                        mutatedRelevantEvents = (0, $c1gko.bX)(relevantEvents, receivingContext.getCurrentData().eventUiBases, mutation, receivingContext);
                        interaction.mutatedEvents = mutatedRelevantEvents;
                        if (!(0, $c1gko.bZ)(interaction, hit.dateProfile, receivingContext)) {
                            isInvalid = true;
                            mutation = null;
                            mutatedRelevantEvents = null;
                            interaction.mutatedEvents = (0, $c1gko.I)();
                        }
                    }
                } else receivingContext = null;
            }
            _this.displayDrag(receivingContext, interaction);
            if (!isInvalid) (0, $c1gko.aw)();
            else (0, $c1gko.ax)();
            if (!isFinal) {
                if (initialContext === receivingContext && // TODO: write test for this
                $5b5f46d3160e73f6$var$isHitsEqual(initialHit, hit)) mutation = null;
                _this.dragging.setMirrorNeedsRevert(!mutation);
                // render the mirror if no already-rendered mirror
                // TODO: wish we could somehow wait for dispatch to guarantee render
                _this.dragging.setMirrorIsVisible(!hit || !_this.subjectEl.getRootNode().querySelector(".fc-event-mirror"));
                // assign states based on new hit
                _this.receivingContext = receivingContext;
                _this.validMutation = mutation;
                _this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        _this.handlePointerUp = function() {
            if (!_this.isDragging) _this.cleanup(); // because handleDragEnd won't fire
        };
        _this.handleDragEnd = function(ev) {
            if (_this.isDragging) {
                var initialContext = _this.component.context;
                var initialView = initialContext.viewApi;
                var _$_assert_this_initialized = (0, $1K4o4._)(_this), receivingContext = _$_assert_this_initialized.receivingContext, validMutation = _$_assert_this_initialized.validMutation;
                var eventDef = _this.eventRange.def;
                var eventInstance = _this.eventRange.instance;
                var eventApi = new (0, $c1gko.a0)(initialContext, eventDef, eventInstance);
                var relevantEvents = _this.relevantEvents;
                var mutatedRelevantEvents = _this.mutatedRelevantEvents;
                var finalHit = _this.hitDragging.finalHit;
                _this.clearDrag(); // must happen after revert animation
                initialContext.emitter.trigger("eventDragStop", {
                    el: _this.subjectEl,
                    event: eventApi,
                    jsEvent: ev.origEvent,
                    view: initialView
                });
                if (validMutation) {
                    // dropped within same calendar
                    if (receivingContext === initialContext) {
                        var updatedEventApi = new (0, $c1gko.a0)(initialContext, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                        initialContext.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: mutatedRelevantEvents
                        });
                        var eventChangeArg = {
                            oldEvent: eventApi,
                            event: updatedEventApi,
                            relatedEvents: (0, $c1gko.w)(mutatedRelevantEvents, initialContext, eventInstance),
                            revert: function() {
                                initialContext.dispatch({
                                    type: "MERGE_EVENTS",
                                    eventStore: relevantEvents
                                });
                            }
                        };
                        var transformed = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = initialContext.getCurrentData().pluginHooks.eventDropTransformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var transformer = _step.value;
                                Object.assign(transformed, transformer(validMutation, initialContext));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        initialContext.emitter.trigger("eventDrop", Object.assign(Object.assign(Object.assign({}, eventChangeArg), transformed), {
                            el: ev.subjectEl,
                            delta: validMutation.datesDelta,
                            jsEvent: ev.origEvent,
                            view: initialView
                        }));
                        initialContext.emitter.trigger("eventChange", eventChangeArg);
                    // dropped in different calendar
                    } else if (receivingContext) {
                        var eventRemoveArg = {
                            event: eventApi,
                            relatedEvents: (0, $c1gko.w)(relevantEvents, initialContext, eventInstance),
                            revert: function() {
                                initialContext.dispatch({
                                    type: "MERGE_EVENTS",
                                    eventStore: relevantEvents
                                });
                            }
                        };
                        initialContext.emitter.trigger("eventLeave", Object.assign(Object.assign({}, eventRemoveArg), {
                            draggedEl: ev.subjectEl,
                            view: initialView
                        }));
                        initialContext.dispatch({
                            type: "REMOVE_EVENTS",
                            eventStore: relevantEvents
                        });
                        initialContext.emitter.trigger("eventRemove", eventRemoveArg);
                        var addedEventDef = mutatedRelevantEvents.defs[eventDef.defId];
                        var addedEventInstance = mutatedRelevantEvents.instances[eventInstance.instanceId];
                        var addedEventApi = new (0, $c1gko.a0)(receivingContext, addedEventDef, addedEventInstance);
                        receivingContext.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: mutatedRelevantEvents
                        });
                        var eventAddArg = {
                            event: addedEventApi,
                            relatedEvents: (0, $c1gko.w)(mutatedRelevantEvents, receivingContext, addedEventInstance),
                            revert: function() {
                                receivingContext.dispatch({
                                    type: "REMOVE_EVENTS",
                                    eventStore: mutatedRelevantEvents
                                });
                            }
                        };
                        receivingContext.emitter.trigger("eventAdd", eventAddArg);
                        if (ev.isTouch) receivingContext.dispatch({
                            type: "SELECT_EVENT",
                            eventInstanceId: eventInstance.instanceId
                        });
                        receivingContext.emitter.trigger("drop", Object.assign(Object.assign({}, $5b5f46d3160e73f6$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                            draggedEl: ev.subjectEl,
                            jsEvent: ev.origEvent,
                            view: finalHit.context.viewApi
                        }));
                        receivingContext.emitter.trigger("eventReceive", Object.assign(Object.assign({}, eventAddArg), {
                            draggedEl: ev.subjectEl,
                            view: finalHit.context.viewApi
                        }));
                    }
                } else initialContext.emitter.trigger("_noEventDrop");
            }
            _this.cleanup();
        };
        var component = (0, $1K4o4._)(_this).component;
        var options = component.context.options;
        var dragging = _this.dragging = new $5b5f46d3160e73f6$var$FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = EventDragging.SELECTOR;
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = options.dragScroll;
        var hitDragging = _this.hitDragging = new $5b5f46d3160e73f6$var$HitDragging(_this.dragging, (0, $c1gko.a7));
        hitDragging.useSubjectCenter = settings.useEventCenter;
        hitDragging.emitter.on("pointerdown", _this.handlePointerDown);
        hitDragging.emitter.on("dragstart", _this.handleDragStart);
        hitDragging.emitter.on("hitupdate", _this.handleHitUpdate);
        hitDragging.emitter.on("pointerup", _this.handlePointerUp);
        hitDragging.emitter.on("dragend", _this.handleDragEnd);
        return _this;
    }
    (0, $hHaEF._)(EventDragging, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragging.destroy();
            }
        },
        {
            // render a drag state on the next receivingCalendar
            key: "displayDrag",
            value: function displayDrag(nextContext, state) {
                var initialContext = this.component.context;
                var prevContext = this.receivingContext;
                // does the previous calendar need to be cleared?
                if (prevContext && prevContext !== nextContext) {
                    // does the initial calendar need to be cleared?
                    // if so, don't clear all the way. we still need to to hide the affectedEvents
                    if (prevContext === initialContext) prevContext.dispatch({
                        type: "SET_EVENT_DRAG",
                        state: {
                            affectedEvents: state.affectedEvents,
                            mutatedEvents: (0, $c1gko.I)(),
                            isEvent: true
                        }
                    });
                    else prevContext.dispatch({
                        type: "UNSET_EVENT_DRAG"
                    });
                }
                if (nextContext) nextContext.dispatch({
                    type: "SET_EVENT_DRAG",
                    state: state
                });
            }
        },
        {
            key: "clearDrag",
            value: function clearDrag() {
                var initialCalendar = this.component.context;
                var receivingContext = this.receivingContext;
                if (receivingContext) receivingContext.dispatch({
                    type: "UNSET_EVENT_DRAG"
                });
                // the initial calendar might have an dummy drag state from displayDrag
                if (initialCalendar !== receivingContext) initialCalendar.dispatch({
                    type: "UNSET_EVENT_DRAG"
                });
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                this.subjectSeg = null;
                this.isDragging = false;
                this.eventRange = null;
                this.relevantEvents = null;
                this.receivingContext = null;
                this.validMutation = null;
                this.mutatedRelevantEvents = null;
            }
        }
    ]);
    return EventDragging;
}((0, $c1gko.Z));
// TODO: test this in IE11
// QUESTION: why do we need it on the resizable???
$5b5f46d3160e73f6$var$EventDragging.SELECTOR = ".fc-event-draggable, .fc-event-resizable";
function $5b5f46d3160e73f6$var$computeEventMutation(hit0, hit1, massagers) {
    var dateSpan0 = hit0.dateSpan;
    var dateSpan1 = hit1.dateSpan;
    var date0 = dateSpan0.range.start;
    var date1 = dateSpan1.range.start;
    var standardProps = {};
    if (dateSpan0.allDay !== dateSpan1.allDay) {
        standardProps.allDay = dateSpan1.allDay;
        standardProps.hasEnd = hit1.context.options.allDayMaintainDuration;
        if (dateSpan1.allDay) // means date1 is already start-of-day,
        // but date0 needs to be converted
        date0 = (0, $c1gko.q)(date0);
    }
    var delta = (0, $c1gko.aA)(date0, date1, hit0.context.dateEnv, hit0.componentId === hit1.componentId ? hit0.largeUnit : null);
    if (delta.milliseconds) standardProps.allDay = false;
    var mutation = {
        datesDelta: delta,
        standardProps: standardProps
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = massagers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var massager = _step.value;
            massager(mutation, hit0, hit1);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mutation;
}
function $5b5f46d3160e73f6$var$getComponentTouchDelay(component) {
    var options = component.context.options;
    var delay = options.eventLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
var $5b5f46d3160e73f6$var$EventResizing = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $dACZV._)(EventResizing, Interaction);
    var _super = (0, $jhb1H._)(EventResizing);
    function EventResizing(settings) {
        (0, $5kWiG._)(this, EventResizing);
        var _this;
        _this = _super.call(this, settings);
        // internal state
        _this.draggingSegEl = null;
        _this.draggingSeg = null; // TODO: rename to resizingSeg? subjectSeg?
        _this.eventRange = null;
        _this.relevantEvents = null;
        _this.validMutation = null;
        _this.mutatedRelevantEvents = null;
        _this.handlePointerDown = function(ev) {
            var component = (0, $1K4o4._)(_this).component;
            var segEl = _this.querySegEl(ev);
            var seg = (0, $c1gko._)(segEl);
            var eventRange = _this.eventRange = seg.eventRange;
            _this.dragging.minDistance = component.context.options.eventDragMinDistance;
            // if touch, need to be working with a selected event
            _this.dragging.setIgnoreMove(!_this.component.isValidSegDownEl(ev.origEvent.target) || ev.isTouch && _this.component.props.eventSelection !== eventRange.instance.instanceId);
        };
        _this.handleDragStart = function(ev) {
            var context = _this.component.context;
            var eventRange = _this.eventRange;
            _this.relevantEvents = (0, $c1gko.aV)(context.getCurrentData().eventStore, _this.eventRange.instance.instanceId);
            var segEl = _this.querySegEl(ev);
            _this.draggingSegEl = segEl;
            _this.draggingSeg = (0, $c1gko._)(segEl);
            context.calendarApi.unselect();
            context.emitter.trigger("eventResizeStart", {
                el: segEl,
                event: new (0, $c1gko.a0)(context, eventRange.def, eventRange.instance),
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
        };
        _this.handleHitUpdate = function(hit, isFinal, ev) {
            var context = _this.component.context;
            var relevantEvents = _this.relevantEvents;
            var initialHit = _this.hitDragging.initialHit;
            var eventInstance = _this.eventRange.instance;
            var mutation = null;
            var mutatedRelevantEvents = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, $c1gko.I)(),
                isEvent: true
            };
            if (hit) {
                var disallowed = hit.componentId === initialHit.componentId && _this.isHitComboAllowed && !_this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) mutation = $5b5f46d3160e73f6$var$computeMutation(initialHit, hit, ev.subjectEl.classList.contains("fc-event-resizer-start"), eventInstance.range);
            }
            if (mutation) {
                mutatedRelevantEvents = (0, $c1gko.bX)(relevantEvents, context.getCurrentData().eventUiBases, mutation, context);
                interaction.mutatedEvents = mutatedRelevantEvents;
                if (!(0, $c1gko.bZ)(interaction, hit.dateProfile, context)) {
                    isInvalid = true;
                    mutation = null;
                    mutatedRelevantEvents = null;
                    interaction.mutatedEvents = null;
                }
            }
            if (mutatedRelevantEvents) context.dispatch({
                type: "SET_EVENT_RESIZE",
                state: interaction
            });
            else context.dispatch({
                type: "UNSET_EVENT_RESIZE"
            });
            if (!isInvalid) (0, $c1gko.aw)();
            else (0, $c1gko.ax)();
            if (!isFinal) {
                if (mutation && $5b5f46d3160e73f6$var$isHitsEqual(initialHit, hit)) mutation = null;
                _this.validMutation = mutation;
                _this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        _this.handleDragEnd = function(ev) {
            var context = _this.component.context;
            var eventDef = _this.eventRange.def;
            var eventInstance = _this.eventRange.instance;
            var eventApi = new (0, $c1gko.a0)(context, eventDef, eventInstance);
            var relevantEvents = _this.relevantEvents;
            var mutatedRelevantEvents = _this.mutatedRelevantEvents;
            context.emitter.trigger("eventResizeStop", {
                el: _this.draggingSegEl,
                event: eventApi,
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
            if (_this.validMutation) {
                var updatedEventApi = new (0, $c1gko.a0)(context, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                context.dispatch({
                    type: "MERGE_EVENTS",
                    eventStore: mutatedRelevantEvents
                });
                var eventChangeArg = {
                    oldEvent: eventApi,
                    event: updatedEventApi,
                    relatedEvents: (0, $c1gko.w)(mutatedRelevantEvents, context, eventInstance),
                    revert: function() {
                        context.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: relevantEvents
                        });
                    }
                };
                context.emitter.trigger("eventResize", Object.assign(Object.assign({}, eventChangeArg), {
                    el: _this.draggingSegEl,
                    startDelta: _this.validMutation.startDelta || (0, $c1gko.d)(0),
                    endDelta: _this.validMutation.endDelta || (0, $c1gko.d)(0),
                    jsEvent: ev.origEvent,
                    view: context.viewApi
                }));
                context.emitter.trigger("eventChange", eventChangeArg);
            } else context.emitter.trigger("_noEventResize");
            // reset all internal state
            _this.draggingSeg = null;
            _this.relevantEvents = null;
            _this.validMutation = null;
        // okay to keep eventInstance around. useful to set it in handlePointerDown
        };
        var component = settings.component;
        var dragging = _this.dragging = new $5b5f46d3160e73f6$var$FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = ".fc-event-resizer";
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = component.context.options.dragScroll;
        var hitDragging = _this.hitDragging = new $5b5f46d3160e73f6$var$HitDragging(_this.dragging, (0, $c1gko.bG)(settings));
        hitDragging.emitter.on("pointerdown", _this.handlePointerDown);
        hitDragging.emitter.on("dragstart", _this.handleDragStart);
        hitDragging.emitter.on("hitupdate", _this.handleHitUpdate);
        hitDragging.emitter.on("dragend", _this.handleDragEnd);
        return _this;
    }
    (0, $hHaEF._)(EventResizing, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragging.destroy();
            }
        },
        {
            key: "querySegEl",
            value: function querySegEl(ev) {
                return (0, $c1gko.$)(ev.subjectEl, ".fc-event");
            }
        }
    ]);
    return EventResizing;
}((0, $c1gko.Z));
function $5b5f46d3160e73f6$var$computeMutation(hit0, hit1, isFromStart, instanceRange) {
    var dateEnv = hit0.context.dateEnv;
    var date0 = hit0.dateSpan.range.start;
    var date1 = hit1.dateSpan.range.start;
    var delta = (0, $c1gko.aA)(date0, date1, dateEnv, hit0.largeUnit);
    if (isFromStart) {
        if (dateEnv.add(instanceRange.start, delta) < instanceRange.end) return {
            startDelta: delta
        };
    } else if (dateEnv.add(instanceRange.end, delta) > instanceRange.start) return {
        endDelta: delta
    };
    return null;
}
var $5b5f46d3160e73f6$var$UnselectAuto = /*#__PURE__*/ function() {
    "use strict";
    function UnselectAuto(context) {
        var _this = this;
        (0, $5kWiG._)(this, UnselectAuto);
        this.context = context;
        this.isRecentPointerDateSelect = false; // wish we could use a selector to detect date selection, but uses hit system
        this.matchesCancel = false;
        this.matchesEvent = false;
        this.onSelect = function(selectInfo) {
            if (selectInfo.jsEvent) _this.isRecentPointerDateSelect = true;
        };
        this.onDocumentPointerDown = function(pev) {
            var unselectCancel = _this.context.options.unselectCancel;
            var downEl = (0, $c1gko.aR)(pev.origEvent);
            _this.matchesCancel = !!(0, $c1gko.$)(downEl, unselectCancel);
            _this.matchesEvent = !!(0, $c1gko.$)(downEl, $5b5f46d3160e73f6$var$EventDragging.SELECTOR); // interaction started on an event?
        };
        this.onDocumentPointerUp = function(pev) {
            var _$context = _this.context;
            var documentPointer = _this.documentPointer;
            var calendarState = _$context.getCurrentData();
            // touch-scrolling should never unfocus any type of selection
            if (!documentPointer.wasTouchScroll) {
                if (calendarState.dateSelection && // an existing date selection?
                !_this.isRecentPointerDateSelect // a new pointer-initiated date selection since last onDocumentPointerUp?
                ) {
                    var unselectAuto = _$context.options.unselectAuto;
                    if (unselectAuto && (!unselectAuto || !_this.matchesCancel)) _$context.calendarApi.unselect(pev);
                }
                if (calendarState.eventSelection && // an existing event selected?
                !_this.matchesEvent // interaction DIDN'T start on an event
                ) _$context.dispatch({
                    type: "UNSELECT_EVENT"
                });
            }
            _this.isRecentPointerDateSelect = false;
        };
        var documentPointer = this.documentPointer = new $5b5f46d3160e73f6$var$PointerDragging(document);
        documentPointer.shouldIgnoreMove = true;
        documentPointer.shouldWatchScroll = false;
        documentPointer.emitter.on("pointerdown", this.onDocumentPointerDown);
        documentPointer.emitter.on("pointerup", this.onDocumentPointerUp);
        /*
        TODO: better way to know about whether there was a selection with the pointer
        */ context.emitter.on("select", this.onSelect);
    }
    (0, $hHaEF._)(UnselectAuto, [
        {
            key: "destroy",
            value: function destroy() {
                this.context.emitter.off("select", this.onSelect);
                this.documentPointer.destroy();
            }
        }
    ]);
    return UnselectAuto;
}();
var $5b5f46d3160e73f6$var$OPTION_REFINERS = {
    fixedMirrorParent: (0, $c1gko.n)
};
var $5b5f46d3160e73f6$var$LISTENER_REFINERS = {
    dateClick: (0, $c1gko.n),
    eventDragStart: (0, $c1gko.n),
    eventDragStop: (0, $c1gko.n),
    eventDrop: (0, $c1gko.n),
    eventResizeStart: (0, $c1gko.n),
    eventResizeStop: (0, $c1gko.n),
    eventResize: (0, $c1gko.n),
    drop: (0, $c1gko.n),
    eventReceive: (0, $c1gko.n),
    eventLeave: (0, $c1gko.n)
};
/*
Given an already instantiated draggable object for one-or-more elements,
Interprets any dragging as an attempt to drag an events that lives outside
of a calendar onto a calendar.
*/ var $5b5f46d3160e73f6$var$ExternalElementDragging = /*#__PURE__*/ function() {
    "use strict";
    function ExternalElementDragging(dragging, suppliedDragMeta) {
        var _this = this;
        (0, $5kWiG._)(this, ExternalElementDragging);
        this.receivingContext = null;
        this.droppableEvent = null; // will exist for all drags, even if create:false
        this.suppliedDragMeta = null;
        this.dragMeta = null;
        this.handleDragStart = function(ev) {
            _this.dragMeta = _this.buildDragMeta(ev.subjectEl);
        };
        this.handleHitUpdate = function(hit, isFinal, ev) {
            var _$dragging = _this.hitDragging.dragging;
            var receivingContext = null;
            var droppableEvent = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: (0, $c1gko.I)(),
                mutatedEvents: (0, $c1gko.I)(),
                isEvent: _this.dragMeta.create
            };
            if (hit) {
                receivingContext = hit.context;
                if (_this.canDropElOnCalendar(ev.subjectEl, receivingContext)) {
                    droppableEvent = $5b5f46d3160e73f6$var$computeEventForDateSpan(hit.dateSpan, _this.dragMeta, receivingContext);
                    interaction.mutatedEvents = (0, $c1gko.aW)(droppableEvent);
                    isInvalid = !(0, $c1gko.bZ)(interaction, hit.dateProfile, receivingContext);
                    if (isInvalid) {
                        interaction.mutatedEvents = (0, $c1gko.I)();
                        droppableEvent = null;
                    }
                }
            }
            _this.displayDrag(receivingContext, interaction);
            // show mirror if no already-rendered mirror element OR if we are shutting down the mirror (?)
            // TODO: wish we could somehow wait for dispatch to guarantee render
            _$dragging.setMirrorIsVisible(isFinal || !droppableEvent || !document.querySelector(".fc-event-mirror"));
            if (!isInvalid) (0, $c1gko.aw)();
            else (0, $c1gko.ax)();
            if (!isFinal) {
                _$dragging.setMirrorNeedsRevert(!droppableEvent);
                _this.receivingContext = receivingContext;
                _this.droppableEvent = droppableEvent;
            }
        };
        this.handleDragEnd = function(pev) {
            var receivingContext = _this.receivingContext, droppableEvent = _this.droppableEvent;
            _this.clearDrag();
            if (receivingContext && droppableEvent) {
                var finalHit = _this.hitDragging.finalHit;
                var finalView = finalHit.context.viewApi;
                var dragMeta = _this.dragMeta;
                receivingContext.emitter.trigger("drop", Object.assign(Object.assign({}, $5b5f46d3160e73f6$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                    draggedEl: pev.subjectEl,
                    jsEvent: pev.origEvent,
                    view: finalView
                }));
                if (dragMeta.create) {
                    var addingEvents = (0, $c1gko.aW)(droppableEvent);
                    receivingContext.dispatch({
                        type: "MERGE_EVENTS",
                        eventStore: addingEvents
                    });
                    if (pev.isTouch) receivingContext.dispatch({
                        type: "SELECT_EVENT",
                        eventInstanceId: droppableEvent.instance.instanceId
                    });
                    // signal that an external event landed
                    receivingContext.emitter.trigger("eventReceive", {
                        event: new (0, $c1gko.a0)(receivingContext, droppableEvent.def, droppableEvent.instance),
                        relatedEvents: [],
                        revert: function() {
                            receivingContext.dispatch({
                                type: "REMOVE_EVENTS",
                                eventStore: addingEvents
                            });
                        },
                        draggedEl: pev.subjectEl,
                        view: finalView
                    });
                }
            }
            _this.receivingContext = null;
            _this.droppableEvent = null;
        };
        var hitDragging = this.hitDragging = new $5b5f46d3160e73f6$var$HitDragging(dragging, (0, $c1gko.a7));
        hitDragging.requireInitial = false; // will start outside of a component
        hitDragging.emitter.on("dragstart", this.handleDragStart);
        hitDragging.emitter.on("hitupdate", this.handleHitUpdate);
        hitDragging.emitter.on("dragend", this.handleDragEnd);
        this.suppliedDragMeta = suppliedDragMeta;
    }
    (0, $hHaEF._)(ExternalElementDragging, [
        {
            key: "buildDragMeta",
            value: function buildDragMeta(subjectEl) {
                if (typeof this.suppliedDragMeta === "object") return (0, $c1gko.bJ)(this.suppliedDragMeta);
                if (typeof this.suppliedDragMeta === "function") return (0, $c1gko.bJ)(this.suppliedDragMeta(subjectEl));
                return $5b5f46d3160e73f6$var$getDragMetaFromEl(subjectEl);
            }
        },
        {
            key: "displayDrag",
            value: function displayDrag(nextContext, state) {
                var prevContext = this.receivingContext;
                if (prevContext && prevContext !== nextContext) prevContext.dispatch({
                    type: "UNSET_EVENT_DRAG"
                });
                if (nextContext) nextContext.dispatch({
                    type: "SET_EVENT_DRAG",
                    state: state
                });
            }
        },
        {
            key: "clearDrag",
            value: function clearDrag() {
                if (this.receivingContext) this.receivingContext.dispatch({
                    type: "UNSET_EVENT_DRAG"
                });
            }
        },
        {
            key: "canDropElOnCalendar",
            value: function canDropElOnCalendar(el, receivingContext) {
                var dropAccept = receivingContext.options.dropAccept;
                if (typeof dropAccept === "function") return dropAccept.call(receivingContext.calendarApi, el);
                if (typeof dropAccept === "string" && dropAccept) return Boolean((0, $c1gko.aQ)(el, dropAccept));
                return true;
            }
        }
    ]);
    return ExternalElementDragging;
}();
// Utils for computing event store from the DragMeta
// ----------------------------------------------------------------------------------------------------
function $5b5f46d3160e73f6$var$computeEventForDateSpan(dateSpan, dragMeta, context) {
    var defProps = Object.assign({}, dragMeta.leftoverProps);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.externalDefTransforms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transform = _step.value;
            Object.assign(defProps, transform(dateSpan, dragMeta));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _refineEventDef = (0, $c1gko.al)(defProps, context), refined = _refineEventDef.refined, extra = _refineEventDef.extra;
    var def = (0, $c1gko.ak)(refined, extra, dragMeta.sourceId, dateSpan.allDay, context.options.forceEventDuration || Boolean(dragMeta.duration), context);
    var start = dateSpan.range.start;
    // only rely on time info if drop zone is all-day,
    // otherwise, we already know the time
    if (dateSpan.allDay && dragMeta.startTime) start = context.dateEnv.add(start, dragMeta.startTime);
    var end = dragMeta.duration ? context.dateEnv.add(start, dragMeta.duration) : (0, $c1gko.cv)(dateSpan.allDay, start, context);
    var instance = (0, $c1gko.aj)(def.defId, {
        start: start,
        end: end
    });
    return {
        def: def,
        instance: instance
    };
}
// Utils for extracting data from element
// ----------------------------------------------------------------------------------------------------
function $5b5f46d3160e73f6$var$getDragMetaFromEl(el) {
    var str = $5b5f46d3160e73f6$var$getEmbeddedElData(el, "event");
    var obj = str ? JSON.parse(str) : {
        create: false
    }; // if no embedded data, assume no event creation
    return (0, $c1gko.bJ)(obj);
}
(0, $c1gko.bI).dataAttrPrefix = "";
function $5b5f46d3160e73f6$var$getEmbeddedElData(el, name) {
    var prefix = (0, $c1gko.bI).dataAttrPrefix;
    var prefixedName = (prefix ? prefix + "-" : "") + name;
    return el.getAttribute("data-" + prefixedName) || "";
}
/*
Makes an element (that is *external* to any calendar) draggable.
Can pass in data that determines how an event will be created when dropped onto a calendar.
Leverages FullCalendar's internal drag-n-drop functionality WITHOUT a third-party drag system.
*/ var $5b5f46d3160e73f6$export$f2a139e5d18b9882 = /*#__PURE__*/ function() {
    "use strict";
    function ExternalDraggable(el) {
        var settings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _this = this;
        (0, $5kWiG._)(this, ExternalDraggable);
        this.handlePointerDown = function(ev) {
            var dragging = _this.dragging;
            var _this_settings = _this.settings, minDistance = _this_settings.minDistance, longPressDelay = _this_settings.longPressDelay;
            dragging.minDistance = minDistance != null ? minDistance : ev.isTouch ? 0 : (0, $c1gko.e).eventDragMinDistance;
            dragging.delay = ev.isTouch ? longPressDelay != null ? longPressDelay : (0, $c1gko.e).longPressDelay : 0;
        };
        this.handleDragStart = function(ev) {
            if (ev.isTouch && _this.dragging.delay && ev.subjectEl.classList.contains("fc-event")) _this.dragging.mirror.getMirrorEl().classList.add("fc-event-selected");
        };
        this.settings = settings;
        var dragging = this.dragging = new $5b5f46d3160e73f6$var$FeaturefulElementDragging(el);
        dragging.touchScrollAllowed = false;
        if (settings.itemSelector != null) dragging.pointer.selector = settings.itemSelector;
        if (settings.appendTo != null) dragging.mirror.parentNode = settings.appendTo; // TODO: write tests
        dragging.emitter.on("pointerdown", this.handlePointerDown);
        dragging.emitter.on("dragstart", this.handleDragStart);
        new $5b5f46d3160e73f6$var$ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
    (0, $hHaEF._)(ExternalDraggable, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragging.destroy();
            }
        }
    ]);
    return ExternalDraggable;
}();
/*
Detects when a *THIRD-PARTY* drag-n-drop system interacts with elements.
The third-party system is responsible for drawing the visuals effects of the drag.
This class simply monitors for pointer movements and fires events.
It also has the ability to hide the moving element (the "mirror") during the drag.
*/ var $5b5f46d3160e73f6$var$InferredElementDragging = /*#__PURE__*/ function(ElementDragging) {
    "use strict";
    (0, $dACZV._)(InferredElementDragging, ElementDragging);
    var _super = (0, $jhb1H._)(InferredElementDragging);
    function InferredElementDragging(containerEl) {
        (0, $5kWiG._)(this, InferredElementDragging);
        var _this;
        _this = _super.call(this, containerEl);
        _this.shouldIgnoreMove = false;
        _this.mirrorSelector = "";
        _this.currentMirrorEl = null;
        _this.handlePointerDown = function(ev) {
            _this.emitter.trigger("pointerdown", ev);
            if (!_this.shouldIgnoreMove) // fire dragstart right away. does not support delay or min-distance
            _this.emitter.trigger("dragstart", ev);
        };
        _this.handlePointerMove = function(ev) {
            if (!_this.shouldIgnoreMove) _this.emitter.trigger("dragmove", ev);
        };
        _this.handlePointerUp = function(ev) {
            _this.emitter.trigger("pointerup", ev);
            if (!_this.shouldIgnoreMove) // fire dragend right away. does not support a revert animation
            _this.emitter.trigger("dragend", ev);
        };
        var pointer = _this.pointer = new $5b5f46d3160e73f6$var$PointerDragging(containerEl);
        pointer.emitter.on("pointerdown", _this.handlePointerDown);
        pointer.emitter.on("pointermove", _this.handlePointerMove);
        pointer.emitter.on("pointerup", _this.handlePointerUp);
        return _this;
    }
    (0, $hHaEF._)(InferredElementDragging, [
        {
            key: "destroy",
            value: function destroy() {
                this.pointer.destroy();
            }
        },
        {
            key: "setIgnoreMove",
            value: function setIgnoreMove(bool) {
                this.shouldIgnoreMove = bool;
            }
        },
        {
            key: "setMirrorIsVisible",
            value: function setMirrorIsVisible(bool) {
                if (bool) // restore a previously hidden element.
                // use the reference in case the selector class has already been removed.
                {
                    if (this.currentMirrorEl) {
                        this.currentMirrorEl.style.visibility = "";
                        this.currentMirrorEl = null;
                    }
                } else {
                    var mirrorEl = this.mirrorSelector ? document.querySelector(this.mirrorSelector) : null;
                    if (mirrorEl) {
                        this.currentMirrorEl = mirrorEl;
                        mirrorEl.style.visibility = "hidden";
                    }
                }
            }
        }
    ]);
    return InferredElementDragging;
}((0, $c1gko.bH));
/*
Bridges third-party drag-n-drop systems with FullCalendar.
Must be instantiated and destroyed by caller.
*/ var $5b5f46d3160e73f6$export$51e5e9a9728fcd8f = /*#__PURE__*/ function() {
    "use strict";
    function ThirdPartyDraggable(containerOrSettings, settings) {
        (0, $5kWiG._)(this, ThirdPartyDraggable);
        var containerEl = document;
        if (// wish we could just test instanceof EventTarget, but doesn't work in IE11
        containerOrSettings === document || containerOrSettings instanceof Element) {
            containerEl = containerOrSettings;
            settings = settings || {};
        } else settings = containerOrSettings || {};
        var dragging = this.dragging = new $5b5f46d3160e73f6$var$InferredElementDragging(containerEl);
        if (typeof settings.itemSelector === "string") dragging.pointer.selector = settings.itemSelector;
        else if (containerEl === document) dragging.pointer.selector = "[data-event]";
        if (typeof settings.mirrorSelector === "string") dragging.mirrorSelector = settings.mirrorSelector;
        new $5b5f46d3160e73f6$var$ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
    (0, $hHaEF._)(ThirdPartyDraggable, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragging.destroy();
            }
        }
    ]);
    return ThirdPartyDraggable;
}();
var $5b5f46d3160e73f6$export$2e2bcd8739ae039 = (0, $e3844b7a193593a0$export$ae829ec7b2625219)({
    name: "@fullcalendar/interaction",
    componentInteractions: [
        $5b5f46d3160e73f6$var$DateClicking,
        $5b5f46d3160e73f6$var$DateSelecting,
        $5b5f46d3160e73f6$var$EventDragging,
        $5b5f46d3160e73f6$var$EventResizing
    ],
    calendarInteractions: [
        $5b5f46d3160e73f6$var$UnselectAuto
    ],
    elementDraggingImpl: $5b5f46d3160e73f6$var$FeaturefulElementDragging,
    optionRefiners: $5b5f46d3160e73f6$var$OPTION_REFINERS,
    listenerRefiners: $5b5f46d3160e73f6$var$LISTENER_REFINERS
});




var $fTHFs = parcelRequire("fTHFs");



var $637b468806477ab0$var$OPTION_REFINERS = {
    allDaySlot: Boolean
};
var $637b468806477ab0$export$2e2bcd8739ae039 = (0, $e3844b7a193593a0$export$ae829ec7b2625219)({
    name: "@fullcalendar/timegrid",
    initialView: "timeGridWeek",
    optionRefiners: $637b468806477ab0$var$OPTION_REFINERS,
    views: {
        timeGrid: {
            component: (0, $fTHFs.DayTimeColsView),
            usesMinMaxTime: true,
            allDaySlot: true,
            slotDuration: "00:30:00",
            slotEventOverlap: true
        },
        timeGridDay: {
            type: "timeGrid",
            duration: {
                days: 1
            }
        },
        timeGridWeek: {
            type: "timeGrid",
            duration: {
                weeks: 1
            }
        }
    }
});




var $1K4o4 = parcelRequire("1K4o4");

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $dACZV = parcelRequire("dACZV");

var $5TJQB = parcelRequire("5TJQB");

var $jhb1H = parcelRequire("jhb1H");

var $c1gko = parcelRequire("c1gko");

var $kgSvt = parcelRequire("kgSvt");
var $cd830f567579f3dc$var$ListViewHeaderRow = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(ListViewHeaderRow, BaseComponent);
    var _super = (0, $jhb1H._)(ListViewHeaderRow);
    function ListViewHeaderRow() {
        (0, $5kWiG._)(this, ListViewHeaderRow);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.state = {
            textId: (0, $c1gko.a5)()
        };
        return _this;
    }
    (0, $hHaEF._)(ListViewHeaderRow, [
        {
            key: "render",
            value: function render() {
                var _this_context = this.context, theme = _this_context.theme, dateEnv = _this_context.dateEnv, options = _this_context.options, viewApi = _this_context.viewApi;
                var _this_props = this.props, cellId = _this_props.cellId, dayDate = _this_props.dayDate, todayRange = _this_props.todayRange;
                var textId = this.state.textId;
                var dayMeta = (0, $c1gko.a_)(dayDate, todayRange);
                // will ever be falsy?
                var text = options.listDayFormat ? dateEnv.format(dayDate, options.listDayFormat) : "";
                // will ever be falsy? also, BAD NAME "alt"
                var sideText = options.listDaySideFormat ? dateEnv.format(dayDate, options.listDaySideFormat) : "";
                var renderProps = Object.assign({
                    date: dateEnv.toDate(dayDate),
                    view: viewApi,
                    textId: textId,
                    text: text,
                    sideText: sideText,
                    navLinkAttrs: (0, $c1gko.b0)(this.context, dayDate),
                    sideNavLinkAttrs: (0, $c1gko.b0)(this.context, dayDate, "day", false)
                }, dayMeta);
                // TODO: make a reusable HOC for dayHeader (used in daygrid/timegrid too)
                return (0, $kgSvt.createElement)((0, $c1gko.C), {
                    elTag: "tr",
                    elClasses: [
                        "fc-list-day"
                    ].concat((0, $5TJQB._)((0, $c1gko.aZ)(dayMeta, theme))),
                    elAttrs: {
                        "data-date": (0, $c1gko.bv)(dayDate)
                    },
                    renderProps: renderProps,
                    generatorName: "dayHeaderContent",
                    customGenerator: options.dayHeaderContent,
                    defaultGenerator: $cd830f567579f3dc$var$renderInnerContent,
                    classNameGenerator: options.dayHeaderClassNames,
                    didMount: options.dayHeaderDidMount,
                    willUnmount: options.dayHeaderWillUnmount
                }, function(InnerContent) {
                    return (0, $kgSvt.createElement)("th", {
                        scope: "colgroup",
                        colSpan: 3,
                        id: cellId,
                        "aria-labelledby": textId
                    }, (0, $kgSvt.createElement)(InnerContent, {
                        elTag: "div",
                        elClasses: [
                            "fc-list-day-cushion",
                            theme.getClass("tableCellShaded")
                        ]
                    }));
                });
            }
        }
    ]);
    return ListViewHeaderRow;
}((0, $c1gko.B));
function $cd830f567579f3dc$var$renderInnerContent(props) {
    return (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, props.text && (0, $kgSvt.createElement)("a", Object.assign({
        id: props.textId,
        className: "fc-list-day-text"
    }, props.navLinkAttrs), props.text), props.sideText && /* not keyboard tabbable */ (0, $kgSvt.createElement)("a", Object.assign({
        "aria-hidden": true,
        className: "fc-list-day-side-text"
    }, props.sideNavLinkAttrs), props.sideText));
}
var $cd830f567579f3dc$var$DEFAULT_TIME_FORMAT = (0, $c1gko.x)({
    hour: "numeric",
    minute: "2-digit",
    meridiem: "short"
});
var $cd830f567579f3dc$var$ListViewEventRow = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $dACZV._)(ListViewEventRow, BaseComponent);
    var _super = (0, $jhb1H._)(ListViewEventRow);
    function ListViewEventRow() {
        (0, $5kWiG._)(this, ListViewEventRow);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(ListViewEventRow, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var seg = props.seg, timeHeaderId = props.timeHeaderId, eventHeaderId = props.eventHeaderId, dateHeaderId = props.dateHeaderId;
                var timeFormat = options.eventTimeFormat || $cd830f567579f3dc$var$DEFAULT_TIME_FORMAT;
                return (0, $kgSvt.createElement)((0, $c1gko.cn), Object.assign({}, props, {
                    elTag: "tr",
                    elClasses: [
                        "fc-list-event",
                        seg.eventRange.def.url && "fc-event-forced-url"
                    ],
                    defaultGenerator: function() {
                        return $cd830f567579f3dc$var$renderEventInnerContent(seg, context);
                    },
                    seg: seg,
                    timeText: "",
                    disableDragging: true,
                    disableResizing: true
                }), function(InnerContent, eventContentArg) {
                    return (0, $kgSvt.createElement)((0, $kgSvt.Fragment), null, $cd830f567579f3dc$var$buildTimeContent(seg, timeFormat, context, timeHeaderId, dateHeaderId), (0, $kgSvt.createElement)("td", {
                        "aria-hidden": true,
                        className: "fc-list-event-graphic"
                    }, (0, $kgSvt.createElement)("span", {
                        className: "fc-list-event-dot",
                        style: {
                            borderColor: eventContentArg.borderColor || eventContentArg.backgroundColor
                        }
                    })), (0, $kgSvt.createElement)(InnerContent, {
                        elTag: "td",
                        elClasses: [
                            "fc-list-event-title"
                        ],
                        elAttrs: {
                            headers: "".concat(eventHeaderId, " ").concat(dateHeaderId)
                        }
                    }));
                });
            }
        }
    ]);
    return ListViewEventRow;
}((0, $c1gko.B));
function $cd830f567579f3dc$var$renderEventInnerContent(seg, context) {
    var interactiveAttrs = (0, $c1gko.bU)(seg, context);
    return (0, $kgSvt.createElement)("a", Object.assign({}, interactiveAttrs), seg.eventRange.def.title);
}
function $cd830f567579f3dc$var$buildTimeContent(seg, timeFormat, context, timeHeaderId, dateHeaderId) {
    var options = context.options;
    if (options.displayEventTime !== false) {
        var eventDef = seg.eventRange.def;
        var eventInstance = seg.eventRange.instance;
        var doAllDay = false;
        var timeText;
        if (eventDef.allDay) doAllDay = true;
        else if ((0, $c1gko.az)(seg.eventRange.range)) {
            if (seg.isStart) timeText = (0, $c1gko.bQ)(seg, timeFormat, context, null, null, eventInstance.range.start, seg.end);
            else if (seg.isEnd) timeText = (0, $c1gko.bQ)(seg, timeFormat, context, null, null, seg.start, eventInstance.range.end);
            else doAllDay = true;
        } else timeText = (0, $c1gko.bQ)(seg, timeFormat, context);
        if (doAllDay) {
            var renderProps = {
                text: context.options.allDayText,
                view: context.viewApi
            };
            return (0, $kgSvt.createElement)((0, $c1gko.C), {
                elTag: "td",
                elClasses: [
                    "fc-list-event-time"
                ],
                elAttrs: {
                    headers: "".concat(timeHeaderId, " ").concat(dateHeaderId)
                },
                renderProps: renderProps,
                generatorName: "allDayContent",
                customGenerator: options.allDayContent,
                defaultGenerator: $cd830f567579f3dc$var$renderAllDayInner,
                classNameGenerator: options.allDayClassNames,
                didMount: options.allDayDidMount,
                willUnmount: options.allDayWillUnmount
            });
        }
        return (0, $kgSvt.createElement)("td", {
            className: "fc-list-event-time"
        }, timeText);
    }
    return null;
}
function $cd830f567579f3dc$var$renderAllDayInner(renderProps) {
    return renderProps.text;
}
/*
Responsible for the scroller, and forwarding event-related actions into the "grid".
*/ var $cd830f567579f3dc$export$84d0dd190d551cd1 = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $dACZV._)(ListView, DateComponent);
    var _super = (0, $jhb1H._)(ListView);
    function ListView() {
        (0, $5kWiG._)(this, ListView);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.computeDateVars = (0, $c1gko.z)($cd830f567579f3dc$var$computeDateVars);
        _this.eventStoreToSegs = (0, $c1gko.z)(_this._eventStoreToSegs);
        _this.state = {
            timeHeaderId: (0, $c1gko.a5)(),
            eventHeaderId: (0, $c1gko.a5)(),
            dateHeaderIdRoot: (0, $c1gko.a5)()
        };
        _this.setRootEl = function(rootEl) {
            if (rootEl) _this.context.registerInteractiveComponent((0, $1K4o4._)(_this), {
                el: rootEl
            });
            else _this.context.unregisterInteractiveComponent((0, $1K4o4._)(_this));
        };
        return _this;
    }
    (0, $hHaEF._)(ListView, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var _this_computeDateVars = this.computeDateVars(props.dateProfile), dayDates = _this_computeDateVars.dayDates, dayRanges = _this_computeDateVars.dayRanges;
                var eventSegs = this.eventStoreToSegs(props.eventStore, props.eventUiBases, dayRanges);
                return (0, $kgSvt.createElement)((0, $c1gko.ct), {
                    elRef: this.setRootEl,
                    elClasses: [
                        "fc-list",
                        context.theme.getClass("table"),
                        context.options.stickyHeaderDates !== false ? "fc-list-sticky" : ""
                    ],
                    viewSpec: context.viewSpec
                }, (0, $kgSvt.createElement)((0, $c1gko.cd), {
                    liquid: !props.isHeightAuto,
                    overflowX: props.isHeightAuto ? "visible" : "hidden",
                    overflowY: props.isHeightAuto ? "visible" : "auto"
                }, eventSegs.length > 0 ? this.renderSegList(eventSegs, dayDates) : this.renderEmptyMessage()));
            }
        },
        {
            key: "renderEmptyMessage",
            value: function renderEmptyMessage() {
                var _this_context = this.context, options = _this_context.options, viewApi = _this_context.viewApi;
                var renderProps = {
                    text: options.noEventsText,
                    view: viewApi
                };
                return (0, $kgSvt.createElement)((0, $c1gko.C), {
                    elTag: "div",
                    elClasses: [
                        "fc-list-empty"
                    ],
                    renderProps: renderProps,
                    generatorName: "noEventsContent",
                    customGenerator: options.noEventsContent,
                    defaultGenerator: $cd830f567579f3dc$var$renderNoEventsInner,
                    classNameGenerator: options.noEventsClassNames,
                    didMount: options.noEventsDidMount,
                    willUnmount: options.noEventsWillUnmount
                }, function(InnerContent) {
                    return (0, $kgSvt.createElement)(InnerContent, {
                        elTag: "div",
                        elClasses: [
                            "fc-list-empty-cushion"
                        ]
                    });
                });
            }
        },
        {
            key: "renderSegList",
            value: function renderSegList(allSegs, dayDates) {
                var _this_context = this.context, theme = _this_context.theme, options = _this_context.options;
                var _this_state = this.state, timeHeaderId = _this_state.timeHeaderId, eventHeaderId = _this_state.eventHeaderId, dateHeaderIdRoot = _this_state.dateHeaderIdRoot;
                var segsByDay = $cd830f567579f3dc$var$groupSegsByDay(allSegs); // sparse array
                return (0, $kgSvt.createElement)((0, $c1gko.ch), {
                    unit: "day"
                }, function(nowDate, todayRange) {
                    var innerNodes = [];
                    for(var dayIndex = 0; dayIndex < segsByDay.length; dayIndex += 1){
                        var daySegs = segsByDay[dayIndex];
                        if (daySegs) {
                            var dayStr = (0, $c1gko.bv)(dayDates[dayIndex]);
                            var dateHeaderId = dateHeaderIdRoot + "-" + dayStr;
                            // append a day header
                            innerNodes.push((0, $kgSvt.createElement)($cd830f567579f3dc$var$ListViewHeaderRow, {
                                key: dayStr,
                                cellId: dateHeaderId,
                                dayDate: dayDates[dayIndex],
                                todayRange: todayRange
                            }));
                            daySegs = (0, $c1gko.bR)(daySegs, options.eventOrder);
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = daySegs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var seg = _step.value;
                                    innerNodes.push((0, $kgSvt.createElement)($cd830f567579f3dc$var$ListViewEventRow, Object.assign({
                                        key: dayStr + ":" + seg.eventRange.instance.instanceId /* are multiple segs for an instanceId */ ,
                                        seg: seg,
                                        isDragging: false,
                                        isResizing: false,
                                        isDateSelecting: false,
                                        isSelected: false,
                                        timeHeaderId: timeHeaderId,
                                        eventHeaderId: eventHeaderId,
                                        dateHeaderId: dateHeaderId
                                    }, (0, $c1gko.bS)(seg, todayRange, nowDate))));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    }
                    return (0, $kgSvt.createElement)("table", {
                        className: "fc-list-table " + theme.getClass("table")
                    }, (0, $kgSvt.createElement)("thead", null, (0, $kgSvt.createElement)("tr", null, (0, $kgSvt.createElement)("th", {
                        scope: "col",
                        id: timeHeaderId
                    }, options.timeHint), (0, $kgSvt.createElement)("th", {
                        scope: "col",
                        "aria-hidden": true
                    }), (0, $kgSvt.createElement)("th", {
                        scope: "col",
                        id: eventHeaderId
                    }, options.eventHint))), (0, $kgSvt.createElement)("tbody", null, innerNodes));
                });
            }
        },
        {
            key: "_eventStoreToSegs",
            value: function _eventStoreToSegs(eventStore, eventUiBases, dayRanges) {
                return this.eventRangesToSegs((0, $c1gko.af)(eventStore, eventUiBases, this.props.dateProfile.activeRange, this.context.options.nextDayThreshold).fg, dayRanges);
            }
        },
        {
            key: "eventRangesToSegs",
            value: function eventRangesToSegs(eventRanges, dayRanges) {
                var _segs;
                var segs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = eventRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var eventRange = _step.value;
                        (_segs = segs).push.apply(_segs, (0, $5TJQB._)(this.eventRangeToSegs(eventRange, dayRanges)));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return segs;
            }
        },
        {
            key: "eventRangeToSegs",
            value: function eventRangeToSegs(eventRange, dayRanges) {
                var dateEnv = this.context.dateEnv;
                var nextDayThreshold = this.context.options.nextDayThreshold;
                var range = eventRange.range;
                var allDay = eventRange.def.allDay;
                var dayIndex;
                var segRange;
                var seg;
                var segs = [];
                for(dayIndex = 0; dayIndex < dayRanges.length; dayIndex += 1){
                    segRange = (0, $c1gko.o)(range, dayRanges[dayIndex]);
                    if (segRange) {
                        seg = {
                            component: this,
                            eventRange: eventRange,
                            start: segRange.start,
                            end: segRange.end,
                            isStart: eventRange.isStart && segRange.start.valueOf() === range.start.valueOf(),
                            isEnd: eventRange.isEnd && segRange.end.valueOf() === range.end.valueOf(),
                            dayIndex: dayIndex
                        };
                        segs.push(seg);
                        // detect when range won't go fully into the next day,
                        // and mutate the latest seg to the be the end.
                        if (!seg.isEnd && !allDay && dayIndex + 1 < dayRanges.length && range.end < dateEnv.add(dayRanges[dayIndex + 1].start, nextDayThreshold)) {
                            seg.end = range.end;
                            seg.isEnd = true;
                            break;
                        }
                    }
                }
                return segs;
            }
        }
    ]);
    return ListView;
}((0, $c1gko.be));
function $cd830f567579f3dc$var$renderNoEventsInner(renderProps) {
    return renderProps.text;
}
function $cd830f567579f3dc$var$computeDateVars(dateProfile) {
    var dayStart = (0, $c1gko.q)(dateProfile.renderRange.start);
    var viewEnd = dateProfile.renderRange.end;
    var dayDates = [];
    var dayRanges = [];
    while(dayStart < viewEnd){
        dayDates.push(dayStart);
        dayRanges.push({
            start: dayStart,
            end: (0, $c1gko.t)(dayStart, 1)
        });
        dayStart = (0, $c1gko.t)(dayStart, 1);
    }
    return {
        dayDates: dayDates,
        dayRanges: dayRanges
    };
}
// Returns a sparse array of arrays, segs grouped by their dayIndex
function $cd830f567579f3dc$var$groupSegsByDay(segs) {
    var segsByDay = []; // sparse array
    var i;
    var seg;
    for(i = 0; i < segs.length; i += 1){
        seg = segs[i];
        (segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = [])).push(seg);
    }
    return segsByDay;
}
var $cd830f567579f3dc$var$css_248z = ':root{--fc-list-event-dot-width:10px;--fc-list-event-hover-bg-color:#f5f5f5}.fc-theme-standard .fc-list{border:1px solid var(--fc-border-color)}.fc .fc-list-empty{align-items:center;background-color:var(--fc-neutral-bg-color);display:flex;height:100%;justify-content:center}.fc .fc-list-empty-cushion{margin:5em 0}.fc .fc-list-table{border-style:hidden;width:100%}.fc .fc-list-table tr>*{border-left:0;border-right:0}.fc .fc-list-sticky .fc-list-day>*{background:var(--fc-page-bg-color);position:sticky;top:0}.fc .fc-list-table thead{left:-10000px;position:absolute}.fc .fc-list-table tbody>tr:first-child th{border-top:0}.fc .fc-list-table th{padding:0}.fc .fc-list-day-cushion,.fc .fc-list-table td{padding:8px 14px}.fc .fc-list-day-cushion:after{clear:both;content:"";display:table}.fc-theme-standard .fc-list-day-cushion{background-color:var(--fc-neutral-bg-color)}.fc-direction-ltr .fc-list-day-text,.fc-direction-rtl .fc-list-day-side-text{float:left}.fc-direction-ltr .fc-list-day-side-text,.fc-direction-rtl .fc-list-day-text{float:right}.fc-direction-ltr .fc-list-table .fc-list-event-graphic{padding-right:0}.fc-direction-rtl .fc-list-table .fc-list-event-graphic{padding-left:0}.fc .fc-list-event.fc-event-forced-url{cursor:pointer}.fc .fc-list-event:hover td{background-color:var(--fc-list-event-hover-bg-color)}.fc .fc-list-event-graphic,.fc .fc-list-event-time{white-space:nowrap;width:1px}.fc .fc-list-event-dot{border:calc(var(--fc-list-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-list-event-dot-width)/2);box-sizing:content-box;display:inline-block;height:0;width:0}.fc .fc-list-event-title a{color:inherit;text-decoration:none}.fc .fc-list-event.fc-event-forced-url:hover a{text-decoration:underline}';
(0, $c1gko.cw)($cd830f567579f3dc$var$css_248z);



var $c1gko = parcelRequire("c1gko");

var $dff2b77ef22c1b42$var$OPTION_REFINERS = {
    listDayFormat: $dff2b77ef22c1b42$var$createFalsableFormatter,
    listDaySideFormat: $dff2b77ef22c1b42$var$createFalsableFormatter,
    noEventsClassNames: (0, $c1gko.n),
    noEventsContent: (0, $c1gko.n),
    noEventsDidMount: (0, $c1gko.n),
    noEventsWillUnmount: (0, $c1gko.n)
};
function $dff2b77ef22c1b42$var$createFalsableFormatter(input) {
    return input === false ? null : (0, $c1gko.x)(input);
}
var $dff2b77ef22c1b42$export$2e2bcd8739ae039 = (0, $e3844b7a193593a0$export$ae829ec7b2625219)({
    name: "@fullcalendar/list",
    optionRefiners: $dff2b77ef22c1b42$var$OPTION_REFINERS,
    views: {
        list: {
            component: (0, $cd830f567579f3dc$export$84d0dd190d551cd1),
            buttonTextKey: "list",
            listDayFormat: {
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        listDay: {
            type: "list",
            duration: {
                days: 1
            },
            listDayFormat: {
                weekday: "long"
            }
        },
        listWeek: {
            type: "list",
            duration: {
                weeks: 1
            },
            listDayFormat: {
                weekday: "long"
            },
            listDaySideFormat: {
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        listMonth: {
            type: "list",
            duration: {
                month: 1
            },
            listDaySideFormat: {
                weekday: "long"
            }
        },
        listYear: {
            type: "list",
            duration: {
                year: 1
            },
            listDaySideFormat: {
                weekday: "long"
            }
        }
    }
});




var $Loi7S = parcelRequire("Loi7S");

var $2B8he = parcelRequire("2B8he");

var $gpGF7 = parcelRequire("gpGF7");

var $4HRPq = parcelRequire("4HRPq");
var $f0e15f007689f3bf$var$CalendarApp = /*#__PURE__*/ function(appView) {
    "use strict";
    (0, $dACZV._)(CalendarApp, appView);
    var _super = (0, $jhb1H._)(CalendarApp);
    function CalendarApp() {
        (0, $5kWiG._)(this, CalendarApp);
        var _this;
        _this = _super.call(this);
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_newDate", new Date());
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_getModalTitleEl", document.querySelector("#event-title"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_getModalStartDateEl", document.querySelector("#event-start-date"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_getModalEndDateEl", document.querySelector("#event-end-date"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_getModalUrlEl", document.querySelector("#event-url"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_getModalAddBtnEl", document.querySelector(".btn-add-event"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_getModalUpdateBtnEl", document.querySelector(".btn-update-event"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_calendarEl", document.querySelector(".calendar"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_myModal", new bootstrap.Modal(document.getElementById("exampleModal")));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_calendarsEvents", {
            Work: "primary",
            Personal: "success",
            Important: "danger",
            Travel: "warning"
        });
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_calendarHeaderToolbar", {
            left: "prev next addEventButton",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek"
        });
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_calendarEventsList", void 0);
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_calendar", void 0);
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_currentPopover", null);
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_calendarSelect", function(info) {
            var getCheckedel = document.querySelector('input[value="Work"]');
            _this._getModalAddBtnEl.style.display = "block";
            _this._getModalUpdateBtnEl.style.display = "none";
            _this._myModal.show();
            _this._getModalStartDateEl.value = info.startStr + "T00:00";
            _this._getModalEndDateEl.value = info.endStr + "T00:00";
            getCheckedel.checked = true;
        });
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_calendarAddEvent", function() {
            var currentDate = new Date();
            var dd = String(currentDate.getDate()).padStart(2, "0");
            var mm = String(currentDate.getMonth() + 1).padStart(2, "0");
            var hours = String(currentDate.getHours()).padStart(2, "0");
            var minutes = String(currentDate.getMinutes()).padStart(2, "0");
            var seconds = String(currentDate.getSeconds()).padStart(2, "0");
            var yyyy = currentDate.getFullYear();
            var combineDate = "".concat(yyyy, "-").concat(mm, "-").concat(dd, "T").concat(hours, ":").concat(minutes, ":").concat(seconds);
            _this._getModalAddBtnEl.style.display = "block";
            _this._getModalUpdateBtnEl.style.display = "none";
            _this._myModal.show();
            _this._getModalStartDateEl.value = combineDate;
            _this._getModalEndDateEl.value = combineDate;
        });
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_calendarEventClick", function(info) {
            var self1 = (0, $1K4o4._)(_this);
            var dropdownMenu = document.querySelector(".event-menu");
            var eventLink = document.querySelector(".event-link");
            dropdownMenu.style.setProperty("left", "".concat(info.jsEvent.pageX, "px"), "important");
            dropdownMenu.style.setProperty("top", "".concat(info.jsEvent.pageY, "px"), "important");
            if (!info.event.url) eventLink.style.display = "none";
            else eventLink.style.display = "block";
            dropdownMenu.classList.toggle("show");
            dropdownMenu.addEventListener("click", function(e) {
                var target = e.target;
                if (target.classList.contains("event-edit")) {
                    e.preventDefault();
                    self1._modalEventClick(info);
                } else if (target.classList.contains("event-delete")) {
                    e.preventDefault();
                    self1._toggleDeleteModal(info);
                } else if (target.classList.contains("event-link")) {
                    if (info.event.url) window.open(info.event.url);
                    info.jsEvent.preventDefault();
                }
            });
            document.addEventListener("click", outsideClickHandler);
            function outsideClickHandler(e) {
                if (!info.el.contains(e.target)) {
                    dropdownMenu.classList.toggle("show");
                    document.removeEventListener("click", outsideClickHandler);
                }
            }
        });
        _this.initialize();
        return _this;
    }
    (0, $hHaEF._)(CalendarApp, [
        {
            key: "initialize",
            value: function initialize() {
                var _this = this;
                return (0, $e2996._)(function() {
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._renderCalendarEvents()
                                ];
                            case 1:
                                _state.sent();
                                _this._activateCalendar();
                                _this._addEvent();
                                _this._updateEvent();
                                _this._clearModalContent();
                                _this._calendar.render();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_renderCalendarEvents",
            value: function _renderCalendarEvents() {
                var _this = this;
                return (0, $e2996._)(function() {
                    var err;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    $gpGF7.getAllItemsFromDatabase("event")
                                ];
                            case 1:
                                _this._calendarEventsList = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                self.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getDynamicMonth",
            value: function _getDynamicMonth() {
                var getMonthValue = this._newDate.getMonth();
                var getUpdatedMonthValue = getMonthValue + 1;
                if (getUpdatedMonthValue < 10) return "0".concat(getUpdatedMonthValue);
                else return "".concat(getUpdatedMonthValue);
            }
        },
        {
            key: "_checkWidowWidth",
            value: function _checkWidowWidth() {
                if (window.innerWidth <= 1199) return true;
                else return false;
            }
        },
        {
            key: "_modalEventClick",
            value: function _modalEventClick(eventObj) {
                var getModalEventId = eventObj.event._def.publicId;
                var getModalEventLevel = eventObj.event._def.extendedProps["calendar"];
                var getModalCheckedRadioBtnEl = document.querySelector('input[value="'.concat(getModalEventLevel, '"]'));
                this._getModalTitleEl.value = eventObj.event.title;
                this._getModalStartDateEl.value = eventObj.event.startStr.split("+")[0];
                this._getModalEndDateEl.value = eventObj.event.endStr.split("+")[0];
                this._getModalUrlEl.value = eventObj.event.url;
                getModalCheckedRadioBtnEl.checked = true;
                this._getModalUpdateBtnEl.setAttribute("data-fc-event-public-id", getModalEventId);
                this._getModalAddBtnEl.style.display = "none";
                this._getModalUpdateBtnEl.style.display = "block";
                this._myModal.show();
            }
        },
        {
            key: "_toggleDeleteModal",
            value: function _toggleDeleteModal(info) {
                var modalBtn = document.querySelector("#deleteConformation");
                if (modalBtn) {
                    var self1 = this;
                    $(modalBtn).modal("show");
                    var eventDeleteBtn = document.querySelector('[data-remove="event"]');
                    eventDeleteBtn.addEventListener("click", function() {
                        var _ref = (0, $e2996._)(function(e) {
                            var eventId, err;
                            return (0, $gAasq.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        e.preventDefault();
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        eventId = info.event._def.publicId;
                                        return [
                                            4,
                                            $gpGF7.deleteItemFromDatabase(eventId, "event")
                                        ];
                                    case 2:
                                        _state.sent();
                                        info.event.remove();
                                        self1.successMessageInfo((0, $4HRPq.ITEMSDELETED));
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        err = _state.sent();
                                        self1.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                        return [
                                            3,
                                            5
                                        ];
                                    case 4:
                                        $(modalBtn).modal("hide");
                                        return [
                                            7
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(e) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                }
            }
        },
        {
            key: "_activateCalendar",
            value: function _activateCalendar() {
                var self1 = this;
                this._calendar = new $e3844b7a193593a0$export$e1aef45b828286de(this._calendarEl, {
                    selectable: true,
                    dayMaxEvents: true,
                    height: self1._checkWidowWidth() ? 900 : 1052,
                    initialView: self1._checkWidowWidth() ? "listWeek" : "dayGridMonth",
                    initialDate: new Date(),
                    headerToolbar: self1._calendarHeaderToolbar,
                    events: self1._calendarEventsList,
                    select: self1._calendarSelect,
                    plugins: [
                        (0, $637b468806477ab0$export$2e2bcd8739ae039),
                        (0, $bd4ac898b43cd5c3$export$2e2bcd8739ae039),
                        (0, $5b5f46d3160e73f6$export$2e2bcd8739ae039),
                        (0, $dff2b77ef22c1b42$export$2e2bcd8739ae039)
                    ],
                    unselect: function unselect() {},
                    customButtons: {
                        addEventButton: {
                            text: "Add Event",
                            click: self1._calendarAddEvent
                        }
                    },
                    //   eventDidMount: function (info) {
                    //     tippy(info.el, {
                    //       content: info.event.title,
                    //       placement: 'bottom',
                    //       arrow: true,
                    //       animation: 'scale',
                    //       theme: 'custom-theme',
                    //     });
                    //   },
                    eventClick: function eventClick(info) {
                        info.jsEvent.preventDefault();
                        self1._calendarEventClick(info);
                    },
                    eventClassNames: function eventClassNames(param) {
                        var calendarEvent = param.event;
                        var getColorValue = self1._calendarsEvents[calendarEvent._def.extendedProps.calendar];
                        return [
                            // Background Color
                            "event-fc-color fc-bg-" + getColorValue
                        ];
                    },
                    //   eventClick: self._calendarEventClick,
                    windowResize: function windowResize(arg) {
                        if (self1._checkWidowWidth()) {
                            self1._calendar.changeView("listWeek");
                            self1._calendar.setOption("height", 900);
                        } else {
                            self1._calendar.changeView("dayGridMonth");
                            self1._calendar.setOption("height", 1052);
                        }
                    }
                });
            }
        },
        {
            key: "_validateInput",
            value: function _validateInput() {
                var startDate = new Date(this._getModalStartDateEl.value);
                var endDate = new Date(this._getModalEndDateEl.value);
                var validationField = document.querySelectorAll(".validation-text");
                var UrlInput = this._getModalUrlEl.value;
                var title = this._getModalTitleEl.value;
                var isValid = true;
                if (startDate > endDate) {
                    validationField[2].innerHTML = "Start date cannot be greater than end date.";
                    validationField[2].style.display = "block";
                    isValid = false;
                } else validationField[2].style.display = "none";
                if (title === "") {
                    validationField[0].innerHTML = "Enter an Event Title.";
                    validationField[0].style.display = "block";
                    isValid = false;
                } else validationField[0].style.display = "none";
                if (UrlInput !== "") try {
                    new URL(UrlInput);
                    isValid = true;
                    validationField[1].style.display = "none";
                } catch (error) {
                    validationField[1].innerHTML = "Enter a Valid Url";
                    validationField[1].style.display = "block";
                    isValid = false;
                }
                return isValid;
            }
        },
        {
            key: "_addEvent",
            value: function _addEvent() {
                var self1 = this;
                this._getModalAddBtnEl.addEventListener("click", function() {
                    var _ref = (0, $e2996._)(function(event) {
                        var data, err;
                        return (0, $gAasq.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    event.preventDefault();
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    if (!self1._validateInput()) return [
                                        2
                                    ];
                                    data = $Loi7S.createEvent();
                                    return [
                                        4,
                                        $gpGF7.addItemtoDatabase(data, "event")
                                    ];
                                case 2:
                                    _state.sent();
                                    self1._calendar.addEvent(data);
                                    self1.successMessageInfo((0, $4HRPq.EVENTSUCCESS));
                                    self1._myModal.hide();
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    err = _state.sent();
                                    self1.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(event) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "_updateEvent",
            value: function _updateEvent() {
                var self1 = this;
                this._getModalUpdateBtnEl.addEventListener("click", /*#__PURE__*/ (0, $e2996._)(function() {
                    var getPublicID, getEvent, data, err;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    3,
                                    4
                                ]);
                                getPublicID = this.dataset.fcEventPublicId;
                                getEvent = self1._calendar.getEventById(getPublicID);
                                data = $Loi7S.createEvent(true, getPublicID);
                                return [
                                    4,
                                    $gpGF7.updateItemInDatabase(getPublicID, "event", data)
                                ];
                            case 1:
                                _state.sent();
                                getEvent.setProp("title", data.title);
                                getEvent.setStart(data.start);
                                getEvent.setEnd(data.end);
                                getEvent.setProp("url", data.url);
                                getEvent.setExtendedProp("calendar", data.extendedProps.calendar);
                                self1.successMessageInfo((0, $4HRPq.SUCCESSUPDATE));
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                err = _state.sent();
                                self1.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                self1._myModal.hide();
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        },
        {
            key: "_clearModalContent",
            value: function _clearModalContent() {
                var self1 = this;
                document.getElementById("exampleModal").addEventListener("hidden.bs.modal", function(event) {
                    var validationField = document.querySelectorAll(".validation-text");
                    self1._getModalTitleEl.value = "";
                    self1._getModalStartDateEl.value = "";
                    self1._getModalEndDateEl.value = "";
                    self1._getModalUrlEl.value = "";
                    var getModalIfCheckedRadioBtnEl = document.querySelector('input[name="event-level"]:checked');
                    if (getModalIfCheckedRadioBtnEl !== null) getModalIfCheckedRadioBtnEl.checked = false;
                    validationField.forEach(function(text) {
                        return text.style.display = "none";
                    });
                });
            }
        }
    ]);
    return CalendarApp;
}((0, $2B8he.default));
new $f0e15f007689f3bf$var$CalendarApp();


//# sourceMappingURL=events.3b069b67.js.map
